
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1985"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1985"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lUgbo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hwuTZ"));

});
parcelRegister("hwuTZ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $cc1d65546d2b5bb1$export$ffb0004e005737fa; }, function (v) { return $cc1d65546d2b5bb1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $cc1d65546d2b5bb1$export$34b9dba7ce09269b; }, function (v) { return $cc1d65546d2b5bb1$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $cc1d65546d2b5bb1$export$25062201e9e25d76; }, function (v) { return $cc1d65546d2b5bb1$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc1d65546d2b5bb1$export$ffb0004e005737fa;
var $cc1d65546d2b5bb1$export$34b9dba7ce09269b;
var $cc1d65546d2b5bb1$export$25062201e9e25d76;
"use strict";
var $cc1d65546d2b5bb1$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $cc1d65546d2b5bb1$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $cc1d65546d2b5bb1$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $cc1d65546d2b5bb1$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$cc1d65546d2b5bb1$export$ffb0004e005737fa = $cc1d65546d2b5bb1$var$REACT_FRAGMENT_TYPE;
$cc1d65546d2b5bb1$export$34b9dba7ce09269b = $cc1d65546d2b5bb1$var$jsxProd;
$cc1d65546d2b5bb1$export$25062201e9e25d76 = $cc1d65546d2b5bb1$var$jsxProd;

});


parcelRegister("fITET", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3wrPS"));

});
parcelRegister("3wrPS", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $2909f3d4d35b038f$export$9c16c1426311996d; }, function (v) { return $2909f3d4d35b038f$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $2909f3d4d35b038f$export$dca3b0875bd9a954; }, function (v) { return $2909f3d4d35b038f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $2909f3d4d35b038f$export$16fa2f45be04daa8; }, function (v) { return $2909f3d4d35b038f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2909f3d4d35b038f$export$ffb0004e005737fa; }, function (v) { return $2909f3d4d35b038f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $2909f3d4d35b038f$export$e2c29f18771995cb; }, function (v) { return $2909f3d4d35b038f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $2909f3d4d35b038f$export$221d75b3f55bb0bd; }, function (v) { return $2909f3d4d35b038f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2909f3d4d35b038f$export$5f8d39834fd61797; }, function (v) { return $2909f3d4d35b038f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2909f3d4d35b038f$export$74bf444e3cd11ea5; }, function (v) { return $2909f3d4d35b038f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $2909f3d4d35b038f$export$1ced07cd6b1985ce; }, function (v) { return $2909f3d4d35b038f$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $2909f3d4d35b038f$export$abd8e32b826d7ea7; }, function (v) { return $2909f3d4d35b038f$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $2909f3d4d35b038f$export$69a3209f1a06c04d; }, function (v) { return $2909f3d4d35b038f$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $2909f3d4d35b038f$export$8c538325882c7eec; }, function (v) { return $2909f3d4d35b038f$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $2909f3d4d35b038f$export$e530037191fcd5d7; }, function (v) { return $2909f3d4d35b038f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $2909f3d4d35b038f$export$fd42f52fd3ae1109; }, function (v) { return $2909f3d4d35b038f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $2909f3d4d35b038f$export$c8a8987d4410bf2d; }, function (v) { return $2909f3d4d35b038f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $2909f3d4d35b038f$export$7d1e3a5e95ceca43; }, function (v) { return $2909f3d4d35b038f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $2909f3d4d35b038f$export$257a8862b851cb5b; }, function (v) { return $2909f3d4d35b038f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $2909f3d4d35b038f$export$a8257692ac88316c; }, function (v) { return $2909f3d4d35b038f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $2909f3d4d35b038f$export$488013bae63b21da; }, function (v) { return $2909f3d4d35b038f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $2909f3d4d35b038f$export$7c73462e0d25e514; }, function (v) { return $2909f3d4d35b038f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $2909f3d4d35b038f$export$7568632d0d33d16d; }, function (v) { return $2909f3d4d35b038f$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $2909f3d4d35b038f$export$f93f40ac0ca7e3a8; }, function (v) { return $2909f3d4d35b038f$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $2909f3d4d35b038f$export$1f96ae73734a86cc; }, function (v) { return $2909f3d4d35b038f$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $2909f3d4d35b038f$export$9a47ced3238df325; }, function (v) { return $2909f3d4d35b038f$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $2909f3d4d35b038f$export$35808ee640e87ca7; }, function (v) { return $2909f3d4d35b038f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $2909f3d4d35b038f$export$fae74005e78b1a27; }, function (v) { return $2909f3d4d35b038f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $2909f3d4d35b038f$export$dc8fbce3eb94dc1e; }, function (v) { return $2909f3d4d35b038f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $2909f3d4d35b038f$export$6a7bc4e911dc01cf; }, function (v) { return $2909f3d4d35b038f$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $2909f3d4d35b038f$export$6d9c69b0de29b591; }, function (v) { return $2909f3d4d35b038f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $2909f3d4d35b038f$export$7f54fc3180508a52; }, function (v) { return $2909f3d4d35b038f$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $2909f3d4d35b038f$export$f680877a34711e37; }, function (v) { return $2909f3d4d35b038f$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $2909f3d4d35b038f$export$d5a552a76deda3c2; }, function (v) { return $2909f3d4d35b038f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $2909f3d4d35b038f$export$aaabe4eda9ed9969; }, function (v) { return $2909f3d4d35b038f$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $2909f3d4d35b038f$export$e5c5a5f917a5871c; }, function (v) { return $2909f3d4d35b038f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $2909f3d4d35b038f$export$1538c33de8887b59; }, function (v) { return $2909f3d4d35b038f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $2909f3d4d35b038f$export$fca7f784ae7a249a; }, function (v) { return $2909f3d4d35b038f$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $2909f3d4d35b038f$export$13e3392192263954; }, function (v) { return $2909f3d4d35b038f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $2909f3d4d35b038f$export$b8f5890fc79d6aca; }, function (v) { return $2909f3d4d35b038f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $2909f3d4d35b038f$export$60241385465d0a34; }, function (v) { return $2909f3d4d35b038f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $2909f3d4d35b038f$export$306c0aa65ff9ec16; }, function (v) { return $2909f3d4d35b038f$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $2909f3d4d35b038f$export$7b286972b8d8ccbf; }, function (v) { return $2909f3d4d35b038f$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $2909f3d4d35b038f$export$83d89fbfd8236492; }, function (v) { return $2909f3d4d35b038f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2909f3d4d35b038f$export$9c16c1426311996d;
var $2909f3d4d35b038f$export$dca3b0875bd9a954;
var $2909f3d4d35b038f$export$16fa2f45be04daa8;
var $2909f3d4d35b038f$export$ffb0004e005737fa;
var $2909f3d4d35b038f$export$e2c29f18771995cb;
var $2909f3d4d35b038f$export$221d75b3f55bb0bd;
var $2909f3d4d35b038f$export$5f8d39834fd61797;
var $2909f3d4d35b038f$export$74bf444e3cd11ea5;
var $2909f3d4d35b038f$export$1ced07cd6b1985ce;
var $2909f3d4d35b038f$export$abd8e32b826d7ea7;
var $2909f3d4d35b038f$export$69a3209f1a06c04d;
var $2909f3d4d35b038f$export$8c538325882c7eec;
var $2909f3d4d35b038f$export$e530037191fcd5d7;
var $2909f3d4d35b038f$export$fd42f52fd3ae1109;
var $2909f3d4d35b038f$export$c8a8987d4410bf2d;
var $2909f3d4d35b038f$export$7d1e3a5e95ceca43;
var $2909f3d4d35b038f$export$257a8862b851cb5b;
var $2909f3d4d35b038f$export$a8257692ac88316c;
var $2909f3d4d35b038f$export$488013bae63b21da;
var $2909f3d4d35b038f$export$7c73462e0d25e514;
var $2909f3d4d35b038f$export$7568632d0d33d16d;
var $2909f3d4d35b038f$export$f93f40ac0ca7e3a8;
var $2909f3d4d35b038f$export$1f96ae73734a86cc;
var $2909f3d4d35b038f$export$9a47ced3238df325;
var $2909f3d4d35b038f$export$35808ee640e87ca7;
var $2909f3d4d35b038f$export$fae74005e78b1a27;
var $2909f3d4d35b038f$export$dc8fbce3eb94dc1e;
var $2909f3d4d35b038f$export$6a7bc4e911dc01cf;
var $2909f3d4d35b038f$export$6d9c69b0de29b591;
var $2909f3d4d35b038f$export$7f54fc3180508a52;
var $2909f3d4d35b038f$export$f680877a34711e37;
var $2909f3d4d35b038f$export$d5a552a76deda3c2;
var $2909f3d4d35b038f$export$aaabe4eda9ed9969;
var $2909f3d4d35b038f$export$e5c5a5f917a5871c;
var $2909f3d4d35b038f$export$1538c33de8887b59;
var $2909f3d4d35b038f$export$fca7f784ae7a249a;
var $2909f3d4d35b038f$export$13e3392192263954;
var $2909f3d4d35b038f$export$b8f5890fc79d6aca;
var $2909f3d4d35b038f$export$60241385465d0a34;
var $2909f3d4d35b038f$export$306c0aa65ff9ec16;
var $2909f3d4d35b038f$export$7b286972b8d8ccbf;
var $2909f3d4d35b038f$export$83d89fbfd8236492;
"use strict";
var $2909f3d4d35b038f$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2909f3d4d35b038f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2909f3d4d35b038f$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2909f3d4d35b038f$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2909f3d4d35b038f$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2909f3d4d35b038f$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2909f3d4d35b038f$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2909f3d4d35b038f$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2909f3d4d35b038f$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2909f3d4d35b038f$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2909f3d4d35b038f$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $2909f3d4d35b038f$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $2909f3d4d35b038f$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2909f3d4d35b038f$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2909f3d4d35b038f$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2909f3d4d35b038f$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2909f3d4d35b038f$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2909f3d4d35b038f$var$assign = Object.assign, $2909f3d4d35b038f$var$emptyObject = {};
function $2909f3d4d35b038f$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2909f3d4d35b038f$var$emptyObject;
    this.updater = updater || $2909f3d4d35b038f$var$ReactNoopUpdateQueue;
}
$2909f3d4d35b038f$var$Component.prototype.isReactComponent = {};
$2909f3d4d35b038f$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$2909f3d4d35b038f$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $2909f3d4d35b038f$var$ComponentDummy() {}
$2909f3d4d35b038f$var$ComponentDummy.prototype = $2909f3d4d35b038f$var$Component.prototype;
function $2909f3d4d35b038f$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2909f3d4d35b038f$var$emptyObject;
    this.updater = updater || $2909f3d4d35b038f$var$ReactNoopUpdateQueue;
}
var $2909f3d4d35b038f$var$pureComponentPrototype = $2909f3d4d35b038f$var$PureComponent.prototype = new $2909f3d4d35b038f$var$ComponentDummy();
$2909f3d4d35b038f$var$pureComponentPrototype.constructor = $2909f3d4d35b038f$var$PureComponent;
$2909f3d4d35b038f$var$assign($2909f3d4d35b038f$var$pureComponentPrototype, $2909f3d4d35b038f$var$Component.prototype);
$2909f3d4d35b038f$var$pureComponentPrototype.isPureReactComponent = !0;
var $2909f3d4d35b038f$var$isArrayImpl = Array.isArray;
function $2909f3d4d35b038f$var$noop() {}
var $2909f3d4d35b038f$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $2909f3d4d35b038f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2909f3d4d35b038f$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $2909f3d4d35b038f$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $2909f3d4d35b038f$var$cloneAndReplaceKey(oldElement, newKey) {
    return $2909f3d4d35b038f$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $2909f3d4d35b038f$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $2909f3d4d35b038f$var$REACT_ELEMENT_TYPE;
}
function $2909f3d4d35b038f$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $2909f3d4d35b038f$var$userProvidedKeyEscapeRegex = /\/+/g;
function $2909f3d4d35b038f$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $2909f3d4d35b038f$var$escape("" + element.key) : index.toString(36);
}
function $2909f3d4d35b038f$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($2909f3d4d35b038f$var$noop, $2909f3d4d35b038f$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $2909f3d4d35b038f$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $2909f3d4d35b038f$var$REACT_ELEMENT_TYPE:
                case $2909f3d4d35b038f$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $2909f3d4d35b038f$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $2909f3d4d35b038f$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $2909f3d4d35b038f$var$getElementKey(children, 0) : nameSoFar, $2909f3d4d35b038f$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($2909f3d4d35b038f$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $2909f3d4d35b038f$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($2909f3d4d35b038f$var$isValidElement(callback) && (callback = $2909f3d4d35b038f$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($2909f3d4d35b038f$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($2909f3d4d35b038f$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $2909f3d4d35b038f$var$getElementKey(nameSoFar, i), invokeCallback += $2909f3d4d35b038f$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $2909f3d4d35b038f$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $2909f3d4d35b038f$var$getElementKey(nameSoFar, i++), invokeCallback += $2909f3d4d35b038f$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $2909f3d4d35b038f$var$mapIntoArray($2909f3d4d35b038f$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $2909f3d4d35b038f$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $2909f3d4d35b038f$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $2909f3d4d35b038f$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $2909f3d4d35b038f$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $2909f3d4d35b038f$var$Children = {
    map: $2909f3d4d35b038f$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $2909f3d4d35b038f$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $2909f3d4d35b038f$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $2909f3d4d35b038f$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$2909f3d4d35b038f$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$2909f3d4d35b038f$export$9c16c1426311996d = $2909f3d4d35b038f$var$REACT_ACTIVITY_TYPE;
$2909f3d4d35b038f$export$dca3b0875bd9a954 = $2909f3d4d35b038f$var$Children;
$2909f3d4d35b038f$export$16fa2f45be04daa8 = $2909f3d4d35b038f$var$Component;
$2909f3d4d35b038f$export$ffb0004e005737fa = $2909f3d4d35b038f$var$REACT_FRAGMENT_TYPE;
$2909f3d4d35b038f$export$e2c29f18771995cb = $2909f3d4d35b038f$var$REACT_PROFILER_TYPE;
$2909f3d4d35b038f$export$221d75b3f55bb0bd = $2909f3d4d35b038f$var$PureComponent;
$2909f3d4d35b038f$export$5f8d39834fd61797 = $2909f3d4d35b038f$var$REACT_STRICT_MODE_TYPE;
$2909f3d4d35b038f$export$74bf444e3cd11ea5 = $2909f3d4d35b038f$var$REACT_SUSPENSE_TYPE;
$2909f3d4d35b038f$export$1ced07cd6b1985ce = $2909f3d4d35b038f$var$ReactSharedInternals;
$2909f3d4d35b038f$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $2909f3d4d35b038f$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$2909f3d4d35b038f$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$2909f3d4d35b038f$export$8c538325882c7eec = function() {
    return null;
};
$2909f3d4d35b038f$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $2909f3d4d35b038f$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$2909f3d4d35b038f$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $2909f3d4d35b038f$var$ReactElement(element.type, key, props);
};
$2909f3d4d35b038f$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $2909f3d4d35b038f$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $2909f3d4d35b038f$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$2909f3d4d35b038f$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$2909f3d4d35b038f$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $2909f3d4d35b038f$var$ReactElement(type, key, props);
};
$2909f3d4d35b038f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$2909f3d4d35b038f$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $2909f3d4d35b038f$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$2909f3d4d35b038f$export$a8257692ac88316c = $2909f3d4d35b038f$var$isValidElement;
$2909f3d4d35b038f$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $2909f3d4d35b038f$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $2909f3d4d35b038f$var$lazyInitializer
    };
};
$2909f3d4d35b038f$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $2909f3d4d35b038f$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$2909f3d4d35b038f$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $2909f3d4d35b038f$var$ReactSharedInternals.T, currentTransition = {};
    $2909f3d4d35b038f$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $2909f3d4d35b038f$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($2909f3d4d35b038f$var$noop, $2909f3d4d35b038f$var$reportGlobalError);
    } catch (error) {
        $2909f3d4d35b038f$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2909f3d4d35b038f$var$ReactSharedInternals.T = prevTransition;
    }
};
$2909f3d4d35b038f$export$f93f40ac0ca7e3a8 = function() {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useCacheRefresh();
};
$2909f3d4d35b038f$export$1f96ae73734a86cc = function(usable) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.use(usable);
};
$2909f3d4d35b038f$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$2909f3d4d35b038f$export$35808ee640e87ca7 = function(callback, deps) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$2909f3d4d35b038f$export$fae74005e78b1a27 = function(Context) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useContext(Context);
};
$2909f3d4d35b038f$export$dc8fbce3eb94dc1e = function() {};
$2909f3d4d35b038f$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$2909f3d4d35b038f$export$6d9c69b0de29b591 = function(create, deps) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useEffect(create, deps);
};
$2909f3d4d35b038f$export$7f54fc3180508a52 = function(callback) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$2909f3d4d35b038f$export$f680877a34711e37 = function() {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useId();
};
$2909f3d4d35b038f$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$2909f3d4d35b038f$export$aaabe4eda9ed9969 = function(create, deps) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$2909f3d4d35b038f$export$e5c5a5f917a5871c = function(create, deps) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$2909f3d4d35b038f$export$1538c33de8887b59 = function(create, deps) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useMemo(create, deps);
};
$2909f3d4d35b038f$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$2909f3d4d35b038f$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$2909f3d4d35b038f$export$b8f5890fc79d6aca = function(initialValue) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useRef(initialValue);
};
$2909f3d4d35b038f$export$60241385465d0a34 = function(initialState) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useState(initialState);
};
$2909f3d4d35b038f$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$2909f3d4d35b038f$export$7b286972b8d8ccbf = function() {
    return $2909f3d4d35b038f$var$ReactSharedInternals.H.useTransition();
};
$2909f3d4d35b038f$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("c0pna", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $8bd92a9a66fc7c77$export$882461b6382ed46c; }, function (v) { return $8bd92a9a66fc7c77$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8bd92a9a66fc7c77$export$757ceba2d55c277e; }, function (v) { return $8bd92a9a66fc7c77$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $8bd92a9a66fc7c77$export$83d89fbfd8236492; }, function (v) { return $8bd92a9a66fc7c77$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8bd92a9a66fc7c77$export$882461b6382ed46c;
var $8bd92a9a66fc7c77$export$757ceba2d55c277e;
var $8bd92a9a66fc7c77$export$83d89fbfd8236492;
"use strict";

var $e744u = parcelRequire("e744u");

var $fITET = parcelRequire("fITET");

var $uov38 = parcelRequire("uov38");
function $8bd92a9a66fc7c77$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8bd92a9a66fc7c77$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $8bd92a9a66fc7c77$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $8bd92a9a66fc7c77$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $8bd92a9a66fc7c77$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $8bd92a9a66fc7c77$var$assertIsMounted(fiber) {
    if ($8bd92a9a66fc7c77$var$getNearestMountedFiber(fiber) !== fiber) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(188));
}
function $8bd92a9a66fc7c77$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $8bd92a9a66fc7c77$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $8bd92a9a66fc7c77$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $8bd92a9a66fc7c77$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $8bd92a9a66fc7c77$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $8bd92a9a66fc7c77$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $8bd92a9a66fc7c77$var$assign = Object.assign, $8bd92a9a66fc7c77$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $8bd92a9a66fc7c77$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8bd92a9a66fc7c77$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8bd92a9a66fc7c77$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8bd92a9a66fc7c77$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8bd92a9a66fc7c77$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8bd92a9a66fc7c77$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8bd92a9a66fc7c77$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8bd92a9a66fc7c77$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8bd92a9a66fc7c77$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $8bd92a9a66fc7c77$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $8bd92a9a66fc7c77$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $8bd92a9a66fc7c77$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $8bd92a9a66fc7c77$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8bd92a9a66fc7c77$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8bd92a9a66fc7c77$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8bd92a9a66fc7c77$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8bd92a9a66fc7c77$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $8bd92a9a66fc7c77$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $8bd92a9a66fc7c77$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $8bd92a9a66fc7c77$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $8bd92a9a66fc7c77$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $8bd92a9a66fc7c77$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $8bd92a9a66fc7c77$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $8bd92a9a66fc7c77$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $8bd92a9a66fc7c77$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $8bd92a9a66fc7c77$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $8bd92a9a66fc7c77$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $8bd92a9a66fc7c77$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $8bd92a9a66fc7c77$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $8bd92a9a66fc7c77$var$getComponentNameFromType(type.type) || "Memo";
        case $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $8bd92a9a66fc7c77$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $8bd92a9a66fc7c77$var$isArrayImpl = Array.isArray, $8bd92a9a66fc7c77$var$ReactSharedInternals = $fITET.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8bd92a9a66fc7c77$var$ReactDOMSharedInternals = $uov38.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8bd92a9a66fc7c77$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $8bd92a9a66fc7c77$var$valueStack = [], $8bd92a9a66fc7c77$var$index = -1;
function $8bd92a9a66fc7c77$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $8bd92a9a66fc7c77$var$pop(cursor) {
    0 > $8bd92a9a66fc7c77$var$index || (cursor.current = $8bd92a9a66fc7c77$var$valueStack[$8bd92a9a66fc7c77$var$index], $8bd92a9a66fc7c77$var$valueStack[$8bd92a9a66fc7c77$var$index] = null, $8bd92a9a66fc7c77$var$index--);
}
function $8bd92a9a66fc7c77$var$push(cursor, value) {
    $8bd92a9a66fc7c77$var$index++;
    $8bd92a9a66fc7c77$var$valueStack[$8bd92a9a66fc7c77$var$index] = cursor.current;
    cursor.current = value;
}
var $8bd92a9a66fc7c77$var$contextStackCursor = $8bd92a9a66fc7c77$var$createCursor(null), $8bd92a9a66fc7c77$var$contextFiberStackCursor = $8bd92a9a66fc7c77$var$createCursor(null), $8bd92a9a66fc7c77$var$rootInstanceStackCursor = $8bd92a9a66fc7c77$var$createCursor(null), $8bd92a9a66fc7c77$var$hostTransitionProviderCursor = $8bd92a9a66fc7c77$var$createCursor(null);
function $8bd92a9a66fc7c77$var$pushHostContainer(fiber, nextRootInstance) {
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$rootInstanceStackCursor, nextRootInstance);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$contextFiberStackCursor, fiber);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $8bd92a9a66fc7c77$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $8bd92a9a66fc7c77$var$getOwnHostContext(nextRootInstance), fiber = $8bd92a9a66fc7c77$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$contextStackCursor);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$contextStackCursor, fiber);
}
function $8bd92a9a66fc7c77$var$popHostContainer() {
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$contextStackCursor);
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$contextFiberStackCursor);
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$rootInstanceStackCursor);
}
function $8bd92a9a66fc7c77$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$hostTransitionProviderCursor, fiber);
    var context = $8bd92a9a66fc7c77$var$contextStackCursor.current;
    var JSCompiler_inline_result = $8bd92a9a66fc7c77$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$contextFiberStackCursor, fiber), $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$contextStackCursor, JSCompiler_inline_result));
}
function $8bd92a9a66fc7c77$var$popHostContext(fiber) {
    $8bd92a9a66fc7c77$var$contextFiberStackCursor.current === fiber && ($8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$contextStackCursor), $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$contextFiberStackCursor));
    $8bd92a9a66fc7c77$var$hostTransitionProviderCursor.current === fiber && ($8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$hostTransitionProviderCursor), $8bd92a9a66fc7c77$var$HostTransitionContext._currentValue = $8bd92a9a66fc7c77$var$sharedNotPendingObject);
}
var $8bd92a9a66fc7c77$var$prefix, $8bd92a9a66fc7c77$var$suffix;
function $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $8bd92a9a66fc7c77$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $8bd92a9a66fc7c77$var$prefix = match && match[1] || "";
        $8bd92a9a66fc7c77$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $8bd92a9a66fc7c77$var$prefix + name + $8bd92a9a66fc7c77$var$suffix;
}
var $8bd92a9a66fc7c77$var$reentry = !1;
function $8bd92a9a66fc7c77$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $8bd92a9a66fc7c77$var$reentry) return "";
    $8bd92a9a66fc7c77$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $8bd92a9a66fc7c77$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $8bd92a9a66fc7c77$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame("Suspense Fallback") : $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $8bd92a9a66fc7c77$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $8bd92a9a66fc7c77$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $8bd92a9a66fc7c77$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $8bd92a9a66fc7c77$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $8bd92a9a66fc7c77$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $8bd92a9a66fc7c77$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $8bd92a9a66fc7c77$var$hasOwnProperty = Object.prototype.hasOwnProperty, $8bd92a9a66fc7c77$var$scheduleCallback$3 = $e744u.unstable_scheduleCallback, $8bd92a9a66fc7c77$var$cancelCallback$1 = $e744u.unstable_cancelCallback, $8bd92a9a66fc7c77$var$shouldYield = $e744u.unstable_shouldYield, $8bd92a9a66fc7c77$var$requestPaint = $e744u.unstable_requestPaint, $8bd92a9a66fc7c77$var$now = $e744u.unstable_now, $8bd92a9a66fc7c77$var$getCurrentPriorityLevel = $e744u.unstable_getCurrentPriorityLevel, $8bd92a9a66fc7c77$var$ImmediatePriority = $e744u.unstable_ImmediatePriority, $8bd92a9a66fc7c77$var$UserBlockingPriority = $e744u.unstable_UserBlockingPriority, $8bd92a9a66fc7c77$var$NormalPriority$1 = $e744u.unstable_NormalPriority, $8bd92a9a66fc7c77$var$LowPriority = $e744u.unstable_LowPriority, $8bd92a9a66fc7c77$var$IdlePriority = $e744u.unstable_IdlePriority, $8bd92a9a66fc7c77$var$log$1 = $e744u.log, $8bd92a9a66fc7c77$var$unstable_setDisableYieldValue = $e744u.unstable_setDisableYieldValue, $8bd92a9a66fc7c77$var$rendererID = null, $8bd92a9a66fc7c77$var$injectedHook = null;
function $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $8bd92a9a66fc7c77$var$log$1 && $8bd92a9a66fc7c77$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($8bd92a9a66fc7c77$var$injectedHook && "function" === typeof $8bd92a9a66fc7c77$var$injectedHook.setStrictMode) try {
        $8bd92a9a66fc7c77$var$injectedHook.setStrictMode($8bd92a9a66fc7c77$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $8bd92a9a66fc7c77$var$clz32 = Math.clz32 ? Math.clz32 : $8bd92a9a66fc7c77$var$clz32Fallback, $8bd92a9a66fc7c77$var$log = Math.log, $8bd92a9a66fc7c77$var$LN2 = Math.LN2;
function $8bd92a9a66fc7c77$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($8bd92a9a66fc7c77$var$log(x) / $8bd92a9a66fc7c77$var$LN2 | 0) | 0;
}
var $8bd92a9a66fc7c77$var$nextTransitionUpdateLane = 256, $8bd92a9a66fc7c77$var$nextTransitionDeferredLane = 262144, $8bd92a9a66fc7c77$var$nextRetryLane = 4194304;
function $8bd92a9a66fc7c77$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $8bd92a9a66fc7c77$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $8bd92a9a66fc7c77$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $8bd92a9a66fc7c77$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8bd92a9a66fc7c77$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $8bd92a9a66fc7c77$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $8bd92a9a66fc7c77$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8bd92a9a66fc7c77$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $8bd92a9a66fc7c77$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $8bd92a9a66fc7c77$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8bd92a9a66fc7c77$var$claimNextRetryLane() {
    var lane = $8bd92a9a66fc7c77$var$nextRetryLane;
    $8bd92a9a66fc7c77$var$nextRetryLane <<= 1;
    0 === ($8bd92a9a66fc7c77$var$nextRetryLane & 62914560) && ($8bd92a9a66fc7c77$var$nextRetryLane = 4194304);
    return lane;
}
function $8bd92a9a66fc7c77$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $8bd92a9a66fc7c77$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $8bd92a9a66fc7c77$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $8bd92a9a66fc7c77$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $8bd92a9a66fc7c77$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $8bd92a9a66fc7c77$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $8bd92a9a66fc7c77$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $8bd92a9a66fc7c77$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $8bd92a9a66fc7c77$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $8bd92a9a66fc7c77$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $8bd92a9a66fc7c77$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $8bd92a9a66fc7c77$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $8bd92a9a66fc7c77$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $8bd92a9a66fc7c77$var$resolveUpdatePriority() {
    var updatePriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $8bd92a9a66fc7c77$var$getEventPriority(updatePriority.type);
}
function $8bd92a9a66fc7c77$var$runWithPriority(priority, fn) {
    var previousPriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
    try {
        return $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $8bd92a9a66fc7c77$var$randomKey = Math.random().toString(36).slice(2), $8bd92a9a66fc7c77$var$internalInstanceKey = "__reactFiber$" + $8bd92a9a66fc7c77$var$randomKey, $8bd92a9a66fc7c77$var$internalPropsKey = "__reactProps$" + $8bd92a9a66fc7c77$var$randomKey, $8bd92a9a66fc7c77$var$internalContainerInstanceKey = "__reactContainer$" + $8bd92a9a66fc7c77$var$randomKey, $8bd92a9a66fc7c77$var$internalEventHandlersKey = "__reactEvents$" + $8bd92a9a66fc7c77$var$randomKey, $8bd92a9a66fc7c77$var$internalEventHandlerListenersKey = "__reactListeners$" + $8bd92a9a66fc7c77$var$randomKey, $8bd92a9a66fc7c77$var$internalEventHandlesSetKey = "__reactHandles$" + $8bd92a9a66fc7c77$var$randomKey, $8bd92a9a66fc7c77$var$internalRootNodeResourcesKey = "__reactResources$" + $8bd92a9a66fc7c77$var$randomKey, $8bd92a9a66fc7c77$var$internalHoistableMarker = "__reactMarker$" + $8bd92a9a66fc7c77$var$randomKey;
function $8bd92a9a66fc7c77$var$detachDeletedInstance(node) {
    delete node[$8bd92a9a66fc7c77$var$internalInstanceKey];
    delete node[$8bd92a9a66fc7c77$var$internalPropsKey];
    delete node[$8bd92a9a66fc7c77$var$internalEventHandlersKey];
    delete node[$8bd92a9a66fc7c77$var$internalEventHandlerListenersKey];
    delete node[$8bd92a9a66fc7c77$var$internalEventHandlesSetKey];
}
function $8bd92a9a66fc7c77$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$8bd92a9a66fc7c77$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$8bd92a9a66fc7c77$var$internalContainerInstanceKey] || parentNode[$8bd92a9a66fc7c77$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $8bd92a9a66fc7c77$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$8bd92a9a66fc7c77$var$internalInstanceKey]) return parentNode;
                targetNode = $8bd92a9a66fc7c77$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $8bd92a9a66fc7c77$var$getInstanceFromNode(node) {
    if (node = node[$8bd92a9a66fc7c77$var$internalInstanceKey] || node[$8bd92a9a66fc7c77$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $8bd92a9a66fc7c77$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(33));
}
function $8bd92a9a66fc7c77$var$getResourcesFromRoot(root) {
    var resources = root[$8bd92a9a66fc7c77$var$internalRootNodeResourcesKey];
    resources || (resources = root[$8bd92a9a66fc7c77$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $8bd92a9a66fc7c77$var$markNodeAsHoistable(node) {
    node[$8bd92a9a66fc7c77$var$internalHoistableMarker] = !0;
}
var $8bd92a9a66fc7c77$var$allNativeEvents = new Set(), $8bd92a9a66fc7c77$var$registrationNameDependencies = {};
function $8bd92a9a66fc7c77$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $8bd92a9a66fc7c77$var$registerDirectEvent(registrationName, dependencies);
    $8bd92a9a66fc7c77$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $8bd92a9a66fc7c77$var$registerDirectEvent(registrationName, dependencies) {
    $8bd92a9a66fc7c77$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$8bd92a9a66fc7c77$var$allNativeEvents.add(dependencies[registrationName]);
}
var $8bd92a9a66fc7c77$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $8bd92a9a66fc7c77$var$illegalAttributeNameCache = {}, $8bd92a9a66fc7c77$var$validatedAttributeNameCache = {};
function $8bd92a9a66fc7c77$var$isAttributeNameSafe(attributeName) {
    if ($8bd92a9a66fc7c77$var$hasOwnProperty.call($8bd92a9a66fc7c77$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($8bd92a9a66fc7c77$var$hasOwnProperty.call($8bd92a9a66fc7c77$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($8bd92a9a66fc7c77$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $8bd92a9a66fc7c77$var$validatedAttributeNameCache[attributeName] = !0;
    $8bd92a9a66fc7c77$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $8bd92a9a66fc7c77$var$setValueForAttribute(node, name, value) {
    if ($8bd92a9a66fc7c77$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $8bd92a9a66fc7c77$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $8bd92a9a66fc7c77$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $8bd92a9a66fc7c77$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $8bd92a9a66fc7c77$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $8bd92a9a66fc7c77$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $8bd92a9a66fc7c77$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $8bd92a9a66fc7c77$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $8bd92a9a66fc7c77$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $8bd92a9a66fc7c77$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $8bd92a9a66fc7c77$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $8bd92a9a66fc7c77$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $8bd92a9a66fc7c77$var$getToStringValue(value);
        } else element.value !== "" + $8bd92a9a66fc7c77$var$getToStringValue(value) && (element.value = "" + $8bd92a9a66fc7c77$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $8bd92a9a66fc7c77$var$setDefaultValue(element, type, $8bd92a9a66fc7c77$var$getToStringValue(value)) : null != defaultValue ? $8bd92a9a66fc7c77$var$setDefaultValue(element, type, $8bd92a9a66fc7c77$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $8bd92a9a66fc7c77$var$getToStringValue(name) : element.removeAttribute("name");
}
function $8bd92a9a66fc7c77$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $8bd92a9a66fc7c77$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $8bd92a9a66fc7c77$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $8bd92a9a66fc7c77$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $8bd92a9a66fc7c77$var$track(element);
}
function $8bd92a9a66fc7c77$var$setDefaultValue(node, type, value) {
    "number" === type && $8bd92a9a66fc7c77$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $8bd92a9a66fc7c77$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $8bd92a9a66fc7c77$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $8bd92a9a66fc7c77$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $8bd92a9a66fc7c77$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $8bd92a9a66fc7c77$var$getToStringValue(defaultValue) : "";
}
function $8bd92a9a66fc7c77$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(92));
            if ($8bd92a9a66fc7c77$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $8bd92a9a66fc7c77$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $8bd92a9a66fc7c77$var$track(element);
}
function $8bd92a9a66fc7c77$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $8bd92a9a66fc7c77$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $8bd92a9a66fc7c77$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $8bd92a9a66fc7c77$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $8bd92a9a66fc7c77$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $8bd92a9a66fc7c77$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $8bd92a9a66fc7c77$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $8bd92a9a66fc7c77$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8bd92a9a66fc7c77$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $8bd92a9a66fc7c77$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $8bd92a9a66fc7c77$var$sanitizeURL(url) {
    return $8bd92a9a66fc7c77$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $8bd92a9a66fc7c77$var$noop$1() {}
var $8bd92a9a66fc7c77$var$currentReplayingEvent = null;
function $8bd92a9a66fc7c77$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $8bd92a9a66fc7c77$var$restoreTarget = null, $8bd92a9a66fc7c77$var$restoreQueue = null;
function $8bd92a9a66fc7c77$var$restoreStateOfTarget(target) {
    var internalInstance = $8bd92a9a66fc7c77$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$8bd92a9a66fc7c77$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $8bd92a9a66fc7c77$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$8bd92a9a66fc7c77$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(90));
                            $8bd92a9a66fc7c77$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $8bd92a9a66fc7c77$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $8bd92a9a66fc7c77$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $8bd92a9a66fc7c77$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $8bd92a9a66fc7c77$var$isInsideEventHandler = !1;
function $8bd92a9a66fc7c77$var$batchedUpdates$1(fn, a, b) {
    if ($8bd92a9a66fc7c77$var$isInsideEventHandler) return fn(a, b);
    $8bd92a9a66fc7c77$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($8bd92a9a66fc7c77$var$isInsideEventHandler = !1, null !== $8bd92a9a66fc7c77$var$restoreTarget || null !== $8bd92a9a66fc7c77$var$restoreQueue) {
            if ($8bd92a9a66fc7c77$var$flushSyncWork$1(), $8bd92a9a66fc7c77$var$restoreTarget && (a = $8bd92a9a66fc7c77$var$restoreTarget, fn = $8bd92a9a66fc7c77$var$restoreQueue, $8bd92a9a66fc7c77$var$restoreQueue = $8bd92a9a66fc7c77$var$restoreTarget = null, $8bd92a9a66fc7c77$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$8bd92a9a66fc7c77$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $8bd92a9a66fc7c77$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$8bd92a9a66fc7c77$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $8bd92a9a66fc7c77$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8bd92a9a66fc7c77$var$passiveBrowserEventsSupported = !1;
if ($8bd92a9a66fc7c77$var$canUseDOM) try {
    var $8bd92a9a66fc7c77$var$options = {};
    Object.defineProperty($8bd92a9a66fc7c77$var$options, "passive", {
        get: function() {
            $8bd92a9a66fc7c77$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $8bd92a9a66fc7c77$var$options, $8bd92a9a66fc7c77$var$options);
    window.removeEventListener("test", $8bd92a9a66fc7c77$var$options, $8bd92a9a66fc7c77$var$options);
} catch (e) {
    $8bd92a9a66fc7c77$var$passiveBrowserEventsSupported = !1;
}
var $8bd92a9a66fc7c77$var$root = null, $8bd92a9a66fc7c77$var$startText = null, $8bd92a9a66fc7c77$var$fallbackText = null;
function $8bd92a9a66fc7c77$var$getData() {
    if ($8bd92a9a66fc7c77$var$fallbackText) return $8bd92a9a66fc7c77$var$fallbackText;
    var start, startValue = $8bd92a9a66fc7c77$var$startText, startLength = startValue.length, end, endValue = "value" in $8bd92a9a66fc7c77$var$root ? $8bd92a9a66fc7c77$var$root.value : $8bd92a9a66fc7c77$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $8bd92a9a66fc7c77$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $8bd92a9a66fc7c77$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $8bd92a9a66fc7c77$var$functionThatReturnsTrue() {
    return !0;
}
function $8bd92a9a66fc7c77$var$functionThatReturnsFalse() {
    return !1;
}
function $8bd92a9a66fc7c77$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $8bd92a9a66fc7c77$var$functionThatReturnsTrue : $8bd92a9a66fc7c77$var$functionThatReturnsFalse;
        this.isPropagationStopped = $8bd92a9a66fc7c77$var$functionThatReturnsFalse;
        return this;
    }
    $8bd92a9a66fc7c77$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $8bd92a9a66fc7c77$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $8bd92a9a66fc7c77$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $8bd92a9a66fc7c77$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $8bd92a9a66fc7c77$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8bd92a9a66fc7c77$var$SyntheticEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$EventInterface), $8bd92a9a66fc7c77$var$UIEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$EventInterface, {
    view: 0,
    detail: 0
}), $8bd92a9a66fc7c77$var$SyntheticUIEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$UIEventInterface), $8bd92a9a66fc7c77$var$lastMovementX, $8bd92a9a66fc7c77$var$lastMovementY, $8bd92a9a66fc7c77$var$lastMouseEvent, $8bd92a9a66fc7c77$var$MouseEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8bd92a9a66fc7c77$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $8bd92a9a66fc7c77$var$lastMouseEvent && ($8bd92a9a66fc7c77$var$lastMouseEvent && "mousemove" === event.type ? ($8bd92a9a66fc7c77$var$lastMovementX = event.screenX - $8bd92a9a66fc7c77$var$lastMouseEvent.screenX, $8bd92a9a66fc7c77$var$lastMovementY = event.screenY - $8bd92a9a66fc7c77$var$lastMouseEvent.screenY) : $8bd92a9a66fc7c77$var$lastMovementY = $8bd92a9a66fc7c77$var$lastMovementX = 0, $8bd92a9a66fc7c77$var$lastMouseEvent = event);
        return $8bd92a9a66fc7c77$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $8bd92a9a66fc7c77$var$lastMovementY;
    }
}), $8bd92a9a66fc7c77$var$SyntheticMouseEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$MouseEventInterface), $8bd92a9a66fc7c77$var$DragEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$MouseEventInterface, {
    dataTransfer: 0
}), $8bd92a9a66fc7c77$var$SyntheticDragEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$DragEventInterface), $8bd92a9a66fc7c77$var$FocusEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$UIEventInterface, {
    relatedTarget: 0
}), $8bd92a9a66fc7c77$var$SyntheticFocusEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$FocusEventInterface), $8bd92a9a66fc7c77$var$AnimationEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8bd92a9a66fc7c77$var$SyntheticAnimationEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$AnimationEventInterface), $8bd92a9a66fc7c77$var$ClipboardEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $8bd92a9a66fc7c77$var$SyntheticClipboardEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$ClipboardEventInterface), $8bd92a9a66fc7c77$var$CompositionEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$EventInterface, {
    data: 0
}), $8bd92a9a66fc7c77$var$SyntheticCompositionEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$CompositionEventInterface), $8bd92a9a66fc7c77$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8bd92a9a66fc7c77$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8bd92a9a66fc7c77$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8bd92a9a66fc7c77$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $8bd92a9a66fc7c77$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $8bd92a9a66fc7c77$var$getEventModifierState() {
    return $8bd92a9a66fc7c77$var$modifierStateGetter;
}
var $8bd92a9a66fc7c77$var$KeyboardEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $8bd92a9a66fc7c77$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $8bd92a9a66fc7c77$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $8bd92a9a66fc7c77$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8bd92a9a66fc7c77$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $8bd92a9a66fc7c77$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $8bd92a9a66fc7c77$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $8bd92a9a66fc7c77$var$SyntheticKeyboardEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$KeyboardEventInterface), $8bd92a9a66fc7c77$var$PointerEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8bd92a9a66fc7c77$var$SyntheticPointerEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$PointerEventInterface), $8bd92a9a66fc7c77$var$TouchEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8bd92a9a66fc7c77$var$getEventModifierState
}), $8bd92a9a66fc7c77$var$SyntheticTouchEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$TouchEventInterface), $8bd92a9a66fc7c77$var$TransitionEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8bd92a9a66fc7c77$var$SyntheticTransitionEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$TransitionEventInterface), $8bd92a9a66fc7c77$var$WheelEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8bd92a9a66fc7c77$var$SyntheticWheelEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$WheelEventInterface), $8bd92a9a66fc7c77$var$ToggleEventInterface = $8bd92a9a66fc7c77$var$assign({}, $8bd92a9a66fc7c77$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $8bd92a9a66fc7c77$var$SyntheticToggleEvent = $8bd92a9a66fc7c77$var$createSyntheticEvent($8bd92a9a66fc7c77$var$ToggleEventInterface), $8bd92a9a66fc7c77$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $8bd92a9a66fc7c77$var$canUseCompositionEvent = $8bd92a9a66fc7c77$var$canUseDOM && "CompositionEvent" in window, $8bd92a9a66fc7c77$var$documentMode = null;
$8bd92a9a66fc7c77$var$canUseDOM && "documentMode" in document && ($8bd92a9a66fc7c77$var$documentMode = document.documentMode);
var $8bd92a9a66fc7c77$var$canUseTextInputEvent = $8bd92a9a66fc7c77$var$canUseDOM && "TextEvent" in window && !$8bd92a9a66fc7c77$var$documentMode, $8bd92a9a66fc7c77$var$useFallbackCompositionData = $8bd92a9a66fc7c77$var$canUseDOM && (!$8bd92a9a66fc7c77$var$canUseCompositionEvent || $8bd92a9a66fc7c77$var$documentMode && 8 < $8bd92a9a66fc7c77$var$documentMode && 11 >= $8bd92a9a66fc7c77$var$documentMode), $8bd92a9a66fc7c77$var$SPACEBAR_CHAR = String.fromCharCode(32), $8bd92a9a66fc7c77$var$hasSpaceKeypress = !1;
function $8bd92a9a66fc7c77$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $8bd92a9a66fc7c77$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8bd92a9a66fc7c77$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $8bd92a9a66fc7c77$var$isComposing = !1;
function $8bd92a9a66fc7c77$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $8bd92a9a66fc7c77$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $8bd92a9a66fc7c77$var$hasSpaceKeypress = !0;
            return $8bd92a9a66fc7c77$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $8bd92a9a66fc7c77$var$SPACEBAR_CHAR && $8bd92a9a66fc7c77$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $8bd92a9a66fc7c77$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($8bd92a9a66fc7c77$var$isComposing) return "compositionend" === domEventName || !$8bd92a9a66fc7c77$var$canUseCompositionEvent && $8bd92a9a66fc7c77$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $8bd92a9a66fc7c77$var$getData(), $8bd92a9a66fc7c77$var$fallbackText = $8bd92a9a66fc7c77$var$startText = $8bd92a9a66fc7c77$var$root = null, $8bd92a9a66fc7c77$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $8bd92a9a66fc7c77$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $8bd92a9a66fc7c77$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8bd92a9a66fc7c77$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$8bd92a9a66fc7c77$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $8bd92a9a66fc7c77$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $8bd92a9a66fc7c77$var$restoreTarget ? $8bd92a9a66fc7c77$var$restoreQueue ? $8bd92a9a66fc7c77$var$restoreQueue.push(target) : $8bd92a9a66fc7c77$var$restoreQueue = [
        target
    ] : $8bd92a9a66fc7c77$var$restoreTarget = target;
    inst = $8bd92a9a66fc7c77$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $8bd92a9a66fc7c77$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $8bd92a9a66fc7c77$var$activeElement$1 = null, $8bd92a9a66fc7c77$var$activeElementInst$1 = null;
function $8bd92a9a66fc7c77$var$runEventInBatch(dispatchQueue) {
    $8bd92a9a66fc7c77$var$processDispatchQueue(dispatchQueue, 0);
}
function $8bd92a9a66fc7c77$var$getInstIfValueChanged(targetInst) {
    var targetNode = $8bd92a9a66fc7c77$var$getNodeFromInstance(targetInst);
    if ($8bd92a9a66fc7c77$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $8bd92a9a66fc7c77$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $8bd92a9a66fc7c77$var$isInputEventSupported = !1;
if ($8bd92a9a66fc7c77$var$canUseDOM) {
    var $8bd92a9a66fc7c77$var$JSCompiler_inline_result$jscomp$286;
    if ($8bd92a9a66fc7c77$var$canUseDOM) {
        var $8bd92a9a66fc7c77$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$8bd92a9a66fc7c77$var$isSupported$jscomp$inline_427) {
            var $8bd92a9a66fc7c77$var$element$jscomp$inline_428 = document.createElement("div");
            $8bd92a9a66fc7c77$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $8bd92a9a66fc7c77$var$isSupported$jscomp$inline_427 = "function" === typeof $8bd92a9a66fc7c77$var$element$jscomp$inline_428.oninput;
        }
        $8bd92a9a66fc7c77$var$JSCompiler_inline_result$jscomp$286 = $8bd92a9a66fc7c77$var$isSupported$jscomp$inline_427;
    } else $8bd92a9a66fc7c77$var$JSCompiler_inline_result$jscomp$286 = !1;
    $8bd92a9a66fc7c77$var$isInputEventSupported = $8bd92a9a66fc7c77$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $8bd92a9a66fc7c77$var$stopWatchingForValueChange() {
    $8bd92a9a66fc7c77$var$activeElement$1 && ($8bd92a9a66fc7c77$var$activeElement$1.detachEvent("onpropertychange", $8bd92a9a66fc7c77$var$handlePropertyChange), $8bd92a9a66fc7c77$var$activeElementInst$1 = $8bd92a9a66fc7c77$var$activeElement$1 = null);
}
function $8bd92a9a66fc7c77$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $8bd92a9a66fc7c77$var$getInstIfValueChanged($8bd92a9a66fc7c77$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $8bd92a9a66fc7c77$var$createAndAccumulateChangeEvent(dispatchQueue, $8bd92a9a66fc7c77$var$activeElementInst$1, nativeEvent, $8bd92a9a66fc7c77$var$getEventTarget(nativeEvent));
        $8bd92a9a66fc7c77$var$batchedUpdates$1($8bd92a9a66fc7c77$var$runEventInBatch, dispatchQueue);
    }
}
function $8bd92a9a66fc7c77$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($8bd92a9a66fc7c77$var$stopWatchingForValueChange(), $8bd92a9a66fc7c77$var$activeElement$1 = target, $8bd92a9a66fc7c77$var$activeElementInst$1 = targetInst, $8bd92a9a66fc7c77$var$activeElement$1.attachEvent("onpropertychange", $8bd92a9a66fc7c77$var$handlePropertyChange)) : "focusout" === domEventName && $8bd92a9a66fc7c77$var$stopWatchingForValueChange();
}
function $8bd92a9a66fc7c77$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $8bd92a9a66fc7c77$var$getInstIfValueChanged($8bd92a9a66fc7c77$var$activeElementInst$1);
}
function $8bd92a9a66fc7c77$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $8bd92a9a66fc7c77$var$getInstIfValueChanged(targetInst);
}
function $8bd92a9a66fc7c77$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $8bd92a9a66fc7c77$var$getInstIfValueChanged(targetInst);
}
function $8bd92a9a66fc7c77$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8bd92a9a66fc7c77$var$objectIs = "function" === typeof Object.is ? Object.is : $8bd92a9a66fc7c77$var$is;
function $8bd92a9a66fc7c77$var$shallowEqual(objA, objB) {
    if ($8bd92a9a66fc7c77$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$8bd92a9a66fc7c77$var$hasOwnProperty.call(objB, currentKey) || !$8bd92a9a66fc7c77$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $8bd92a9a66fc7c77$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $8bd92a9a66fc7c77$var$getNodeForCharacterOffset(root, offset) {
    var node = $8bd92a9a66fc7c77$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $8bd92a9a66fc7c77$var$getLeafNode(node);
    }
}
function $8bd92a9a66fc7c77$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $8bd92a9a66fc7c77$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $8bd92a9a66fc7c77$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $8bd92a9a66fc7c77$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $8bd92a9a66fc7c77$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $8bd92a9a66fc7c77$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $8bd92a9a66fc7c77$var$skipSelectionChangeEvent = $8bd92a9a66fc7c77$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $8bd92a9a66fc7c77$var$activeElement = null, $8bd92a9a66fc7c77$var$activeElementInst = null, $8bd92a9a66fc7c77$var$lastSelection = null, $8bd92a9a66fc7c77$var$mouseDown = !1;
function $8bd92a9a66fc7c77$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $8bd92a9a66fc7c77$var$mouseDown || null == $8bd92a9a66fc7c77$var$activeElement || $8bd92a9a66fc7c77$var$activeElement !== $8bd92a9a66fc7c77$var$getActiveElement(doc) || (doc = $8bd92a9a66fc7c77$var$activeElement, "selectionStart" in doc && $8bd92a9a66fc7c77$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $8bd92a9a66fc7c77$var$lastSelection && $8bd92a9a66fc7c77$var$shallowEqual($8bd92a9a66fc7c77$var$lastSelection, doc) || ($8bd92a9a66fc7c77$var$lastSelection = doc, doc = $8bd92a9a66fc7c77$var$accumulateTwoPhaseListeners($8bd92a9a66fc7c77$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $8bd92a9a66fc7c77$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $8bd92a9a66fc7c77$var$activeElement)));
}
function $8bd92a9a66fc7c77$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $8bd92a9a66fc7c77$var$vendorPrefixes = {
    animationend: $8bd92a9a66fc7c77$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $8bd92a9a66fc7c77$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $8bd92a9a66fc7c77$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $8bd92a9a66fc7c77$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $8bd92a9a66fc7c77$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $8bd92a9a66fc7c77$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $8bd92a9a66fc7c77$var$makePrefixMap("Transition", "TransitionEnd")
}, $8bd92a9a66fc7c77$var$prefixedEventNames = {}, $8bd92a9a66fc7c77$var$style = {};
$8bd92a9a66fc7c77$var$canUseDOM && ($8bd92a9a66fc7c77$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $8bd92a9a66fc7c77$var$vendorPrefixes.animationend.animation, delete $8bd92a9a66fc7c77$var$vendorPrefixes.animationiteration.animation, delete $8bd92a9a66fc7c77$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $8bd92a9a66fc7c77$var$vendorPrefixes.transitionend.transition);
function $8bd92a9a66fc7c77$var$getVendorPrefixedEventName(eventName) {
    if ($8bd92a9a66fc7c77$var$prefixedEventNames[eventName]) return $8bd92a9a66fc7c77$var$prefixedEventNames[eventName];
    if (!$8bd92a9a66fc7c77$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $8bd92a9a66fc7c77$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $8bd92a9a66fc7c77$var$style) return $8bd92a9a66fc7c77$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $8bd92a9a66fc7c77$var$ANIMATION_END = $8bd92a9a66fc7c77$var$getVendorPrefixedEventName("animationend"), $8bd92a9a66fc7c77$var$ANIMATION_ITERATION = $8bd92a9a66fc7c77$var$getVendorPrefixedEventName("animationiteration"), $8bd92a9a66fc7c77$var$ANIMATION_START = $8bd92a9a66fc7c77$var$getVendorPrefixedEventName("animationstart"), $8bd92a9a66fc7c77$var$TRANSITION_RUN = $8bd92a9a66fc7c77$var$getVendorPrefixedEventName("transitionrun"), $8bd92a9a66fc7c77$var$TRANSITION_START = $8bd92a9a66fc7c77$var$getVendorPrefixedEventName("transitionstart"), $8bd92a9a66fc7c77$var$TRANSITION_CANCEL = $8bd92a9a66fc7c77$var$getVendorPrefixedEventName("transitioncancel"), $8bd92a9a66fc7c77$var$TRANSITION_END = $8bd92a9a66fc7c77$var$getVendorPrefixedEventName("transitionend"), $8bd92a9a66fc7c77$var$topLevelEventsToReactNames = new Map(), $8bd92a9a66fc7c77$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$8bd92a9a66fc7c77$var$simpleEventPluginEvents.push("scrollEnd");
function $8bd92a9a66fc7c77$var$registerSimpleEvent(domEventName, reactName) {
    $8bd92a9a66fc7c77$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $8bd92a9a66fc7c77$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $8bd92a9a66fc7c77$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $8bd92a9a66fc7c77$var$concurrentQueues = [], $8bd92a9a66fc7c77$var$concurrentQueuesIndex = 0, $8bd92a9a66fc7c77$var$concurrentlyUpdatedLanes = 0;
function $8bd92a9a66fc7c77$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $8bd92a9a66fc7c77$var$concurrentQueuesIndex, i = $8bd92a9a66fc7c77$var$concurrentlyUpdatedLanes = $8bd92a9a66fc7c77$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $8bd92a9a66fc7c77$var$concurrentQueues[i];
        $8bd92a9a66fc7c77$var$concurrentQueues[i++] = null;
        var queue = $8bd92a9a66fc7c77$var$concurrentQueues[i];
        $8bd92a9a66fc7c77$var$concurrentQueues[i++] = null;
        var update = $8bd92a9a66fc7c77$var$concurrentQueues[i];
        $8bd92a9a66fc7c77$var$concurrentQueues[i++] = null;
        var lane = $8bd92a9a66fc7c77$var$concurrentQueues[i];
        $8bd92a9a66fc7c77$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $8bd92a9a66fc7c77$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $8bd92a9a66fc7c77$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $8bd92a9a66fc7c77$var$concurrentQueues[$8bd92a9a66fc7c77$var$concurrentQueuesIndex++] = fiber;
    $8bd92a9a66fc7c77$var$concurrentQueues[$8bd92a9a66fc7c77$var$concurrentQueuesIndex++] = queue;
    $8bd92a9a66fc7c77$var$concurrentQueues[$8bd92a9a66fc7c77$var$concurrentQueuesIndex++] = update;
    $8bd92a9a66fc7c77$var$concurrentQueues[$8bd92a9a66fc7c77$var$concurrentQueuesIndex++] = lane;
    $8bd92a9a66fc7c77$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $8bd92a9a66fc7c77$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $8bd92a9a66fc7c77$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $8bd92a9a66fc7c77$var$getRootForUpdatedFiber(fiber);
}
function $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $8bd92a9a66fc7c77$var$enqueueUpdate$1(fiber, null, null, lane);
    return $8bd92a9a66fc7c77$var$getRootForUpdatedFiber(fiber);
}
function $8bd92a9a66fc7c77$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $8bd92a9a66fc7c77$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $8bd92a9a66fc7c77$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $8bd92a9a66fc7c77$var$nestedUpdateCount) throw $8bd92a9a66fc7c77$var$nestedUpdateCount = 0, $8bd92a9a66fc7c77$var$rootWithNestedUpdates = null, Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $8bd92a9a66fc7c77$var$emptyContextObject = {};
function $8bd92a9a66fc7c77$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8bd92a9a66fc7c77$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $8bd92a9a66fc7c77$var$FiberNode(tag, pendingProps, key, mode);
}
function $8bd92a9a66fc7c77$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $8bd92a9a66fc7c77$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $8bd92a9a66fc7c77$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $8bd92a9a66fc7c77$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $8bd92a9a66fc7c77$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $8bd92a9a66fc7c77$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $8bd92a9a66fc7c77$var$isHostHoistableType(type, pendingProps, $8bd92a9a66fc7c77$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $8bd92a9a66fc7c77$var$REACT_ACTIVITY_TYPE:
            return type = $8bd92a9a66fc7c77$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $8bd92a9a66fc7c77$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $8bd92a9a66fc7c77$var$REACT_FRAGMENT_TYPE:
            return $8bd92a9a66fc7c77$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $8bd92a9a66fc7c77$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $8bd92a9a66fc7c77$var$REACT_PROFILER_TYPE:
            return type = $8bd92a9a66fc7c77$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $8bd92a9a66fc7c77$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $8bd92a9a66fc7c77$var$REACT_SUSPENSE_TYPE:
            return type = $8bd92a9a66fc7c77$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $8bd92a9a66fc7c77$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $8bd92a9a66fc7c77$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $8bd92a9a66fc7c77$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $8bd92a9a66fc7c77$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $8bd92a9a66fc7c77$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $8bd92a9a66fc7c77$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $8bd92a9a66fc7c77$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $8bd92a9a66fc7c77$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $8bd92a9a66fc7c77$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $8bd92a9a66fc7c77$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $8bd92a9a66fc7c77$var$createFiberFromText(content, mode, lanes) {
    content = $8bd92a9a66fc7c77$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $8bd92a9a66fc7c77$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $8bd92a9a66fc7c77$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $8bd92a9a66fc7c77$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $8bd92a9a66fc7c77$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $8bd92a9a66fc7c77$var$CapturedStacks = new WeakMap();
function $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $8bd92a9a66fc7c77$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $8bd92a9a66fc7c77$var$getStackByFiberInDevAndProd(source)
        };
        $8bd92a9a66fc7c77$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $8bd92a9a66fc7c77$var$getStackByFiberInDevAndProd(source)
    };
}
var $8bd92a9a66fc7c77$var$forkStack = [], $8bd92a9a66fc7c77$var$forkStackIndex = 0, $8bd92a9a66fc7c77$var$treeForkProvider = null, $8bd92a9a66fc7c77$var$treeForkCount = 0, $8bd92a9a66fc7c77$var$idStack = [], $8bd92a9a66fc7c77$var$idStackIndex = 0, $8bd92a9a66fc7c77$var$treeContextProvider = null, $8bd92a9a66fc7c77$var$treeContextId = 1, $8bd92a9a66fc7c77$var$treeContextOverflow = "";
function $8bd92a9a66fc7c77$var$pushTreeFork(workInProgress, totalChildren) {
    $8bd92a9a66fc7c77$var$forkStack[$8bd92a9a66fc7c77$var$forkStackIndex++] = $8bd92a9a66fc7c77$var$treeForkCount;
    $8bd92a9a66fc7c77$var$forkStack[$8bd92a9a66fc7c77$var$forkStackIndex++] = $8bd92a9a66fc7c77$var$treeForkProvider;
    $8bd92a9a66fc7c77$var$treeForkProvider = workInProgress;
    $8bd92a9a66fc7c77$var$treeForkCount = totalChildren;
}
function $8bd92a9a66fc7c77$var$pushTreeId(workInProgress, totalChildren, index) {
    $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex++] = $8bd92a9a66fc7c77$var$treeContextId;
    $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex++] = $8bd92a9a66fc7c77$var$treeContextOverflow;
    $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex++] = $8bd92a9a66fc7c77$var$treeContextProvider;
    $8bd92a9a66fc7c77$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $8bd92a9a66fc7c77$var$treeContextId;
    workInProgress = $8bd92a9a66fc7c77$var$treeContextOverflow;
    var baseLength = 32 - $8bd92a9a66fc7c77$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $8bd92a9a66fc7c77$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $8bd92a9a66fc7c77$var$treeContextId = 1 << 32 - $8bd92a9a66fc7c77$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $8bd92a9a66fc7c77$var$treeContextOverflow = length + workInProgress;
    } else $8bd92a9a66fc7c77$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $8bd92a9a66fc7c77$var$treeContextOverflow = workInProgress;
}
function $8bd92a9a66fc7c77$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($8bd92a9a66fc7c77$var$pushTreeFork(workInProgress, 1), $8bd92a9a66fc7c77$var$pushTreeId(workInProgress, 1, 0));
}
function $8bd92a9a66fc7c77$var$popTreeContext(workInProgress) {
    for(; workInProgress === $8bd92a9a66fc7c77$var$treeForkProvider;)$8bd92a9a66fc7c77$var$treeForkProvider = $8bd92a9a66fc7c77$var$forkStack[--$8bd92a9a66fc7c77$var$forkStackIndex], $8bd92a9a66fc7c77$var$forkStack[$8bd92a9a66fc7c77$var$forkStackIndex] = null, $8bd92a9a66fc7c77$var$treeForkCount = $8bd92a9a66fc7c77$var$forkStack[--$8bd92a9a66fc7c77$var$forkStackIndex], $8bd92a9a66fc7c77$var$forkStack[$8bd92a9a66fc7c77$var$forkStackIndex] = null;
    for(; workInProgress === $8bd92a9a66fc7c77$var$treeContextProvider;)$8bd92a9a66fc7c77$var$treeContextProvider = $8bd92a9a66fc7c77$var$idStack[--$8bd92a9a66fc7c77$var$idStackIndex], $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex] = null, $8bd92a9a66fc7c77$var$treeContextOverflow = $8bd92a9a66fc7c77$var$idStack[--$8bd92a9a66fc7c77$var$idStackIndex], $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex] = null, $8bd92a9a66fc7c77$var$treeContextId = $8bd92a9a66fc7c77$var$idStack[--$8bd92a9a66fc7c77$var$idStackIndex], $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex] = null;
}
function $8bd92a9a66fc7c77$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex++] = $8bd92a9a66fc7c77$var$treeContextId;
    $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex++] = $8bd92a9a66fc7c77$var$treeContextOverflow;
    $8bd92a9a66fc7c77$var$idStack[$8bd92a9a66fc7c77$var$idStackIndex++] = $8bd92a9a66fc7c77$var$treeContextProvider;
    $8bd92a9a66fc7c77$var$treeContextId = suspendedContext.id;
    $8bd92a9a66fc7c77$var$treeContextOverflow = suspendedContext.overflow;
    $8bd92a9a66fc7c77$var$treeContextProvider = workInProgress;
}
var $8bd92a9a66fc7c77$var$hydrationParentFiber = null, $8bd92a9a66fc7c77$var$nextHydratableInstance = null, $8bd92a9a66fc7c77$var$isHydrating = !1, $8bd92a9a66fc7c77$var$hydrationErrors = null, $8bd92a9a66fc7c77$var$rootOrSingletonContext = !1, $8bd92a9a66fc7c77$var$HydrationMismatchException = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(519));
function $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(fiber) {
    var error = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $8bd92a9a66fc7c77$var$queueHydrationError($8bd92a9a66fc7c77$var$createCapturedValueAtFiber(error, fiber));
    throw $8bd92a9a66fc7c77$var$HydrationMismatchException;
}
function $8bd92a9a66fc7c77$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$8bd92a9a66fc7c77$var$internalInstanceKey] = fiber;
    instance[$8bd92a9a66fc7c77$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("cancel", instance);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $8bd92a9a66fc7c77$var$mediaEventTypes.length; type++)$8bd92a9a66fc7c77$var$listenToNonDelegatedEvent($8bd92a9a66fc7c77$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("error", instance);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("invalid", instance);
            $8bd92a9a66fc7c77$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("invalid", instance), $8bd92a9a66fc7c77$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $8bd92a9a66fc7c77$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("beforetoggle", instance), $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $8bd92a9a66fc7c77$var$noop$1), instance = !0) : instance = !1;
    instance || $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(fiber, !0);
}
function $8bd92a9a66fc7c77$var$popToNextHostParent(fiber) {
    for($8bd92a9a66fc7c77$var$hydrationParentFiber = fiber.return; $8bd92a9a66fc7c77$var$hydrationParentFiber;)switch($8bd92a9a66fc7c77$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $8bd92a9a66fc7c77$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $8bd92a9a66fc7c77$var$rootOrSingletonContext = !0;
            return;
        default:
            $8bd92a9a66fc7c77$var$hydrationParentFiber = $8bd92a9a66fc7c77$var$hydrationParentFiber.return;
    }
}
function $8bd92a9a66fc7c77$var$popHydrationState(fiber) {
    if (fiber !== $8bd92a9a66fc7c77$var$hydrationParentFiber) return !1;
    if (!$8bd92a9a66fc7c77$var$isHydrating) return $8bd92a9a66fc7c77$var$popToNextHostParent(fiber), $8bd92a9a66fc7c77$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $8bd92a9a66fc7c77$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $8bd92a9a66fc7c77$var$nextHydratableInstance && $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(fiber);
    $8bd92a9a66fc7c77$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(317));
        $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(317));
        $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $8bd92a9a66fc7c77$var$nextHydratableInstance, $8bd92a9a66fc7c77$var$isSingletonScope(fiber.type) ? (fiber = $8bd92a9a66fc7c77$var$previousHydratableOnEnteringScopedSingleton, $8bd92a9a66fc7c77$var$previousHydratableOnEnteringScopedSingleton = null, $8bd92a9a66fc7c77$var$nextHydratableInstance = fiber) : $8bd92a9a66fc7c77$var$nextHydratableInstance = tag) : $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$hydrationParentFiber ? $8bd92a9a66fc7c77$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $8bd92a9a66fc7c77$var$resetHydrationState() {
    $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$hydrationParentFiber = null;
    $8bd92a9a66fc7c77$var$isHydrating = !1;
}
function $8bd92a9a66fc7c77$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $8bd92a9a66fc7c77$var$hydrationErrors;
    null !== queuedErrors && (null === $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors ? $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors = queuedErrors : $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors.push.apply($8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors, queuedErrors), $8bd92a9a66fc7c77$var$hydrationErrors = null);
    return queuedErrors;
}
function $8bd92a9a66fc7c77$var$queueHydrationError(error) {
    null === $8bd92a9a66fc7c77$var$hydrationErrors ? $8bd92a9a66fc7c77$var$hydrationErrors = [
        error
    ] : $8bd92a9a66fc7c77$var$hydrationErrors.push(error);
}
var $8bd92a9a66fc7c77$var$valueCursor = $8bd92a9a66fc7c77$var$createCursor(null), $8bd92a9a66fc7c77$var$currentlyRenderingFiber$1 = null, $8bd92a9a66fc7c77$var$lastContextDependency = null;
function $8bd92a9a66fc7c77$var$pushProvider(providerFiber, context, nextValue) {
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $8bd92a9a66fc7c77$var$popProvider(context) {
    context._currentValue = $8bd92a9a66fc7c77$var$valueCursor.current;
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$valueCursor);
}
function $8bd92a9a66fc7c77$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $8bd92a9a66fc7c77$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $8bd92a9a66fc7c77$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $8bd92a9a66fc7c77$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $8bd92a9a66fc7c77$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $8bd92a9a66fc7c77$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $8bd92a9a66fc7c77$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($8bd92a9a66fc7c77$var$HostTransitionContext) : current = [
                $8bd92a9a66fc7c77$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $8bd92a9a66fc7c77$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $8bd92a9a66fc7c77$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$8bd92a9a66fc7c77$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $8bd92a9a66fc7c77$var$prepareToReadContext(workInProgress) {
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber$1 = workInProgress;
    $8bd92a9a66fc7c77$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $8bd92a9a66fc7c77$var$readContext(context) {
    return $8bd92a9a66fc7c77$var$readContextForConsumer($8bd92a9a66fc7c77$var$currentlyRenderingFiber$1, context);
}
function $8bd92a9a66fc7c77$var$readContextDuringReconciliation(consumer, context) {
    null === $8bd92a9a66fc7c77$var$currentlyRenderingFiber$1 && $8bd92a9a66fc7c77$var$prepareToReadContext(consumer);
    return $8bd92a9a66fc7c77$var$readContextForConsumer(consumer, context);
}
function $8bd92a9a66fc7c77$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $8bd92a9a66fc7c77$var$lastContextDependency) {
        if (null === consumer) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(308));
        $8bd92a9a66fc7c77$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $8bd92a9a66fc7c77$var$lastContextDependency = $8bd92a9a66fc7c77$var$lastContextDependency.next = context;
    return value;
}
var $8bd92a9a66fc7c77$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $8bd92a9a66fc7c77$var$scheduleCallback$2 = $e744u.unstable_scheduleCallback, $8bd92a9a66fc7c77$var$NormalPriority = $e744u.unstable_NormalPriority, $8bd92a9a66fc7c77$var$CacheContext = {
    $$typeof: $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $8bd92a9a66fc7c77$var$createCache() {
    return {
        controller: new $8bd92a9a66fc7c77$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $8bd92a9a66fc7c77$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $8bd92a9a66fc7c77$var$scheduleCallback$2($8bd92a9a66fc7c77$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $8bd92a9a66fc7c77$var$currentEntangledListeners = null, $8bd92a9a66fc7c77$var$currentEntangledPendingCount = 0, $8bd92a9a66fc7c77$var$currentEntangledLane = 0, $8bd92a9a66fc7c77$var$currentEntangledActionThenable = null;
function $8bd92a9a66fc7c77$var$entangleAsyncAction(transition, thenable) {
    if (null === $8bd92a9a66fc7c77$var$currentEntangledListeners) {
        var entangledListeners = $8bd92a9a66fc7c77$var$currentEntangledListeners = [];
        $8bd92a9a66fc7c77$var$currentEntangledPendingCount = 0;
        $8bd92a9a66fc7c77$var$currentEntangledLane = $8bd92a9a66fc7c77$var$requestTransitionLane();
        $8bd92a9a66fc7c77$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $8bd92a9a66fc7c77$var$currentEntangledPendingCount++;
    thenable.then($8bd92a9a66fc7c77$var$pingEngtangledActionScope, $8bd92a9a66fc7c77$var$pingEngtangledActionScope);
    return thenable;
}
function $8bd92a9a66fc7c77$var$pingEngtangledActionScope() {
    if (0 === --$8bd92a9a66fc7c77$var$currentEntangledPendingCount && null !== $8bd92a9a66fc7c77$var$currentEntangledListeners) {
        null !== $8bd92a9a66fc7c77$var$currentEntangledActionThenable && ($8bd92a9a66fc7c77$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $8bd92a9a66fc7c77$var$currentEntangledListeners;
        $8bd92a9a66fc7c77$var$currentEntangledListeners = null;
        $8bd92a9a66fc7c77$var$currentEntangledLane = 0;
        $8bd92a9a66fc7c77$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $8bd92a9a66fc7c77$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $8bd92a9a66fc7c77$var$prevOnStartTransitionFinish = $8bd92a9a66fc7c77$var$ReactSharedInternals.S;
$8bd92a9a66fc7c77$var$ReactSharedInternals.S = function(transition, returnValue) {
    $8bd92a9a66fc7c77$var$globalMostRecentTransitionTime = $8bd92a9a66fc7c77$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $8bd92a9a66fc7c77$var$entangleAsyncAction(transition, returnValue);
    null !== $8bd92a9a66fc7c77$var$prevOnStartTransitionFinish && $8bd92a9a66fc7c77$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $8bd92a9a66fc7c77$var$resumedCache = $8bd92a9a66fc7c77$var$createCursor(null);
function $8bd92a9a66fc7c77$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $8bd92a9a66fc7c77$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $8bd92a9a66fc7c77$var$workInProgressRoot.pooledCache;
}
function $8bd92a9a66fc7c77$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$resumedCache, $8bd92a9a66fc7c77$var$resumedCache.current) : $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$resumedCache, prevCachePool.pool);
}
function $8bd92a9a66fc7c77$var$getSuspendedCache() {
    var cacheFromPool = $8bd92a9a66fc7c77$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $8bd92a9a66fc7c77$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $8bd92a9a66fc7c77$var$SuspenseException = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(460)), $8bd92a9a66fc7c77$var$SuspenseyCommitException = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(474)), $8bd92a9a66fc7c77$var$SuspenseActionException = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(542)), $8bd92a9a66fc7c77$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $8bd92a9a66fc7c77$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $8bd92a9a66fc7c77$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($8bd92a9a66fc7c77$var$noop$1, $8bd92a9a66fc7c77$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $8bd92a9a66fc7c77$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($8bd92a9a66fc7c77$var$noop$1, $8bd92a9a66fc7c77$var$noop$1);
            else {
                thenableState = $8bd92a9a66fc7c77$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $8bd92a9a66fc7c77$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $8bd92a9a66fc7c77$var$suspendedThenable = thenable;
            throw $8bd92a9a66fc7c77$var$SuspenseException;
    }
}
function $8bd92a9a66fc7c77$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $8bd92a9a66fc7c77$var$suspendedThenable = x, $8bd92a9a66fc7c77$var$SuspenseException;
        throw x;
    }
}
var $8bd92a9a66fc7c77$var$suspendedThenable = null;
function $8bd92a9a66fc7c77$var$getSuspendedThenable() {
    if (null === $8bd92a9a66fc7c77$var$suspendedThenable) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(459));
    var thenable = $8bd92a9a66fc7c77$var$suspendedThenable;
    $8bd92a9a66fc7c77$var$suspendedThenable = null;
    return thenable;
}
function $8bd92a9a66fc7c77$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $8bd92a9a66fc7c77$var$SuspenseException || rejectedReason === $8bd92a9a66fc7c77$var$SuspenseActionException) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(483));
}
var $8bd92a9a66fc7c77$var$thenableState$1 = null, $8bd92a9a66fc7c77$var$thenableIndexCounter$1 = 0;
function $8bd92a9a66fc7c77$var$unwrapThenable(thenable) {
    var index = $8bd92a9a66fc7c77$var$thenableIndexCounter$1;
    $8bd92a9a66fc7c77$var$thenableIndexCounter$1 += 1;
    null === $8bd92a9a66fc7c77$var$thenableState$1 && ($8bd92a9a66fc7c77$var$thenableState$1 = []);
    return $8bd92a9a66fc7c77$var$trackUsedThenable($8bd92a9a66fc7c77$var$thenableState$1, thenable, index);
}
function $8bd92a9a66fc7c77$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $8bd92a9a66fc7c77$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $8bd92a9a66fc7c77$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $8bd92a9a66fc7c77$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $8bd92a9a66fc7c77$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $8bd92a9a66fc7c77$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $8bd92a9a66fc7c77$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE && $8bd92a9a66fc7c77$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $8bd92a9a66fc7c77$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $8bd92a9a66fc7c77$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $8bd92a9a66fc7c77$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $8bd92a9a66fc7c77$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $8bd92a9a66fc7c77$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $8bd92a9a66fc7c77$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8bd92a9a66fc7c77$var$REACT_ELEMENT_TYPE:
                    return lanes = $8bd92a9a66fc7c77$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8bd92a9a66fc7c77$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $8bd92a9a66fc7c77$var$REACT_PORTAL_TYPE:
                    return newChild = $8bd92a9a66fc7c77$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE:
                    return newChild = $8bd92a9a66fc7c77$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($8bd92a9a66fc7c77$var$isArrayImpl(newChild) || $8bd92a9a66fc7c77$var$getIteratorFn(newChild)) return newChild = $8bd92a9a66fc7c77$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $8bd92a9a66fc7c77$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $8bd92a9a66fc7c77$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8bd92a9a66fc7c77$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8bd92a9a66fc7c77$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $8bd92a9a66fc7c77$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE:
                    return newChild = $8bd92a9a66fc7c77$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($8bd92a9a66fc7c77$var$isArrayImpl(newChild) || $8bd92a9a66fc7c77$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $8bd92a9a66fc7c77$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $8bd92a9a66fc7c77$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8bd92a9a66fc7c77$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8bd92a9a66fc7c77$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $8bd92a9a66fc7c77$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE:
                    return newChild = $8bd92a9a66fc7c77$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($8bd92a9a66fc7c77$var$isArrayImpl(newChild) || $8bd92a9a66fc7c77$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $8bd92a9a66fc7c77$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $8bd92a9a66fc7c77$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8bd92a9a66fc7c77$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $8bd92a9a66fc7c77$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8bd92a9a66fc7c77$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $8bd92a9a66fc7c77$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE && $8bd92a9a66fc7c77$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $8bd92a9a66fc7c77$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $8bd92a9a66fc7c77$var$REACT_FRAGMENT_TYPE ? (lanes = $8bd92a9a66fc7c77$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $8bd92a9a66fc7c77$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8bd92a9a66fc7c77$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $8bd92a9a66fc7c77$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $8bd92a9a66fc7c77$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $8bd92a9a66fc7c77$var$REACT_LAZY_TYPE:
                    return newChild = $8bd92a9a66fc7c77$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($8bd92a9a66fc7c77$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($8bd92a9a66fc7c77$var$getIteratorFn(newChild)) {
                key = $8bd92a9a66fc7c77$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8bd92a9a66fc7c77$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8bd92a9a66fc7c77$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8bd92a9a66fc7c77$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $8bd92a9a66fc7c77$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $8bd92a9a66fc7c77$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $8bd92a9a66fc7c77$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $8bd92a9a66fc7c77$var$SuspenseException || x === $8bd92a9a66fc7c77$var$SuspenseActionException) throw x;
            var fiber = $8bd92a9a66fc7c77$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $8bd92a9a66fc7c77$var$reconcileChildFibers = $8bd92a9a66fc7c77$var$createChildReconciler(!0), $8bd92a9a66fc7c77$var$mountChildFibers = $8bd92a9a66fc7c77$var$createChildReconciler(!1), $8bd92a9a66fc7c77$var$hasForceUpdate = !1;
function $8bd92a9a66fc7c77$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $8bd92a9a66fc7c77$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $8bd92a9a66fc7c77$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8bd92a9a66fc7c77$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($8bd92a9a66fc7c77$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $8bd92a9a66fc7c77$var$getRootForUpdatedFiber(fiber);
        $8bd92a9a66fc7c77$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $8bd92a9a66fc7c77$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $8bd92a9a66fc7c77$var$getRootForUpdatedFiber(fiber);
}
function $8bd92a9a66fc7c77$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $8bd92a9a66fc7c77$var$markRootEntangled(root, lane);
    }
}
function $8bd92a9a66fc7c77$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $8bd92a9a66fc7c77$var$didReadFromEntangledAsyncAction = !1;
function $8bd92a9a66fc7c77$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($8bd92a9a66fc7c77$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $8bd92a9a66fc7c77$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $8bd92a9a66fc7c77$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $8bd92a9a66fc7c77$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $8bd92a9a66fc7c77$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $8bd92a9a66fc7c77$var$currentEntangledLane && ($8bd92a9a66fc7c77$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $8bd92a9a66fc7c77$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $8bd92a9a66fc7c77$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $8bd92a9a66fc7c77$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $8bd92a9a66fc7c77$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$8bd92a9a66fc7c77$var$callCallback(callbacks[updateQueue], context);
}
var $8bd92a9a66fc7c77$var$currentTreeHiddenStackCursor = $8bd92a9a66fc7c77$var$createCursor(null), $8bd92a9a66fc7c77$var$prevEntangledRenderLanesCursor = $8bd92a9a66fc7c77$var$createCursor(0);
function $8bd92a9a66fc7c77$var$pushHiddenContext(fiber, context) {
    fiber = $8bd92a9a66fc7c77$var$entangledRenderLanes;
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$prevEntangledRenderLanesCursor, fiber);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$currentTreeHiddenStackCursor, context);
    $8bd92a9a66fc7c77$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $8bd92a9a66fc7c77$var$reuseHiddenContextOnStack() {
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$prevEntangledRenderLanesCursor, $8bd92a9a66fc7c77$var$entangledRenderLanes);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$currentTreeHiddenStackCursor, $8bd92a9a66fc7c77$var$currentTreeHiddenStackCursor.current);
}
function $8bd92a9a66fc7c77$var$popHiddenContext() {
    $8bd92a9a66fc7c77$var$entangledRenderLanes = $8bd92a9a66fc7c77$var$prevEntangledRenderLanesCursor.current;
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$currentTreeHiddenStackCursor);
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$prevEntangledRenderLanesCursor);
}
var $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor = $8bd92a9a66fc7c77$var$createCursor(null), $8bd92a9a66fc7c77$var$shellBoundary = null;
function $8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, $8bd92a9a66fc7c77$var$suspenseStackCursor.current & 1);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseHandlerStackCursor, handler);
    null === $8bd92a9a66fc7c77$var$shellBoundary && (null === current || null !== $8bd92a9a66fc7c77$var$currentTreeHiddenStackCursor.current ? $8bd92a9a66fc7c77$var$shellBoundary = handler : null !== current.memoizedState && ($8bd92a9a66fc7c77$var$shellBoundary = handler));
}
function $8bd92a9a66fc7c77$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, $8bd92a9a66fc7c77$var$suspenseStackCursor.current);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseHandlerStackCursor, fiber);
    null === $8bd92a9a66fc7c77$var$shellBoundary && ($8bd92a9a66fc7c77$var$shellBoundary = fiber);
}
function $8bd92a9a66fc7c77$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, $8bd92a9a66fc7c77$var$suspenseStackCursor.current), $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseHandlerStackCursor, fiber), null === $8bd92a9a66fc7c77$var$shellBoundary && ($8bd92a9a66fc7c77$var$shellBoundary = fiber)) : $8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(fiber);
}
function $8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack() {
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, $8bd92a9a66fc7c77$var$suspenseStackCursor.current);
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseHandlerStackCursor, $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current);
}
function $8bd92a9a66fc7c77$var$popSuspenseHandler(fiber) {
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$suspenseHandlerStackCursor);
    $8bd92a9a66fc7c77$var$shellBoundary === fiber && ($8bd92a9a66fc7c77$var$shellBoundary = null);
    $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$suspenseStackCursor);
}
var $8bd92a9a66fc7c77$var$suspenseStackCursor = $8bd92a9a66fc7c77$var$createCursor(0);
function $8bd92a9a66fc7c77$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $8bd92a9a66fc7c77$var$isSuspenseInstancePending(state) || $8bd92a9a66fc7c77$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $8bd92a9a66fc7c77$var$renderLanes = 0, $8bd92a9a66fc7c77$var$currentlyRenderingFiber = null, $8bd92a9a66fc7c77$var$currentHook = null, $8bd92a9a66fc7c77$var$workInProgressHook = null, $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdate = !1, $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $8bd92a9a66fc7c77$var$localIdCounter = 0, $8bd92a9a66fc7c77$var$thenableIndexCounter = 0, $8bd92a9a66fc7c77$var$thenableState = null, $8bd92a9a66fc7c77$var$globalClientIdCounter = 0;
function $8bd92a9a66fc7c77$var$throwInvalidHookError() {
    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(321));
}
function $8bd92a9a66fc7c77$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$8bd92a9a66fc7c77$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $8bd92a9a66fc7c77$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $8bd92a9a66fc7c77$var$renderLanes = nextRenderLanes;
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $8bd92a9a66fc7c77$var$HooksDispatcherOnMount : $8bd92a9a66fc7c77$var$HooksDispatcherOnUpdate;
    $8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $8bd92a9a66fc7c77$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $8bd92a9a66fc7c77$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $8bd92a9a66fc7c77$var$finishRenderingHooks(current) {
    $8bd92a9a66fc7c77$var$ReactSharedInternals.H = $8bd92a9a66fc7c77$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $8bd92a9a66fc7c77$var$currentHook && null !== $8bd92a9a66fc7c77$var$currentHook.next;
    $8bd92a9a66fc7c77$var$renderLanes = 0;
    $8bd92a9a66fc7c77$var$workInProgressHook = $8bd92a9a66fc7c77$var$currentHook = $8bd92a9a66fc7c77$var$currentlyRenderingFiber = null;
    $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdate = !1;
    $8bd92a9a66fc7c77$var$thenableIndexCounter = 0;
    $8bd92a9a66fc7c77$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(300));
    null === current || $8bd92a9a66fc7c77$var$didReceiveUpdate || (current = current.dependencies, null !== current && $8bd92a9a66fc7c77$var$checkIfContextChanged(current) && ($8bd92a9a66fc7c77$var$didReceiveUpdate = !0));
}
function $8bd92a9a66fc7c77$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdateDuringThisPass && ($8bd92a9a66fc7c77$var$thenableState = null);
        $8bd92a9a66fc7c77$var$thenableIndexCounter = 0;
        $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $8bd92a9a66fc7c77$var$workInProgressHook = $8bd92a9a66fc7c77$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $8bd92a9a66fc7c77$var$ReactSharedInternals.H = $8bd92a9a66fc7c77$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $8bd92a9a66fc7c77$var$TransitionAwareHostComponent() {
    var dispatcher = $8bd92a9a66fc7c77$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $8bd92a9a66fc7c77$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $8bd92a9a66fc7c77$var$currentHook ? $8bd92a9a66fc7c77$var$currentHook.memoizedState : null) !== dispatcher && ($8bd92a9a66fc7c77$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $8bd92a9a66fc7c77$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $8bd92a9a66fc7c77$var$localIdCounter;
    $8bd92a9a66fc7c77$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $8bd92a9a66fc7c77$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $8bd92a9a66fc7c77$var$resetHooksOnUnwind(workInProgress) {
    if ($8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdate = !1;
    }
    $8bd92a9a66fc7c77$var$renderLanes = 0;
    $8bd92a9a66fc7c77$var$workInProgressHook = $8bd92a9a66fc7c77$var$currentHook = $8bd92a9a66fc7c77$var$currentlyRenderingFiber = null;
    $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $8bd92a9a66fc7c77$var$thenableIndexCounter = $8bd92a9a66fc7c77$var$localIdCounter = 0;
    $8bd92a9a66fc7c77$var$thenableState = null;
}
function $8bd92a9a66fc7c77$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8bd92a9a66fc7c77$var$workInProgressHook ? $8bd92a9a66fc7c77$var$currentlyRenderingFiber.memoizedState = $8bd92a9a66fc7c77$var$workInProgressHook = hook : $8bd92a9a66fc7c77$var$workInProgressHook = $8bd92a9a66fc7c77$var$workInProgressHook.next = hook;
    return $8bd92a9a66fc7c77$var$workInProgressHook;
}
function $8bd92a9a66fc7c77$var$updateWorkInProgressHook() {
    if (null === $8bd92a9a66fc7c77$var$currentHook) {
        var nextCurrentHook = $8bd92a9a66fc7c77$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $8bd92a9a66fc7c77$var$currentHook.next;
    var nextWorkInProgressHook = null === $8bd92a9a66fc7c77$var$workInProgressHook ? $8bd92a9a66fc7c77$var$currentlyRenderingFiber.memoizedState : $8bd92a9a66fc7c77$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $8bd92a9a66fc7c77$var$workInProgressHook = nextWorkInProgressHook, $8bd92a9a66fc7c77$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $8bd92a9a66fc7c77$var$currentlyRenderingFiber.alternate) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(467));
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(310));
        }
        $8bd92a9a66fc7c77$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $8bd92a9a66fc7c77$var$currentHook.memoizedState,
            baseState: $8bd92a9a66fc7c77$var$currentHook.baseState,
            baseQueue: $8bd92a9a66fc7c77$var$currentHook.baseQueue,
            queue: $8bd92a9a66fc7c77$var$currentHook.queue,
            next: null
        };
        null === $8bd92a9a66fc7c77$var$workInProgressHook ? $8bd92a9a66fc7c77$var$currentlyRenderingFiber.memoizedState = $8bd92a9a66fc7c77$var$workInProgressHook = nextCurrentHook : $8bd92a9a66fc7c77$var$workInProgressHook = $8bd92a9a66fc7c77$var$workInProgressHook.next = nextCurrentHook;
    }
    return $8bd92a9a66fc7c77$var$workInProgressHook;
}
function $8bd92a9a66fc7c77$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $8bd92a9a66fc7c77$var$useThenable(thenable) {
    var index = $8bd92a9a66fc7c77$var$thenableIndexCounter;
    $8bd92a9a66fc7c77$var$thenableIndexCounter += 1;
    null === $8bd92a9a66fc7c77$var$thenableState && ($8bd92a9a66fc7c77$var$thenableState = []);
    thenable = $8bd92a9a66fc7c77$var$trackUsedThenable($8bd92a9a66fc7c77$var$thenableState, thenable, index);
    index = $8bd92a9a66fc7c77$var$currentlyRenderingFiber;
    null === (null === $8bd92a9a66fc7c77$var$workInProgressHook ? index.memoizedState : $8bd92a9a66fc7c77$var$workInProgressHook.next) && (index = index.alternate, $8bd92a9a66fc7c77$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $8bd92a9a66fc7c77$var$HooksDispatcherOnMount : $8bd92a9a66fc7c77$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $8bd92a9a66fc7c77$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $8bd92a9a66fc7c77$var$useThenable(usable);
        if (usable.$$typeof === $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE) return $8bd92a9a66fc7c77$var$readContext(usable);
    }
    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(438, String(usable)));
}
function $8bd92a9a66fc7c77$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $8bd92a9a66fc7c77$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $8bd92a9a66fc7c77$var$createFunctionComponentUpdateQueue(), $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $8bd92a9a66fc7c77$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $8bd92a9a66fc7c77$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $8bd92a9a66fc7c77$var$updateReducer(reducer) {
    var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    return $8bd92a9a66fc7c77$var$updateReducerImpl(hook, $8bd92a9a66fc7c77$var$currentHook, reducer);
}
function $8bd92a9a66fc7c77$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($8bd92a9a66fc7c77$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $8bd92a9a66fc7c77$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($8bd92a9a66fc7c77$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $8bd92a9a66fc7c77$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $8bd92a9a66fc7c77$var$currentlyRenderingFiber.lanes |= revertLane, $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $8bd92a9a66fc7c77$var$currentlyRenderingFiber.lanes |= updateLane, $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$8bd92a9a66fc7c77$var$objectIs(pendingQueue, hook.memoizedState) && ($8bd92a9a66fc7c77$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $8bd92a9a66fc7c77$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $8bd92a9a66fc7c77$var$rerenderReducer(reducer) {
    var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $8bd92a9a66fc7c77$var$objectIs(newState, hook.memoizedState) || ($8bd92a9a66fc7c77$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $8bd92a9a66fc7c77$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $8bd92a9a66fc7c77$var$currentlyRenderingFiber, hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $8bd92a9a66fc7c77$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$8bd92a9a66fc7c77$var$objectIs(($8bd92a9a66fc7c77$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $8bd92a9a66fc7c77$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $8bd92a9a66fc7c77$var$updateEffect($8bd92a9a66fc7c77$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $8bd92a9a66fc7c77$var$workInProgressHook && $8bd92a9a66fc7c77$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $8bd92a9a66fc7c77$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $8bd92a9a66fc7c77$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $8bd92a9a66fc7c77$var$workInProgressRoot) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($8bd92a9a66fc7c77$var$renderLanes & 127) || $8bd92a9a66fc7c77$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $8bd92a9a66fc7c77$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $8bd92a9a66fc7c77$var$createFunctionComponentUpdateQueue(), $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $8bd92a9a66fc7c77$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $8bd92a9a66fc7c77$var$checkIfSnapshotChanged(inst) && $8bd92a9a66fc7c77$var$forceStoreRerender(fiber);
}
function $8bd92a9a66fc7c77$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $8bd92a9a66fc7c77$var$checkIfSnapshotChanged(inst) && $8bd92a9a66fc7c77$var$forceStoreRerender(fiber);
    });
}
function $8bd92a9a66fc7c77$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$8bd92a9a66fc7c77$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $8bd92a9a66fc7c77$var$forceStoreRerender(fiber) {
    var root = $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $8bd92a9a66fc7c77$var$mountStateImpl(initialState) {
    var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8bd92a9a66fc7c77$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $8bd92a9a66fc7c77$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $8bd92a9a66fc7c77$var$updateReducerImpl(hook, $8bd92a9a66fc7c77$var$currentHook, "function" === typeof reducer ? reducer : $8bd92a9a66fc7c77$var$basicStateReducer);
}
function $8bd92a9a66fc7c77$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($8bd92a9a66fc7c77$var$isRenderPhaseUpdate(fiber)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $8bd92a9a66fc7c77$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $8bd92a9a66fc7c77$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $8bd92a9a66fc7c77$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $8bd92a9a66fc7c77$var$ReactSharedInternals.T, currentTransition = {};
        $8bd92a9a66fc7c77$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $8bd92a9a66fc7c77$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $8bd92a9a66fc7c77$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $8bd92a9a66fc7c77$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8bd92a9a66fc7c77$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $8bd92a9a66fc7c77$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $8bd92a9a66fc7c77$var$onActionError(actionQueue, node, error$66);
    }
}
function $8bd92a9a66fc7c77$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $8bd92a9a66fc7c77$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $8bd92a9a66fc7c77$var$onActionError(actionQueue, node, error);
    }) : $8bd92a9a66fc7c77$var$onActionSuccess(actionQueue, node, returnValue);
}
function $8bd92a9a66fc7c77$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $8bd92a9a66fc7c77$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $8bd92a9a66fc7c77$var$runActionStateAction(actionQueue, nextState)));
}
function $8bd92a9a66fc7c77$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $8bd92a9a66fc7c77$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $8bd92a9a66fc7c77$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $8bd92a9a66fc7c77$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $8bd92a9a66fc7c77$var$mountActionState(action, initialStateProp) {
    if ($8bd92a9a66fc7c77$var$isHydrating) {
        var ssrFormState = $8bd92a9a66fc7c77$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $8bd92a9a66fc7c77$var$currentlyRenderingFiber;
                if ($8bd92a9a66fc7c77$var$isHydrating) {
                    if ($8bd92a9a66fc7c77$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $8bd92a9a66fc7c77$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $8bd92a9a66fc7c77$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $8bd92a9a66fc7c77$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8bd92a9a66fc7c77$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $8bd92a9a66fc7c77$var$dispatchSetState.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $8bd92a9a66fc7c77$var$mountStateImpl(!1);
    inRootOrSingleton = $8bd92a9a66fc7c77$var$dispatchOptimisticSetState.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $8bd92a9a66fc7c77$var$dispatchActionState.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $8bd92a9a66fc7c77$var$updateActionState(action) {
    var stateHook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    return $8bd92a9a66fc7c77$var$updateActionStateImpl(stateHook, $8bd92a9a66fc7c77$var$currentHook, action);
}
function $8bd92a9a66fc7c77$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $8bd92a9a66fc7c77$var$updateReducerImpl(stateHook, currentStateHook, $8bd92a9a66fc7c77$var$actionStateReducer)[0];
    stateHook = $8bd92a9a66fc7c77$var$updateReducer($8bd92a9a66fc7c77$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $8bd92a9a66fc7c77$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $8bd92a9a66fc7c77$var$SuspenseException) throw $8bd92a9a66fc7c77$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($8bd92a9a66fc7c77$var$currentlyRenderingFiber.flags |= 2048, $8bd92a9a66fc7c77$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $8bd92a9a66fc7c77$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $8bd92a9a66fc7c77$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $8bd92a9a66fc7c77$var$rerenderActionState(action) {
    var stateHook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook(), currentStateHook = $8bd92a9a66fc7c77$var$currentHook;
    if (null !== currentStateHook) return $8bd92a9a66fc7c77$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $8bd92a9a66fc7c77$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $8bd92a9a66fc7c77$var$createFunctionComponentUpdateQueue(), $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $8bd92a9a66fc7c77$var$updateRef() {
    return $8bd92a9a66fc7c77$var$updateWorkInProgressHook().memoizedState;
}
function $8bd92a9a66fc7c77$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $8bd92a9a66fc7c77$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $8bd92a9a66fc7c77$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $8bd92a9a66fc7c77$var$currentHook && null !== deps && $8bd92a9a66fc7c77$var$areHookInputsEqual(deps, $8bd92a9a66fc7c77$var$currentHook.memoizedState.deps) ? hook.memoizedState = $8bd92a9a66fc7c77$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($8bd92a9a66fc7c77$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $8bd92a9a66fc7c77$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $8bd92a9a66fc7c77$var$mountEffect(create, deps) {
    $8bd92a9a66fc7c77$var$mountEffectImpl(8390656, 8, create, deps);
}
function $8bd92a9a66fc7c77$var$updateEffect(create, deps) {
    $8bd92a9a66fc7c77$var$updateEffectImpl(2048, 8, create, deps);
}
function $8bd92a9a66fc7c77$var$useEffectEventImpl(payload) {
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $8bd92a9a66fc7c77$var$createFunctionComponentUpdateQueue(), $8bd92a9a66fc7c77$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $8bd92a9a66fc7c77$var$updateEvent(callback) {
    var ref = $8bd92a9a66fc7c77$var$updateWorkInProgressHook().memoizedState;
    $8bd92a9a66fc7c77$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($8bd92a9a66fc7c77$var$executionContext & 2)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $8bd92a9a66fc7c77$var$updateInsertionEffect(create, deps) {
    return $8bd92a9a66fc7c77$var$updateEffectImpl(4, 2, create, deps);
}
function $8bd92a9a66fc7c77$var$updateLayoutEffect(create, deps) {
    return $8bd92a9a66fc7c77$var$updateEffectImpl(4, 4, create, deps);
}
function $8bd92a9a66fc7c77$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $8bd92a9a66fc7c77$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $8bd92a9a66fc7c77$var$updateEffectImpl(4, 4, $8bd92a9a66fc7c77$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $8bd92a9a66fc7c77$var$mountDebugValue() {}
function $8bd92a9a66fc7c77$var$updateCallback(callback, deps) {
    var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8bd92a9a66fc7c77$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $8bd92a9a66fc7c77$var$updateMemo(nextCreate, deps) {
    var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8bd92a9a66fc7c77$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $8bd92a9a66fc7c77$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($8bd92a9a66fc7c77$var$renderLanes & 1073741824) && 0 === ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $8bd92a9a66fc7c77$var$requestDeferredLane();
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber.lanes |= hook;
    $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $8bd92a9a66fc7c77$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($8bd92a9a66fc7c77$var$objectIs(value, prevValue)) return value;
    if (null !== $8bd92a9a66fc7c77$var$currentTreeHiddenStackCursor.current) return hook = $8bd92a9a66fc7c77$var$mountDeferredValueImpl(hook, value, initialValue), $8bd92a9a66fc7c77$var$objectIs(hook, prevValue) || ($8bd92a9a66fc7c77$var$didReceiveUpdate = !0), hook;
    if (0 === ($8bd92a9a66fc7c77$var$renderLanes & 42) || 0 !== ($8bd92a9a66fc7c77$var$renderLanes & 1073741824) && 0 === ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 261930)) return $8bd92a9a66fc7c77$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $8bd92a9a66fc7c77$var$requestDeferredLane();
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber.lanes |= hook;
    $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $8bd92a9a66fc7c77$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
    $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $8bd92a9a66fc7c77$var$ReactSharedInternals.T, currentTransition = {};
    $8bd92a9a66fc7c77$var$ReactSharedInternals.T = currentTransition;
    $8bd92a9a66fc7c77$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $8bd92a9a66fc7c77$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $8bd92a9a66fc7c77$var$chainThenableValue(returnValue, finishedState);
            $8bd92a9a66fc7c77$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $8bd92a9a66fc7c77$var$requestUpdateLane(fiber));
        } else $8bd92a9a66fc7c77$var$dispatchSetStateInternal(fiber, queue, finishedState, $8bd92a9a66fc7c77$var$requestUpdateLane(fiber));
    } catch (error) {
        $8bd92a9a66fc7c77$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $8bd92a9a66fc7c77$var$requestUpdateLane());
    } finally{
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8bd92a9a66fc7c77$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8bd92a9a66fc7c77$var$noop() {}
function $8bd92a9a66fc7c77$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(476));
    var queue = $8bd92a9a66fc7c77$var$ensureFormComponentIsStateful(formFiber).queue;
    $8bd92a9a66fc7c77$var$startTransition(formFiber, queue, pendingState, $8bd92a9a66fc7c77$var$sharedNotPendingObject, null === action ? $8bd92a9a66fc7c77$var$noop : function() {
        $8bd92a9a66fc7c77$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $8bd92a9a66fc7c77$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $8bd92a9a66fc7c77$var$sharedNotPendingObject,
        baseState: $8bd92a9a66fc7c77$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8bd92a9a66fc7c77$var$basicStateReducer,
            lastRenderedState: $8bd92a9a66fc7c77$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8bd92a9a66fc7c77$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $8bd92a9a66fc7c77$var$requestFormReset$1(formFiber) {
    var stateHook = $8bd92a9a66fc7c77$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $8bd92a9a66fc7c77$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $8bd92a9a66fc7c77$var$requestUpdateLane());
}
function $8bd92a9a66fc7c77$var$useHostTransitionStatus() {
    return $8bd92a9a66fc7c77$var$readContext($8bd92a9a66fc7c77$var$HostTransitionContext);
}
function $8bd92a9a66fc7c77$var$updateId() {
    return $8bd92a9a66fc7c77$var$updateWorkInProgressHook().memoizedState;
}
function $8bd92a9a66fc7c77$var$updateRefresh() {
    return $8bd92a9a66fc7c77$var$updateWorkInProgressHook().memoizedState;
}
function $8bd92a9a66fc7c77$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $8bd92a9a66fc7c77$var$requestUpdateLane();
                fiber = $8bd92a9a66fc7c77$var$createUpdate(lane);
                var root$69 = $8bd92a9a66fc7c77$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(root$69, provider, lane), $8bd92a9a66fc7c77$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $8bd92a9a66fc7c77$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $8bd92a9a66fc7c77$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $8bd92a9a66fc7c77$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $8bd92a9a66fc7c77$var$isRenderPhaseUpdate(fiber) ? $8bd92a9a66fc7c77$var$enqueueRenderPhaseUpdate(queue, action) : (action = $8bd92a9a66fc7c77$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(action, fiber, lane), $8bd92a9a66fc7c77$var$entangleTransitionUpdate(action, queue, lane)));
}
function $8bd92a9a66fc7c77$var$dispatchSetState(fiber, queue, action) {
    var lane = $8bd92a9a66fc7c77$var$requestUpdateLane();
    $8bd92a9a66fc7c77$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $8bd92a9a66fc7c77$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8bd92a9a66fc7c77$var$isRenderPhaseUpdate(fiber)) $8bd92a9a66fc7c77$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($8bd92a9a66fc7c77$var$objectIs(eagerState, currentState)) return $8bd92a9a66fc7c77$var$enqueueUpdate$1(fiber, queue, update, 0), null === $8bd92a9a66fc7c77$var$workInProgressRoot && $8bd92a9a66fc7c77$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $8bd92a9a66fc7c77$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(action, fiber, lane), $8bd92a9a66fc7c77$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $8bd92a9a66fc7c77$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $8bd92a9a66fc7c77$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8bd92a9a66fc7c77$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $8bd92a9a66fc7c77$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $8bd92a9a66fc7c77$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $8bd92a9a66fc7c77$var$currentlyRenderingFiber || null !== alternate && alternate === $8bd92a9a66fc7c77$var$currentlyRenderingFiber;
}
function $8bd92a9a66fc7c77$var$enqueueRenderPhaseUpdate(queue, update) {
    $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdateDuringThisPass = $8bd92a9a66fc7c77$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $8bd92a9a66fc7c77$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $8bd92a9a66fc7c77$var$markRootEntangled(root, lane);
    }
}
var $8bd92a9a66fc7c77$var$ContextOnlyDispatcher = {
    readContext: $8bd92a9a66fc7c77$var$readContext,
    use: $8bd92a9a66fc7c77$var$use,
    useCallback: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useContext: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useEffect: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useImperativeHandle: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useLayoutEffect: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useInsertionEffect: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useMemo: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useReducer: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useRef: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useState: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useDebugValue: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useDeferredValue: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useTransition: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useSyncExternalStore: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useId: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useHostTransitionStatus: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useFormState: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useActionState: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useOptimistic: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useMemoCache: $8bd92a9a66fc7c77$var$throwInvalidHookError,
    useCacheRefresh: $8bd92a9a66fc7c77$var$throwInvalidHookError
};
$8bd92a9a66fc7c77$var$ContextOnlyDispatcher.useEffectEvent = $8bd92a9a66fc7c77$var$throwInvalidHookError;
var $8bd92a9a66fc7c77$var$HooksDispatcherOnMount = {
    readContext: $8bd92a9a66fc7c77$var$readContext,
    use: $8bd92a9a66fc7c77$var$use,
    useCallback: function(callback, deps) {
        $8bd92a9a66fc7c77$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $8bd92a9a66fc7c77$var$readContext,
    useEffect: $8bd92a9a66fc7c77$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $8bd92a9a66fc7c77$var$mountEffectImpl(4194308, 4, $8bd92a9a66fc7c77$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $8bd92a9a66fc7c77$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $8bd92a9a66fc7c77$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($8bd92a9a66fc7c77$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $8bd92a9a66fc7c77$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $8bd92a9a66fc7c77$var$dispatchReducerAction.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $8bd92a9a66fc7c77$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $8bd92a9a66fc7c77$var$dispatchSetState.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $8bd92a9a66fc7c77$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
        return $8bd92a9a66fc7c77$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $8bd92a9a66fc7c77$var$mountStateImpl(!1);
        stateHook = $8bd92a9a66fc7c77$var$startTransition.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $8bd92a9a66fc7c77$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $8bd92a9a66fc7c77$var$currentlyRenderingFiber, hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
        if ($8bd92a9a66fc7c77$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $8bd92a9a66fc7c77$var$workInProgressRoot) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(349));
            0 !== ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 127) || $8bd92a9a66fc7c77$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $8bd92a9a66fc7c77$var$mountEffect($8bd92a9a66fc7c77$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $8bd92a9a66fc7c77$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $8bd92a9a66fc7c77$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook(), identifierPrefix = $8bd92a9a66fc7c77$var$workInProgressRoot.identifierPrefix;
        if ($8bd92a9a66fc7c77$var$isHydrating) {
            var JSCompiler_inline_result = $8bd92a9a66fc7c77$var$treeContextOverflow;
            var idWithLeadingBit = $8bd92a9a66fc7c77$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $8bd92a9a66fc7c77$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $8bd92a9a66fc7c77$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $8bd92a9a66fc7c77$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $8bd92a9a66fc7c77$var$useHostTransitionStatus,
    useFormState: $8bd92a9a66fc7c77$var$mountActionState,
    useActionState: $8bd92a9a66fc7c77$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $8bd92a9a66fc7c77$var$dispatchOptimisticSetState.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $8bd92a9a66fc7c77$var$useMemoCache,
    useCacheRefresh: function() {
        return $8bd92a9a66fc7c77$var$mountWorkInProgressHook().memoizedState = $8bd92a9a66fc7c77$var$refreshCache.bind(null, $8bd92a9a66fc7c77$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $8bd92a9a66fc7c77$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($8bd92a9a66fc7c77$var$executionContext & 2)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $8bd92a9a66fc7c77$var$HooksDispatcherOnUpdate = {
    readContext: $8bd92a9a66fc7c77$var$readContext,
    use: $8bd92a9a66fc7c77$var$use,
    useCallback: $8bd92a9a66fc7c77$var$updateCallback,
    useContext: $8bd92a9a66fc7c77$var$readContext,
    useEffect: $8bd92a9a66fc7c77$var$updateEffect,
    useImperativeHandle: $8bd92a9a66fc7c77$var$updateImperativeHandle,
    useInsertionEffect: $8bd92a9a66fc7c77$var$updateInsertionEffect,
    useLayoutEffect: $8bd92a9a66fc7c77$var$updateLayoutEffect,
    useMemo: $8bd92a9a66fc7c77$var$updateMemo,
    useReducer: $8bd92a9a66fc7c77$var$updateReducer,
    useRef: $8bd92a9a66fc7c77$var$updateRef,
    useState: function() {
        return $8bd92a9a66fc7c77$var$updateReducer($8bd92a9a66fc7c77$var$basicStateReducer);
    },
    useDebugValue: $8bd92a9a66fc7c77$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
        return $8bd92a9a66fc7c77$var$updateDeferredValueImpl(hook, $8bd92a9a66fc7c77$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8bd92a9a66fc7c77$var$updateReducer($8bd92a9a66fc7c77$var$basicStateReducer)[0], start = $8bd92a9a66fc7c77$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8bd92a9a66fc7c77$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8bd92a9a66fc7c77$var$updateSyncExternalStore,
    useId: $8bd92a9a66fc7c77$var$updateId,
    useHostTransitionStatus: $8bd92a9a66fc7c77$var$useHostTransitionStatus,
    useFormState: $8bd92a9a66fc7c77$var$updateActionState,
    useActionState: $8bd92a9a66fc7c77$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
        return $8bd92a9a66fc7c77$var$updateOptimisticImpl(hook, $8bd92a9a66fc7c77$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $8bd92a9a66fc7c77$var$useMemoCache,
    useCacheRefresh: $8bd92a9a66fc7c77$var$updateRefresh
};
$8bd92a9a66fc7c77$var$HooksDispatcherOnUpdate.useEffectEvent = $8bd92a9a66fc7c77$var$updateEvent;
var $8bd92a9a66fc7c77$var$HooksDispatcherOnRerender = {
    readContext: $8bd92a9a66fc7c77$var$readContext,
    use: $8bd92a9a66fc7c77$var$use,
    useCallback: $8bd92a9a66fc7c77$var$updateCallback,
    useContext: $8bd92a9a66fc7c77$var$readContext,
    useEffect: $8bd92a9a66fc7c77$var$updateEffect,
    useImperativeHandle: $8bd92a9a66fc7c77$var$updateImperativeHandle,
    useInsertionEffect: $8bd92a9a66fc7c77$var$updateInsertionEffect,
    useLayoutEffect: $8bd92a9a66fc7c77$var$updateLayoutEffect,
    useMemo: $8bd92a9a66fc7c77$var$updateMemo,
    useReducer: $8bd92a9a66fc7c77$var$rerenderReducer,
    useRef: $8bd92a9a66fc7c77$var$updateRef,
    useState: function() {
        return $8bd92a9a66fc7c77$var$rerenderReducer($8bd92a9a66fc7c77$var$basicStateReducer);
    },
    useDebugValue: $8bd92a9a66fc7c77$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
        return null === $8bd92a9a66fc7c77$var$currentHook ? $8bd92a9a66fc7c77$var$mountDeferredValueImpl(hook, value, initialValue) : $8bd92a9a66fc7c77$var$updateDeferredValueImpl(hook, $8bd92a9a66fc7c77$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8bd92a9a66fc7c77$var$rerenderReducer($8bd92a9a66fc7c77$var$basicStateReducer)[0], start = $8bd92a9a66fc7c77$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8bd92a9a66fc7c77$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8bd92a9a66fc7c77$var$updateSyncExternalStore,
    useId: $8bd92a9a66fc7c77$var$updateId,
    useHostTransitionStatus: $8bd92a9a66fc7c77$var$useHostTransitionStatus,
    useFormState: $8bd92a9a66fc7c77$var$rerenderActionState,
    useActionState: $8bd92a9a66fc7c77$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8bd92a9a66fc7c77$var$updateWorkInProgressHook();
        if (null !== $8bd92a9a66fc7c77$var$currentHook) return $8bd92a9a66fc7c77$var$updateOptimisticImpl(hook, $8bd92a9a66fc7c77$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $8bd92a9a66fc7c77$var$useMemoCache,
    useCacheRefresh: $8bd92a9a66fc7c77$var$updateRefresh
};
$8bd92a9a66fc7c77$var$HooksDispatcherOnRerender.useEffectEvent = $8bd92a9a66fc7c77$var$updateEvent;
function $8bd92a9a66fc7c77$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $8bd92a9a66fc7c77$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $8bd92a9a66fc7c77$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8bd92a9a66fc7c77$var$requestUpdateLane(), update = $8bd92a9a66fc7c77$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8bd92a9a66fc7c77$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(payload, inst, lane), $8bd92a9a66fc7c77$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8bd92a9a66fc7c77$var$requestUpdateLane(), update = $8bd92a9a66fc7c77$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8bd92a9a66fc7c77$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(payload, inst, lane), $8bd92a9a66fc7c77$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $8bd92a9a66fc7c77$var$requestUpdateLane(), update = $8bd92a9a66fc7c77$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $8bd92a9a66fc7c77$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(callback, inst, lane), $8bd92a9a66fc7c77$var$entangleTransitions(callback, inst, lane));
    }
};
function $8bd92a9a66fc7c77$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$8bd92a9a66fc7c77$var$shallowEqual(oldProps, newProps) || !$8bd92a9a66fc7c77$var$shallowEqual(oldState, newState) : !0;
}
function $8bd92a9a66fc7c77$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $8bd92a9a66fc7c77$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $8bd92a9a66fc7c77$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $8bd92a9a66fc7c77$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $8bd92a9a66fc7c77$var$defaultOnUncaughtError(error) {
    $8bd92a9a66fc7c77$var$reportGlobalError(error);
}
function $8bd92a9a66fc7c77$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $8bd92a9a66fc7c77$var$defaultOnRecoverableError(error) {
    $8bd92a9a66fc7c77$var$reportGlobalError(error);
}
function $8bd92a9a66fc7c77$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $8bd92a9a66fc7c77$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $8bd92a9a66fc7c77$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $8bd92a9a66fc7c77$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $8bd92a9a66fc7c77$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $8bd92a9a66fc7c77$var$createClassErrorUpdate(lane) {
    lane = $8bd92a9a66fc7c77$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $8bd92a9a66fc7c77$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $8bd92a9a66fc7c77$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $8bd92a9a66fc7c77$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed ? $8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $8bd92a9a66fc7c77$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $8bd92a9a66fc7c77$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $8bd92a9a66fc7c77$var$shellBoundary ? $8bd92a9a66fc7c77$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $8bd92a9a66fc7c77$var$workInProgressRootExitStatus && ($8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $8bd92a9a66fc7c77$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $8bd92a9a66fc7c77$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $8bd92a9a66fc7c77$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $8bd92a9a66fc7c77$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $8bd92a9a66fc7c77$var$attachPingListener(root, value, rootRenderLanes);
        $8bd92a9a66fc7c77$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($8bd92a9a66fc7c77$var$isHydrating) return returnFiber = $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $8bd92a9a66fc7c77$var$HydrationMismatchException && (root = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(422), {
        cause: value
    }), $8bd92a9a66fc7c77$var$queueHydrationError($8bd92a9a66fc7c77$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $8bd92a9a66fc7c77$var$HydrationMismatchException && (returnFiber = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(423), {
        cause: value
    }), $8bd92a9a66fc7c77$var$queueHydrationError($8bd92a9a66fc7c77$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $8bd92a9a66fc7c77$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $8bd92a9a66fc7c77$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $8bd92a9a66fc7c77$var$workInProgressRootExitStatus && ($8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $8bd92a9a66fc7c77$var$workInProgressRootConcurrentErrors ? $8bd92a9a66fc7c77$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $8bd92a9a66fc7c77$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $8bd92a9a66fc7c77$var$workInProgressRootExitStatus && ($8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $8bd92a9a66fc7c77$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $8bd92a9a66fc7c77$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed || !$8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $8bd92a9a66fc7c77$var$createClassErrorUpdate(rootRenderLanes), $8bd92a9a66fc7c77$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $8bd92a9a66fc7c77$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $8bd92a9a66fc7c77$var$SelectiveHydrationException = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(461)), $8bd92a9a66fc7c77$var$didReceiveUpdate = !1;
function $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $8bd92a9a66fc7c77$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $8bd92a9a66fc7c77$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $8bd92a9a66fc7c77$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $8bd92a9a66fc7c77$var$prepareToReadContext(workInProgress);
    nextProps = $8bd92a9a66fc7c77$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $8bd92a9a66fc7c77$var$checkDidRenderIdHook();
    if (null !== current && !$8bd92a9a66fc7c77$var$didReceiveUpdate) return $8bd92a9a66fc7c77$var$bailoutHooks(current, workInProgress, renderLanes), $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8bd92a9a66fc7c77$var$isHydrating && key && $8bd92a9a66fc7c77$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8bd92a9a66fc7c77$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$8bd92a9a66fc7c77$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $8bd92a9a66fc7c77$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $8bd92a9a66fc7c77$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$8bd92a9a66fc7c77$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $8bd92a9a66fc7c77$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $8bd92a9a66fc7c77$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $8bd92a9a66fc7c77$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($8bd92a9a66fc7c77$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($8bd92a9a66fc7c77$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $8bd92a9a66fc7c77$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($8bd92a9a66fc7c77$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $8bd92a9a66fc7c77$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $8bd92a9a66fc7c77$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $8bd92a9a66fc7c77$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $8bd92a9a66fc7c77$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $8bd92a9a66fc7c77$var$pushHiddenContext(workInProgress, prevState) : $8bd92a9a66fc7c77$var$reuseHiddenContextOnStack(), $8bd92a9a66fc7c77$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $8bd92a9a66fc7c77$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($8bd92a9a66fc7c77$var$pushTransition(workInProgress, prevState.cachePool), $8bd92a9a66fc7c77$var$pushHiddenContext(workInProgress, prevState), $8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $8bd92a9a66fc7c77$var$pushTransition(workInProgress, null), $8bd92a9a66fc7c77$var$reuseHiddenContextOnStack(), $8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(workInProgress));
    $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $8bd92a9a66fc7c77$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $8bd92a9a66fc7c77$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $8bd92a9a66fc7c77$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $8bd92a9a66fc7c77$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $8bd92a9a66fc7c77$var$pushTransition(workInProgress, null);
    $8bd92a9a66fc7c77$var$reuseHiddenContextOnStack();
    $8bd92a9a66fc7c77$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $8bd92a9a66fc7c77$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $8bd92a9a66fc7c77$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $8bd92a9a66fc7c77$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $8bd92a9a66fc7c77$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8bd92a9a66fc7c77$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8bd92a9a66fc7c77$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $8bd92a9a66fc7c77$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($8bd92a9a66fc7c77$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $8bd92a9a66fc7c77$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $8bd92a9a66fc7c77$var$bailoutOffscreenComponent(null, current);
            $8bd92a9a66fc7c77$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $8bd92a9a66fc7c77$var$nextHydratableInstance) ? (current = $8bd92a9a66fc7c77$var$canHydrateHydrationBoundary(current, $8bd92a9a66fc7c77$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8bd92a9a66fc7c77$var$treeContextProvider ? {
                    id: $8bd92a9a66fc7c77$var$treeContextId,
                    overflow: $8bd92a9a66fc7c77$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8bd92a9a66fc7c77$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress, $8bd92a9a66fc7c77$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $8bd92a9a66fc7c77$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $8bd92a9a66fc7c77$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $8bd92a9a66fc7c77$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(558));
        } else if ($8bd92a9a66fc7c77$var$didReceiveUpdate || $8bd92a9a66fc7c77$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $8bd92a9a66fc7c77$var$didReceiveUpdate || didSuspend) {
            nextProps = $8bd92a9a66fc7c77$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $8bd92a9a66fc7c77$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(current, dehydrated), $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $8bd92a9a66fc7c77$var$SelectiveHydrationException;
            $8bd92a9a66fc7c77$var$renderDidSuspendDelayIfPossible();
            workInProgress = $8bd92a9a66fc7c77$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratable(dehydrated.nextSibling), $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress, $8bd92a9a66fc7c77$var$isHydrating = !0, $8bd92a9a66fc7c77$var$hydrationErrors = null, $8bd92a9a66fc7c77$var$rootOrSingletonContext = !1, null !== current && $8bd92a9a66fc7c77$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $8bd92a9a66fc7c77$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $8bd92a9a66fc7c77$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $8bd92a9a66fc7c77$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $8bd92a9a66fc7c77$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8bd92a9a66fc7c77$var$prepareToReadContext(workInProgress);
    Component = $8bd92a9a66fc7c77$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $8bd92a9a66fc7c77$var$checkDidRenderIdHook();
    if (null !== current && !$8bd92a9a66fc7c77$var$didReceiveUpdate) return $8bd92a9a66fc7c77$var$bailoutHooks(current, workInProgress, renderLanes), $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8bd92a9a66fc7c77$var$isHydrating && nextProps && $8bd92a9a66fc7c77$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $8bd92a9a66fc7c77$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $8bd92a9a66fc7c77$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $8bd92a9a66fc7c77$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $8bd92a9a66fc7c77$var$finishRenderingHooks(current);
    Component = $8bd92a9a66fc7c77$var$checkDidRenderIdHook();
    if (null !== current && !$8bd92a9a66fc7c77$var$didReceiveUpdate) return $8bd92a9a66fc7c77$var$bailoutHooks(current, workInProgress, renderLanes), $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8bd92a9a66fc7c77$var$isHydrating && Component && $8bd92a9a66fc7c77$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8bd92a9a66fc7c77$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8bd92a9a66fc7c77$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $8bd92a9a66fc7c77$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $8bd92a9a66fc7c77$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $8bd92a9a66fc7c77$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $8bd92a9a66fc7c77$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $8bd92a9a66fc7c77$var$readContext(contextType) : $8bd92a9a66fc7c77$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($8bd92a9a66fc7c77$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $8bd92a9a66fc7c77$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $8bd92a9a66fc7c77$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $8bd92a9a66fc7c77$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $8bd92a9a66fc7c77$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $8bd92a9a66fc7c77$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $8bd92a9a66fc7c77$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $8bd92a9a66fc7c77$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $8bd92a9a66fc7c77$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8bd92a9a66fc7c77$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8bd92a9a66fc7c77$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $8bd92a9a66fc7c77$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($8bd92a9a66fc7c77$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $8bd92a9a66fc7c77$var$hasForceUpdate || $8bd92a9a66fc7c77$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $8bd92a9a66fc7c77$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $8bd92a9a66fc7c77$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $8bd92a9a66fc7c77$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $8bd92a9a66fc7c77$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $8bd92a9a66fc7c77$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $8bd92a9a66fc7c77$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8bd92a9a66fc7c77$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8bd92a9a66fc7c77$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $8bd92a9a66fc7c77$var$hasForceUpdate || null !== current && null !== current.dependencies && $8bd92a9a66fc7c77$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($8bd92a9a66fc7c77$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $8bd92a9a66fc7c77$var$hasForceUpdate || $8bd92a9a66fc7c77$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $8bd92a9a66fc7c77$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $8bd92a9a66fc7c77$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $8bd92a9a66fc7c77$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $8bd92a9a66fc7c77$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $8bd92a9a66fc7c77$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $8bd92a9a66fc7c77$var$resetHydrationState();
    workInProgress.flags |= 256;
    $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $8bd92a9a66fc7c77$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $8bd92a9a66fc7c77$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $8bd92a9a66fc7c77$var$getSuspendedCache()
    };
}
function $8bd92a9a66fc7c77$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $8bd92a9a66fc7c77$var$workInProgressDeferredLane);
    return current;
}
function $8bd92a9a66fc7c77$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($8bd92a9a66fc7c77$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($8bd92a9a66fc7c77$var$isHydrating) {
            showFallback ? $8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $8bd92a9a66fc7c77$var$nextHydratableInstance) ? (current = $8bd92a9a66fc7c77$var$canHydrateHydrationBoundary(current, $8bd92a9a66fc7c77$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8bd92a9a66fc7c77$var$treeContextProvider ? {
                    id: $8bd92a9a66fc7c77$var$treeContextId,
                    overflow: $8bd92a9a66fc7c77$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8bd92a9a66fc7c77$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress, $8bd92a9a66fc7c77$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(workInProgress);
            $8bd92a9a66fc7c77$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $8bd92a9a66fc7c77$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $8bd92a9a66fc7c77$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $8bd92a9a66fc7c77$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8bd92a9a66fc7c77$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8bd92a9a66fc7c77$var$SUSPENDED_MARKER, $8bd92a9a66fc7c77$var$bailoutOffscreenComponent(null, nextProps);
        $8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $8bd92a9a66fc7c77$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $8bd92a9a66fc7c77$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $8bd92a9a66fc7c77$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $8bd92a9a66fc7c77$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $8bd92a9a66fc7c77$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $8bd92a9a66fc7c77$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8bd92a9a66fc7c77$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8bd92a9a66fc7c77$var$SUSPENDED_MARKER, workInProgress = $8bd92a9a66fc7c77$var$bailoutOffscreenComponent(null, nextProps));
        else if ($8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress), $8bd92a9a66fc7c77$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $8bd92a9a66fc7c77$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $8bd92a9a66fc7c77$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($8bd92a9a66fc7c77$var$didReceiveUpdate || $8bd92a9a66fc7c77$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $8bd92a9a66fc7c77$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $8bd92a9a66fc7c77$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $8bd92a9a66fc7c77$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(current, nextProps), $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $8bd92a9a66fc7c77$var$SelectiveHydrationException;
            $8bd92a9a66fc7c77$var$isSuspenseInstancePending(nextPrimaryChildren) || $8bd92a9a66fc7c77$var$renderDidSuspendDelayIfPossible();
            workInProgress = $8bd92a9a66fc7c77$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $8bd92a9a66fc7c77$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratable(nextPrimaryChildren.nextSibling), $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress, $8bd92a9a66fc7c77$var$isHydrating = !0, $8bd92a9a66fc7c77$var$hydrationErrors = null, $8bd92a9a66fc7c77$var$rootOrSingletonContext = !1, null !== current && $8bd92a9a66fc7c77$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $8bd92a9a66fc7c77$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $8bd92a9a66fc7c77$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $8bd92a9a66fc7c77$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $8bd92a9a66fc7c77$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $8bd92a9a66fc7c77$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $8bd92a9a66fc7c77$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $8bd92a9a66fc7c77$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $8bd92a9a66fc7c77$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $8bd92a9a66fc7c77$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $8bd92a9a66fc7c77$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8bd92a9a66fc7c77$var$SUSPENDED_MARKER, $8bd92a9a66fc7c77$var$bailoutOffscreenComponent(current.child, nextProps);
    $8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $8bd92a9a66fc7c77$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $8bd92a9a66fc7c77$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $8bd92a9a66fc7c77$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $8bd92a9a66fc7c77$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $8bd92a9a66fc7c77$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $8bd92a9a66fc7c77$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8bd92a9a66fc7c77$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8bd92a9a66fc7c77$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $8bd92a9a66fc7c77$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $8bd92a9a66fc7c77$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $8bd92a9a66fc7c77$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $8bd92a9a66fc7c77$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $8bd92a9a66fc7c77$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, suspenseContext);
    $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $8bd92a9a66fc7c77$var$isHydrating ? $8bd92a9a66fc7c77$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $8bd92a9a66fc7c77$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $8bd92a9a66fc7c77$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $8bd92a9a66fc7c77$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $8bd92a9a66fc7c77$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $8bd92a9a66fc7c77$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $8bd92a9a66fc7c77$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $8bd92a9a66fc7c77$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($8bd92a9a66fc7c77$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $8bd92a9a66fc7c77$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $8bd92a9a66fc7c77$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $8bd92a9a66fc7c77$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $8bd92a9a66fc7c77$var$checkIfContextChanged(current) ? !0 : !1;
}
function $8bd92a9a66fc7c77$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $8bd92a9a66fc7c77$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $8bd92a9a66fc7c77$var$pushProvider(workInProgress, $8bd92a9a66fc7c77$var$CacheContext, current.memoizedState.cache);
            $8bd92a9a66fc7c77$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $8bd92a9a66fc7c77$var$pushHostContext(workInProgress);
            break;
        case 4:
            $8bd92a9a66fc7c77$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $8bd92a9a66fc7c77$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $8bd92a9a66fc7c77$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $8bd92a9a66fc7c77$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $8bd92a9a66fc7c77$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($8bd92a9a66fc7c77$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $8bd92a9a66fc7c77$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, $8bd92a9a66fc7c77$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $8bd92a9a66fc7c77$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $8bd92a9a66fc7c77$var$pushProvider(workInProgress, $8bd92a9a66fc7c77$var$CacheContext, current.memoizedState.cache);
    }
    return $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $8bd92a9a66fc7c77$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $8bd92a9a66fc7c77$var$didReceiveUpdate = !0;
        else {
            if (!$8bd92a9a66fc7c77$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $8bd92a9a66fc7c77$var$didReceiveUpdate = !1, $8bd92a9a66fc7c77$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $8bd92a9a66fc7c77$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $8bd92a9a66fc7c77$var$didReceiveUpdate = !1, $8bd92a9a66fc7c77$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $8bd92a9a66fc7c77$var$pushTreeId(workInProgress, $8bd92a9a66fc7c77$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $8bd92a9a66fc7c77$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $8bd92a9a66fc7c77$var$shouldConstruct(current) ? (props = $8bd92a9a66fc7c77$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $8bd92a9a66fc7c77$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $8bd92a9a66fc7c77$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $8bd92a9a66fc7c77$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $8bd92a9a66fc7c77$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $8bd92a9a66fc7c77$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $8bd92a9a66fc7c77$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $8bd92a9a66fc7c77$var$getComponentNameFromType(current) || current;
                    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $8bd92a9a66fc7c77$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $8bd92a9a66fc7c77$var$resolveClassComponentProps(props, workInProgress.pendingProps), $8bd92a9a66fc7c77$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $8bd92a9a66fc7c77$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $8bd92a9a66fc7c77$var$cloneUpdateQueue(current, workInProgress);
                $8bd92a9a66fc7c77$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $8bd92a9a66fc7c77$var$pushProvider(workInProgress, $8bd92a9a66fc7c77$var$CacheContext, props);
                props !== prevState.cache && $8bd92a9a66fc7c77$var$propagateContextChanges(workInProgress, [
                    $8bd92a9a66fc7c77$var$CacheContext
                ], renderLanes, !0);
                $8bd92a9a66fc7c77$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $8bd92a9a66fc7c77$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(424)), workInProgress);
                        $8bd92a9a66fc7c77$var$queueHydrationError($$typeof);
                        workInProgress = $8bd92a9a66fc7c77$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratable(current.firstChild);
                        $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress;
                        $8bd92a9a66fc7c77$var$isHydrating = !0;
                        $8bd92a9a66fc7c77$var$hydrationErrors = null;
                        $8bd92a9a66fc7c77$var$rootOrSingletonContext = !0;
                        renderLanes = $8bd92a9a66fc7c77$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $8bd92a9a66fc7c77$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $8bd92a9a66fc7c77$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $8bd92a9a66fc7c77$var$markRef(current, workInProgress), null === current ? (renderLanes = $8bd92a9a66fc7c77$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $8bd92a9a66fc7c77$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $8bd92a9a66fc7c77$var$getOwnerDocumentFromRootContainer($8bd92a9a66fc7c77$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$8bd92a9a66fc7c77$var$internalInstanceKey] = workInProgress, props[$8bd92a9a66fc7c77$var$internalPropsKey] = current, $8bd92a9a66fc7c77$var$setInitialProperties(props, renderLanes, current), $8bd92a9a66fc7c77$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $8bd92a9a66fc7c77$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $8bd92a9a66fc7c77$var$pushHostContext(workInProgress), null === current && $8bd92a9a66fc7c77$var$isHydrating && (props = workInProgress.stateNode = $8bd92a9a66fc7c77$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $8bd92a9a66fc7c77$var$rootInstanceStackCursor.current), $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress, $8bd92a9a66fc7c77$var$rootOrSingletonContext = !0, $$typeof = $8bd92a9a66fc7c77$var$nextHydratableInstance, $8bd92a9a66fc7c77$var$isSingletonScope(workInProgress.type) ? ($8bd92a9a66fc7c77$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratable(props.firstChild)) : $8bd92a9a66fc7c77$var$nextHydratableInstance = $$typeof), $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $8bd92a9a66fc7c77$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $8bd92a9a66fc7c77$var$isHydrating) {
                if ($$typeof = props = $8bd92a9a66fc7c77$var$nextHydratableInstance) props = $8bd92a9a66fc7c77$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $8bd92a9a66fc7c77$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress, $8bd92a9a66fc7c77$var$nextHydratableInstance = $8bd92a9a66fc7c77$var$getNextHydratable(props.firstChild), $8bd92a9a66fc7c77$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(workInProgress);
            }
            $8bd92a9a66fc7c77$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $8bd92a9a66fc7c77$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $8bd92a9a66fc7c77$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $8bd92a9a66fc7c77$var$renderWithHooks(current, workInProgress, $8bd92a9a66fc7c77$var$TransitionAwareHostComponent, null, null, renderLanes), $8bd92a9a66fc7c77$var$HostTransitionContext._currentValue = $$typeof);
            $8bd92a9a66fc7c77$var$markRef(current, workInProgress);
            $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $8bd92a9a66fc7c77$var$isHydrating) {
                if (current = renderLanes = $8bd92a9a66fc7c77$var$nextHydratableInstance) renderLanes = $8bd92a9a66fc7c77$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $8bd92a9a66fc7c77$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $8bd92a9a66fc7c77$var$hydrationParentFiber = workInProgress, $8bd92a9a66fc7c77$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $8bd92a9a66fc7c77$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $8bd92a9a66fc7c77$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $8bd92a9a66fc7c77$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $8bd92a9a66fc7c77$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $8bd92a9a66fc7c77$var$pushProvider(workInProgress, workInProgress.type, props.value), $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $8bd92a9a66fc7c77$var$prepareToReadContext(workInProgress), $$typeof = $8bd92a9a66fc7c77$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $8bd92a9a66fc7c77$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $8bd92a9a66fc7c77$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $8bd92a9a66fc7c77$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $8bd92a9a66fc7c77$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $8bd92a9a66fc7c77$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $8bd92a9a66fc7c77$var$prepareToReadContext(workInProgress), props = $8bd92a9a66fc7c77$var$readContext($8bd92a9a66fc7c77$var$CacheContext), null === current ? ($$typeof = $8bd92a9a66fc7c77$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $8bd92a9a66fc7c77$var$workInProgressRoot, prevState = $8bd92a9a66fc7c77$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $8bd92a9a66fc7c77$var$initializeUpdateQueue(workInProgress), $8bd92a9a66fc7c77$var$pushProvider(workInProgress, $8bd92a9a66fc7c77$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($8bd92a9a66fc7c77$var$cloneUpdateQueue(current, workInProgress), $8bd92a9a66fc7c77$var$processUpdateQueue(workInProgress, null, null, renderLanes), $8bd92a9a66fc7c77$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $8bd92a9a66fc7c77$var$pushProvider(workInProgress, $8bd92a9a66fc7c77$var$CacheContext, props)) : (props = prevState.cache, $8bd92a9a66fc7c77$var$pushProvider(workInProgress, $8bd92a9a66fc7c77$var$CacheContext, props), props !== $$typeof.cache && $8bd92a9a66fc7c77$var$propagateContextChanges(workInProgress, [
                $8bd92a9a66fc7c77$var$CacheContext
            ], renderLanes, !0))), $8bd92a9a66fc7c77$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8bd92a9a66fc7c77$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $8bd92a9a66fc7c77$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($8bd92a9a66fc7c77$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $8bd92a9a66fc7c77$var$suspendedThenable = $8bd92a9a66fc7c77$var$noopSuspenseyCommitThenable, $8bd92a9a66fc7c77$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $8bd92a9a66fc7c77$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$8bd92a9a66fc7c77$var$preloadResource(resource)) {
        if ($8bd92a9a66fc7c77$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $8bd92a9a66fc7c77$var$suspendedThenable = $8bd92a9a66fc7c77$var$noopSuspenseyCommitThenable, $8bd92a9a66fc7c77$var$SuspenseyCommitException;
    }
}
function $8bd92a9a66fc7c77$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $8bd92a9a66fc7c77$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $8bd92a9a66fc7c77$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $8bd92a9a66fc7c77$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$8bd92a9a66fc7c77$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $8bd92a9a66fc7c77$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $8bd92a9a66fc7c77$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $8bd92a9a66fc7c77$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), null;
        case 1:
            return $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $8bd92a9a66fc7c77$var$popProvider($8bd92a9a66fc7c77$var$CacheContext);
            $8bd92a9a66fc7c77$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $8bd92a9a66fc7c77$var$popHydrationState(workInProgress) ? $8bd92a9a66fc7c77$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $8bd92a9a66fc7c77$var$upgradeHydrationErrorsToRecoverable());
            $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($8bd92a9a66fc7c77$var$markUpdate(workInProgress), null !== nextResource ? ($8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), $8bd92a9a66fc7c77$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), $8bd92a9a66fc7c77$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($8bd92a9a66fc7c77$var$markUpdate(workInProgress), $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), $8bd92a9a66fc7c77$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $8bd92a9a66fc7c77$var$markUpdate(workInProgress), $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), $8bd92a9a66fc7c77$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $8bd92a9a66fc7c77$var$popHostContext(workInProgress);
            renderLanes = $8bd92a9a66fc7c77$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8bd92a9a66fc7c77$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(166));
                    $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $8bd92a9a66fc7c77$var$contextStackCursor.current;
                $8bd92a9a66fc7c77$var$popHydrationState(workInProgress) ? $8bd92a9a66fc7c77$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $8bd92a9a66fc7c77$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $8bd92a9a66fc7c77$var$markUpdate(workInProgress));
            }
            $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $8bd92a9a66fc7c77$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8bd92a9a66fc7c77$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(166));
                    $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $8bd92a9a66fc7c77$var$contextStackCursor.current;
                if ($8bd92a9a66fc7c77$var$popHydrationState(workInProgress)) $8bd92a9a66fc7c77$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $8bd92a9a66fc7c77$var$getOwnerDocumentFromRootContainer($8bd92a9a66fc7c77$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$8bd92a9a66fc7c77$var$internalInstanceKey] = workInProgress;
                    nextResource[$8bd92a9a66fc7c77$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($8bd92a9a66fc7c77$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $8bd92a9a66fc7c77$var$markUpdate(workInProgress);
                }
            }
            $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
            $8bd92a9a66fc7c77$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8bd92a9a66fc7c77$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(166));
                current = $8bd92a9a66fc7c77$var$rootInstanceStackCursor.current;
                if ($8bd92a9a66fc7c77$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $8bd92a9a66fc7c77$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$8bd92a9a66fc7c77$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $8bd92a9a66fc7c77$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $8bd92a9a66fc7c77$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $8bd92a9a66fc7c77$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$8bd92a9a66fc7c77$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $8bd92a9a66fc7c77$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(557));
                        current[$8bd92a9a66fc7c77$var$internalInstanceKey] = workInProgress;
                    } else $8bd92a9a66fc7c77$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $8bd92a9a66fc7c77$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(558));
            }
            $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $8bd92a9a66fc7c77$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(317));
                        type[$8bd92a9a66fc7c77$var$internalInstanceKey] = workInProgress;
                    } else $8bd92a9a66fc7c77$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $8bd92a9a66fc7c77$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $8bd92a9a66fc7c77$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $8bd92a9a66fc7c77$var$popHostContainer(), null === current && $8bd92a9a66fc7c77$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), null;
        case 10:
            return $8bd92a9a66fc7c77$var$popProvider(workInProgress.type), $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), null;
        case 19:
            $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $8bd92a9a66fc7c77$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $8bd92a9a66fc7c77$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $8bd92a9a66fc7c77$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $8bd92a9a66fc7c77$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $8bd92a9a66fc7c77$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$8bd92a9a66fc7c77$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, $8bd92a9a66fc7c77$var$suspenseStackCursor.current & 1 | 2);
                            $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $8bd92a9a66fc7c77$var$now() > $8bd92a9a66fc7c77$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $8bd92a9a66fc7c77$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $8bd92a9a66fc7c77$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $8bd92a9a66fc7c77$var$scheduleRetryEffect(workInProgress, current), $8bd92a9a66fc7c77$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$8bd92a9a66fc7c77$var$isHydrating) return $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), null;
                    } else 2 * $8bd92a9a66fc7c77$var$now() - newProps.renderingStartTime > $8bd92a9a66fc7c77$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $8bd92a9a66fc7c77$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $8bd92a9a66fc7c77$var$now(), current.sibling = null, renderLanes = $8bd92a9a66fc7c77$var$suspenseStackCursor.current, $8bd92a9a66fc7c77$var$push($8bd92a9a66fc7c77$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $8bd92a9a66fc7c77$var$isHydrating && $8bd92a9a66fc7c77$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress), $8bd92a9a66fc7c77$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $8bd92a9a66fc7c77$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $8bd92a9a66fc7c77$var$popProvider($8bd92a9a66fc7c77$var$CacheContext), $8bd92a9a66fc7c77$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8bd92a9a66fc7c77$var$unwindWork(current, workInProgress) {
    $8bd92a9a66fc7c77$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $8bd92a9a66fc7c77$var$popProvider($8bd92a9a66fc7c77$var$CacheContext), $8bd92a9a66fc7c77$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $8bd92a9a66fc7c77$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(340));
                $8bd92a9a66fc7c77$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(340));
                $8bd92a9a66fc7c77$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$suspenseStackCursor), null;
        case 4:
            return $8bd92a9a66fc7c77$var$popHostContainer(), null;
        case 10:
            return $8bd92a9a66fc7c77$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $8bd92a9a66fc7c77$var$popSuspenseHandler(workInProgress), $8bd92a9a66fc7c77$var$popHiddenContext(), null !== current && $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $8bd92a9a66fc7c77$var$popProvider($8bd92a9a66fc7c77$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $8bd92a9a66fc7c77$var$unwindInterruptedWork(current, interruptedWork) {
    $8bd92a9a66fc7c77$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $8bd92a9a66fc7c77$var$popProvider($8bd92a9a66fc7c77$var$CacheContext);
            $8bd92a9a66fc7c77$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $8bd92a9a66fc7c77$var$popHostContext(interruptedWork);
            break;
        case 4:
            $8bd92a9a66fc7c77$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $8bd92a9a66fc7c77$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $8bd92a9a66fc7c77$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$suspenseStackCursor);
            break;
        case 10:
            $8bd92a9a66fc7c77$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $8bd92a9a66fc7c77$var$popSuspenseHandler(interruptedWork);
            $8bd92a9a66fc7c77$var$popHiddenContext();
            null !== current && $8bd92a9a66fc7c77$var$pop($8bd92a9a66fc7c77$var$resumedCache);
            break;
        case 24:
            $8bd92a9a66fc7c77$var$popProvider($8bd92a9a66fc7c77$var$CacheContext);
    }
}
function $8bd92a9a66fc7c77$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $8bd92a9a66fc7c77$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8bd92a9a66fc7c77$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $8bd92a9a66fc7c77$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8bd92a9a66fc7c77$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $8bd92a9a66fc7c77$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8bd92a9a66fc7c77$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8bd92a9a66fc7c77$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $8bd92a9a66fc7c77$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $8bd92a9a66fc7c77$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $8bd92a9a66fc7c77$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8bd92a9a66fc7c77$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $8bd92a9a66fc7c77$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$8bd92a9a66fc7c77$var$internalPropsKey] = newProps;
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8bd92a9a66fc7c77$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $8bd92a9a66fc7c77$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $8bd92a9a66fc7c77$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $8bd92a9a66fc7c77$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $8bd92a9a66fc7c77$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $8bd92a9a66fc7c77$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $8bd92a9a66fc7c77$var$noop$1));
    else if (4 !== tag && (27 === tag && $8bd92a9a66fc7c77$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($8bd92a9a66fc7c77$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$8bd92a9a66fc7c77$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $8bd92a9a66fc7c77$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $8bd92a9a66fc7c77$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($8bd92a9a66fc7c77$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$8bd92a9a66fc7c77$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $8bd92a9a66fc7c77$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $8bd92a9a66fc7c77$var$setInitialProperties(singleton, type, props);
        singleton[$8bd92a9a66fc7c77$var$internalInstanceKey] = finishedWork;
        singleton[$8bd92a9a66fc7c77$var$internalPropsKey] = props;
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden = !1, $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden = !1, $8bd92a9a66fc7c77$var$needsFormReset = !1, $8bd92a9a66fc7c77$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $8bd92a9a66fc7c77$var$nextEffect = null;
function $8bd92a9a66fc7c77$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $8bd92a9a66fc7c77$var$eventsEnabled = $8bd92a9a66fc7c77$var$_enabled;
    root = $8bd92a9a66fc7c77$var$getActiveElementDeep(root);
    if ($8bd92a9a66fc7c77$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $8bd92a9a66fc7c77$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $8bd92a9a66fc7c77$var$_enabled = !1;
    for($8bd92a9a66fc7c77$var$nextEffect = firstChild; null !== $8bd92a9a66fc7c77$var$nextEffect;)if (firstChild = $8bd92a9a66fc7c77$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $8bd92a9a66fc7c77$var$nextEffect = root;
    else for(; null !== $8bd92a9a66fc7c77$var$nextEffect;){
        firstChild = $8bd92a9a66fc7c77$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $8bd92a9a66fc7c77$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $8bd92a9a66fc7c77$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $8bd92a9a66fc7c77$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $8bd92a9a66fc7c77$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $8bd92a9a66fc7c77$var$nextEffect = root;
            break;
        }
        $8bd92a9a66fc7c77$var$nextEffect = firstChild.return;
    }
}
function $8bd92a9a66fc7c77$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8bd92a9a66fc7c77$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $8bd92a9a66fc7c77$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $8bd92a9a66fc7c77$var$commitClassCallbacks(finishedWork);
            flags & 512 && $8bd92a9a66fc7c77$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $8bd92a9a66fc7c77$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $8bd92a9a66fc7c77$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $8bd92a9a66fc7c77$var$commitHostMount(finishedWork);
            flags & 512 && $8bd92a9a66fc7c77$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8bd92a9a66fc7c77$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8bd92a9a66fc7c77$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $8bd92a9a66fc7c77$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $8bd92a9a66fc7c77$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden;
                prevProps = $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden;
                $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden = flags;
                ($8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden = prevProps;
                $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $8bd92a9a66fc7c77$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $8bd92a9a66fc7c77$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $8bd92a9a66fc7c77$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $8bd92a9a66fc7c77$var$hostParent = null, $8bd92a9a66fc7c77$var$hostParentIsContainer = !1;
function $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$8bd92a9a66fc7c77$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $8bd92a9a66fc7c77$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($8bd92a9a66fc7c77$var$injectedHook && "function" === typeof $8bd92a9a66fc7c77$var$injectedHook.onCommitFiberUnmount) try {
        $8bd92a9a66fc7c77$var$injectedHook.onCommitFiberUnmount($8bd92a9a66fc7c77$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || $8bd92a9a66fc7c77$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || $8bd92a9a66fc7c77$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $8bd92a9a66fc7c77$var$hostParent, prevHostParentIsContainer = $8bd92a9a66fc7c77$var$hostParentIsContainer;
            $8bd92a9a66fc7c77$var$isSingletonScope(deletedFiber.type) && ($8bd92a9a66fc7c77$var$hostParent = deletedFiber.stateNode, $8bd92a9a66fc7c77$var$hostParentIsContainer = !1);
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8bd92a9a66fc7c77$var$releaseSingletonInstance(deletedFiber.stateNode);
            $8bd92a9a66fc7c77$var$hostParent = prevHostParent;
            $8bd92a9a66fc7c77$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || $8bd92a9a66fc7c77$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $8bd92a9a66fc7c77$var$hostParent;
            prevHostParentIsContainer = $8bd92a9a66fc7c77$var$hostParentIsContainer;
            $8bd92a9a66fc7c77$var$hostParent = null;
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8bd92a9a66fc7c77$var$hostParent = prevHostParent;
            $8bd92a9a66fc7c77$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $8bd92a9a66fc7c77$var$hostParent) {
                if ($8bd92a9a66fc7c77$var$hostParentIsContainer) try {
                    (9 === $8bd92a9a66fc7c77$var$hostParent.nodeType ? $8bd92a9a66fc7c77$var$hostParent.body : "HTML" === $8bd92a9a66fc7c77$var$hostParent.nodeName ? $8bd92a9a66fc7c77$var$hostParent.ownerDocument.body : $8bd92a9a66fc7c77$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $8bd92a9a66fc7c77$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $8bd92a9a66fc7c77$var$hostParent && ($8bd92a9a66fc7c77$var$hostParentIsContainer ? (finishedRoot = $8bd92a9a66fc7c77$var$hostParent, $8bd92a9a66fc7c77$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $8bd92a9a66fc7c77$var$retryIfBlockedOn(finishedRoot)) : $8bd92a9a66fc7c77$var$clearHydrationBoundary($8bd92a9a66fc7c77$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $8bd92a9a66fc7c77$var$hostParent;
            prevHostParentIsContainer = $8bd92a9a66fc7c77$var$hostParentIsContainer;
            $8bd92a9a66fc7c77$var$hostParent = deletedFiber.stateNode.containerInfo;
            $8bd92a9a66fc7c77$var$hostParentIsContainer = !0;
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8bd92a9a66fc7c77$var$hostParent = prevHostParent;
            $8bd92a9a66fc7c77$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || ($8bd92a9a66fc7c77$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $8bd92a9a66fc7c77$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden = (prevHostParent = $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $8bd92a9a66fc7c77$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $8bd92a9a66fc7c77$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $8bd92a9a66fc7c77$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8bd92a9a66fc7c77$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $8bd92a9a66fc7c77$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8bd92a9a66fc7c77$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $8bd92a9a66fc7c77$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $8bd92a9a66fc7c77$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $8bd92a9a66fc7c77$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $8bd92a9a66fc7c77$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $8bd92a9a66fc7c77$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($8bd92a9a66fc7c77$var$isSingletonScope(parent.type)) {
                        $8bd92a9a66fc7c77$var$hostParent = parent.stateNode;
                        $8bd92a9a66fc7c77$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $8bd92a9a66fc7c77$var$hostParent = parent.stateNode;
                    $8bd92a9a66fc7c77$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $8bd92a9a66fc7c77$var$hostParent = parent.stateNode.containerInfo;
                    $8bd92a9a66fc7c77$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $8bd92a9a66fc7c77$var$hostParent) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(160));
        $8bd92a9a66fc7c77$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $8bd92a9a66fc7c77$var$hostParent = null;
        $8bd92a9a66fc7c77$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$8bd92a9a66fc7c77$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $8bd92a9a66fc7c77$var$currentHoistableRoot = null;
function $8bd92a9a66fc7c77$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($8bd92a9a66fc7c77$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $8bd92a9a66fc7c77$var$commitHookEffectListMount(3, finishedWork), $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || null === current || $8bd92a9a66fc7c77$var$safelyDetachRef(current, current.return));
            flags & 64 && $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $8bd92a9a66fc7c77$var$currentHoistableRoot;
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || null === current || $8bd92a9a66fc7c77$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$8bd92a9a66fc7c77$var$internalHoistableMarker] || currentResource[$8bd92a9a66fc7c77$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $8bd92a9a66fc7c77$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$8bd92a9a66fc7c77$var$internalInstanceKey] = finishedWork;
                                        $8bd92a9a66fc7c77$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $8bd92a9a66fc7c77$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8bd92a9a66fc7c77$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $8bd92a9a66fc7c77$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8bd92a9a66fc7c77$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$8bd92a9a66fc7c77$var$internalInstanceKey] = finishedWork;
                                $8bd92a9a66fc7c77$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $8bd92a9a66fc7c77$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $8bd92a9a66fc7c77$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $8bd92a9a66fc7c77$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $8bd92a9a66fc7c77$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $8bd92a9a66fc7c77$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || null === current || $8bd92a9a66fc7c77$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $8bd92a9a66fc7c77$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || null === current || $8bd92a9a66fc7c77$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $8bd92a9a66fc7c77$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $8bd92a9a66fc7c77$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($8bd92a9a66fc7c77$var$needsFormReset = !0);
            break;
        case 6:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $8bd92a9a66fc7c77$var$tagCaches = null;
            hoistableRoot = $8bd92a9a66fc7c77$var$currentHoistableRoot;
            $8bd92a9a66fc7c77$var$currentHoistableRoot = $8bd92a9a66fc7c77$var$getHoistableRoot(root.containerInfo);
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$currentHoistableRoot = hoistableRoot;
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $8bd92a9a66fc7c77$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $8bd92a9a66fc7c77$var$needsFormReset && ($8bd92a9a66fc7c77$var$needsFormReset = !1, $8bd92a9a66fc7c77$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $8bd92a9a66fc7c77$var$currentHoistableRoot;
            $8bd92a9a66fc7c77$var$currentHoistableRoot = $8bd92a9a66fc7c77$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            $8bd92a9a66fc7c77$var$currentHoistableRoot = flags;
            break;
        case 12:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8bd92a9a66fc7c77$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($8bd92a9a66fc7c77$var$globalMostRecentFallbackTime = $8bd92a9a66fc7c77$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8bd92a9a66fc7c77$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden;
            $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $8bd92a9a66fc7c77$var$offscreenSubtreeIsHidden || $8bd92a9a66fc7c77$var$offscreenSubtreeWasHidden || $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $8bd92a9a66fc7c77$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $8bd92a9a66fc7c77$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $8bd92a9a66fc7c77$var$hideOrUnhideDehydratedBoundary(instance, !0) : $8bd92a9a66fc7c77$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $8bd92a9a66fc7c77$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $8bd92a9a66fc7c77$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8bd92a9a66fc7c77$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $8bd92a9a66fc7c77$var$recursivelyTraverseMutationEffects(root, finishedWork), $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork);
    }
}
function $8bd92a9a66fc7c77$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($8bd92a9a66fc7c77$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $8bd92a9a66fc7c77$var$getHostSibling(finishedWork);
                    $8bd92a9a66fc7c77$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($8bd92a9a66fc7c77$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $8bd92a9a66fc7c77$var$getHostSibling(finishedWork);
                    $8bd92a9a66fc7c77$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $8bd92a9a66fc7c77$var$getHostSibling(finishedWork);
                    $8bd92a9a66fc7c77$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $8bd92a9a66fc7c77$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $8bd92a9a66fc7c77$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $8bd92a9a66fc7c77$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$8bd92a9a66fc7c77$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $8bd92a9a66fc7c77$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $8bd92a9a66fc7c77$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $8bd92a9a66fc7c77$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $8bd92a9a66fc7c77$var$safelyDetachRef(finishedWork, finishedWork.return);
                $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $8bd92a9a66fc7c77$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8bd92a9a66fc7c77$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$8bd92a9a66fc7c77$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $8bd92a9a66fc7c77$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $8bd92a9a66fc7c77$var$commitClassCallbacks(finishedWork);
                $8bd92a9a66fc7c77$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $8bd92a9a66fc7c77$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $8bd92a9a66fc7c77$var$commitHostMount(finishedWork);
                $8bd92a9a66fc7c77$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $8bd92a9a66fc7c77$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $8bd92a9a66fc7c77$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8bd92a9a66fc7c77$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8bd92a9a66fc7c77$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $8bd92a9a66fc7c77$var$releaseCache(previousCache));
}
function $8bd92a9a66fc7c77$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $8bd92a9a66fc7c77$var$releaseCache(current));
}
function $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8bd92a9a66fc7c77$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $8bd92a9a66fc7c77$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8bd92a9a66fc7c77$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $8bd92a9a66fc7c77$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $8bd92a9a66fc7c77$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $8bd92a9a66fc7c77$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $8bd92a9a66fc7c77$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $8bd92a9a66fc7c77$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8bd92a9a66fc7c77$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $8bd92a9a66fc7c77$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $8bd92a9a66fc7c77$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $8bd92a9a66fc7c77$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $8bd92a9a66fc7c77$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $8bd92a9a66fc7c77$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $8bd92a9a66fc7c77$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $8bd92a9a66fc7c77$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8bd92a9a66fc7c77$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8bd92a9a66fc7c77$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $8bd92a9a66fc7c77$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8bd92a9a66fc7c77$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8bd92a9a66fc7c77$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8bd92a9a66fc7c77$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8bd92a9a66fc7c77$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $8bd92a9a66fc7c77$var$suspenseyCommitFlag = 8192;
function $8bd92a9a66fc7c77$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $8bd92a9a66fc7c77$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$8bd92a9a66fc7c77$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $8bd92a9a66fc7c77$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $8bd92a9a66fc7c77$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $8bd92a9a66fc7c77$var$suspenseyCommitFlag && null !== fiber.memoizedState && $8bd92a9a66fc7c77$var$suspendResource(suspendedState, $8bd92a9a66fc7c77$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $8bd92a9a66fc7c77$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $8bd92a9a66fc7c77$var$currentHoistableRoot;
            $8bd92a9a66fc7c77$var$currentHoistableRoot = $8bd92a9a66fc7c77$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $8bd92a9a66fc7c77$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $8bd92a9a66fc7c77$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $8bd92a9a66fc7c77$var$suspenseyCommitFlag, $8bd92a9a66fc7c77$var$suspenseyCommitFlag = 16777216, $8bd92a9a66fc7c77$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $8bd92a9a66fc7c77$var$suspenseyCommitFlag = previousHoistableRoot) : $8bd92a9a66fc7c77$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $8bd92a9a66fc7c77$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $8bd92a9a66fc7c77$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $8bd92a9a66fc7c77$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8bd92a9a66fc7c77$var$nextEffect = childToDelete;
            $8bd92a9a66fc7c77$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8bd92a9a66fc7c77$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8bd92a9a66fc7c77$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $8bd92a9a66fc7c77$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $8bd92a9a66fc7c77$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $8bd92a9a66fc7c77$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $8bd92a9a66fc7c77$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $8bd92a9a66fc7c77$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8bd92a9a66fc7c77$var$nextEffect = childToDelete;
            $8bd92a9a66fc7c77$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8bd92a9a66fc7c77$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $8bd92a9a66fc7c77$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $8bd92a9a66fc7c77$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $8bd92a9a66fc7c77$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8bd92a9a66fc7c77$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $8bd92a9a66fc7c77$var$nextEffect;){
        var fiber = $8bd92a9a66fc7c77$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $8bd92a9a66fc7c77$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $8bd92a9a66fc7c77$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $8bd92a9a66fc7c77$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $8bd92a9a66fc7c77$var$nextEffect;){
            cache = $8bd92a9a66fc7c77$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $8bd92a9a66fc7c77$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $8bd92a9a66fc7c77$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $8bd92a9a66fc7c77$var$nextEffect = sibling;
                break a;
            }
            $8bd92a9a66fc7c77$var$nextEffect = returnFiber;
        }
    }
}
var $8bd92a9a66fc7c77$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $8bd92a9a66fc7c77$var$readContext($8bd92a9a66fc7c77$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $8bd92a9a66fc7c77$var$readContext($8bd92a9a66fc7c77$var$CacheContext).controller.signal;
    }
}, $8bd92a9a66fc7c77$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $8bd92a9a66fc7c77$var$executionContext = 0, $8bd92a9a66fc7c77$var$workInProgressRoot = null, $8bd92a9a66fc7c77$var$workInProgress = null, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes = 0, $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0, $8bd92a9a66fc7c77$var$workInProgressThrownValue = null, $8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings = !1, $8bd92a9a66fc7c77$var$workInProgressRootIsPrerendering = !1, $8bd92a9a66fc7c77$var$workInProgressRootDidAttachPingListener = !1, $8bd92a9a66fc7c77$var$entangledRenderLanes = 0, $8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 0, $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes = 0, $8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes = 0, $8bd92a9a66fc7c77$var$workInProgressRootPingedLanes = 0, $8bd92a9a66fc7c77$var$workInProgressDeferredLane = 0, $8bd92a9a66fc7c77$var$workInProgressSuspendedRetryLanes = 0, $8bd92a9a66fc7c77$var$workInProgressRootConcurrentErrors = null, $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors = null, $8bd92a9a66fc7c77$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $8bd92a9a66fc7c77$var$globalMostRecentFallbackTime = 0, $8bd92a9a66fc7c77$var$globalMostRecentTransitionTime = 0, $8bd92a9a66fc7c77$var$workInProgressRootRenderTargetTime = Infinity, $8bd92a9a66fc7c77$var$workInProgressTransitions = null, $8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed = null, $8bd92a9a66fc7c77$var$pendingEffectsStatus = 0, $8bd92a9a66fc7c77$var$pendingEffectsRoot = null, $8bd92a9a66fc7c77$var$pendingFinishedWork = null, $8bd92a9a66fc7c77$var$pendingEffectsLanes = 0, $8bd92a9a66fc7c77$var$pendingEffectsRemainingLanes = 0, $8bd92a9a66fc7c77$var$pendingPassiveTransitions = null, $8bd92a9a66fc7c77$var$pendingRecoverableErrors = null, $8bd92a9a66fc7c77$var$nestedUpdateCount = 0, $8bd92a9a66fc7c77$var$rootWithNestedUpdates = null;
function $8bd92a9a66fc7c77$var$requestUpdateLane() {
    return 0 !== ($8bd92a9a66fc7c77$var$executionContext & 2) && 0 !== $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes ? $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & -$8bd92a9a66fc7c77$var$workInProgressRootRenderLanes : null !== $8bd92a9a66fc7c77$var$ReactSharedInternals.T ? $8bd92a9a66fc7c77$var$requestTransitionLane() : $8bd92a9a66fc7c77$var$resolveUpdatePriority();
}
function $8bd92a9a66fc7c77$var$requestDeferredLane() {
    if (0 === $8bd92a9a66fc7c77$var$workInProgressDeferredLane) {
        if (0 === ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 536870912) || $8bd92a9a66fc7c77$var$isHydrating) {
            var lane = $8bd92a9a66fc7c77$var$nextTransitionDeferredLane;
            $8bd92a9a66fc7c77$var$nextTransitionDeferredLane <<= 1;
            0 === ($8bd92a9a66fc7c77$var$nextTransitionDeferredLane & 3932160) && ($8bd92a9a66fc7c77$var$nextTransitionDeferredLane = 262144);
            $8bd92a9a66fc7c77$var$workInProgressDeferredLane = lane;
        } else $8bd92a9a66fc7c77$var$workInProgressDeferredLane = 536870912;
    }
    lane = $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $8bd92a9a66fc7c77$var$workInProgressDeferredLane;
}
function $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $8bd92a9a66fc7c77$var$workInProgressRoot && (2 === $8bd92a9a66fc7c77$var$workInProgressSuspendedReason || 9 === $8bd92a9a66fc7c77$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $8bd92a9a66fc7c77$var$prepareFreshStack(root, 0), $8bd92a9a66fc7c77$var$markRootSuspended(root, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes, $8bd92a9a66fc7c77$var$workInProgressDeferredLane, !1);
    $8bd92a9a66fc7c77$var$markRootUpdated$1(root, lane);
    if (0 === ($8bd92a9a66fc7c77$var$executionContext & 2) || root !== $8bd92a9a66fc7c77$var$workInProgressRoot) root === $8bd92a9a66fc7c77$var$workInProgressRoot && (0 === ($8bd92a9a66fc7c77$var$executionContext & 2) && ($8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $8bd92a9a66fc7c77$var$workInProgressRootExitStatus && $8bd92a9a66fc7c77$var$markRootSuspended(root, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes, $8bd92a9a66fc7c77$var$workInProgressDeferredLane, !1)), $8bd92a9a66fc7c77$var$ensureRootIsScheduled(root);
}
function $8bd92a9a66fc7c77$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($8bd92a9a66fc7c77$var$executionContext & 6)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $8bd92a9a66fc7c77$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $8bd92a9a66fc7c77$var$renderRootConcurrent(root$jscomp$0, lanes) : $8bd92a9a66fc7c77$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $8bd92a9a66fc7c77$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $8bd92a9a66fc7c77$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$8bd92a9a66fc7c77$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $8bd92a9a66fc7c77$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $8bd92a9a66fc7c77$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($8bd92a9a66fc7c77$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $8bd92a9a66fc7c77$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($8bd92a9a66fc7c77$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors;
                            $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors ? $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors.push.apply($8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $8bd92a9a66fc7c77$var$prepareFreshStack(root$jscomp$0, 0);
                $8bd92a9a66fc7c77$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $8bd92a9a66fc7c77$var$markRootSuspended(shouldTimeSlice, lanes, $8bd92a9a66fc7c77$var$workInProgressDeferredLane, !$8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $8bd92a9a66fc7c77$var$globalMostRecentFallbackTime + 300 - $8bd92a9a66fc7c77$var$now(), 10 < exitStatus)) {
                    $8bd92a9a66fc7c77$var$markRootSuspended(shouldTimeSlice, lanes, $8bd92a9a66fc7c77$var$workInProgressDeferredLane, !$8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $8bd92a9a66fc7c77$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $8bd92a9a66fc7c77$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $8bd92a9a66fc7c77$var$scheduleTimeout($8bd92a9a66fc7c77$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors, $8bd92a9a66fc7c77$var$workInProgressTransitions, $8bd92a9a66fc7c77$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8bd92a9a66fc7c77$var$workInProgressDeferredLane, $8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes, $8bd92a9a66fc7c77$var$workInProgressSuspendedRetryLanes, $8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $8bd92a9a66fc7c77$var$commitRootWhenReady(shouldTimeSlice, forceSync, $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors, $8bd92a9a66fc7c77$var$workInProgressTransitions, $8bd92a9a66fc7c77$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8bd92a9a66fc7c77$var$workInProgressDeferredLane, $8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes, $8bd92a9a66fc7c77$var$workInProgressSuspendedRetryLanes, $8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $8bd92a9a66fc7c77$var$ensureRootIsScheduled(root$jscomp$0);
}
function $8bd92a9a66fc7c77$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $8bd92a9a66fc7c77$var$noop$1
        };
        $8bd92a9a66fc7c77$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $8bd92a9a66fc7c77$var$globalMostRecentFallbackTime - $8bd92a9a66fc7c77$var$now() : (lanes & 4194048) === lanes ? $8bd92a9a66fc7c77$var$globalMostRecentTransitionTime - $8bd92a9a66fc7c77$var$now() : 0;
        timeoutOffset = $8bd92a9a66fc7c77$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $8bd92a9a66fc7c77$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($8bd92a9a66fc7c77$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $8bd92a9a66fc7c77$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $8bd92a9a66fc7c77$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $8bd92a9a66fc7c77$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$8bd92a9a66fc7c77$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $8bd92a9a66fc7c77$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$8bd92a9a66fc7c77$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $8bd92a9a66fc7c77$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $8bd92a9a66fc7c77$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $8bd92a9a66fc7c77$var$flushSyncWork$1() {
    return 0 === ($8bd92a9a66fc7c77$var$executionContext & 6) ? ($8bd92a9a66fc7c77$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $8bd92a9a66fc7c77$var$resetWorkInProgressStack() {
    if (null !== $8bd92a9a66fc7c77$var$workInProgress) {
        if (0 === $8bd92a9a66fc7c77$var$workInProgressSuspendedReason) var interruptedWork = $8bd92a9a66fc7c77$var$workInProgress.return;
        else interruptedWork = $8bd92a9a66fc7c77$var$workInProgress, $8bd92a9a66fc7c77$var$lastContextDependency = $8bd92a9a66fc7c77$var$currentlyRenderingFiber$1 = null, $8bd92a9a66fc7c77$var$resetHooksOnUnwind(interruptedWork), $8bd92a9a66fc7c77$var$thenableState$1 = null, $8bd92a9a66fc7c77$var$thenableIndexCounter$1 = 0, interruptedWork = $8bd92a9a66fc7c77$var$workInProgress;
        for(; null !== interruptedWork;)$8bd92a9a66fc7c77$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $8bd92a9a66fc7c77$var$workInProgress = null;
    }
}
function $8bd92a9a66fc7c77$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $8bd92a9a66fc7c77$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $8bd92a9a66fc7c77$var$pendingEffectsLanes = 0;
    $8bd92a9a66fc7c77$var$resetWorkInProgressStack();
    $8bd92a9a66fc7c77$var$workInProgressRoot = root;
    $8bd92a9a66fc7c77$var$workInProgress = timeoutHandle = $8bd92a9a66fc7c77$var$createWorkInProgress(root.current, null);
    $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes = lanes;
    $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0;
    $8bd92a9a66fc7c77$var$workInProgressThrownValue = null;
    $8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $8bd92a9a66fc7c77$var$workInProgressRootIsPrerendering = $8bd92a9a66fc7c77$var$checkIfRootIsPrerendering(root, lanes);
    $8bd92a9a66fc7c77$var$workInProgressRootDidAttachPingListener = !1;
    $8bd92a9a66fc7c77$var$workInProgressSuspendedRetryLanes = $8bd92a9a66fc7c77$var$workInProgressDeferredLane = $8bd92a9a66fc7c77$var$workInProgressRootPingedLanes = $8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes = $8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes = $8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 0;
    $8bd92a9a66fc7c77$var$workInProgressRootRecoverableErrors = $8bd92a9a66fc7c77$var$workInProgressRootConcurrentErrors = null;
    $8bd92a9a66fc7c77$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $8bd92a9a66fc7c77$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $8bd92a9a66fc7c77$var$entangledRenderLanes = lanes;
    $8bd92a9a66fc7c77$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $8bd92a9a66fc7c77$var$handleThrow(root, thrownValue) {
    $8bd92a9a66fc7c77$var$currentlyRenderingFiber = null;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.H = $8bd92a9a66fc7c77$var$ContextOnlyDispatcher;
    thrownValue === $8bd92a9a66fc7c77$var$SuspenseException || thrownValue === $8bd92a9a66fc7c77$var$SuspenseActionException ? (thrownValue = $8bd92a9a66fc7c77$var$getSuspendedThenable(), $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 3) : thrownValue === $8bd92a9a66fc7c77$var$SuspenseyCommitException ? (thrownValue = $8bd92a9a66fc7c77$var$getSuspendedThenable(), $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 4) : $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = thrownValue === $8bd92a9a66fc7c77$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $8bd92a9a66fc7c77$var$workInProgressThrownValue = thrownValue;
    null === $8bd92a9a66fc7c77$var$workInProgress && ($8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 1, $8bd92a9a66fc7c77$var$logUncaughtError(root, $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $8bd92a9a66fc7c77$var$shouldRemainOnPreviousScreen() {
    var handler = $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 4194048) === $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes ? null === $8bd92a9a66fc7c77$var$shellBoundary ? !0 : !1 : ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 62914560) === $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes || 0 !== ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 536870912) ? handler === $8bd92a9a66fc7c77$var$shellBoundary : !1;
}
function $8bd92a9a66fc7c77$var$pushDispatcher() {
    var prevDispatcher = $8bd92a9a66fc7c77$var$ReactSharedInternals.H;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.H = $8bd92a9a66fc7c77$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $8bd92a9a66fc7c77$var$ContextOnlyDispatcher : prevDispatcher;
}
function $8bd92a9a66fc7c77$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $8bd92a9a66fc7c77$var$ReactSharedInternals.A;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.A = $8bd92a9a66fc7c77$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $8bd92a9a66fc7c77$var$renderDidSuspendDelayIfPossible() {
    $8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 4;
    $8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings || ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 4194048) !== $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes && null !== $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current || ($8bd92a9a66fc7c77$var$workInProgressRootIsPrerendering = !0);
    0 === ($8bd92a9a66fc7c77$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($8bd92a9a66fc7c77$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $8bd92a9a66fc7c77$var$workInProgressRoot || $8bd92a9a66fc7c77$var$markRootSuspended($8bd92a9a66fc7c77$var$workInProgressRoot, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes, $8bd92a9a66fc7c77$var$workInProgressDeferredLane, !1);
}
function $8bd92a9a66fc7c77$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $8bd92a9a66fc7c77$var$executionContext;
    $8bd92a9a66fc7c77$var$executionContext |= 2;
    var prevDispatcher = $8bd92a9a66fc7c77$var$pushDispatcher(), prevAsyncDispatcher = $8bd92a9a66fc7c77$var$pushAsyncDispatcher();
    if ($8bd92a9a66fc7c77$var$workInProgressRoot !== root || $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes !== lanes) $8bd92a9a66fc7c77$var$workInProgressTransitions = null, $8bd92a9a66fc7c77$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $8bd92a9a66fc7c77$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $8bd92a9a66fc7c77$var$workInProgressSuspendedReason && null !== $8bd92a9a66fc7c77$var$workInProgress) {
            var unitOfWork = $8bd92a9a66fc7c77$var$workInProgress, thrownValue = $8bd92a9a66fc7c77$var$workInProgressThrownValue;
            switch($8bd92a9a66fc7c77$var$workInProgressSuspendedReason){
                case 8:
                    $8bd92a9a66fc7c77$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $8bd92a9a66fc7c77$var$workInProgressSuspendedReason;
                    $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0;
                    $8bd92a9a66fc7c77$var$workInProgressThrownValue = null;
                    $8bd92a9a66fc7c77$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $8bd92a9a66fc7c77$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $8bd92a9a66fc7c77$var$workInProgressSuspendedReason, $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0, $8bd92a9a66fc7c77$var$workInProgressThrownValue = null, $8bd92a9a66fc7c77$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $8bd92a9a66fc7c77$var$workLoopSync();
        exitStatus = $8bd92a9a66fc7c77$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $8bd92a9a66fc7c77$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $8bd92a9a66fc7c77$var$lastContextDependency = $8bd92a9a66fc7c77$var$currentlyRenderingFiber$1 = null;
    $8bd92a9a66fc7c77$var$executionContext = prevExecutionContext;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.H = prevDispatcher;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $8bd92a9a66fc7c77$var$workInProgress && ($8bd92a9a66fc7c77$var$workInProgressRoot = null, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes = 0, $8bd92a9a66fc7c77$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $8bd92a9a66fc7c77$var$workLoopSync() {
    for(; null !== $8bd92a9a66fc7c77$var$workInProgress;)$8bd92a9a66fc7c77$var$performUnitOfWork($8bd92a9a66fc7c77$var$workInProgress);
}
function $8bd92a9a66fc7c77$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $8bd92a9a66fc7c77$var$executionContext;
    $8bd92a9a66fc7c77$var$executionContext |= 2;
    var prevDispatcher = $8bd92a9a66fc7c77$var$pushDispatcher(), prevAsyncDispatcher = $8bd92a9a66fc7c77$var$pushAsyncDispatcher();
    $8bd92a9a66fc7c77$var$workInProgressRoot !== root || $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes !== lanes ? ($8bd92a9a66fc7c77$var$workInProgressTransitions = null, $8bd92a9a66fc7c77$var$workInProgressRootRenderTargetTime = $8bd92a9a66fc7c77$var$now() + 500, $8bd92a9a66fc7c77$var$prepareFreshStack(root, lanes)) : $8bd92a9a66fc7c77$var$workInProgressRootIsPrerendering = $8bd92a9a66fc7c77$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $8bd92a9a66fc7c77$var$workInProgressSuspendedReason && null !== $8bd92a9a66fc7c77$var$workInProgress) {
            lanes = $8bd92a9a66fc7c77$var$workInProgress;
            var thrownValue = $8bd92a9a66fc7c77$var$workInProgressThrownValue;
            b: switch($8bd92a9a66fc7c77$var$workInProgressSuspendedReason){
                case 1:
                    $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0;
                    $8bd92a9a66fc7c77$var$workInProgressThrownValue = null;
                    $8bd92a9a66fc7c77$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($8bd92a9a66fc7c77$var$isThenableResolved(thrownValue)) {
                        $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0;
                        $8bd92a9a66fc7c77$var$workInProgressThrownValue = null;
                        $8bd92a9a66fc7c77$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $8bd92a9a66fc7c77$var$workInProgressSuspendedReason && 9 !== $8bd92a9a66fc7c77$var$workInProgressSuspendedReason || $8bd92a9a66fc7c77$var$workInProgressRoot !== root || ($8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 7);
                        $8bd92a9a66fc7c77$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $8bd92a9a66fc7c77$var$isThenableResolved(thrownValue) ? ($8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0, $8bd92a9a66fc7c77$var$workInProgressThrownValue = null, $8bd92a9a66fc7c77$var$replaySuspendedUnitOfWork(lanes)) : ($8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0, $8bd92a9a66fc7c77$var$workInProgressThrownValue = null, $8bd92a9a66fc7c77$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($8bd92a9a66fc7c77$var$workInProgress.tag){
                        case 26:
                            resource = $8bd92a9a66fc7c77$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $8bd92a9a66fc7c77$var$workInProgress;
                            if (resource ? $8bd92a9a66fc7c77$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0;
                                $8bd92a9a66fc7c77$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $8bd92a9a66fc7c77$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($8bd92a9a66fc7c77$var$workInProgress = returnFiber, $8bd92a9a66fc7c77$var$completeUnitOfWork(returnFiber)) : $8bd92a9a66fc7c77$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0;
                    $8bd92a9a66fc7c77$var$workInProgressThrownValue = null;
                    $8bd92a9a66fc7c77$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $8bd92a9a66fc7c77$var$workInProgressSuspendedReason = 0;
                    $8bd92a9a66fc7c77$var$workInProgressThrownValue = null;
                    $8bd92a9a66fc7c77$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $8bd92a9a66fc7c77$var$resetWorkInProgressStack();
                    $8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(462));
            }
        }
        $8bd92a9a66fc7c77$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $8bd92a9a66fc7c77$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $8bd92a9a66fc7c77$var$lastContextDependency = $8bd92a9a66fc7c77$var$currentlyRenderingFiber$1 = null;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.H = prevDispatcher;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $8bd92a9a66fc7c77$var$executionContext = prevExecutionContext;
    if (null !== $8bd92a9a66fc7c77$var$workInProgress) return 0;
    $8bd92a9a66fc7c77$var$workInProgressRoot = null;
    $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes = 0;
    $8bd92a9a66fc7c77$var$finishQueueingConcurrentUpdates();
    return $8bd92a9a66fc7c77$var$workInProgressRootExitStatus;
}
function $8bd92a9a66fc7c77$var$workLoopConcurrentByScheduler() {
    for(; null !== $8bd92a9a66fc7c77$var$workInProgress && !$8bd92a9a66fc7c77$var$shouldYield();)$8bd92a9a66fc7c77$var$performUnitOfWork($8bd92a9a66fc7c77$var$workInProgress);
}
function $8bd92a9a66fc7c77$var$performUnitOfWork(unitOfWork) {
    var next = $8bd92a9a66fc7c77$var$beginWork(unitOfWork.alternate, unitOfWork, $8bd92a9a66fc7c77$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8bd92a9a66fc7c77$var$completeUnitOfWork(unitOfWork) : $8bd92a9a66fc7c77$var$workInProgress = next;
}
function $8bd92a9a66fc7c77$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $8bd92a9a66fc7c77$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $8bd92a9a66fc7c77$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $8bd92a9a66fc7c77$var$resetHooksOnUnwind(next);
        default:
            $8bd92a9a66fc7c77$var$unwindInterruptedWork(current, next), next = $8bd92a9a66fc7c77$var$workInProgress = $8bd92a9a66fc7c77$var$resetWorkInProgress(next, $8bd92a9a66fc7c77$var$entangledRenderLanes), next = $8bd92a9a66fc7c77$var$beginWork(current, next, $8bd92a9a66fc7c77$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8bd92a9a66fc7c77$var$completeUnitOfWork(unitOfWork) : $8bd92a9a66fc7c77$var$workInProgress = next;
}
function $8bd92a9a66fc7c77$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $8bd92a9a66fc7c77$var$lastContextDependency = $8bd92a9a66fc7c77$var$currentlyRenderingFiber$1 = null;
    $8bd92a9a66fc7c77$var$resetHooksOnUnwind(unitOfWork);
    $8bd92a9a66fc7c77$var$thenableState$1 = null;
    $8bd92a9a66fc7c77$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($8bd92a9a66fc7c77$var$throwException(root, returnFiber, unitOfWork, thrownValue, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes)) {
            $8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 1;
            $8bd92a9a66fc7c77$var$logUncaughtError(root, $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(thrownValue, root.current));
            $8bd92a9a66fc7c77$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $8bd92a9a66fc7c77$var$workInProgress = returnFiber, error;
        $8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 1;
        $8bd92a9a66fc7c77$var$logUncaughtError(root, $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(thrownValue, root.current));
        $8bd92a9a66fc7c77$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($8bd92a9a66fc7c77$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($8bd92a9a66fc7c77$var$workInProgressRootIsPrerendering || 0 !== ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $8bd92a9a66fc7c77$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $8bd92a9a66fc7c77$var$unwindUnitOfWork(unitOfWork, root);
    } else $8bd92a9a66fc7c77$var$completeUnitOfWork(unitOfWork);
}
function $8bd92a9a66fc7c77$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $8bd92a9a66fc7c77$var$unwindUnitOfWork(completedWork, $8bd92a9a66fc7c77$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $8bd92a9a66fc7c77$var$completeWork(completedWork.alternate, completedWork, $8bd92a9a66fc7c77$var$entangledRenderLanes);
        if (null !== next) {
            $8bd92a9a66fc7c77$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $8bd92a9a66fc7c77$var$workInProgress = completedWork;
            return;
        }
        $8bd92a9a66fc7c77$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $8bd92a9a66fc7c77$var$workInProgressRootExitStatus && ($8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 5);
}
function $8bd92a9a66fc7c77$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $8bd92a9a66fc7c77$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $8bd92a9a66fc7c77$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $8bd92a9a66fc7c77$var$workInProgress = unitOfWork;
            return;
        }
        $8bd92a9a66fc7c77$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $8bd92a9a66fc7c77$var$workInProgressRootExitStatus = 6;
    $8bd92a9a66fc7c77$var$workInProgress = null;
}
function $8bd92a9a66fc7c77$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $8bd92a9a66fc7c77$var$flushPendingEffects();
    while (0 !== $8bd92a9a66fc7c77$var$pendingEffectsStatus);
    if (0 !== ($8bd92a9a66fc7c77$var$executionContext & 6)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $8bd92a9a66fc7c77$var$concurrentlyUpdatedLanes;
        $8bd92a9a66fc7c77$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $8bd92a9a66fc7c77$var$workInProgressRoot && ($8bd92a9a66fc7c77$var$workInProgress = $8bd92a9a66fc7c77$var$workInProgressRoot = null, $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes = 0);
        $8bd92a9a66fc7c77$var$pendingFinishedWork = finishedWork;
        $8bd92a9a66fc7c77$var$pendingEffectsRoot = root;
        $8bd92a9a66fc7c77$var$pendingEffectsLanes = lanes;
        $8bd92a9a66fc7c77$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $8bd92a9a66fc7c77$var$pendingPassiveTransitions = transitions;
        $8bd92a9a66fc7c77$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $8bd92a9a66fc7c77$var$scheduleCallback$1($8bd92a9a66fc7c77$var$NormalPriority$1, function() {
            $8bd92a9a66fc7c77$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $8bd92a9a66fc7c77$var$ReactSharedInternals.T;
            $8bd92a9a66fc7c77$var$ReactSharedInternals.T = null;
            transitions = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
            $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $8bd92a9a66fc7c77$var$executionContext;
            $8bd92a9a66fc7c77$var$executionContext |= 4;
            try {
                $8bd92a9a66fc7c77$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $8bd92a9a66fc7c77$var$executionContext = spawnedLane, $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = transitions, $8bd92a9a66fc7c77$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $8bd92a9a66fc7c77$var$pendingEffectsStatus = 1;
        $8bd92a9a66fc7c77$var$flushMutationEffects();
        $8bd92a9a66fc7c77$var$flushLayoutEffects();
        $8bd92a9a66fc7c77$var$flushSpawnedWork();
    }
}
function $8bd92a9a66fc7c77$var$flushMutationEffects() {
    if (1 === $8bd92a9a66fc7c77$var$pendingEffectsStatus) {
        $8bd92a9a66fc7c77$var$pendingEffectsStatus = 0;
        var root = $8bd92a9a66fc7c77$var$pendingEffectsRoot, finishedWork = $8bd92a9a66fc7c77$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $8bd92a9a66fc7c77$var$ReactSharedInternals.T;
            $8bd92a9a66fc7c77$var$ReactSharedInternals.T = null;
            var previousPriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
            $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8bd92a9a66fc7c77$var$executionContext;
            $8bd92a9a66fc7c77$var$executionContext |= 4;
            try {
                $8bd92a9a66fc7c77$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $8bd92a9a66fc7c77$var$selectionInformation, curFocusedElem = $8bd92a9a66fc7c77$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $8bd92a9a66fc7c77$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $8bd92a9a66fc7c77$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $8bd92a9a66fc7c77$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $8bd92a9a66fc7c77$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $8bd92a9a66fc7c77$var$_enabled = !!$8bd92a9a66fc7c77$var$eventsEnabled;
                $8bd92a9a66fc7c77$var$selectionInformation = $8bd92a9a66fc7c77$var$eventsEnabled = null;
            } finally{
                $8bd92a9a66fc7c77$var$executionContext = prevExecutionContext, $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = previousPriority, $8bd92a9a66fc7c77$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $8bd92a9a66fc7c77$var$pendingEffectsStatus = 2;
    }
}
function $8bd92a9a66fc7c77$var$flushLayoutEffects() {
    if (2 === $8bd92a9a66fc7c77$var$pendingEffectsStatus) {
        $8bd92a9a66fc7c77$var$pendingEffectsStatus = 0;
        var root = $8bd92a9a66fc7c77$var$pendingEffectsRoot, finishedWork = $8bd92a9a66fc7c77$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $8bd92a9a66fc7c77$var$ReactSharedInternals.T;
            $8bd92a9a66fc7c77$var$ReactSharedInternals.T = null;
            var previousPriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
            $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8bd92a9a66fc7c77$var$executionContext;
            $8bd92a9a66fc7c77$var$executionContext |= 4;
            try {
                $8bd92a9a66fc7c77$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $8bd92a9a66fc7c77$var$executionContext = prevExecutionContext, $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = previousPriority, $8bd92a9a66fc7c77$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $8bd92a9a66fc7c77$var$pendingEffectsStatus = 3;
    }
}
function $8bd92a9a66fc7c77$var$flushSpawnedWork() {
    if (4 === $8bd92a9a66fc7c77$var$pendingEffectsStatus || 3 === $8bd92a9a66fc7c77$var$pendingEffectsStatus) {
        $8bd92a9a66fc7c77$var$pendingEffectsStatus = 0;
        $8bd92a9a66fc7c77$var$requestPaint();
        var root = $8bd92a9a66fc7c77$var$pendingEffectsRoot, finishedWork = $8bd92a9a66fc7c77$var$pendingFinishedWork, lanes = $8bd92a9a66fc7c77$var$pendingEffectsLanes, recoverableErrors = $8bd92a9a66fc7c77$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $8bd92a9a66fc7c77$var$pendingEffectsStatus = 5 : ($8bd92a9a66fc7c77$var$pendingEffectsStatus = 0, $8bd92a9a66fc7c77$var$pendingFinishedWork = $8bd92a9a66fc7c77$var$pendingEffectsRoot = null, $8bd92a9a66fc7c77$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $8bd92a9a66fc7c77$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($8bd92a9a66fc7c77$var$injectedHook && "function" === typeof $8bd92a9a66fc7c77$var$injectedHook.onCommitFiberRoot) try {
            $8bd92a9a66fc7c77$var$injectedHook.onCommitFiberRoot($8bd92a9a66fc7c77$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $8bd92a9a66fc7c77$var$ReactSharedInternals.T;
            remainingLanes = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
            $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 2;
            $8bd92a9a66fc7c77$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $8bd92a9a66fc7c77$var$ReactSharedInternals.T = finishedWork, $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($8bd92a9a66fc7c77$var$pendingEffectsLanes & 3) && $8bd92a9a66fc7c77$var$flushPendingEffects();
        $8bd92a9a66fc7c77$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $8bd92a9a66fc7c77$var$rootWithNestedUpdates ? $8bd92a9a66fc7c77$var$nestedUpdateCount++ : ($8bd92a9a66fc7c77$var$nestedUpdateCount = 0, $8bd92a9a66fc7c77$var$rootWithNestedUpdates = root) : $8bd92a9a66fc7c77$var$nestedUpdateCount = 0;
        $8bd92a9a66fc7c77$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $8bd92a9a66fc7c77$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $8bd92a9a66fc7c77$var$releaseCache(remainingLanes)));
}
function $8bd92a9a66fc7c77$var$flushPendingEffects() {
    $8bd92a9a66fc7c77$var$flushMutationEffects();
    $8bd92a9a66fc7c77$var$flushLayoutEffects();
    $8bd92a9a66fc7c77$var$flushSpawnedWork();
    return $8bd92a9a66fc7c77$var$flushPassiveEffects();
}
function $8bd92a9a66fc7c77$var$flushPassiveEffects() {
    if (5 !== $8bd92a9a66fc7c77$var$pendingEffectsStatus) return !1;
    var root = $8bd92a9a66fc7c77$var$pendingEffectsRoot, remainingLanes = $8bd92a9a66fc7c77$var$pendingEffectsRemainingLanes;
    $8bd92a9a66fc7c77$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $8bd92a9a66fc7c77$var$lanesToEventPriority($8bd92a9a66fc7c77$var$pendingEffectsLanes), prevTransition = $8bd92a9a66fc7c77$var$ReactSharedInternals.T, previousPriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
    try {
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $8bd92a9a66fc7c77$var$ReactSharedInternals.T = null;
        renderPriority = $8bd92a9a66fc7c77$var$pendingPassiveTransitions;
        $8bd92a9a66fc7c77$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $8bd92a9a66fc7c77$var$pendingEffectsRoot, lanes = $8bd92a9a66fc7c77$var$pendingEffectsLanes;
        $8bd92a9a66fc7c77$var$pendingEffectsStatus = 0;
        $8bd92a9a66fc7c77$var$pendingFinishedWork = $8bd92a9a66fc7c77$var$pendingEffectsRoot = null;
        $8bd92a9a66fc7c77$var$pendingEffectsLanes = 0;
        if (0 !== ($8bd92a9a66fc7c77$var$executionContext & 6)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(331));
        var prevExecutionContext = $8bd92a9a66fc7c77$var$executionContext;
        $8bd92a9a66fc7c77$var$executionContext |= 4;
        $8bd92a9a66fc7c77$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $8bd92a9a66fc7c77$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $8bd92a9a66fc7c77$var$executionContext = prevExecutionContext;
        $8bd92a9a66fc7c77$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($8bd92a9a66fc7c77$var$injectedHook && "function" === typeof $8bd92a9a66fc7c77$var$injectedHook.onPostCommitFiberRoot) try {
            $8bd92a9a66fc7c77$var$injectedHook.onPostCommitFiberRoot($8bd92a9a66fc7c77$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = previousPriority, $8bd92a9a66fc7c77$var$ReactSharedInternals.T = prevTransition, $8bd92a9a66fc7c77$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $8bd92a9a66fc7c77$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $8bd92a9a66fc7c77$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $8bd92a9a66fc7c77$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($8bd92a9a66fc7c77$var$markRootUpdated$1(rootFiber, 2), $8bd92a9a66fc7c77$var$ensureRootIsScheduled(rootFiber));
}
function $8bd92a9a66fc7c77$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $8bd92a9a66fc7c77$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $8bd92a9a66fc7c77$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed || !$8bd92a9a66fc7c77$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $8bd92a9a66fc7c77$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $8bd92a9a66fc7c77$var$createClassErrorUpdate(2);
                instance = $8bd92a9a66fc7c77$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($8bd92a9a66fc7c77$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $8bd92a9a66fc7c77$var$markRootUpdated$1(instance, 2), $8bd92a9a66fc7c77$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $8bd92a9a66fc7c77$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $8bd92a9a66fc7c77$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($8bd92a9a66fc7c77$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $8bd92a9a66fc7c77$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $8bd92a9a66fc7c77$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $8bd92a9a66fc7c77$var$workInProgressRoot === root && ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $8bd92a9a66fc7c77$var$workInProgressRootExitStatus || 3 === $8bd92a9a66fc7c77$var$workInProgressRootExitStatus && ($8bd92a9a66fc7c77$var$workInProgressRootRenderLanes & 62914560) === $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes && 300 > $8bd92a9a66fc7c77$var$now() - $8bd92a9a66fc7c77$var$globalMostRecentFallbackTime ? 0 === ($8bd92a9a66fc7c77$var$executionContext & 2) && $8bd92a9a66fc7c77$var$prepareFreshStack(root, 0) : $8bd92a9a66fc7c77$var$workInProgressRootPingedLanes |= pingedLanes, $8bd92a9a66fc7c77$var$workInProgressSuspendedRetryLanes === $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes && ($8bd92a9a66fc7c77$var$workInProgressSuspendedRetryLanes = 0));
    $8bd92a9a66fc7c77$var$ensureRootIsScheduled(root);
}
function $8bd92a9a66fc7c77$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $8bd92a9a66fc7c77$var$claimNextRetryLane());
    boundaryFiber = $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($8bd92a9a66fc7c77$var$markRootUpdated$1(boundaryFiber, retryLane), $8bd92a9a66fc7c77$var$ensureRootIsScheduled(boundaryFiber));
}
function $8bd92a9a66fc7c77$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $8bd92a9a66fc7c77$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8bd92a9a66fc7c77$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $8bd92a9a66fc7c77$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8bd92a9a66fc7c77$var$scheduleCallback$1(priorityLevel, callback) {
    return $8bd92a9a66fc7c77$var$scheduleCallback$3(priorityLevel, callback);
}
var $8bd92a9a66fc7c77$var$firstScheduledRoot = null, $8bd92a9a66fc7c77$var$lastScheduledRoot = null, $8bd92a9a66fc7c77$var$didScheduleMicrotask = !1, $8bd92a9a66fc7c77$var$mightHavePendingSyncWork = !1, $8bd92a9a66fc7c77$var$isFlushingWork = !1, $8bd92a9a66fc7c77$var$currentEventTransitionLane = 0;
function $8bd92a9a66fc7c77$var$ensureRootIsScheduled(root) {
    root !== $8bd92a9a66fc7c77$var$lastScheduledRoot && null === root.next && (null === $8bd92a9a66fc7c77$var$lastScheduledRoot ? $8bd92a9a66fc7c77$var$firstScheduledRoot = $8bd92a9a66fc7c77$var$lastScheduledRoot = root : $8bd92a9a66fc7c77$var$lastScheduledRoot = $8bd92a9a66fc7c77$var$lastScheduledRoot.next = root);
    $8bd92a9a66fc7c77$var$mightHavePendingSyncWork = !0;
    $8bd92a9a66fc7c77$var$didScheduleMicrotask || ($8bd92a9a66fc7c77$var$didScheduleMicrotask = !0, $8bd92a9a66fc7c77$var$scheduleImmediateRootScheduleTask());
}
function $8bd92a9a66fc7c77$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$8bd92a9a66fc7c77$var$isFlushingWork && $8bd92a9a66fc7c77$var$mightHavePendingSyncWork) {
        $8bd92a9a66fc7c77$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $8bd92a9a66fc7c77$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $8bd92a9a66fc7c77$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $8bd92a9a66fc7c77$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $8bd92a9a66fc7c77$var$getNextLanes(root$170, root$170 === $8bd92a9a66fc7c77$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $8bd92a9a66fc7c77$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $8bd92a9a66fc7c77$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $8bd92a9a66fc7c77$var$isFlushingWork = !1;
    }
}
function $8bd92a9a66fc7c77$var$processRootScheduleInImmediateTask() {
    $8bd92a9a66fc7c77$var$processRootScheduleInMicrotask();
}
function $8bd92a9a66fc7c77$var$processRootScheduleInMicrotask() {
    $8bd92a9a66fc7c77$var$mightHavePendingSyncWork = $8bd92a9a66fc7c77$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $8bd92a9a66fc7c77$var$currentEventTransitionLane && $8bd92a9a66fc7c77$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $8bd92a9a66fc7c77$var$currentEventTransitionLane);
    for(var currentTime = $8bd92a9a66fc7c77$var$now(), prev = null, root = $8bd92a9a66fc7c77$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $8bd92a9a66fc7c77$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $8bd92a9a66fc7c77$var$firstScheduledRoot = next : prev.next = next, null === next && ($8bd92a9a66fc7c77$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $8bd92a9a66fc7c77$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $8bd92a9a66fc7c77$var$pendingEffectsStatus && 5 !== $8bd92a9a66fc7c77$var$pendingEffectsStatus || $8bd92a9a66fc7c77$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $8bd92a9a66fc7c77$var$currentEventTransitionLane && ($8bd92a9a66fc7c77$var$currentEventTransitionLane = 0);
}
function $8bd92a9a66fc7c77$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $8bd92a9a66fc7c77$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $8bd92a9a66fc7c77$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $8bd92a9a66fc7c77$var$workInProgressRoot;
    suspendedLanes = $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes;
    suspendedLanes = $8bd92a9a66fc7c77$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $8bd92a9a66fc7c77$var$workInProgressSuspendedReason || 9 === $8bd92a9a66fc7c77$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $8bd92a9a66fc7c77$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $8bd92a9a66fc7c77$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $8bd92a9a66fc7c77$var$cancelCallback$1(pingedLanes);
        switch($8bd92a9a66fc7c77$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $8bd92a9a66fc7c77$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $8bd92a9a66fc7c77$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $8bd92a9a66fc7c77$var$IdlePriority;
                break;
            default:
                suspendedLanes = $8bd92a9a66fc7c77$var$NormalPriority$1;
        }
        pingedLanes = $8bd92a9a66fc7c77$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $8bd92a9a66fc7c77$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $8bd92a9a66fc7c77$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $8bd92a9a66fc7c77$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $8bd92a9a66fc7c77$var$pendingEffectsStatus && 5 !== $8bd92a9a66fc7c77$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($8bd92a9a66fc7c77$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $8bd92a9a66fc7c77$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $8bd92a9a66fc7c77$var$getNextLanes(root, root === $8bd92a9a66fc7c77$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $8bd92a9a66fc7c77$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $8bd92a9a66fc7c77$var$scheduleTaskForRootDuringMicrotask(root, $8bd92a9a66fc7c77$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $8bd92a9a66fc7c77$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $8bd92a9a66fc7c77$var$performSyncWorkOnRoot(root, lanes) {
    if ($8bd92a9a66fc7c77$var$flushPendingEffects()) return null;
    $8bd92a9a66fc7c77$var$performWorkOnRoot(root, lanes, !0);
}
function $8bd92a9a66fc7c77$var$scheduleImmediateRootScheduleTask() {
    $8bd92a9a66fc7c77$var$scheduleMicrotask(function() {
        0 !== ($8bd92a9a66fc7c77$var$executionContext & 6) ? $8bd92a9a66fc7c77$var$scheduleCallback$3($8bd92a9a66fc7c77$var$ImmediatePriority, $8bd92a9a66fc7c77$var$processRootScheduleInImmediateTask) : $8bd92a9a66fc7c77$var$processRootScheduleInMicrotask();
    });
}
function $8bd92a9a66fc7c77$var$requestTransitionLane() {
    if (0 === $8bd92a9a66fc7c77$var$currentEventTransitionLane) {
        var actionScopeLane = $8bd92a9a66fc7c77$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $8bd92a9a66fc7c77$var$nextTransitionUpdateLane, $8bd92a9a66fc7c77$var$nextTransitionUpdateLane <<= 1, 0 === ($8bd92a9a66fc7c77$var$nextTransitionUpdateLane & 261888) && ($8bd92a9a66fc7c77$var$nextTransitionUpdateLane = 256));
        $8bd92a9a66fc7c77$var$currentEventTransitionLane = actionScopeLane;
    }
    return $8bd92a9a66fc7c77$var$currentEventTransitionLane;
}
function $8bd92a9a66fc7c77$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $8bd92a9a66fc7c77$var$sanitizeURL("" + actionProp);
}
function $8bd92a9a66fc7c77$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $8bd92a9a66fc7c77$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $8bd92a9a66fc7c77$var$coerceFormActionProp((nativeEventTarget[$8bd92a9a66fc7c77$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$8bd92a9a66fc7c77$var$internalPropsKey] || null) ? $8bd92a9a66fc7c77$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $8bd92a9a66fc7c77$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $8bd92a9a66fc7c77$var$currentEventTransitionLane) {
                                var formData = submitter ? $8bd92a9a66fc7c77$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $8bd92a9a66fc7c77$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $8bd92a9a66fc7c77$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $8bd92a9a66fc7c77$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $8bd92a9a66fc7c77$var$i$jscomp$inline_1577 = 0; $8bd92a9a66fc7c77$var$i$jscomp$inline_1577 < $8bd92a9a66fc7c77$var$simpleEventPluginEvents.length; $8bd92a9a66fc7c77$var$i$jscomp$inline_1577++){
    var $8bd92a9a66fc7c77$var$eventName$jscomp$inline_1578 = $8bd92a9a66fc7c77$var$simpleEventPluginEvents[$8bd92a9a66fc7c77$var$i$jscomp$inline_1577], $8bd92a9a66fc7c77$var$domEventName$jscomp$inline_1579 = $8bd92a9a66fc7c77$var$eventName$jscomp$inline_1578.toLowerCase(), $8bd92a9a66fc7c77$var$capitalizedEvent$jscomp$inline_1580 = $8bd92a9a66fc7c77$var$eventName$jscomp$inline_1578[0].toUpperCase() + $8bd92a9a66fc7c77$var$eventName$jscomp$inline_1578.slice(1);
    $8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$domEventName$jscomp$inline_1579, "on" + $8bd92a9a66fc7c77$var$capitalizedEvent$jscomp$inline_1580);
}
$8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$ANIMATION_END, "onAnimationEnd");
$8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$ANIMATION_ITERATION, "onAnimationIteration");
$8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$ANIMATION_START, "onAnimationStart");
$8bd92a9a66fc7c77$var$registerSimpleEvent("dblclick", "onDoubleClick");
$8bd92a9a66fc7c77$var$registerSimpleEvent("focusin", "onFocus");
$8bd92a9a66fc7c77$var$registerSimpleEvent("focusout", "onBlur");
$8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$TRANSITION_RUN, "onTransitionRun");
$8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$TRANSITION_START, "onTransitionStart");
$8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$TRANSITION_CANCEL, "onTransitionCancel");
$8bd92a9a66fc7c77$var$registerSimpleEvent($8bd92a9a66fc7c77$var$TRANSITION_END, "onTransitionEnd");
$8bd92a9a66fc7c77$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8bd92a9a66fc7c77$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8bd92a9a66fc7c77$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8bd92a9a66fc7c77$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8bd92a9a66fc7c77$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8bd92a9a66fc7c77$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8bd92a9a66fc7c77$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8bd92a9a66fc7c77$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8bd92a9a66fc7c77$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8bd92a9a66fc7c77$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8bd92a9a66fc7c77$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8bd92a9a66fc7c77$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($8bd92a9a66fc7c77$var$mediaEventTypes));
function $8bd92a9a66fc7c77$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8bd92a9a66fc7c77$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8bd92a9a66fc7c77$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$8bd92a9a66fc7c77$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$8bd92a9a66fc7c77$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($8bd92a9a66fc7c77$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $8bd92a9a66fc7c77$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $8bd92a9a66fc7c77$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $8bd92a9a66fc7c77$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $8bd92a9a66fc7c77$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$8bd92a9a66fc7c77$var$listeningMarker]) {
        rootContainerElement[$8bd92a9a66fc7c77$var$listeningMarker] = !0;
        $8bd92a9a66fc7c77$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($8bd92a9a66fc7c77$var$nonDelegatedEvents.has(domEventName) || $8bd92a9a66fc7c77$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $8bd92a9a66fc7c77$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$8bd92a9a66fc7c77$var$listeningMarker] || (ownerDocument[$8bd92a9a66fc7c77$var$listeningMarker] = !0, $8bd92a9a66fc7c77$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $8bd92a9a66fc7c77$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($8bd92a9a66fc7c77$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $8bd92a9a66fc7c77$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $8bd92a9a66fc7c77$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $8bd92a9a66fc7c77$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$8bd92a9a66fc7c77$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $8bd92a9a66fc7c77$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $8bd92a9a66fc7c77$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $8bd92a9a66fc7c77$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $8bd92a9a66fc7c77$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $8bd92a9a66fc7c77$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $8bd92a9a66fc7c77$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticTouchEvent;
                        break;
                    case $8bd92a9a66fc7c77$var$ANIMATION_END:
                    case $8bd92a9a66fc7c77$var$ANIMATION_ITERATION:
                    case $8bd92a9a66fc7c77$var$ANIMATION_START:
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticAnimationEvent;
                        break;
                    case $8bd92a9a66fc7c77$var$TRANSITION_END:
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $8bd92a9a66fc7c77$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $8bd92a9a66fc7c77$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($8bd92a9a66fc7c77$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $8bd92a9a66fc7c77$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($8bd92a9a66fc7c77$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$8bd92a9a66fc7c77$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $8bd92a9a66fc7c77$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $8bd92a9a66fc7c77$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $8bd92a9a66fc7c77$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $8bd92a9a66fc7c77$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $8bd92a9a66fc7c77$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $8bd92a9a66fc7c77$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $8bd92a9a66fc7c77$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $8bd92a9a66fc7c77$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $8bd92a9a66fc7c77$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $8bd92a9a66fc7c77$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $8bd92a9a66fc7c77$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $8bd92a9a66fc7c77$var$getTargetInstForChangeEvent;
                else if ($8bd92a9a66fc7c77$var$isTextInputElement(reactName)) {
                    if ($8bd92a9a66fc7c77$var$isInputEventSupported) getTargetInstFunc = $8bd92a9a66fc7c77$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $8bd92a9a66fc7c77$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $8bd92a9a66fc7c77$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $8bd92a9a66fc7c77$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $8bd92a9a66fc7c77$var$getTargetInstForChangeEvent) : getTargetInstFunc = $8bd92a9a66fc7c77$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $8bd92a9a66fc7c77$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $8bd92a9a66fc7c77$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $8bd92a9a66fc7c77$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($8bd92a9a66fc7c77$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $8bd92a9a66fc7c77$var$activeElement = handleEventFunc, $8bd92a9a66fc7c77$var$activeElementInst = targetInst, $8bd92a9a66fc7c77$var$lastSelection = null;
                    break;
                case "focusout":
                    $8bd92a9a66fc7c77$var$lastSelection = $8bd92a9a66fc7c77$var$activeElementInst = $8bd92a9a66fc7c77$var$activeElement = null;
                    break;
                case "mousedown":
                    $8bd92a9a66fc7c77$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8bd92a9a66fc7c77$var$mouseDown = !1;
                    $8bd92a9a66fc7c77$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($8bd92a9a66fc7c77$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $8bd92a9a66fc7c77$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($8bd92a9a66fc7c77$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $8bd92a9a66fc7c77$var$isComposing ? $8bd92a9a66fc7c77$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($8bd92a9a66fc7c77$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($8bd92a9a66fc7c77$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $8bd92a9a66fc7c77$var$isComposing && (fallbackData = $8bd92a9a66fc7c77$var$getData()) : ($8bd92a9a66fc7c77$var$root = nativeEventTarget, $8bd92a9a66fc7c77$var$startText = "value" in $8bd92a9a66fc7c77$var$root ? $8bd92a9a66fc7c77$var$root.value : $8bd92a9a66fc7c77$var$root.textContent, $8bd92a9a66fc7c77$var$isComposing = !0)), handleEventFunc = $8bd92a9a66fc7c77$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $8bd92a9a66fc7c77$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $8bd92a9a66fc7c77$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $8bd92a9a66fc7c77$var$canUseTextInputEvent ? $8bd92a9a66fc7c77$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $8bd92a9a66fc7c77$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $8bd92a9a66fc7c77$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $8bd92a9a66fc7c77$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $8bd92a9a66fc7c77$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $8bd92a9a66fc7c77$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $8bd92a9a66fc7c77$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $8bd92a9a66fc7c77$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $8bd92a9a66fc7c77$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($8bd92a9a66fc7c77$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $8bd92a9a66fc7c77$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($8bd92a9a66fc7c77$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $8bd92a9a66fc7c77$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $8bd92a9a66fc7c77$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $8bd92a9a66fc7c77$var$getListener(target, registrationName), null != stateNode && listeners.unshift($8bd92a9a66fc7c77$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $8bd92a9a66fc7c77$var$getListener(target, registrationName), null != stateNode && listeners.push($8bd92a9a66fc7c77$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $8bd92a9a66fc7c77$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $8bd92a9a66fc7c77$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $8bd92a9a66fc7c77$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($8bd92a9a66fc7c77$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($8bd92a9a66fc7c77$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $8bd92a9a66fc7c77$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $8bd92a9a66fc7c77$var$normalizeMarkupForTextOrAttribute(clientText);
    return $8bd92a9a66fc7c77$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $8bd92a9a66fc7c77$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $8bd92a9a66fc7c77$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $8bd92a9a66fc7c77$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $8bd92a9a66fc7c77$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $8bd92a9a66fc7c77$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $8bd92a9a66fc7c77$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $8bd92a9a66fc7c77$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $8bd92a9a66fc7c77$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8bd92a9a66fc7c77$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $8bd92a9a66fc7c77$var$setProp(domElement, tag, "name", props.name, props, null), $8bd92a9a66fc7c77$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $8bd92a9a66fc7c77$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $8bd92a9a66fc7c77$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($8bd92a9a66fc7c77$var$setProp(domElement, tag, "encType", props.encType, props, null), $8bd92a9a66fc7c77$var$setProp(domElement, tag, "method", props.method, props, null), $8bd92a9a66fc7c77$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8bd92a9a66fc7c77$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8bd92a9a66fc7c77$var$noop$1);
            break;
        case "onScroll":
            null != value && $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $8bd92a9a66fc7c77$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("toggle", domElement);
            $8bd92a9a66fc7c77$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $8bd92a9a66fc7c77$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $8bd92a9a66fc7c77$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $8bd92a9a66fc7c77$var$aliases.get(key) || key, $8bd92a9a66fc7c77$var$setValueForAttribute(domElement, key, value);
    }
}
function $8bd92a9a66fc7c77$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $8bd92a9a66fc7c77$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $8bd92a9a66fc7c77$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $8bd92a9a66fc7c77$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8bd92a9a66fc7c77$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$8bd92a9a66fc7c77$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$8bd92a9a66fc7c77$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $8bd92a9a66fc7c77$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $8bd92a9a66fc7c77$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("error", domElement);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(137, tag));
                    default:
                        $8bd92a9a66fc7c77$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $8bd92a9a66fc7c77$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $8bd92a9a66fc7c77$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $8bd92a9a66fc7c77$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $8bd92a9a66fc7c77$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $8bd92a9a66fc7c77$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $8bd92a9a66fc7c77$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(91));
                    break;
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $8bd92a9a66fc7c77$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("toggle", domElement);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("cancel", domElement);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $8bd92a9a66fc7c77$var$mediaEventTypes.length; hasSrc++)$8bd92a9a66fc7c77$var$listenToNonDelegatedEvent($8bd92a9a66fc7c77$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("error", domElement);
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("error", domElement), $8bd92a9a66fc7c77$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(137, tag));
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($8bd92a9a66fc7c77$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $8bd92a9a66fc7c77$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $8bd92a9a66fc7c77$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $8bd92a9a66fc7c77$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $8bd92a9a66fc7c77$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $8bd92a9a66fc7c77$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $8bd92a9a66fc7c77$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $8bd92a9a66fc7c77$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $8bd92a9a66fc7c77$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $8bd92a9a66fc7c77$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $8bd92a9a66fc7c77$var$updateOptions(domElement, !!lastProps, tag, !0) : $8bd92a9a66fc7c77$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $8bd92a9a66fc7c77$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $8bd92a9a66fc7c77$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $8bd92a9a66fc7c77$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $8bd92a9a66fc7c77$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($8bd92a9a66fc7c77$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $8bd92a9a66fc7c77$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $8bd92a9a66fc7c77$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $8bd92a9a66fc7c77$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $8bd92a9a66fc7c77$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $8bd92a9a66fc7c77$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $8bd92a9a66fc7c77$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $8bd92a9a66fc7c77$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $8bd92a9a66fc7c77$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $8bd92a9a66fc7c77$var$eventsEnabled = null, $8bd92a9a66fc7c77$var$selectionInformation = null;
function $8bd92a9a66fc7c77$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $8bd92a9a66fc7c77$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $8bd92a9a66fc7c77$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $8bd92a9a66fc7c77$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $8bd92a9a66fc7c77$var$currentPopstateTransitionEvent = null;
function $8bd92a9a66fc7c77$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $8bd92a9a66fc7c77$var$currentPopstateTransitionEvent) return !1;
        $8bd92a9a66fc7c77$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $8bd92a9a66fc7c77$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $8bd92a9a66fc7c77$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $8bd92a9a66fc7c77$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $8bd92a9a66fc7c77$var$localPromise = "function" === typeof Promise ? Promise : void 0, $8bd92a9a66fc7c77$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8bd92a9a66fc7c77$var$localPromise ? function(callback) {
    return $8bd92a9a66fc7c77$var$localPromise.resolve(null).then(callback).catch($8bd92a9a66fc7c77$var$handleErrorInNextTick);
} : $8bd92a9a66fc7c77$var$scheduleTimeout;
function $8bd92a9a66fc7c77$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $8bd92a9a66fc7c77$var$isSingletonScope(type) {
    return "head" === type;
}
function $8bd92a9a66fc7c77$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $8bd92a9a66fc7c77$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $8bd92a9a66fc7c77$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $8bd92a9a66fc7c77$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$8bd92a9a66fc7c77$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $8bd92a9a66fc7c77$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $8bd92a9a66fc7c77$var$retryIfBlockedOn(hydrationInstance);
}
function $8bd92a9a66fc7c77$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $8bd92a9a66fc7c77$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $8bd92a9a66fc7c77$var$clearContainerSparingly(node);
                $8bd92a9a66fc7c77$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $8bd92a9a66fc7c77$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$8bd92a9a66fc7c77$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $8bd92a9a66fc7c77$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $8bd92a9a66fc7c77$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8bd92a9a66fc7c77$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8bd92a9a66fc7c77$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8bd92a9a66fc7c77$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8bd92a9a66fc7c77$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $8bd92a9a66fc7c77$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $8bd92a9a66fc7c77$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $8bd92a9a66fc7c77$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $8bd92a9a66fc7c77$var$previousHydratableOnEnteringScopedSingleton = null;
function $8bd92a9a66fc7c77$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $8bd92a9a66fc7c77$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $8bd92a9a66fc7c77$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $8bd92a9a66fc7c77$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $8bd92a9a66fc7c77$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(451));
    }
}
function $8bd92a9a66fc7c77$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $8bd92a9a66fc7c77$var$detachDeletedInstance(instance);
}
var $8bd92a9a66fc7c77$var$preloadPropsMap = new Map(), $8bd92a9a66fc7c77$var$preconnectsSet = new Set();
function $8bd92a9a66fc7c77$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $8bd92a9a66fc7c77$var$previousDispatcher = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.d;
$8bd92a9a66fc7c77$var$ReactDOMSharedInternals.d = {
    f: $8bd92a9a66fc7c77$var$flushSyncWork,
    r: $8bd92a9a66fc7c77$var$requestFormReset,
    D: $8bd92a9a66fc7c77$var$prefetchDNS,
    C: $8bd92a9a66fc7c77$var$preconnect,
    L: $8bd92a9a66fc7c77$var$preload,
    m: $8bd92a9a66fc7c77$var$preloadModule,
    X: $8bd92a9a66fc7c77$var$preinitScript,
    S: $8bd92a9a66fc7c77$var$preinitStyle,
    M: $8bd92a9a66fc7c77$var$preinitModuleScript
};
function $8bd92a9a66fc7c77$var$flushSyncWork() {
    var previousWasRendering = $8bd92a9a66fc7c77$var$previousDispatcher.f(), wasRendering = $8bd92a9a66fc7c77$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $8bd92a9a66fc7c77$var$requestFormReset(form) {
    var formInst = $8bd92a9a66fc7c77$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $8bd92a9a66fc7c77$var$requestFormReset$1(formInst) : $8bd92a9a66fc7c77$var$previousDispatcher.r(form);
}
var $8bd92a9a66fc7c77$var$globalDocument = "undefined" === typeof document ? null : document;
function $8bd92a9a66fc7c77$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $8bd92a9a66fc7c77$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $8bd92a9a66fc7c77$var$preconnectsSet.has(limitedEscapedHref) || ($8bd92a9a66fc7c77$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $8bd92a9a66fc7c77$var$setInitialProperties(href, "link", rel), $8bd92a9a66fc7c77$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $8bd92a9a66fc7c77$var$prefetchDNS(href) {
    $8bd92a9a66fc7c77$var$previousDispatcher.D(href);
    $8bd92a9a66fc7c77$var$preconnectAs("dns-prefetch", href, null);
}
function $8bd92a9a66fc7c77$var$preconnect(href, crossOrigin) {
    $8bd92a9a66fc7c77$var$previousDispatcher.C(href, crossOrigin);
    $8bd92a9a66fc7c77$var$preconnectAs("preconnect", href, crossOrigin);
}
function $8bd92a9a66fc7c77$var$preload(href, as, options) {
    $8bd92a9a66fc7c77$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $8bd92a9a66fc7c77$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $8bd92a9a66fc7c77$var$getStyleKey(href);
                break;
            case "script":
                key = $8bd92a9a66fc7c77$var$getScriptKey(href);
        }
        $8bd92a9a66fc7c77$var$preloadPropsMap.has(key) || (href = $8bd92a9a66fc7c77$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $8bd92a9a66fc7c77$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($8bd92a9a66fc7c77$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($8bd92a9a66fc7c77$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $8bd92a9a66fc7c77$var$setInitialProperties(as, "link", href), $8bd92a9a66fc7c77$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $8bd92a9a66fc7c77$var$preloadModule(href, options) {
    $8bd92a9a66fc7c77$var$previousDispatcher.m(href, options);
    var ownerDocument = $8bd92a9a66fc7c77$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $8bd92a9a66fc7c77$var$getScriptKey(href);
        }
        if (!$8bd92a9a66fc7c77$var$preloadPropsMap.has(key) && (href = $8bd92a9a66fc7c77$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $8bd92a9a66fc7c77$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($8bd92a9a66fc7c77$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $8bd92a9a66fc7c77$var$setInitialProperties(as, "link", href);
            $8bd92a9a66fc7c77$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $8bd92a9a66fc7c77$var$preinitStyle(href, precedence, options) {
    $8bd92a9a66fc7c77$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $8bd92a9a66fc7c77$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $8bd92a9a66fc7c77$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $8bd92a9a66fc7c77$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($8bd92a9a66fc7c77$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $8bd92a9a66fc7c77$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $8bd92a9a66fc7c77$var$preloadPropsMap.get(key)) && $8bd92a9a66fc7c77$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $8bd92a9a66fc7c77$var$markNodeAsHoistable(link);
                $8bd92a9a66fc7c77$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $8bd92a9a66fc7c77$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $8bd92a9a66fc7c77$var$preinitScript(src, options) {
    $8bd92a9a66fc7c77$var$previousDispatcher.X(src, options);
    var ownerDocument = $8bd92a9a66fc7c77$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8bd92a9a66fc7c77$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8bd92a9a66fc7c77$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8bd92a9a66fc7c77$var$getScriptSelectorFromKey(key)), resource || (src = $8bd92a9a66fc7c77$var$assign({
            src: src,
            async: !0
        }, options), (options = $8bd92a9a66fc7c77$var$preloadPropsMap.get(key)) && $8bd92a9a66fc7c77$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8bd92a9a66fc7c77$var$markNodeAsHoistable(resource), $8bd92a9a66fc7c77$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8bd92a9a66fc7c77$var$preinitModuleScript(src, options) {
    $8bd92a9a66fc7c77$var$previousDispatcher.M(src, options);
    var ownerDocument = $8bd92a9a66fc7c77$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8bd92a9a66fc7c77$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8bd92a9a66fc7c77$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8bd92a9a66fc7c77$var$getScriptSelectorFromKey(key)), resource || (src = $8bd92a9a66fc7c77$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $8bd92a9a66fc7c77$var$preloadPropsMap.get(key)) && $8bd92a9a66fc7c77$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8bd92a9a66fc7c77$var$markNodeAsHoistable(resource), $8bd92a9a66fc7c77$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8bd92a9a66fc7c77$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $8bd92a9a66fc7c77$var$rootInstanceStackCursor.current) ? $8bd92a9a66fc7c77$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $8bd92a9a66fc7c77$var$getStyleKey(pendingProps.href), pendingProps = $8bd92a9a66fc7c77$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $8bd92a9a66fc7c77$var$getStyleKey(pendingProps.href);
                var styles$243 = $8bd92a9a66fc7c77$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($8bd92a9a66fc7c77$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $8bd92a9a66fc7c77$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $8bd92a9a66fc7c77$var$preloadPropsMap.set(type, pendingProps), styles$243 || $8bd92a9a66fc7c77$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $8bd92a9a66fc7c77$var$getScriptKey(pendingProps), pendingProps = $8bd92a9a66fc7c77$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(444, type));
    }
}
function $8bd92a9a66fc7c77$var$getStyleKey(href) {
    return 'href="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $8bd92a9a66fc7c77$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $8bd92a9a66fc7c77$var$stylesheetPropsFromRawProps(rawProps) {
    return $8bd92a9a66fc7c77$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $8bd92a9a66fc7c77$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $8bd92a9a66fc7c77$var$setInitialProperties(key, "link", preloadProps), $8bd92a9a66fc7c77$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $8bd92a9a66fc7c77$var$getScriptKey(src) {
    return '[src="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $8bd92a9a66fc7c77$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $8bd92a9a66fc7c77$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $8bd92a9a66fc7c77$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $8bd92a9a66fc7c77$var$markNodeAsHoistable(instance), instance;
            var styleProps = $8bd92a9a66fc7c77$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $8bd92a9a66fc7c77$var$markNodeAsHoistable(instance);
            $8bd92a9a66fc7c77$var$setInitialProperties(instance, "style", styleProps);
            $8bd92a9a66fc7c77$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $8bd92a9a66fc7c77$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($8bd92a9a66fc7c77$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $8bd92a9a66fc7c77$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $8bd92a9a66fc7c77$var$stylesheetPropsFromRawProps(props);
            (styleProps = $8bd92a9a66fc7c77$var$preloadPropsMap.get(styleProps)) && $8bd92a9a66fc7c77$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $8bd92a9a66fc7c77$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8bd92a9a66fc7c77$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $8bd92a9a66fc7c77$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $8bd92a9a66fc7c77$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($8bd92a9a66fc7c77$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $8bd92a9a66fc7c77$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $8bd92a9a66fc7c77$var$preloadPropsMap.get(instance$249)) instance = $8bd92a9a66fc7c77$var$assign({}, props), $8bd92a9a66fc7c77$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $8bd92a9a66fc7c77$var$markNodeAsHoistable(styleProps);
            $8bd92a9a66fc7c77$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $8bd92a9a66fc7c77$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $8bd92a9a66fc7c77$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $8bd92a9a66fc7c77$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $8bd92a9a66fc7c77$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $8bd92a9a66fc7c77$var$tagCaches = null;
function $8bd92a9a66fc7c77$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $8bd92a9a66fc7c77$var$tagCaches) {
        var cache = new Map();
        var caches = $8bd92a9a66fc7c77$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $8bd92a9a66fc7c77$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$8bd92a9a66fc7c77$var$internalHoistableMarker] || node[$8bd92a9a66fc7c77$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $8bd92a9a66fc7c77$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $8bd92a9a66fc7c77$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $8bd92a9a66fc7c77$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $8bd92a9a66fc7c77$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $8bd92a9a66fc7c77$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($8bd92a9a66fc7c77$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $8bd92a9a66fc7c77$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $8bd92a9a66fc7c77$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $8bd92a9a66fc7c77$var$stylesheetPropsFromRawProps(props);
            (key = $8bd92a9a66fc7c77$var$preloadPropsMap.get(key)) && $8bd92a9a66fc7c77$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $8bd92a9a66fc7c77$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8bd92a9a66fc7c77$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $8bd92a9a66fc7c77$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $8bd92a9a66fc7c77$var$estimatedBytesWithinLimit = 0;
function $8bd92a9a66fc7c77$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $8bd92a9a66fc7c77$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $8bd92a9a66fc7c77$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $8bd92a9a66fc7c77$var$estimatedBytesWithinLimit && ($8bd92a9a66fc7c77$var$estimatedBytesWithinLimit = 62500 * $8bd92a9a66fc7c77$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $8bd92a9a66fc7c77$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $8bd92a9a66fc7c77$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $8bd92a9a66fc7c77$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $8bd92a9a66fc7c77$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $8bd92a9a66fc7c77$var$precedencesByRoot = null;
function $8bd92a9a66fc7c77$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $8bd92a9a66fc7c77$var$precedencesByRoot = new Map(), resources.forEach($8bd92a9a66fc7c77$var$insertStylesheetIntoRoot, state), $8bd92a9a66fc7c77$var$precedencesByRoot = null, $8bd92a9a66fc7c77$var$onUnsuspend.call(state));
}
function $8bd92a9a66fc7c77$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $8bd92a9a66fc7c77$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $8bd92a9a66fc7c77$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $8bd92a9a66fc7c77$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $8bd92a9a66fc7c77$var$HostTransitionContext = {
    $$typeof: $8bd92a9a66fc7c77$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $8bd92a9a66fc7c77$var$sharedNotPendingObject,
    _currentValue2: $8bd92a9a66fc7c77$var$sharedNotPendingObject,
    _threadCount: 0
};
function $8bd92a9a66fc7c77$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $8bd92a9a66fc7c77$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8bd92a9a66fc7c77$var$createLaneMap(0);
    this.hiddenUpdates = $8bd92a9a66fc7c77$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $8bd92a9a66fc7c77$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $8bd92a9a66fc7c77$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $8bd92a9a66fc7c77$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $8bd92a9a66fc7c77$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $8bd92a9a66fc7c77$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $8bd92a9a66fc7c77$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $8bd92a9a66fc7c77$var$emptyContextObject;
    parentComponent = $8bd92a9a66fc7c77$var$emptyContextObject;
    return parentComponent;
}
function $8bd92a9a66fc7c77$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $8bd92a9a66fc7c77$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $8bd92a9a66fc7c77$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $8bd92a9a66fc7c77$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(element, rootFiber, lane), $8bd92a9a66fc7c77$var$entangleTransitions(element, rootFiber, lane));
}
function $8bd92a9a66fc7c77$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $8bd92a9a66fc7c77$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $8bd92a9a66fc7c77$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $8bd92a9a66fc7c77$var$markRetryLaneImpl(fiber, retryLane);
}
function $8bd92a9a66fc7c77$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $8bd92a9a66fc7c77$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $8bd92a9a66fc7c77$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $8bd92a9a66fc7c77$var$requestUpdateLane();
        lane = $8bd92a9a66fc7c77$var$getBumpedLaneForHydrationByLane(lane);
        var root = $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(root, fiber, lane);
        $8bd92a9a66fc7c77$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $8bd92a9a66fc7c77$var$_enabled = !0;
function $8bd92a9a66fc7c77$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8bd92a9a66fc7c77$var$ReactSharedInternals.T;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.T = null;
    var previousPriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
    try {
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 2, $8bd92a9a66fc7c77$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = previousPriority, $8bd92a9a66fc7c77$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8bd92a9a66fc7c77$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8bd92a9a66fc7c77$var$ReactSharedInternals.T;
    $8bd92a9a66fc7c77$var$ReactSharedInternals.T = null;
    var previousPriority = $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p;
    try {
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = 8, $8bd92a9a66fc7c77$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8bd92a9a66fc7c77$var$ReactDOMSharedInternals.p = previousPriority, $8bd92a9a66fc7c77$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8bd92a9a66fc7c77$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($8bd92a9a66fc7c77$var$_enabled) {
        var blockedOn = $8bd92a9a66fc7c77$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $8bd92a9a66fc7c77$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8bd92a9a66fc7c77$var$return_targetInst, targetContainer), $8bd92a9a66fc7c77$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($8bd92a9a66fc7c77$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($8bd92a9a66fc7c77$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $8bd92a9a66fc7c77$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $8bd92a9a66fc7c77$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $8bd92a9a66fc7c77$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $8bd92a9a66fc7c77$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $8bd92a9a66fc7c77$var$ensureRootIsScheduled(fiber);
                                0 === ($8bd92a9a66fc7c77$var$executionContext & 6) && ($8bd92a9a66fc7c77$var$workInProgressRootRenderTargetTime = $8bd92a9a66fc7c77$var$now() + 500, $8bd92a9a66fc7c77$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $8bd92a9a66fc7c77$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $8bd92a9a66fc7c77$var$scheduleUpdateOnFiber(root, fiber, 2), $8bd92a9a66fc7c77$var$flushSyncWork$1(), $8bd92a9a66fc7c77$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $8bd92a9a66fc7c77$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $8bd92a9a66fc7c77$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8bd92a9a66fc7c77$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $8bd92a9a66fc7c77$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $8bd92a9a66fc7c77$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $8bd92a9a66fc7c77$var$getEventTarget(nativeEvent);
    return $8bd92a9a66fc7c77$var$findInstanceBlockingTarget(nativeEvent);
}
var $8bd92a9a66fc7c77$var$return_targetInst = null;
function $8bd92a9a66fc7c77$var$findInstanceBlockingTarget(targetNode) {
    $8bd92a9a66fc7c77$var$return_targetInst = null;
    targetNode = $8bd92a9a66fc7c77$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $8bd92a9a66fc7c77$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $8bd92a9a66fc7c77$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $8bd92a9a66fc7c77$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $8bd92a9a66fc7c77$var$return_targetInst = targetNode;
    return null;
}
function $8bd92a9a66fc7c77$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($8bd92a9a66fc7c77$var$getCurrentPriorityLevel()){
                case $8bd92a9a66fc7c77$var$ImmediatePriority:
                    return 2;
                case $8bd92a9a66fc7c77$var$UserBlockingPriority:
                    return 8;
                case $8bd92a9a66fc7c77$var$NormalPriority$1:
                case $8bd92a9a66fc7c77$var$LowPriority:
                    return 32;
                case $8bd92a9a66fc7c77$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $8bd92a9a66fc7c77$var$hasScheduledReplayAttempt = !1, $8bd92a9a66fc7c77$var$queuedFocus = null, $8bd92a9a66fc7c77$var$queuedDrag = null, $8bd92a9a66fc7c77$var$queuedMouse = null, $8bd92a9a66fc7c77$var$queuedPointers = new Map(), $8bd92a9a66fc7c77$var$queuedPointerCaptures = new Map(), $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets = [], $8bd92a9a66fc7c77$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $8bd92a9a66fc7c77$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $8bd92a9a66fc7c77$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $8bd92a9a66fc7c77$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $8bd92a9a66fc7c77$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $8bd92a9a66fc7c77$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8bd92a9a66fc7c77$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $8bd92a9a66fc7c77$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $8bd92a9a66fc7c77$var$getInstanceFromNode(blockedOn), null !== blockedOn && $8bd92a9a66fc7c77$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $8bd92a9a66fc7c77$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $8bd92a9a66fc7c77$var$queuedFocus = $8bd92a9a66fc7c77$var$accumulateOrCreateContinuousQueuedReplayableEvent($8bd92a9a66fc7c77$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $8bd92a9a66fc7c77$var$queuedDrag = $8bd92a9a66fc7c77$var$accumulateOrCreateContinuousQueuedReplayableEvent($8bd92a9a66fc7c77$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $8bd92a9a66fc7c77$var$queuedMouse = $8bd92a9a66fc7c77$var$accumulateOrCreateContinuousQueuedReplayableEvent($8bd92a9a66fc7c77$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $8bd92a9a66fc7c77$var$queuedPointers.set(pointerId, $8bd92a9a66fc7c77$var$accumulateOrCreateContinuousQueuedReplayableEvent($8bd92a9a66fc7c77$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $8bd92a9a66fc7c77$var$queuedPointerCaptures.set(pointerId, $8bd92a9a66fc7c77$var$accumulateOrCreateContinuousQueuedReplayableEvent($8bd92a9a66fc7c77$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $8bd92a9a66fc7c77$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $8bd92a9a66fc7c77$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $8bd92a9a66fc7c77$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $8bd92a9a66fc7c77$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8bd92a9a66fc7c77$var$runWithPriority(queuedTarget.priority, function() {
                        $8bd92a9a66fc7c77$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $8bd92a9a66fc7c77$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8bd92a9a66fc7c77$var$runWithPriority(queuedTarget.priority, function() {
                        $8bd92a9a66fc7c77$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $8bd92a9a66fc7c77$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $8bd92a9a66fc7c77$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $8bd92a9a66fc7c77$var$currentReplayingEvent = null;
        } else return targetContainers = $8bd92a9a66fc7c77$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $8bd92a9a66fc7c77$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $8bd92a9a66fc7c77$var$replayUnblockedEvents() {
    $8bd92a9a66fc7c77$var$hasScheduledReplayAttempt = !1;
    null !== $8bd92a9a66fc7c77$var$queuedFocus && $8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEvent($8bd92a9a66fc7c77$var$queuedFocus) && ($8bd92a9a66fc7c77$var$queuedFocus = null);
    null !== $8bd92a9a66fc7c77$var$queuedDrag && $8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEvent($8bd92a9a66fc7c77$var$queuedDrag) && ($8bd92a9a66fc7c77$var$queuedDrag = null);
    null !== $8bd92a9a66fc7c77$var$queuedMouse && $8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEvent($8bd92a9a66fc7c77$var$queuedMouse) && ($8bd92a9a66fc7c77$var$queuedMouse = null);
    $8bd92a9a66fc7c77$var$queuedPointers.forEach($8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEventInMap);
    $8bd92a9a66fc7c77$var$queuedPointerCaptures.forEach($8bd92a9a66fc7c77$var$attemptReplayContinuousQueuedEventInMap);
}
function $8bd92a9a66fc7c77$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $8bd92a9a66fc7c77$var$hasScheduledReplayAttempt || ($8bd92a9a66fc7c77$var$hasScheduledReplayAttempt = !0, $e744u.unstable_scheduleCallback($e744u.unstable_NormalPriority, $8bd92a9a66fc7c77$var$replayUnblockedEvents)));
}
var $8bd92a9a66fc7c77$var$lastScheduledReplayQueue = null;
function $8bd92a9a66fc7c77$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $8bd92a9a66fc7c77$var$lastScheduledReplayQueue !== formReplayingQueue && ($8bd92a9a66fc7c77$var$lastScheduledReplayQueue = formReplayingQueue, $e744u.unstable_scheduleCallback($e744u.unstable_NormalPriority, function() {
        $8bd92a9a66fc7c77$var$lastScheduledReplayQueue === formReplayingQueue && ($8bd92a9a66fc7c77$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $8bd92a9a66fc7c77$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $8bd92a9a66fc7c77$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $8bd92a9a66fc7c77$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $8bd92a9a66fc7c77$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $8bd92a9a66fc7c77$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $8bd92a9a66fc7c77$var$queuedFocus && $8bd92a9a66fc7c77$var$scheduleCallbackIfUnblocked($8bd92a9a66fc7c77$var$queuedFocus, unblocked);
    null !== $8bd92a9a66fc7c77$var$queuedDrag && $8bd92a9a66fc7c77$var$scheduleCallbackIfUnblocked($8bd92a9a66fc7c77$var$queuedDrag, unblocked);
    null !== $8bd92a9a66fc7c77$var$queuedMouse && $8bd92a9a66fc7c77$var$scheduleCallbackIfUnblocked($8bd92a9a66fc7c77$var$queuedMouse, unblocked);
    $8bd92a9a66fc7c77$var$queuedPointers.forEach(unblock);
    $8bd92a9a66fc7c77$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets.length && (i = $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$8bd92a9a66fc7c77$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$8bd92a9a66fc7c77$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $8bd92a9a66fc7c77$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$8bd92a9a66fc7c77$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $8bd92a9a66fc7c77$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $8bd92a9a66fc7c77$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $8bd92a9a66fc7c77$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $8bd92a9a66fc7c77$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8bd92a9a66fc7c77$var$ReactDOMHydrationRoot.prototype.render = $8bd92a9a66fc7c77$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(409));
    var current = root.current, lane = $8bd92a9a66fc7c77$var$requestUpdateLane();
    $8bd92a9a66fc7c77$var$updateContainerImpl(current, lane, children, root, null, null);
};
$8bd92a9a66fc7c77$var$ReactDOMHydrationRoot.prototype.unmount = $8bd92a9a66fc7c77$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $8bd92a9a66fc7c77$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $8bd92a9a66fc7c77$var$flushSyncWork$1();
        container[$8bd92a9a66fc7c77$var$internalContainerInstanceKey] = null;
    }
};
function $8bd92a9a66fc7c77$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8bd92a9a66fc7c77$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $8bd92a9a66fc7c77$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets[i].priority; i++);
        $8bd92a9a66fc7c77$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $8bd92a9a66fc7c77$var$attemptExplicitHydrationTarget(target);
    }
};
var $8bd92a9a66fc7c77$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $fITET.version;
if ("19.2.8" !== $8bd92a9a66fc7c77$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(527, $8bd92a9a66fc7c77$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$8bd92a9a66fc7c77$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $8bd92a9a66fc7c77$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $8bd92a9a66fc7c77$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $8bd92a9a66fc7c77$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $8bd92a9a66fc7c77$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8bd92a9a66fc7c77$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8bd92a9a66fc7c77$var$hook$jscomp$inline_2348.isDisabled && $8bd92a9a66fc7c77$var$hook$jscomp$inline_2348.supportsFiber) try {
        $8bd92a9a66fc7c77$var$rendererID = $8bd92a9a66fc7c77$var$hook$jscomp$inline_2348.inject($8bd92a9a66fc7c77$var$internals$jscomp$inline_2347), $8bd92a9a66fc7c77$var$injectedHook = $8bd92a9a66fc7c77$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$8bd92a9a66fc7c77$export$882461b6382ed46c = function(container, options) {
    if (!$8bd92a9a66fc7c77$var$isValidContainer(container)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8bd92a9a66fc7c77$var$defaultOnUncaughtError, onCaughtError = $8bd92a9a66fc7c77$var$defaultOnCaughtError, onRecoverableError = $8bd92a9a66fc7c77$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $8bd92a9a66fc7c77$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $8bd92a9a66fc7c77$var$defaultOnDefaultTransitionIndicator);
    container[$8bd92a9a66fc7c77$var$internalContainerInstanceKey] = options.current;
    $8bd92a9a66fc7c77$var$listenToAllSupportedEvents(container);
    return new $8bd92a9a66fc7c77$var$ReactDOMRoot(options);
};
$8bd92a9a66fc7c77$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$8bd92a9a66fc7c77$var$isValidContainer(container)) throw Error($8bd92a9a66fc7c77$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8bd92a9a66fc7c77$var$defaultOnUncaughtError, onCaughtError = $8bd92a9a66fc7c77$var$defaultOnCaughtError, onRecoverableError = $8bd92a9a66fc7c77$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $8bd92a9a66fc7c77$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $8bd92a9a66fc7c77$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $8bd92a9a66fc7c77$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $8bd92a9a66fc7c77$var$requestUpdateLane();
    isStrictMode = $8bd92a9a66fc7c77$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $8bd92a9a66fc7c77$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $8bd92a9a66fc7c77$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $8bd92a9a66fc7c77$var$markRootUpdated$1(initialChildren, options);
    $8bd92a9a66fc7c77$var$ensureRootIsScheduled(initialChildren);
    container[$8bd92a9a66fc7c77$var$internalContainerInstanceKey] = initialChildren.current;
    $8bd92a9a66fc7c77$var$listenToAllSupportedEvents(container);
    return new $8bd92a9a66fc7c77$var$ReactDOMHydrationRoot(initialChildren);
};
$8bd92a9a66fc7c77$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("e744u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hwoem"));

});
parcelRegister("hwoem", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $cc18388832d02742$export$c4744153514ff05d; }, function (v) { return $cc18388832d02742$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $cc18388832d02742$export$3e506c1ccc9cc1a7; }, function (v) { return $cc18388832d02742$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $cc18388832d02742$export$e26fe2ed2fa76875; }, function (v) { return $cc18388832d02742$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $cc18388832d02742$export$502329bbf4b505b1; }, function (v) { return $cc18388832d02742$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $cc18388832d02742$export$6e3807111c4874c4; }, function (v) { return $cc18388832d02742$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $cc18388832d02742$export$c27134553091fb3a; }, function (v) { return $cc18388832d02742$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $cc18388832d02742$export$33ee1acdc04fd2a2; }, function (v) { return $cc18388832d02742$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $cc18388832d02742$export$b00a404bbd5edef2; }, function (v) { return $cc18388832d02742$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $cc18388832d02742$export$d66a1c1c77bd778b; }, function (v) { return $cc18388832d02742$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $cc18388832d02742$export$d3dfb8e4810cb555; }, function (v) { return $cc18388832d02742$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $cc18388832d02742$export$72fdf0e06517287b; }, function (v) { return $cc18388832d02742$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $cc18388832d02742$export$816d2913ae6b83b1; }, function (v) { return $cc18388832d02742$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $cc18388832d02742$export$61bcfe829111a1d0; }, function (v) { return $cc18388832d02742$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $cc18388832d02742$export$7ee8c9beb337bc3f; }, function (v) { return $cc18388832d02742$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $cc18388832d02742$export$b5836b71941fa3ed; }, function (v) { return $cc18388832d02742$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $cc18388832d02742$export$cf845f2c119da08a; }, function (v) { return $cc18388832d02742$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc18388832d02742$export$c4744153514ff05d;
var $cc18388832d02742$export$3e506c1ccc9cc1a7;
var $cc18388832d02742$export$e26fe2ed2fa76875;
var $cc18388832d02742$export$502329bbf4b505b1;
var $cc18388832d02742$export$6e3807111c4874c4;
var $cc18388832d02742$export$c27134553091fb3a;
var $cc18388832d02742$export$33ee1acdc04fd2a2;
var $cc18388832d02742$export$b00a404bbd5edef2;
var $cc18388832d02742$export$d66a1c1c77bd778b;
var $cc18388832d02742$export$d3dfb8e4810cb555;
var $cc18388832d02742$export$72fdf0e06517287b;
var $cc18388832d02742$export$816d2913ae6b83b1;
var $cc18388832d02742$export$61bcfe829111a1d0;
var $cc18388832d02742$export$7ee8c9beb337bc3f;
var $cc18388832d02742$export$b5836b71941fa3ed;
var $cc18388832d02742$export$cf845f2c119da08a;
"use strict";
function $cc18388832d02742$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cc18388832d02742$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cc18388832d02742$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cc18388832d02742$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cc18388832d02742$var$compare(left, last)) rightIndex < length && 0 > $cc18388832d02742$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cc18388832d02742$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cc18388832d02742$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cc18388832d02742$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cc18388832d02742$var$localPerformance = performance;
    $cc18388832d02742$export$c4744153514ff05d = function() {
        return $cc18388832d02742$var$localPerformance.now();
    };
} else {
    var $cc18388832d02742$var$localDate = Date, $cc18388832d02742$var$initialTime = $cc18388832d02742$var$localDate.now();
    $cc18388832d02742$export$c4744153514ff05d = function() {
        return $cc18388832d02742$var$localDate.now() - $cc18388832d02742$var$initialTime;
    };
}
var $cc18388832d02742$var$taskQueue = [], $cc18388832d02742$var$timerQueue = [], $cc18388832d02742$var$taskIdCounter = 1, $cc18388832d02742$var$currentTask = null, $cc18388832d02742$var$currentPriorityLevel = 3, $cc18388832d02742$var$isPerformingWork = !1, $cc18388832d02742$var$isHostCallbackScheduled = !1, $cc18388832d02742$var$isHostTimeoutScheduled = !1, $cc18388832d02742$var$needsPaint = !1, $cc18388832d02742$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cc18388832d02742$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cc18388832d02742$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cc18388832d02742$var$advanceTimers(currentTime) {
    for(var timer = $cc18388832d02742$var$peek($cc18388832d02742$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cc18388832d02742$var$pop($cc18388832d02742$var$timerQueue);
        else if (timer.startTime <= currentTime) $cc18388832d02742$var$pop($cc18388832d02742$var$timerQueue), timer.sortIndex = timer.expirationTime, $cc18388832d02742$var$push($cc18388832d02742$var$taskQueue, timer);
        else break;
        timer = $cc18388832d02742$var$peek($cc18388832d02742$var$timerQueue);
    }
}
function $cc18388832d02742$var$handleTimeout(currentTime) {
    $cc18388832d02742$var$isHostTimeoutScheduled = !1;
    $cc18388832d02742$var$advanceTimers(currentTime);
    if (!$cc18388832d02742$var$isHostCallbackScheduled) {
        if (null !== $cc18388832d02742$var$peek($cc18388832d02742$var$taskQueue)) $cc18388832d02742$var$isHostCallbackScheduled = !0, $cc18388832d02742$var$isMessageLoopRunning || ($cc18388832d02742$var$isMessageLoopRunning = !0, $cc18388832d02742$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cc18388832d02742$var$peek($cc18388832d02742$var$timerQueue);
            null !== firstTimer && $cc18388832d02742$var$requestHostTimeout($cc18388832d02742$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cc18388832d02742$var$isMessageLoopRunning = !1, $cc18388832d02742$var$taskTimeoutID = -1, $cc18388832d02742$var$frameInterval = 5, $cc18388832d02742$var$startTime = -1;
function $cc18388832d02742$var$shouldYieldToHost() {
    return $cc18388832d02742$var$needsPaint ? !0 : $cc18388832d02742$export$c4744153514ff05d() - $cc18388832d02742$var$startTime < $cc18388832d02742$var$frameInterval ? !1 : !0;
}
function $cc18388832d02742$var$performWorkUntilDeadline() {
    $cc18388832d02742$var$needsPaint = !1;
    if ($cc18388832d02742$var$isMessageLoopRunning) {
        var currentTime = $cc18388832d02742$export$c4744153514ff05d();
        $cc18388832d02742$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cc18388832d02742$var$isHostCallbackScheduled = !1;
                $cc18388832d02742$var$isHostTimeoutScheduled && ($cc18388832d02742$var$isHostTimeoutScheduled = !1, $cc18388832d02742$var$localClearTimeout($cc18388832d02742$var$taskTimeoutID), $cc18388832d02742$var$taskTimeoutID = -1);
                $cc18388832d02742$var$isPerformingWork = !0;
                var previousPriorityLevel = $cc18388832d02742$var$currentPriorityLevel;
                try {
                    b: {
                        $cc18388832d02742$var$advanceTimers(currentTime);
                        for($cc18388832d02742$var$currentTask = $cc18388832d02742$var$peek($cc18388832d02742$var$taskQueue); null !== $cc18388832d02742$var$currentTask && !($cc18388832d02742$var$currentTask.expirationTime > currentTime && $cc18388832d02742$var$shouldYieldToHost());){
                            var callback = $cc18388832d02742$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cc18388832d02742$var$currentTask.callback = null;
                                $cc18388832d02742$var$currentPriorityLevel = $cc18388832d02742$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cc18388832d02742$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cc18388832d02742$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cc18388832d02742$var$currentTask.callback = continuationCallback;
                                    $cc18388832d02742$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cc18388832d02742$var$currentTask === $cc18388832d02742$var$peek($cc18388832d02742$var$taskQueue) && $cc18388832d02742$var$pop($cc18388832d02742$var$taskQueue);
                                $cc18388832d02742$var$advanceTimers(currentTime);
                            } else $cc18388832d02742$var$pop($cc18388832d02742$var$taskQueue);
                            $cc18388832d02742$var$currentTask = $cc18388832d02742$var$peek($cc18388832d02742$var$taskQueue);
                        }
                        if (null !== $cc18388832d02742$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cc18388832d02742$var$peek($cc18388832d02742$var$timerQueue);
                            null !== firstTimer && $cc18388832d02742$var$requestHostTimeout($cc18388832d02742$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cc18388832d02742$var$currentTask = null, $cc18388832d02742$var$currentPriorityLevel = previousPriorityLevel, $cc18388832d02742$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cc18388832d02742$var$schedulePerformWorkUntilDeadline() : $cc18388832d02742$var$isMessageLoopRunning = !1;
        }
    }
}
var $cc18388832d02742$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cc18388832d02742$var$localSetImmediate) $cc18388832d02742$var$schedulePerformWorkUntilDeadline = function() {
    $cc18388832d02742$var$localSetImmediate($cc18388832d02742$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cc18388832d02742$var$channel = new MessageChannel(), $cc18388832d02742$var$port = $cc18388832d02742$var$channel.port2;
    $cc18388832d02742$var$channel.port1.onmessage = $cc18388832d02742$var$performWorkUntilDeadline;
    $cc18388832d02742$var$schedulePerformWorkUntilDeadline = function() {
        $cc18388832d02742$var$port.postMessage(null);
    };
} else $cc18388832d02742$var$schedulePerformWorkUntilDeadline = function() {
    $cc18388832d02742$var$localSetTimeout($cc18388832d02742$var$performWorkUntilDeadline, 0);
};
function $cc18388832d02742$var$requestHostTimeout(callback, ms) {
    $cc18388832d02742$var$taskTimeoutID = $cc18388832d02742$var$localSetTimeout(function() {
        callback($cc18388832d02742$export$c4744153514ff05d());
    }, ms);
}
$cc18388832d02742$export$3e506c1ccc9cc1a7 = 5;
$cc18388832d02742$export$e26fe2ed2fa76875 = 1;
$cc18388832d02742$export$502329bbf4b505b1 = 4;
$cc18388832d02742$export$6e3807111c4874c4 = 3;
$cc18388832d02742$export$c27134553091fb3a = null;
$cc18388832d02742$export$33ee1acdc04fd2a2 = 2;
$cc18388832d02742$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cc18388832d02742$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cc18388832d02742$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cc18388832d02742$export$d3dfb8e4810cb555 = function() {
    return $cc18388832d02742$var$currentPriorityLevel;
};
$cc18388832d02742$export$72fdf0e06517287b = function(eventHandler) {
    switch($cc18388832d02742$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cc18388832d02742$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cc18388832d02742$var$currentPriorityLevel;
    $cc18388832d02742$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cc18388832d02742$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cc18388832d02742$export$816d2913ae6b83b1 = function() {
    $cc18388832d02742$var$needsPaint = !0;
};
$cc18388832d02742$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cc18388832d02742$var$currentPriorityLevel;
    $cc18388832d02742$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cc18388832d02742$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cc18388832d02742$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cc18388832d02742$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cc18388832d02742$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cc18388832d02742$var$push($cc18388832d02742$var$timerQueue, priorityLevel), null === $cc18388832d02742$var$peek($cc18388832d02742$var$taskQueue) && priorityLevel === $cc18388832d02742$var$peek($cc18388832d02742$var$timerQueue) && ($cc18388832d02742$var$isHostTimeoutScheduled ? ($cc18388832d02742$var$localClearTimeout($cc18388832d02742$var$taskTimeoutID), $cc18388832d02742$var$taskTimeoutID = -1) : $cc18388832d02742$var$isHostTimeoutScheduled = !0, $cc18388832d02742$var$requestHostTimeout($cc18388832d02742$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cc18388832d02742$var$push($cc18388832d02742$var$taskQueue, priorityLevel), $cc18388832d02742$var$isHostCallbackScheduled || $cc18388832d02742$var$isPerformingWork || ($cc18388832d02742$var$isHostCallbackScheduled = !0, $cc18388832d02742$var$isMessageLoopRunning || ($cc18388832d02742$var$isMessageLoopRunning = !0, $cc18388832d02742$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cc18388832d02742$export$b5836b71941fa3ed = $cc18388832d02742$var$shouldYieldToHost;
$cc18388832d02742$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cc18388832d02742$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cc18388832d02742$var$currentPriorityLevel;
        $cc18388832d02742$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cc18388832d02742$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("uov38", function(module, exports) {
'use strict';
function $05b5ce9b357b7914$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($05b5ce9b357b7914$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$05b5ce9b357b7914$var$checkDCE();

module.exports = (parcelRequire("cf2yE"));

});
parcelRegister("cf2yE", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $8e98deb5483957b3$export$69ce8ef3fe5cead0; }, function (v) { return $8e98deb5483957b3$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $8e98deb5483957b3$export$d39a5bbd09211389; }, function (v) { return $8e98deb5483957b3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $8e98deb5483957b3$export$cd75ccfd720a3cd4; }, function (v) { return $8e98deb5483957b3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $8e98deb5483957b3$export$a0816fa17a9e79be; }, function (v) { return $8e98deb5483957b3$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $8e98deb5483957b3$export$7292efcadded39f3; }, function (v) { return $8e98deb5483957b3$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $8e98deb5483957b3$export$da407abadb9b8f86; }, function (v) { return $8e98deb5483957b3$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $8e98deb5483957b3$export$314cfea32580671c; }, function (v) { return $8e98deb5483957b3$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $8e98deb5483957b3$export$513ccb98c53b8039; }, function (v) { return $8e98deb5483957b3$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $8e98deb5483957b3$export$dbca993bc2d264a; }, function (v) { return $8e98deb5483957b3$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $8e98deb5483957b3$export$4797a8006f0655d0; }, function (v) { return $8e98deb5483957b3$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $8e98deb5483957b3$export$c78a37762a8d58e1; }, function (v) { return $8e98deb5483957b3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $8e98deb5483957b3$export$606f11b2eb45ecc6; }, function (v) { return $8e98deb5483957b3$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $8e98deb5483957b3$export$f7e8a0bf92324b1e; }, function (v) { return $8e98deb5483957b3$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $8e98deb5483957b3$export$83d89fbfd8236492; }, function (v) { return $8e98deb5483957b3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e98deb5483957b3$export$69ce8ef3fe5cead0;
var $8e98deb5483957b3$export$d39a5bbd09211389;
var $8e98deb5483957b3$export$cd75ccfd720a3cd4;
var $8e98deb5483957b3$export$a0816fa17a9e79be;
var $8e98deb5483957b3$export$7292efcadded39f3;
var $8e98deb5483957b3$export$da407abadb9b8f86;
var $8e98deb5483957b3$export$314cfea32580671c;
var $8e98deb5483957b3$export$513ccb98c53b8039;
var $8e98deb5483957b3$export$dbca993bc2d264a;
var $8e98deb5483957b3$export$4797a8006f0655d0;
var $8e98deb5483957b3$export$c78a37762a8d58e1;
var $8e98deb5483957b3$export$606f11b2eb45ecc6;
var $8e98deb5483957b3$export$f7e8a0bf92324b1e;
var $8e98deb5483957b3$export$83d89fbfd8236492;
"use strict";

var $fITET = parcelRequire("fITET");
function $8e98deb5483957b3$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8e98deb5483957b3$var$noop() {}
var $8e98deb5483957b3$var$Internals = {
    d: {
        f: $8e98deb5483957b3$var$noop,
        r: function() {
            throw Error($8e98deb5483957b3$var$formatProdErrorMessage(522));
        },
        D: $8e98deb5483957b3$var$noop,
        C: $8e98deb5483957b3$var$noop,
        L: $8e98deb5483957b3$var$noop,
        m: $8e98deb5483957b3$var$noop,
        X: $8e98deb5483957b3$var$noop,
        S: $8e98deb5483957b3$var$noop,
        M: $8e98deb5483957b3$var$noop
    },
    p: 0,
    findDOMNode: null
}, $8e98deb5483957b3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $8e98deb5483957b3$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8e98deb5483957b3$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $8e98deb5483957b3$var$ReactSharedInternals = $fITET.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $8e98deb5483957b3$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$8e98deb5483957b3$export$69ce8ef3fe5cead0 = $8e98deb5483957b3$var$Internals;
$8e98deb5483957b3$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($8e98deb5483957b3$var$formatProdErrorMessage(299));
    return $8e98deb5483957b3$var$createPortal$1(children, container, null, key);
};
$8e98deb5483957b3$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $8e98deb5483957b3$var$ReactSharedInternals.T, previousUpdatePriority = $8e98deb5483957b3$var$Internals.p;
    try {
        if ($8e98deb5483957b3$var$ReactSharedInternals.T = null, $8e98deb5483957b3$var$Internals.p = 2, fn) return fn();
    } finally{
        $8e98deb5483957b3$var$ReactSharedInternals.T = previousTransition, $8e98deb5483957b3$var$Internals.p = previousUpdatePriority, $8e98deb5483957b3$var$Internals.d.f();
    }
};
$8e98deb5483957b3$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $8e98deb5483957b3$var$Internals.d.C(href, options));
};
$8e98deb5483957b3$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $8e98deb5483957b3$var$Internals.d.D(href);
};
$8e98deb5483957b3$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8e98deb5483957b3$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $8e98deb5483957b3$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $8e98deb5483957b3$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$8e98deb5483957b3$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $8e98deb5483957b3$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $8e98deb5483957b3$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $8e98deb5483957b3$var$Internals.d.M(href);
    }
};
$8e98deb5483957b3$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8e98deb5483957b3$var$getCrossOriginStringAs(as, options.crossOrigin);
        $8e98deb5483957b3$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$8e98deb5483957b3$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $8e98deb5483957b3$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $8e98deb5483957b3$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $8e98deb5483957b3$var$Internals.d.m(href);
    }
};
$8e98deb5483957b3$export$4797a8006f0655d0 = function(form) {
    $8e98deb5483957b3$var$Internals.d.r(form);
};
$8e98deb5483957b3$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$8e98deb5483957b3$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $8e98deb5483957b3$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$8e98deb5483957b3$export$f7e8a0bf92324b1e = function() {
    return $8e98deb5483957b3$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$8e98deb5483957b3$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("PAdBB", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return $737d96742fae595e$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigationType", function () { return $737d96742fae595e$export$1b3f31771c5d07c; });
$parcel$export(module.exports, "useNavigate", function () { return $737d96742fae595e$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $737d96742fae595e$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "Navigate", function () { return $737d96742fae595e$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $737d96742fae595e$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $737d96742fae595e$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "BrowserRouter", function () { return $737d96742fae595e$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $737d96742fae595e$export$a6c7ac8248d6e38a; });
/**
 * react-router v7.18.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $fITET = parcelRequire("fITET");
var $737d96742fae595e$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-BV7QT456.mjs"
});
var $737d96742fae595e$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $737d96742fae595e$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $737d96742fae595e$var$__typeError("Cannot " + msg);
var $737d96742fae595e$var$__privateGet = (obj, member, getter)=>($737d96742fae595e$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $737d96742fae595e$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $737d96742fae595e$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $737d96742fae595e$var$__privateSet = (obj, member, value, setter)=>($737d96742fae595e$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $737d96742fae595e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $737d96742fae595e$export$825a82322d91916e = /^[\\/]{2}/;
function $737d96742fae595e$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $737d96742fae595e$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($737d96742fae595e$export$e19cd5f9376f8cee || {});
var $737d96742fae595e$var$PopStateEventType = "popstate";
function $737d96742fae595e$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $737d96742fae595e$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $737d96742fae595e$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $737d96742fae595e$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $737d96742fae595e$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $737d96742fae595e$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $737d96742fae595e$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $737d96742fae595e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to);
    }
    return $737d96742fae595e$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $737d96742fae595e$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $737d96742fae595e$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $737d96742fae595e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $737d96742fae595e$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $737d96742fae595e$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $737d96742fae595e$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $737d96742fae595e$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $737d96742fae595e$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $737d96742fae595e$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $737d96742fae595e$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $737d96742fae595e$var$createKey(),
        mask: mask
    };
    return location;
}
function $737d96742fae595e$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $737d96742fae595e$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $737d96742fae595e$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $737d96742fae595e$var$isLocation(to) ? to : $737d96742fae595e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $737d96742fae595e$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $737d96742fae595e$var$isLocation(to) ? to : $737d96742fae595e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $737d96742fae595e$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $737d96742fae595e$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($737d96742fae595e$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($737d96742fae595e$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $737d96742fae595e$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $737d96742fae595e$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $737d96742fae595e$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $737d96742fae595e$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $737d96742fae595e$var$_map;
var $737d96742fae595e$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $737d96742fae595e$var$__privateAdd(this, $737d96742fae595e$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_map).has(context)) return $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_map).set(context, value);
    }
};
$737d96742fae595e$var$_map = new WeakMap();
var $737d96742fae595e$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $737d96742fae595e$var$isUnsupportedLazyRouteObjectKey(key) {
    return $737d96742fae595e$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $737d96742fae595e$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $737d96742fae595e$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $737d96742fae595e$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $737d96742fae595e$var$isIndexRoute(route) {
    return route.index === true;
}
function $737d96742fae595e$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $737d96742fae595e$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $737d96742fae595e$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($737d96742fae595e$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $737d96742fae595e$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $737d96742fae595e$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $737d96742fae595e$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $737d96742fae595e$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $737d96742fae595e$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $737d96742fae595e$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $737d96742fae595e$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $737d96742fae595e$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $737d96742fae595e$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $737d96742fae595e$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $737d96742fae595e$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $737d96742fae595e$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $737d96742fae595e$var$flattenAndRankRoutes(routes) {
    let branches = $737d96742fae595e$var$flattenRoutes(routes);
    $737d96742fae595e$var$rankRouteBranches(branches);
    return branches;
}
function $737d96742fae595e$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $737d96742fae595e$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $737d96742fae595e$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $737d96742fae595e$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $737d96742fae595e$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $737d96742fae595e$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $737d96742fae595e$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $737d96742fae595e$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $737d96742fae595e$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $737d96742fae595e$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $737d96742fae595e$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $737d96742fae595e$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $737d96742fae595e$var$paramRe = /^:[\w-]+$/;
var $737d96742fae595e$var$dynamicSegmentValue = 3;
var $737d96742fae595e$var$indexRouteValue = 2;
var $737d96742fae595e$var$emptySegmentValue = 1;
var $737d96742fae595e$var$staticSegmentValue = 10;
var $737d96742fae595e$var$splatPenalty = -2;
var $737d96742fae595e$var$isSplat = (s)=>s === "*";
function $737d96742fae595e$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($737d96742fae595e$var$isSplat)) initialScore += $737d96742fae595e$var$splatPenalty;
    if (index) initialScore += $737d96742fae595e$var$indexRouteValue;
    return segments.filter((s)=>!$737d96742fae595e$var$isSplat(s)).reduce((score, segment)=>score + ($737d96742fae595e$var$paramRe.test(segment) ? $737d96742fae595e$var$dynamicSegmentValue : segment === "" ? $737d96742fae595e$var$emptySegmentValue : $737d96742fae595e$var$staticSegmentValue), initialScore);
}
function $737d96742fae595e$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $737d96742fae595e$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $737d96742fae595e$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $737d96742fae595e$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $737d96742fae595e$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $737d96742fae595e$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $737d96742fae595e$var$normalizePathname($737d96742fae595e$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $737d96742fae595e$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $737d96742fae595e$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $737d96742fae595e$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $737d96742fae595e$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $737d96742fae595e$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $737d96742fae595e$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $737d96742fae595e$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $737d96742fae595e$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $737d96742fae595e$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $737d96742fae595e$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $737d96742fae595e$var$compilePath(path, caseSensitive = false, end = true) {
    $737d96742fae595e$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $737d96742fae595e$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $737d96742fae595e$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $737d96742fae595e$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $737d96742fae595e$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $737d96742fae595e$var$joinPaths([
        basename,
        pathname
    ]);
}
var $737d96742fae595e$var$isAbsoluteUrl = (url)=>$737d96742fae595e$var$ABSOLUTE_URL_REGEX.test(url);
function $737d96742fae595e$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $737d96742fae595e$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $737d96742fae595e$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $737d96742fae595e$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $737d96742fae595e$var$normalizeSearch(search),
        hash: $737d96742fae595e$var$normalizeHash(hash)
    };
}
function $737d96742fae595e$var$resolvePathname(relativePath, fromPathname) {
    let segments = $737d96742fae595e$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $737d96742fae595e$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $737d96742fae595e$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $737d96742fae595e$var$getResolveToMatches(matches) {
    let pathMatches = $737d96742fae595e$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $737d96742fae595e$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $737d96742fae595e$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $737d96742fae595e$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $737d96742fae595e$var$getInvalidPathError("?", "pathname", "search", to));
        $737d96742fae595e$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $737d96742fae595e$var$getInvalidPathError("#", "pathname", "hash", to));
        $737d96742fae595e$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $737d96742fae595e$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $737d96742fae595e$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $737d96742fae595e$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $737d96742fae595e$var$joinPaths = (paths)=>$737d96742fae595e$var$removeDoubleSlashes(paths.join("/"));
function $737d96742fae595e$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $737d96742fae595e$var$normalizePathname = (pathname)=>$737d96742fae595e$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $737d96742fae595e$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $737d96742fae595e$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $737d96742fae595e$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $737d96742fae595e$export$4051a07651545597(data2, init) {
    return new $737d96742fae595e$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $737d96742fae595e$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $737d96742fae595e$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $737d96742fae595e$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $737d96742fae595e$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $737d96742fae595e$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $737d96742fae595e$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $737d96742fae595e$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $737d96742fae595e$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $737d96742fae595e$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $737d96742fae595e$var$joinPaths(parts) || "/";
}
var $737d96742fae595e$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $737d96742fae595e$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$737d96742fae595e$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($737d96742fae595e$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $737d96742fae595e$export$825a82322d91916e.test(to) ? new URL($737d96742fae595e$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $737d96742fae595e$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $737d96742fae595e$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $737d96742fae595e$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $737d96742fae595e$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $737d96742fae595e$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $737d96742fae595e$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$737d96742fae595e$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $737d96742fae595e$var$wrapImpl(aggregated[key], original, (...args)=>$737d96742fae595e$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$737d96742fae595e$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$737d96742fae595e$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $737d96742fae595e$var$wrapImpl(aggregated.middleware, original, (...args)=>$737d96742fae595e$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$737d96742fae595e$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $737d96742fae595e$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$737d96742fae595e$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $737d96742fae595e$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $737d96742fae595e$export$fe53371bee54353d(to) : ".",
                ...$737d96742fae595e$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$737d96742fae595e$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$737d96742fae595e$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $737d96742fae595e$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$737d96742fae595e$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$737d96742fae595e$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $737d96742fae595e$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $737d96742fae595e$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $737d96742fae595e$var$getReadonlyRequest(request),
            context: context != null ? $737d96742fae595e$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $737d96742fae595e$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $737d96742fae595e$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $737d96742fae595e$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $737d96742fae595e$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $737d96742fae595e$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $737d96742fae595e$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $737d96742fae595e$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $737d96742fae595e$var$getReadonlyContext(context)
    };
}
function $737d96742fae595e$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $737d96742fae595e$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $737d96742fae595e$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $737d96742fae595e$var$getReadonlyContext(context) {
    if ($737d96742fae595e$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $737d96742fae595e$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $737d96742fae595e$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $737d96742fae595e$var$objectProtoNames;
}
// lib/router/navigation.ts
var $737d96742fae595e$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $737d96742fae595e$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $737d96742fae595e$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $737d96742fae595e$var$DEFAULT_NAVIGATION_URL;
    }
}
function $737d96742fae595e$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $737d96742fae595e$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $737d96742fae595e$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$737d96742fae595e$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$737d96742fae595e$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$737d96742fae595e$var$isExplicitUrl(original, originalUrl) || !$737d96742fae595e$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $737d96742fae595e$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $737d96742fae595e$var$validMutationMethods = new Set($737d96742fae595e$var$validMutationMethodsArr);
var $737d96742fae595e$var$validRequestMethodsArr = [
    "GET",
    ...$737d96742fae595e$var$validMutationMethodsArr
];
var $737d96742fae595e$var$validRequestMethods = new Set($737d96742fae595e$var$validRequestMethodsArr);
var $737d96742fae595e$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $737d96742fae595e$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $737d96742fae595e$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $737d96742fae595e$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $737d96742fae595e$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $737d96742fae595e$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $737d96742fae595e$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $737d96742fae595e$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $737d96742fae595e$var$_routes, $737d96742fae595e$var$_branches, $737d96742fae595e$var$_hmrRoutes, $737d96742fae595e$var$_hmrBranches;
var $737d96742fae595e$var$DataRoutes = class {
    constructor(routes){
        $737d96742fae595e$var$__privateAdd(this, $737d96742fae595e$var$_routes);
        $737d96742fae595e$var$__privateAdd(this, $737d96742fae595e$var$_branches);
        $737d96742fae595e$var$__privateAdd(this, $737d96742fae595e$var$_hmrRoutes);
        $737d96742fae595e$var$__privateAdd(this, $737d96742fae595e$var$_hmrBranches);
        $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_routes, routes);
        $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_branches, $737d96742fae595e$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_hmrRoutes) ?? $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_hmrBranches) ?? $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_branches);
    }
    get hasHMRRoutes() {
        return $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_routes, routes);
        $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_branches, $737d96742fae595e$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_hmrRoutes, routes);
        $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_hmrBranches, $737d96742fae595e$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_hmrRoutes)) {
            $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_routes, $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_hmrRoutes));
            $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_branches, $737d96742fae595e$var$__privateGet(this, $737d96742fae595e$var$_hmrBranches));
            $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_hmrRoutes, void 0);
            $737d96742fae595e$var$__privateSet(this, $737d96742fae595e$var$_hmrBranches, void 0);
        }
    }
};
$737d96742fae595e$var$_routes = new WeakMap();
$737d96742fae595e$var$_branches = new WeakMap();
$737d96742fae595e$var$_hmrRoutes = new WeakMap();
$737d96742fae595e$var$_hmrBranches = new WeakMap();
function $737d96742fae595e$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $737d96742fae595e$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $737d96742fae595e$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$737d96742fae595e$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $737d96742fae595e$var$DataRoutes($737d96742fae595e$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $737d96742fae595e$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $737d96742fae595e$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $737d96742fae595e$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $737d96742fae595e$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$737d96742fae595e$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $737d96742fae595e$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $737d96742fae595e$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $737d96742fae595e$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $737d96742fae595e$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $737d96742fae595e$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$737d96742fae595e$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $737d96742fae595e$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $737d96742fae595e$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $737d96742fae595e$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $737d96742fae595e$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $737d96742fae595e$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $737d96742fae595e$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $737d96742fae595e$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $737d96742fae595e$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($737d96742fae595e$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $737d96742fae595e$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $737d96742fae595e$export$fe53371bee54353d(opts.mask), $737d96742fae595e$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $737d96742fae595e$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $737d96742fae595e$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $737d96742fae595e$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $737d96742fae595e$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $737d96742fae595e$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $737d96742fae595e$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $737d96742fae595e$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $737d96742fae595e$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $737d96742fae595e$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $737d96742fae595e$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $737d96742fae595e$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $737d96742fae595e$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($737d96742fae595e$var$isErrorResult(result) && $737d96742fae595e$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $737d96742fae595e$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $737d96742fae595e$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$737d96742fae595e$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $737d96742fae595e$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $737d96742fae595e$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $737d96742fae595e$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $737d96742fae595e$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $737d96742fae595e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($737d96742fae595e$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $737d96742fae595e$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($737d96742fae595e$var$isErrorResult(result)) {
            let boundaryMatch = $737d96742fae595e$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $737d96742fae595e$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $737d96742fae595e$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $737d96742fae595e$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $737d96742fae595e$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $737d96742fae595e$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $737d96742fae595e$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$737d96742fae595e$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $737d96742fae595e$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $737d96742fae595e$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $737d96742fae595e$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$737d96742fae595e$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $737d96742fae595e$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $737d96742fae595e$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $737d96742fae595e$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $737d96742fae595e$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $737d96742fae595e$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $737d96742fae595e$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $737d96742fae595e$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $737d96742fae595e$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $737d96742fae595e$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $737d96742fae595e$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $737d96742fae595e$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $737d96742fae595e$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($737d96742fae595e$var$isRedirectResult(actionResult) || $737d96742fae595e$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $737d96742fae595e$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($737d96742fae595e$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $737d96742fae595e$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $737d96742fae595e$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($737d96742fae595e$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $737d96742fae595e$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $737d96742fae595e$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $737d96742fae595e$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $737d96742fae595e$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $737d96742fae595e$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $737d96742fae595e$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $737d96742fae595e$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $737d96742fae595e$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $737d96742fae595e$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $737d96742fae595e$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $737d96742fae595e$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $737d96742fae595e$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $737d96742fae595e$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $737d96742fae595e$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $737d96742fae595e$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $737d96742fae595e$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $737d96742fae595e$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $737d96742fae595e$var$getDoneFetcher(void 0));
            return;
        }
        if ($737d96742fae595e$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $737d96742fae595e$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($737d96742fae595e$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $737d96742fae595e$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $737d96742fae595e$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $737d96742fae595e$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $737d96742fae595e$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $737d96742fae595e$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($737d96742fae595e$var$isAbsoluteUrl(location)) {
                const url = $737d96742fae595e$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $737d96742fae595e$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $737d96742fae595e$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($737d96742fae595e$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $737d96742fae595e$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $737d96742fae595e$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $737d96742fae595e$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$737d96742fae595e$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($737d96742fae595e$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $737d96742fae595e$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $737d96742fae595e$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $737d96742fae595e$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $737d96742fae595e$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $737d96742fae595e$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $737d96742fae595e$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $737d96742fae595e$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $737d96742fae595e$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $737d96742fae595e$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $737d96742fae595e$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $737d96742fae595e$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $737d96742fae595e$export$386d57f03f0b2883;
        $737d96742fae595e$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $737d96742fae595e$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $737d96742fae595e$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $737d96742fae595e$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $737d96742fae595e$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$737d96742fae595e$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $737d96742fae595e$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $737d96742fae595e$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $737d96742fae595e$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $737d96742fae595e$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $737d96742fae595e$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $737d96742fae595e$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($737d96742fae595e$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $737d96742fae595e$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $737d96742fae595e$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $737d96742fae595e$export$3336b097a6fbc59a(routes, opts) {
    $737d96742fae595e$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $737d96742fae595e$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$737d96742fae595e$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $737d96742fae595e$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $737d96742fae595e$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $737d96742fae595e$var$defaultNormalizePath;
        let method = request.method;
        let location = $737d96742fae595e$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $737d96742fae595e$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $737d96742fae595e$export$b8d3e69d4b3eff04();
        if (!$737d96742fae595e$var$isValidMethod(method) && method !== "HEAD") {
            let error = $737d96742fae595e$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $737d96742fae595e$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $737d96742fae595e$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $737d96742fae595e$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $737d96742fae595e$export$f5708dca728d7177(requestContext instanceof $737d96742fae595e$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $737d96742fae595e$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $737d96742fae595e$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $737d96742fae595e$var$createDataFunctionUrl(request, location),
                    pattern: $737d96742fae595e$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($737d96742fae595e$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($737d96742fae595e$export$6e80290866a84dd4(error)) return error;
                    if ($737d96742fae595e$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $737d96742fae595e$export$f2680fa305b734ca(error.status, error.statusText, await $737d96742fae595e$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($737d96742fae595e$export$e0163cfdf7bc9cfa(error)) error = $737d96742fae595e$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $737d96742fae595e$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $737d96742fae595e$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $737d96742fae595e$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $737d96742fae595e$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $737d96742fae595e$export$f5708dca728d7177($737d96742fae595e$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($737d96742fae595e$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($737d96742fae595e$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $737d96742fae595e$var$defaultNormalizePath;
        let method = request.method;
        let location = $737d96742fae595e$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $737d96742fae595e$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $737d96742fae595e$export$b8d3e69d4b3eff04();
        if (!$737d96742fae595e$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $737d96742fae595e$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $737d96742fae595e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $737d96742fae595e$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $737d96742fae595e$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $737d96742fae595e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $737d96742fae595e$export$f5708dca728d7177(requestContext instanceof $737d96742fae595e$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $737d96742fae595e$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $737d96742fae595e$var$runServerMiddlewarePipeline({
                request: request,
                url: $737d96742fae595e$var$createDataFunctionUrl(request, location),
                pattern: $737d96742fae595e$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $737d96742fae595e$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($737d96742fae595e$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($737d96742fae595e$var$dataWithResponseInitToResponse(error));
                if ($737d96742fae595e$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($737d96742fae595e$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $737d96742fae595e$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($737d96742fae595e$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $737d96742fae595e$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $737d96742fae595e$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($737d96742fae595e$var$isDataStrategyResult(e) && $737d96742fae595e$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($737d96742fae595e$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $737d96742fae595e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $737d96742fae595e$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($737d96742fae595e$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($737d96742fae595e$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($737d96742fae595e$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $737d96742fae595e$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $737d96742fae595e$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($737d96742fae595e$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $737d96742fae595e$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $737d96742fae595e$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $737d96742fae595e$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $737d96742fae595e$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $737d96742fae595e$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $737d96742fae595e$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $737d96742fae595e$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $737d96742fae595e$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $737d96742fae595e$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $737d96742fae595e$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $737d96742fae595e$var$callDataStrategyImpl(dataStrategy || $737d96742fae595e$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($737d96742fae595e$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $737d96742fae595e$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($737d96742fae595e$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($737d96742fae595e$export$e0163cfdf7bc9cfa(result.result)) throw $737d96742fae595e$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $737d96742fae595e$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $737d96742fae595e$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $737d96742fae595e$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $737d96742fae595e$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $737d96742fae595e$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $737d96742fae595e$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $737d96742fae595e$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $737d96742fae595e$var$resolveTo(to ? to : ".", $737d96742fae595e$var$getResolveToMatches(contextualMatches), $737d96742fae595e$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $737d96742fae595e$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $737d96742fae595e$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $737d96742fae595e$export$fe53371bee54353d(path);
}
function $737d96742fae595e$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$737d96742fae595e$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$737d96742fae595e$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $737d96742fae595e$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $737d96742fae595e$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $737d96742fae595e$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$737d96742fae595e$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$737d96742fae595e$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $737d96742fae595e$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $737d96742fae595e$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $737d96742fae595e$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $737d96742fae595e$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $737d96742fae595e$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($737d96742fae595e$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $737d96742fae595e$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $737d96742fae595e$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $737d96742fae595e$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $737d96742fae595e$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $737d96742fae595e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $737d96742fae595e$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $737d96742fae595e$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$737d96742fae595e$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $737d96742fae595e$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($737d96742fae595e$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $737d96742fae595e$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($737d96742fae595e$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $737d96742fae595e$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $737d96742fae595e$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $737d96742fae595e$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $737d96742fae595e$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $737d96742fae595e$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($737d96742fae595e$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $737d96742fae595e$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $737d96742fae595e$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$737d96742fae595e$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $737d96742fae595e$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $737d96742fae595e$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $737d96742fae595e$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $737d96742fae595e$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $737d96742fae595e$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$737d96742fae595e$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $737d96742fae595e$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $737d96742fae595e$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $737d96742fae595e$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$737d96742fae595e$var$isSameRoute(aChild, bChild))) ?? false;
}
var $737d96742fae595e$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $737d96742fae595e$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $737d96742fae595e$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $737d96742fae595e$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $737d96742fae595e$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $737d96742fae595e$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $737d96742fae595e$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $737d96742fae595e$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $737d96742fae595e$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $737d96742fae595e$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $737d96742fae595e$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $737d96742fae595e$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $737d96742fae595e$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $737d96742fae595e$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $737d96742fae595e$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $737d96742fae595e$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $737d96742fae595e$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $737d96742fae595e$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $737d96742fae595e$var$isNonNullable(value) {
    return value !== void 0;
}
function $737d96742fae595e$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $737d96742fae595e$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($737d96742fae595e$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $737d96742fae595e$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $737d96742fae595e$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $737d96742fae595e$var$defaultDataStrategy(args);
    return $737d96742fae595e$var$runClientMiddlewarePipeline(args, ()=>$737d96742fae595e$var$defaultDataStrategy(args));
}
function $737d96742fae595e$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $737d96742fae595e$var$runMiddlewarePipeline(args, handler, processResult, $737d96742fae595e$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $737d96742fae595e$export$e0163cfdf7bc9cfa(result) ? $737d96742fae595e$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $737d96742fae595e$var$runClientMiddlewarePipeline(args, handler) {
    return $737d96742fae595e$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($737d96742fae595e$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $737d96742fae595e$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $737d96742fae595e$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $737d96742fae595e$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $737d96742fae595e$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $737d96742fae595e$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $737d96742fae595e$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $737d96742fae595e$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $737d96742fae595e$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $737d96742fae595e$var$loadLazyRoute(match.route, $737d96742fae595e$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $737d96742fae595e$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $737d96742fae595e$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $737d96742fae595e$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $737d96742fae595e$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $737d96742fae595e$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$737d96742fae595e$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($737d96742fae595e$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $737d96742fae595e$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $737d96742fae595e$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $737d96742fae595e$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $737d96742fae595e$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $737d96742fae595e$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $737d96742fae595e$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $737d96742fae595e$var$createDataFunctionUrl(request, path),
        pattern: $737d96742fae595e$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $737d96742fae595e$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $737d96742fae595e$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $737d96742fae595e$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $737d96742fae595e$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $737d96742fae595e$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $737d96742fae595e$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $737d96742fae595e$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $737d96742fae595e$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($737d96742fae595e$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $737d96742fae595e$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $737d96742fae595e$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($737d96742fae595e$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $737d96742fae595e$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $737d96742fae595e$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $737d96742fae595e$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($737d96742fae595e$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $737d96742fae595e$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $737d96742fae595e$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$737d96742fae595e$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $737d96742fae595e$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $737d96742fae595e$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $737d96742fae595e$export$961a3ef7a4da3a39(location) {
    try {
        return $737d96742fae595e$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $737d96742fae595e$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($737d96742fae595e$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $737d96742fae595e$export$825a82322d91916e.test(normalizedLocation) ? new URL($737d96742fae595e$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($737d96742fae595e$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $737d96742fae595e$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $737d96742fae595e$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($737d96742fae595e$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $737d96742fae595e$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($737d96742fae595e$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $737d96742fae595e$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $737d96742fae595e$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $737d96742fae595e$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $737d96742fae595e$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $737d96742fae595e$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $737d96742fae595e$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $737d96742fae595e$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $737d96742fae595e$export$f5708dca728d7177(!$737d96742fae595e$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($737d96742fae595e$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $737d96742fae595e$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $737d96742fae595e$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $737d96742fae595e$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $737d96742fae595e$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $737d96742fae595e$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $737d96742fae595e$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($737d96742fae595e$var$isErrorResult(result)) {
            let boundaryMatch = $737d96742fae595e$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($737d96742fae595e$var$isRedirectResult(result)) $737d96742fae595e$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $737d96742fae595e$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $737d96742fae595e$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $737d96742fae595e$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $737d96742fae595e$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $737d96742fae595e$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $737d96742fae595e$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $737d96742fae595e$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $737d96742fae595e$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $737d96742fae595e$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $737d96742fae595e$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($737d96742fae595e$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $737d96742fae595e$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(path) : path;
    return $737d96742fae595e$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $737d96742fae595e$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $737d96742fae595e$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $737d96742fae595e$var$dataWithResponseInitToErrorResponse(data2) {
    return new $737d96742fae595e$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $737d96742fae595e$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $737d96742fae595e$var$isDataStrategyResult(value));
}
function $737d96742fae595e$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $737d96742fae595e$var$isRedirectDataStrategyResult(result) {
    return $737d96742fae595e$export$3f1eb41d9a6a6a27(result.result) && $737d96742fae595e$var$redirectStatusCodes.has(result.result.status);
}
function $737d96742fae595e$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $737d96742fae595e$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $737d96742fae595e$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $737d96742fae595e$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $737d96742fae595e$export$794b2760043cf8cd(statusCode) {
    return $737d96742fae595e$var$redirectStatusCodes.has(statusCode);
}
function $737d96742fae595e$export$6e80290866a84dd4(result) {
    return $737d96742fae595e$export$3f1eb41d9a6a6a27(result) && $737d96742fae595e$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $737d96742fae595e$var$isValidMethod(method) {
    return $737d96742fae595e$var$validRequestMethods.has(method.toUpperCase());
}
function $737d96742fae595e$export$cbae47800eb95bc3(method) {
    return $737d96742fae595e$var$validMutationMethods.has(method.toUpperCase());
}
function $737d96742fae595e$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $737d96742fae595e$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $737d96742fae595e$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $737d96742fae595e$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $737d96742fae595e$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $737d96742fae595e$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $737d96742fae595e$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $737d96742fae595e$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $737d96742fae595e$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $737d96742fae595e$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $737d96742fae595e$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($737d96742fae595e$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $737d96742fae595e$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($737d96742fae595e$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $737d96742fae595e$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $737d96742fae595e$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $737d96742fae595e$export$2eeee58951ff3c1c = $fITET.createContext(null);
$737d96742fae595e$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $737d96742fae595e$export$315e3ffb01f217 = $fITET.createContext(null);
$737d96742fae595e$export$315e3ffb01f217.displayName = "DataRouterState";
var $737d96742fae595e$export$717f757c655223f1 = $fITET.createContext(false);
function $737d96742fae595e$var$useIsRSCRouterContext() {
    return $fITET.useContext($737d96742fae595e$export$717f757c655223f1);
}
var $737d96742fae595e$export$3681f408decb40d1 = $fITET.createContext({
    isTransitioning: false
});
$737d96742fae595e$export$3681f408decb40d1.displayName = "ViewTransition";
var $737d96742fae595e$export$cb3f1df1bef00a39 = $fITET.createContext(/* @__PURE__ */ new Map());
$737d96742fae595e$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $737d96742fae595e$var$AwaitContext = $fITET.createContext(null);
$737d96742fae595e$var$AwaitContext.displayName = "Await";
var $737d96742fae595e$export$2666c20e15407622 = (props)=>$fITET.createElement($737d96742fae595e$var$AwaitContext.Provider, props);
var $737d96742fae595e$export$3044ab7fdabeaee6 = $fITET.createContext(null);
$737d96742fae595e$export$3044ab7fdabeaee6.displayName = "Navigation";
var $737d96742fae595e$export$e6a44b110a0c44d3 = $fITET.createContext(null);
$737d96742fae595e$export$e6a44b110a0c44d3.displayName = "Location";
var $737d96742fae595e$export$aac280ed165a4397 = $fITET.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$737d96742fae595e$export$aac280ed165a4397.displayName = "Route";
var $737d96742fae595e$var$RouteErrorContext = $fITET.createContext(null);
$737d96742fae595e$var$RouteErrorContext.displayName = "RouteError";
var $737d96742fae595e$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $737d96742fae595e$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $737d96742fae595e$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $737d96742fae595e$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $737d96742fae595e$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$737d96742fae595e$var$ERROR_DIGEST_BASE}:${$737d96742fae595e$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $737d96742fae595e$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$737d96742fae595e$var$ERROR_DIGEST_BASE}:${$737d96742fae595e$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $737d96742fae595e$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $737d96742fae595e$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $737d96742fae595e$export$f5708dca728d7177($737d96742fae595e$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $737d96742fae595e$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $737d96742fae595e$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $737d96742fae595e$export$9c954a9d03d32f4a() {
    return $fITET.useContext($737d96742fae595e$export$e6a44b110a0c44d3) != null;
}
function $737d96742fae595e$export$45d76561a5302f2b() {
    $737d96742fae595e$export$f5708dca728d7177($737d96742fae595e$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $fITET.useContext($737d96742fae595e$export$e6a44b110a0c44d3).location;
}
function $737d96742fae595e$export$1b3f31771c5d07c() {
    return $fITET.useContext($737d96742fae595e$export$e6a44b110a0c44d3).navigationType;
}
function $737d96742fae595e$export$6c330e8992e8a295(pattern) {
    $737d96742fae595e$export$f5708dca728d7177($737d96742fae595e$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $737d96742fae595e$export$45d76561a5302f2b();
    return $fITET.useMemo(()=>$737d96742fae595e$export$81336c211d5ff295(pattern, $737d96742fae595e$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $737d96742fae595e$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $737d96742fae595e$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6).static;
    if (!isStatic) $fITET.useLayoutEffect(cb);
}
function $737d96742fae595e$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    return isDataRoute ? $737d96742fae595e$var$useNavigateStable() : $737d96742fae595e$var$useNavigateUnstable();
}
function $737d96742fae595e$var$useNavigateUnstable() {
    $737d96742fae595e$export$f5708dca728d7177($737d96742fae595e$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $fITET.useContext($737d96742fae595e$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let { matches: matches } = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    let { pathname: locationPathname } = $737d96742fae595e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($737d96742fae595e$var$getResolveToMatches(matches));
    let activeRef = $fITET.useRef(false);
    $737d96742fae595e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $fITET.useCallback((to, options = {})=>{
        $737d96742fae595e$var$warning(activeRef.current, $737d96742fae595e$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $737d96742fae595e$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $737d96742fae595e$var$joinPaths([
            basename,
            path.pathname
        ]);
        $737d96742fae595e$export$6c8e41f66e7aa990(typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to), navigator.createHref(path), $737d96742fae595e$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $737d96742fae595e$var$OutletContext = $fITET.createContext(null);
function $737d96742fae595e$export$4138103a3ae699cc() {
    return $fITET.useContext($737d96742fae595e$var$OutletContext);
}
function $737d96742fae595e$export$a3be3530d8e40d0b(context) {
    let outlet = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397).outlet;
    return $fITET.useMemo(()=>outlet && /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $737d96742fae595e$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $737d96742fae595e$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    let { pathname: locationPathname } = $737d96742fae595e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($737d96742fae595e$var$getResolveToMatches(matches));
    return $fITET.useMemo(()=>$737d96742fae595e$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $737d96742fae595e$export$5d3fca4a98652595(routes, locationArg) {
    return $737d96742fae595e$var$useRoutesImpl(routes, locationArg);
}
function $737d96742fae595e$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $737d96742fae595e$export$f5708dca728d7177($737d96742fae595e$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($737d96742fae595e$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $737d96742fae595e$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $737d96742fae595e$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $737d96742fae595e$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $737d96742fae595e$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $737d96742fae595e$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($737d96742fae595e$export$945fecf35a8ef089) {
        $737d96742fae595e$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $737d96742fae595e$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $737d96742fae595e$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $737d96742fae595e$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $737d96742fae595e$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $737d96742fae595e$var$DefaultErrorComponent() {
    let error = $737d96742fae595e$export$ed527bf60f6e05f2();
    let message = $737d96742fae595e$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($737d96742fae595e$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, /* @__PURE__ */ $fITET.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $fITET.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $fITET.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $fITET.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, /* @__PURE__ */ $fITET.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $fITET.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $fITET.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $737d96742fae595e$var$defaultErrorElement = /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$DefaultErrorComponent, null);
var $737d96742fae595e$var$RenderErrorBoundary = class extends $fITET.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $737d96742fae595e$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$737d96742fae595e$var$RenderErrorBoundary.contextType = $737d96742fae595e$export$717f757c655223f1;
var $737d96742fae595e$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $737d96742fae595e$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $737d96742fae595e$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $737d96742fae595e$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $737d96742fae595e$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $737d96742fae595e$export$6c8e41f66e7aa990(redirect2.location, target, $737d96742fae595e$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($737d96742fae595e$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($737d96742fae595e$var$isBrowser && !$737d96742fae595e$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $737d96742fae595e$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $fITET.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $737d96742fae595e$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $fITET.useContext($737d96742fae595e$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $737d96742fae595e$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $737d96742fae595e$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $737d96742fae595e$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $737d96742fae595e$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $737d96742fae595e$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $fITET.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $737d96742fae595e$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $737d96742fae595e$var$useDataRouterContext(hookName) {
    let ctx = $fITET.useContext($737d96742fae595e$export$2eeee58951ff3c1c);
    $737d96742fae595e$export$f5708dca728d7177(ctx, $737d96742fae595e$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $737d96742fae595e$var$useDataRouterState(hookName) {
    let state = $fITET.useContext($737d96742fae595e$export$315e3ffb01f217);
    $737d96742fae595e$export$f5708dca728d7177(state, $737d96742fae595e$var$getDataRouterConsoleError(hookName));
    return state;
}
function $737d96742fae595e$var$useRouteContext(hookName) {
    let route = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    $737d96742fae595e$export$f5708dca728d7177(route, $737d96742fae595e$var$getDataRouterConsoleError(hookName));
    return route;
}
function $737d96742fae595e$var$useCurrentRouteId(hookName) {
    let route = $737d96742fae595e$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $737d96742fae595e$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $737d96742fae595e$var$useRouteId() {
    return $737d96742fae595e$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $737d96742fae595e$export$d0fd4b7106de2769() {
    let state = $737d96742fae595e$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $fITET.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $737d96742fae595e$export$600dc272ed516c15() {
    let dataRouterContext = $737d96742fae595e$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $737d96742fae595e$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $fITET.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $fITET.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $737d96742fae595e$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $737d96742fae595e$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $fITET.useMemo(()=>matches.map((m)=>$737d96742fae595e$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $737d96742fae595e$export$1448a5050d252c4d() {
    let state = $737d96742fae595e$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $737d96742fae595e$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $737d96742fae595e$export$fd5d37484eab868d(routeId) {
    let state = $737d96742fae595e$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $737d96742fae595e$export$fdc00f3f26066d5e() {
    let state = $737d96742fae595e$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $737d96742fae595e$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $737d96742fae595e$export$ed527bf60f6e05f2() {
    let error = $fITET.useContext($737d96742fae595e$var$RouteErrorContext);
    let state = $737d96742fae595e$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $737d96742fae595e$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $737d96742fae595e$export$78a72ddb39bdd145() {
    let value = $fITET.useContext($737d96742fae595e$var$AwaitContext);
    return value?._data;
}
function $737d96742fae595e$export$17f53340677d5831() {
    let value = $fITET.useContext($737d96742fae595e$var$AwaitContext);
    return value?._error;
}
var $737d96742fae595e$var$blockerId = 0;
function $737d96742fae595e$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $737d96742fae595e$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $737d96742fae595e$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $fITET.useState("");
    let blockerFunction = $fITET.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $737d96742fae595e$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $737d96742fae595e$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $fITET.useEffect(()=>{
        let key = String(++$737d96742fae595e$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $fITET.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $737d96742fae595e$export$386d57f03f0b2883;
}
function $737d96742fae595e$var$useNavigateStable() {
    let { router: router } = $737d96742fae595e$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $737d96742fae595e$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $fITET.useRef(false);
    $737d96742fae595e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $fITET.useCallback(async (to, options = {})=>{
        $737d96742fae595e$var$warning(activeRef.current, $737d96742fae595e$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $737d96742fae595e$var$alreadyWarned = {};
function $737d96742fae595e$var$warningOnce(key, cond, message) {
    if (!cond && !$737d96742fae595e$var$alreadyWarned[key]) {
        $737d96742fae595e$var$alreadyWarned[key] = true;
        $737d96742fae595e$var$warning(false, message);
    }
}
function $737d96742fae595e$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $737d96742fae595e$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $737d96742fae595e$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $737d96742fae595e$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $737d96742fae595e$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $737d96742fae595e$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $fITET.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$737d96742fae595e$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $fITET.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$737d96742fae595e$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $fITET.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $737d96742fae595e$var$alreadyWarned2 = {};
function $737d96742fae595e$export$5b28268982f175ba(condition, message) {
    if (!condition && !$737d96742fae595e$var$alreadyWarned2[message]) {
        $737d96742fae595e$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $737d96742fae595e$var$USE_OPTIMISTIC = "useOptimistic";
var $737d96742fae595e$var$useOptimisticImpl = $fITET[$737d96742fae595e$var$USE_OPTIMISTIC];
var $737d96742fae595e$var$stableUseOptimisticSetter = ()=>void 0;
function $737d96742fae595e$var$useOptimisticSafe(val) {
    if ($737d96742fae595e$var$useOptimisticImpl) return $737d96742fae595e$var$useOptimisticImpl(val);
    else return [
        val,
        $737d96742fae595e$var$stableUseOptimisticSetter
    ];
}
function $737d96742fae595e$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($737d96742fae595e$export$945fecf35a8ef089) {
            if (route.element) $737d96742fae595e$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $fITET.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($737d96742fae595e$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $737d96742fae595e$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $fITET.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($737d96742fae595e$export$945fecf35a8ef089) {
            if (route.errorElement) $737d96742fae595e$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $fITET.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $737d96742fae595e$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $737d96742fae595e$export$f30f7e456d254e83(routes, opts) {
    return $737d96742fae595e$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $737d96742fae595e$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $737d96742fae595e$export$e2fd2c03906469db,
        mapRouteProperties: $737d96742fae595e$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $737d96742fae595e$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $737d96742fae595e$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $737d96742fae595e$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $fITET.useState(router.state);
    let [state, setOptimisticState] = $737d96742fae595e$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $fITET.useState();
    let [vtContext, setVtContext] = $fITET.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $fITET.useState();
    let [transition, setTransition] = $fITET.useState();
    let [interruption, setInterruption] = $fITET.useState();
    let fetcherData = $fITET.useRef(/* @__PURE__ */ new Map());
    let setState = $fITET.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $737d96742fae595e$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $737d96742fae595e$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $737d96742fae595e$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $fITET.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$737d96742fae595e$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $fITET.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $fITET.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $737d96742fae595e$var$Deferred());
    }, [
        vtContext
    ]);
    $fITET.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $fITET.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$737d96742fae595e$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $fITET.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $fITET.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $fITET.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $fITET.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $737d96742fae595e$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $737d96742fae595e$var$MemoizedDataRoutes = $fITET.memo($737d96742fae595e$var$DataRoutes2);
function $737d96742fae595e$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $737d96742fae595e$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $737d96742fae595e$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $fITET.useRef();
    if (historyRef.current == null) historyRef.current = $737d96742fae595e$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fITET.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fITET.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $fITET.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $fITET.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $737d96742fae595e$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $737d96742fae595e$export$f5708dca728d7177($737d96742fae595e$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    $737d96742fae595e$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    let { pathname: locationPathname } = $737d96742fae595e$export$45d76561a5302f2b();
    let navigate = $737d96742fae595e$export$9770f232ac06a008();
    let path = $737d96742fae595e$var$resolveTo(to, $737d96742fae595e$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $737d96742fae595e$export$6c8e41f66e7aa990(typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to), navigator.createHref(path), $737d96742fae595e$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $fITET.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $737d96742fae595e$export$910ae8079b2c2852(props) {
    return $737d96742fae595e$export$a3be3530d8e40d0b(props.context);
}
function $737d96742fae595e$export$e7b0ac011bb776c6(props) {
    $737d96742fae595e$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $737d96742fae595e$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $737d96742fae595e$export$f5708dca728d7177(!$737d96742fae595e$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $fITET.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $737d96742fae595e$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $fITET.useMemo(()=>{
        let trailingPathname = $737d96742fae595e$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $737d96742fae595e$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $737d96742fae595e$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $737d96742fae595e$export$5d3fca4a98652595($737d96742fae595e$export$16da398f5434bdec(children), location);
}
function $737d96742fae595e$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $fITET.useContext($737d96742fae595e$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $fITET.useContext($737d96742fae595e$export$315e3ffb01f217);
    let onError = $fITET.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $737d96742fae595e$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$ResolveAwait, null, children));
}
var $737d96742fae595e$var$AwaitErrorBoundary = class extends $fITET.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $737d96742fae595e$var$ResolveAwait({ children: children }) {
    let data2 = $737d96742fae595e$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, toRender);
}
function $737d96742fae595e$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $fITET.Children.forEach(children, (element, index)=>{
        if (!$fITET.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $fITET.Fragment) {
            routes.push.apply(routes, $737d96742fae595e$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $737d96742fae595e$export$f5708dca728d7177(element.type === $737d96742fae595e$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $737d96742fae595e$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $737d96742fae595e$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $737d96742fae595e$export$9b5b6d122dea0c88 = $737d96742fae595e$export$16da398f5434bdec;
function $737d96742fae595e$export$daf73786167a7f72(matches) {
    return $737d96742fae595e$var$_renderMatches(matches);
}
function $737d96742fae595e$var$useRouteComponentProps() {
    return {
        params: $737d96742fae595e$export$99eaa27ddbbb95ef(),
        loaderData: $737d96742fae595e$export$1448a5050d252c4d(),
        actionData: $737d96742fae595e$export$fdc00f3f26066d5e(),
        matches: $737d96742fae595e$export$2378eb7f5ff86053()
    };
}
function $737d96742fae595e$export$6c4f3826290c37af({ children: children }) {
    const props = $737d96742fae595e$var$useRouteComponentProps();
    return $fITET.cloneElement(children, props);
}
function $737d96742fae595e$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $737d96742fae595e$var$useRouteComponentProps();
        return $fITET.createElement(Component4, props);
    };
}
function $737d96742fae595e$var$useHydrateFallbackProps() {
    return {
        params: $737d96742fae595e$export$99eaa27ddbbb95ef(),
        loaderData: $737d96742fae595e$export$1448a5050d252c4d(),
        actionData: $737d96742fae595e$export$fdc00f3f26066d5e()
    };
}
function $737d96742fae595e$export$f8cff34f39c1932a({ children: children }) {
    const props = $737d96742fae595e$var$useHydrateFallbackProps();
    return $fITET.cloneElement(children, props);
}
function $737d96742fae595e$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $737d96742fae595e$var$useHydrateFallbackProps();
        return $fITET.createElement(HydrateFallback, props);
    };
}
function $737d96742fae595e$var$useErrorBoundaryProps() {
    return {
        params: $737d96742fae595e$export$99eaa27ddbbb95ef(),
        loaderData: $737d96742fae595e$export$1448a5050d252c4d(),
        actionData: $737d96742fae595e$export$fdc00f3f26066d5e(),
        error: $737d96742fae595e$export$ed527bf60f6e05f2()
    };
}
function $737d96742fae595e$export$e5afde5c4b6d747b({ children: children }) {
    const props = $737d96742fae595e$var$useErrorBoundaryProps();
    return $fITET.cloneElement(children, props);
}
function $737d96742fae595e$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $737d96742fae595e$var$useErrorBoundaryProps();
        return $fITET.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $737d96742fae595e$var$defaultMethod = "get";
var $737d96742fae595e$var$defaultEncType = "application/x-www-form-urlencoded";
function $737d96742fae595e$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $737d96742fae595e$var$isButtonElement(object) {
    return $737d96742fae595e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $737d96742fae595e$var$isFormElement(object) {
    return $737d96742fae595e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $737d96742fae595e$var$isInputElement(object) {
    return $737d96742fae595e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $737d96742fae595e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $737d96742fae595e$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$737d96742fae595e$var$isModifiedEvent(event);
}
function $737d96742fae595e$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $737d96742fae595e$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $737d96742fae595e$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $737d96742fae595e$var$_formDataSupportsSubmitter = null;
function $737d96742fae595e$var$isFormDataSubmitterSupported() {
    if ($737d96742fae595e$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $737d96742fae595e$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $737d96742fae595e$var$_formDataSupportsSubmitter = true;
    }
    return $737d96742fae595e$var$_formDataSupportsSubmitter;
}
var $737d96742fae595e$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $737d96742fae595e$var$getFormEncType(encType) {
    if (encType != null && !$737d96742fae595e$var$supportedFormEncTypes.has(encType)) {
        $737d96742fae595e$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$737d96742fae595e$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $737d96742fae595e$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($737d96742fae595e$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $737d96742fae595e$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $737d96742fae595e$var$defaultMethod;
        encType = $737d96742fae595e$var$getFormEncType(target.getAttribute("enctype")) || $737d96742fae595e$var$defaultEncType;
        formData = new FormData(target);
    } else if ($737d96742fae595e$var$isButtonElement(target) || $737d96742fae595e$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $737d96742fae595e$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $737d96742fae595e$var$defaultMethod;
        encType = $737d96742fae595e$var$getFormEncType(target.getAttribute("formenctype")) || $737d96742fae595e$var$getFormEncType(form.getAttribute("enctype")) || $737d96742fae595e$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$737d96742fae595e$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($737d96742fae595e$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $737d96742fae595e$var$defaultMethod;
        action = null;
        encType = $737d96742fae595e$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $737d96742fae595e$var$HOLE = -1;
var $737d96742fae595e$var$NAN = -2;
var $737d96742fae595e$var$NEGATIVE_INFINITY = -3;
var $737d96742fae595e$var$NEGATIVE_ZERO = -4;
var $737d96742fae595e$var$NULL = -5;
var $737d96742fae595e$var$POSITIVE_INFINITY = -6;
var $737d96742fae595e$var$UNDEFINED = -7;
var $737d96742fae595e$var$TYPE_BIGINT = "B";
var $737d96742fae595e$var$TYPE_DATE = "D";
var $737d96742fae595e$var$TYPE_ERROR = "E";
var $737d96742fae595e$var$TYPE_MAP = "M";
var $737d96742fae595e$var$TYPE_NULL_OBJECT = "N";
var $737d96742fae595e$var$TYPE_PROMISE = "P";
var $737d96742fae595e$var$TYPE_REGEXP = "R";
var $737d96742fae595e$var$TYPE_SET = "S";
var $737d96742fae595e$var$TYPE_SYMBOL = "Y";
var $737d96742fae595e$var$TYPE_URL = "U";
var $737d96742fae595e$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $737d96742fae595e$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $737d96742fae595e$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $737d96742fae595e$var$TIME_LIMIT_MS = 1;
var $737d96742fae595e$var$getNow = ()=>Date.now();
var $737d96742fae595e$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $737d96742fae595e$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $737d96742fae595e$var$UNDEFINED;
    if (input === null) return $737d96742fae595e$var$NULL;
    if (Number.isNaN(input)) return $737d96742fae595e$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $737d96742fae595e$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $737d96742fae595e$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $737d96742fae595e$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $737d96742fae595e$var$stringify.call(this, stack);
    return index;
}
async function $737d96742fae595e$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $737d96742fae595e$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $737d96742fae595e$var$UNDEFINED;
        if (value === null) return $737d96742fae595e$var$NULL;
        if (Number.isNaN(value)) return $737d96742fae595e$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $737d96742fae595e$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $737d96742fae595e$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $737d96742fae595e$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $737d96742fae595e$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $737d96742fae595e$var$TIME_LIMIT_MS) {
            await $737d96742fae595e$var$yieldToMain();
            lastYieldTime = $737d96742fae595e$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$737d96742fae595e$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$737d96742fae595e$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$737d96742fae595e$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $737d96742fae595e$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$737d96742fae595e$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$737d96742fae595e$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$737d96742fae595e$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$737d96742fae595e$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$737d96742fae595e$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$737d96742fae595e$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$737d96742fae595e$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$737d96742fae595e$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$737d96742fae595e$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$737d96742fae595e$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($737d96742fae595e$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $737d96742fae595e$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $737d96742fae595e$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $737d96742fae595e$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $737d96742fae595e$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $737d96742fae595e$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $737d96742fae595e$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $737d96742fae595e$var$hydrate.call(this, startIndex);
}
function $737d96742fae595e$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $737d96742fae595e$var$UNDEFINED:
                set(void 0);
                continue;
            case $737d96742fae595e$var$NULL:
                set(null);
                continue;
            case $737d96742fae595e$var$NAN:
                set(NaN);
                continue;
            case $737d96742fae595e$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $737d96742fae595e$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $737d96742fae595e$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $737d96742fae595e$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $737d96742fae595e$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $737d96742fae595e$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $737d96742fae595e$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $737d96742fae595e$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $737d96742fae595e$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $737d96742fae595e$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $737d96742fae595e$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $737d96742fae595e$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $737d96742fae595e$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $737d96742fae595e$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $737d96742fae595e$var$globalObj && $737d96742fae595e$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $737d96742fae595e$var$globalObj && typeof $737d96742fae595e$var$globalObj[errorType] === "function" ? new $737d96742fae595e$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $737d96742fae595e$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $737d96742fae595e$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $737d96742fae595e$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $737d96742fae595e$var$Deferred2();
    const reader = readable.pipeThrough($737d96742fae595e$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $737d96742fae595e$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $737d96742fae595e$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $737d96742fae595e$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $737d96742fae595e$var$unflatten.call(this, line)
    };
}
async function $737d96742fae595e$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $737d96742fae595e$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $737d96742fae595e$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $737d96742fae595e$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $737d96742fae595e$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $737d96742fae595e$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $737d96742fae595e$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $737d96742fae595e$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$737d96742fae595e$var$TYPE_PROMISE}${deferredId}:[["${$737d96742fae595e$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$737d96742fae595e$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$737d96742fae595e$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $737d96742fae595e$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$737d96742fae595e$var$TYPE_ERROR}${deferredId}:[["${$737d96742fae595e$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$737d96742fae595e$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$737d96742fae595e$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $737d96742fae595e$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $737d96742fae595e$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $737d96742fae595e$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $737d96742fae595e$export$4cf11838cdc2a8a8(html) {
    return html.replace($737d96742fae595e$var$ESCAPE_REGEX, (match)=>$737d96742fae595e$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $737d96742fae595e$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $737d96742fae595e$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $737d96742fae595e$var$SingleFetchNoResultError = class extends Error {
};
var $737d96742fae595e$export$ae9272e641ead836 = 202;
var $737d96742fae595e$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $737d96742fae595e$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $fITET.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$737d96742fae595e$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, scriptTag, /* @__PURE__ */ $fITET.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, scriptTag, /* @__PURE__ */ $fITET.createElement($fITET.Suspense, null, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $737d96742fae595e$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $737d96742fae595e$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $737d96742fae595e$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $737d96742fae595e$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $737d96742fae595e$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $737d96742fae595e$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $737d96742fae595e$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $737d96742fae595e$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $737d96742fae595e$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $737d96742fae595e$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $737d96742fae595e$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $737d96742fae595e$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($737d96742fae595e$export$3f1eb41d9a6a6a27(result.result) || $737d96742fae595e$export$972111febbeef05b(result.result) || $737d96742fae595e$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $737d96742fae595e$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $737d96742fae595e$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $737d96742fae595e$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $737d96742fae595e$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$737d96742fae595e$var$createDeferred2());
    let singleFetchDfd = $737d96742fae595e$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $737d96742fae595e$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $737d96742fae595e$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $737d96742fae595e$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $737d96742fae595e$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $737d96742fae595e$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $737d96742fae595e$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $737d96742fae595e$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $737d96742fae595e$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $737d96742fae595e$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $737d96742fae595e$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $737d96742fae595e$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$737d96742fae595e$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$737d96742fae595e$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $737d96742fae595e$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $737d96742fae595e$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $737d96742fae595e$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $737d96742fae595e$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $737d96742fae595e$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $737d96742fae595e$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($737d96742fae595e$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $737d96742fae595e$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $737d96742fae595e$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($737d96742fae595e$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$737d96742fae595e$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $737d96742fae595e$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $737d96742fae595e$export$4023ad4ecd4126a2(body, global) {
    return $737d96742fae595e$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $737d96742fae595e$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $737d96742fae595e$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$737d96742fae595e$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $737d96742fae595e$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $737d96742fae595e$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $737d96742fae595e$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $737d96742fae595e$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $737d96742fae595e$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $737d96742fae595e$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $737d96742fae595e$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $737d96742fae595e$var$getModuleLinkHrefs(matches, manifest);
    return $737d96742fae595e$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $737d96742fae595e$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $737d96742fae595e$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $737d96742fae595e$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($737d96742fae595e$var$prefetchStyleLink));
}
async function $737d96742fae595e$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$737d96742fae595e$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$737d96742fae595e$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$737d96742fae595e$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($737d96742fae595e$var$prefetchStyleLink));
}
async function $737d96742fae595e$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $737d96742fae595e$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $737d96742fae595e$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $737d96742fae595e$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $737d96742fae595e$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $737d96742fae595e$var$dedupeLinkDescriptors(links.flat(1).filter($737d96742fae595e$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $737d96742fae595e$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $737d96742fae595e$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $737d96742fae595e$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $737d96742fae595e$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $737d96742fae595e$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $737d96742fae595e$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$737d96742fae595e$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($737d96742fae595e$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $737d96742fae595e$var$_isPreloadSupported;
function $737d96742fae595e$var$isPreloadSupported() {
    if ($737d96742fae595e$var$_isPreloadSupported !== void 0) return $737d96742fae595e$var$_isPreloadSupported;
    let el = document.createElement("link");
    $737d96742fae595e$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $737d96742fae595e$var$_isPreloadSupported;
}
function $737d96742fae595e$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $737d96742fae595e$var$useFrameworkContext();
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $737d96742fae595e$export$945fecf35a8ef089 ? /* @__PURE__ */ $fITET.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $737d96742fae595e$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $737d96742fae595e$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $737d96742fae595e$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $737d96742fae595e$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$RemixRootDefaultErrorBoundary, {
            error: $737d96742fae595e$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $fITET.createElement(routeModule.Layout, null, /* @__PURE__ */ $fITET.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $fITET.createElement(routeModule.Layout, null, /* @__PURE__ */ $fITET.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $fITET.createElement(routeModule.Layout, null, /* @__PURE__ */ $fITET.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $737d96742fae595e$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $737d96742fae595e$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $737d96742fae595e$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$737d96742fae595e$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $737d96742fae595e$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $737d96742fae595e$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $737d96742fae595e$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $737d96742fae595e$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $737d96742fae595e$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $737d96742fae595e$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $737d96742fae595e$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $737d96742fae595e$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $737d96742fae595e$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $737d96742fae595e$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $737d96742fae595e$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $737d96742fae595e$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $737d96742fae595e$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$737d96742fae595e$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $737d96742fae595e$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $737d96742fae595e$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $737d96742fae595e$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $737d96742fae595e$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $737d96742fae595e$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $737d96742fae595e$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $737d96742fae595e$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $737d96742fae595e$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $737d96742fae595e$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $737d96742fae595e$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $737d96742fae595e$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $737d96742fae595e$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $737d96742fae595e$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $737d96742fae595e$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $737d96742fae595e$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $737d96742fae595e$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $737d96742fae595e$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $737d96742fae595e$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $737d96742fae595e$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $737d96742fae595e$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $737d96742fae595e$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $737d96742fae595e$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $737d96742fae595e$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $737d96742fae595e$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $737d96742fae595e$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $737d96742fae595e$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $737d96742fae595e$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $737d96742fae595e$var$nextPaths = /* @__PURE__ */ new Set();
var $737d96742fae595e$var$discoveredPathsMaxSize = 1e3;
var $737d96742fae595e$var$discoveredPaths = /* @__PURE__ */ new Set();
var $737d96742fae595e$export$b5915cf27fa06b9f = 7680;
function $737d96742fae595e$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $737d96742fae595e$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $737d96742fae595e$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $737d96742fae595e$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $737d96742fae595e$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$737d96742fae595e$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($737d96742fae595e$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $737d96742fae595e$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $737d96742fae595e$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $737d96742fae595e$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $fITET.useEffect(()=>{
        if (!$737d96742fae595e$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$737d96742fae595e$var$discoveredPaths.has(pathname)) $737d96742fae595e$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($737d96742fae595e$var$nextPaths.keys()).filter((path)=>{
                if ($737d96742fae595e$var$discoveredPaths.has(path)) {
                    $737d96742fae595e$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $737d96742fae595e$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $737d96742fae595e$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $737d96742fae595e$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $737d96742fae595e$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $737d96742fae595e$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $737d96742fae595e$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $737d96742fae595e$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($737d96742fae595e$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $737d96742fae595e$export$b5915cf27fa06b9f) {
        $737d96742fae595e$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($737d96742fae595e$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($737d96742fae595e$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($737d96742fae595e$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$737d96742fae595e$var$addToFifoQueue(p, $737d96742fae595e$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $737d96742fae595e$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $737d96742fae595e$var$addToFifoQueue(path, queue) {
    if (queue.size >= $737d96742fae595e$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $737d96742fae595e$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $737d96742fae595e$var$useDataRouterContext2() {
    let context = $fITET.useContext($737d96742fae595e$export$2eeee58951ff3c1c);
    $737d96742fae595e$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $737d96742fae595e$var$useDataRouterStateContext() {
    let context = $fITET.useContext($737d96742fae595e$export$315e3ffb01f217);
    $737d96742fae595e$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $737d96742fae595e$export$208d6a3bc3aa62bd = $fITET.createContext(void 0);
$737d96742fae595e$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $737d96742fae595e$var$useFrameworkContext() {
    let context = $fITET.useContext($737d96742fae595e$export$208d6a3bc3aa62bd);
    $737d96742fae595e$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $737d96742fae595e$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $fITET.useContext($737d96742fae595e$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $fITET.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $fITET.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $fITET.useRef(null);
    $fITET.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $fITET.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $737d96742fae595e$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $737d96742fae595e$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $737d96742fae595e$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $737d96742fae595e$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $737d96742fae595e$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $737d96742fae595e$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $737d96742fae595e$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$737d96742fae595e$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $737d96742fae595e$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $737d96742fae595e$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $737d96742fae595e$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $737d96742fae595e$var$useDataRouterStateContext();
    let matches = $737d96742fae595e$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $fITET.useMemo(()=>$737d96742fae595e$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $fITET.createElement("style", {
        [$737d96742fae595e$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $fITET.createElement("link", {
        [$737d96742fae595e$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$737d96742fae595e$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $fITET.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $737d96742fae595e$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $737d96742fae595e$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $737d96742fae595e$var$useFrameworkContext();
    let { router: router } = $737d96742fae595e$var$useDataRouterContext2();
    let matches = $fITET.useMemo(()=>$737d96742fae595e$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $737d96742fae595e$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $737d96742fae595e$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $fITET.useState([]);
    $fITET.useEffect(()=>{
        let interrupted = false;
        $737d96742fae595e$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $737d96742fae595e$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let { future: future } = $737d96742fae595e$var$useFrameworkContext();
    let { basename: basename } = $737d96742fae595e$var$useDataRouterContext2();
    let dataHrefs = $fITET.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $737d96742fae595e$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $fITET.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $737d96742fae595e$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $737d96742fae595e$var$useFrameworkContext();
    let { basename: basename } = $737d96742fae595e$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $737d96742fae595e$var$useDataRouterStateContext();
    let newMatchesForData = $fITET.useMemo(()=>$737d96742fae595e$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $fITET.useMemo(()=>$737d96742fae595e$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $fITET.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $737d96742fae595e$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $fITET.useMemo(()=>$737d96742fae595e$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $737d96742fae595e$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $fITET.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $fITET.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $fITET.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $737d96742fae595e$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $737d96742fae595e$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $737d96742fae595e$var$useDataRouterStateContext();
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let _matches = $737d96742fae595e$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$737d96742fae595e$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $fITET.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $fITET.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $fITET.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $fITET.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $737d96742fae595e$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $fITET.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $737d96742fae595e$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $737d96742fae595e$var$isHydrated = false;
function $737d96742fae595e$export$3be068dde909e563() {
    $737d96742fae595e$var$isHydrated = true;
}
function $737d96742fae595e$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $737d96742fae595e$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $737d96742fae595e$var$useDataRouterContext2();
    let { matches: routerMatches } = $737d96742fae595e$var$useDataRouterStateContext();
    let isRSCRouterContext = $737d96742fae595e$var$useIsRSCRouterContext();
    let enableFogOfWar = $737d96742fae595e$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $737d96742fae595e$var$getActiveMatches(routerMatches, null, isSpaMode);
    $fITET.useEffect(()=>{
        $737d96742fae595e$export$3be068dde909e563();
    }, []);
    let initialScripts = $fITET.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $737d96742fae595e$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($737d96742fae595e$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, /* @__PURE__ */ $fITET.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $fITET.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $737d96742fae595e$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($737d96742fae595e$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $737d96742fae595e$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $737d96742fae595e$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $fITET.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $fITET.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $fITET.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $fITET.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $737d96742fae595e$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $737d96742fae595e$export$32e57f52df4b6e34 = class extends $fITET.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $737d96742fae595e$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $737d96742fae595e$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $fITET.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($737d96742fae595e$export$972111febbeef05b(error)) return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $fITET.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $737d96742fae595e$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $fITET.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $fITET.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $737d96742fae595e$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $737d96742fae595e$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $fITET.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $fITET.createElement("head", null, /* @__PURE__ */ $fITET.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $fITET.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $fITET.createElement("title", null, title)), /* @__PURE__ */ $fITET.createElement("body", null, /* @__PURE__ */ $fITET.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$ff0bf87698939488, null) : null)));
}
var $737d96742fae595e$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($737d96742fae595e$var$isBrowser2) window.__reactRouterVersion = "7.18.3";
} catch (e) {}
function $737d96742fae595e$export$1f3f55432a00e06d(routes, opts) {
    return $737d96742fae595e$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $737d96742fae595e$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $737d96742fae595e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $737d96742fae595e$export$9269a41d8c4635e,
        hydrationRouteProperties: $737d96742fae595e$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $737d96742fae595e$export$1ba7ed8a3a7b3765(routes, opts) {
    return $737d96742fae595e$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $737d96742fae595e$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $737d96742fae595e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $737d96742fae595e$export$9269a41d8c4635e,
        hydrationRouteProperties: $737d96742fae595e$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $737d96742fae595e$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $737d96742fae595e$var$deserializeErrors(state.errors)
    };
    return state;
}
function $737d96742fae595e$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $737d96742fae595e$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $737d96742fae595e$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $737d96742fae595e$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $fITET.useRef();
    if (historyRef.current == null) historyRef.current = $737d96742fae595e$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fITET.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fITET.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $fITET.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $fITET.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $737d96742fae595e$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $fITET.useRef();
    if (historyRef.current == null) historyRef.current = $737d96742fae595e$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fITET.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fITET.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $fITET.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $fITET.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $737d96742fae595e$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $fITET.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fITET.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $fITET.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $fITET.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$737d96742fae595e$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $737d96742fae595e$export$a6c7ac8248d6e38a = $fITET.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $737d96742fae595e$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $737d96742fae595e$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $737d96742fae595e$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $737d96742fae595e$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $737d96742fae595e$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $737d96742fae595e$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $737d96742fae595e$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $fITET.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $737d96742fae595e$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, link, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$737d96742fae595e$export$a6c7ac8248d6e38a.displayName = "Link";
var $737d96742fae595e$export$b0d92dbee9b5b60d = $fITET.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $737d96742fae595e$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let routerState = $fITET.useContext($737d96742fae595e$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $737d96742fae595e$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $737d96742fae595e$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$737d96742fae595e$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $737d96742fae595e$export$a7fed597f4b8afd8 = $fITET.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $737d96742fae595e$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let submit = $737d96742fae595e$export$47c85c6e3a081d3();
    let formAction = $737d96742fae595e$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $737d96742fae595e$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $fITET.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $fITET.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$737d96742fae595e$export$a7fed597f4b8afd8.displayName = "Form";
function $737d96742fae595e$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $fITET.useContext($737d96742fae595e$export$208d6a3bc3aa62bd);
    let { basename: basename } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let matches = $737d96742fae595e$export$2378eb7f5ff86053();
    $737d96742fae595e$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $fITET.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $737d96742fae595e$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $fITET.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$737d96742fae595e$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $737d96742fae595e$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$737d96742fae595e$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$737d96742fae595e$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $737d96742fae595e$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $737d96742fae595e$var$useDataRouterContext3(hookName) {
    let ctx = $fITET.useContext($737d96742fae595e$export$2eeee58951ff3c1c);
    $737d96742fae595e$export$f5708dca728d7177(ctx, $737d96742fae595e$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $737d96742fae595e$var$useDataRouterState2(hookName) {
    let state = $fITET.useContext($737d96742fae595e$export$315e3ffb01f217);
    $737d96742fae595e$export$f5708dca728d7177(state, $737d96742fae595e$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $737d96742fae595e$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $737d96742fae595e$export$9770f232ac06a008();
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let path = $737d96742fae595e$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $fITET.useCallback((event)=>{
        if ($737d96742fae595e$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $737d96742fae595e$export$fe53371bee54353d(location) === $737d96742fae595e$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $fITET.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $737d96742fae595e$export$f1a78c17382fe22a(defaultInit) {
    $737d96742fae595e$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $fITET.useRef($737d96742fae595e$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $fITET.useRef(false);
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let searchParams = $fITET.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $737d96742fae595e$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $737d96742fae595e$export$9770f232ac06a008();
    let setSearchParams = $fITET.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $737d96742fae595e$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $737d96742fae595e$var$fetcherId = 0;
var $737d96742fae595e$var$getUniqueFetcherId = ()=>`__${String(++$737d96742fae595e$var$fetcherId)}__`;
function $737d96742fae595e$export$47c85c6e3a081d3() {
    let { router: router } = $737d96742fae595e$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let currentRouteId = $737d96742fae595e$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $fITET.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $737d96742fae595e$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $737d96742fae595e$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $737d96742fae595e$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let routeContext = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    $737d96742fae595e$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$737d96742fae595e$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $737d96742fae595e$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $737d96742fae595e$export$fe53371bee54353d(path);
}
function $737d96742fae595e$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $737d96742fae595e$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $737d96742fae595e$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $fITET.useContext($737d96742fae595e$export$cb3f1df1bef00a39);
    let route = $fITET.useContext($737d96742fae595e$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $737d96742fae595e$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $737d96742fae595e$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $737d96742fae595e$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $fITET.useId();
    let [fetcherKey, setFetcherKey] = $fITET.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $fITET.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $fITET.useCallback(async (href, opts)=>{
        $737d96742fae595e$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $737d96742fae595e$export$47c85c6e3a081d3();
    let submit = $fITET.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $fITET.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $fITET.useMemo(()=>{
        let FetcherForm2 = $fITET.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $737d96742fae595e$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $fITET.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $737d96742fae595e$export$fa996778a3a31087() {
    let state = $737d96742fae595e$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $fITET.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $737d96742fae595e$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $737d96742fae595e$var$savedScrollPositions = {};
function $737d96742fae595e$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $737d96742fae595e$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $737d96742fae595e$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $737d96742fae595e$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $737d96742fae595e$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $fITET.useContext($737d96742fae595e$export$3044ab7fdabeaee6);
    let location = $737d96742fae595e$export$45d76561a5302f2b();
    let matches = $737d96742fae595e$export$2378eb7f5ff86053();
    let navigation = $737d96742fae595e$export$d0fd4b7106de2769();
    $fITET.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $737d96742fae595e$var$usePageHide($fITET.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $737d96742fae595e$var$getScrollRestorationKey(location, matches, basename, getKey);
            $737d96742fae595e$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $737d96742fae595e$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($737d96742fae595e$var$savedScrollPositions));
        } catch (error) {
            $737d96742fae595e$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $fITET.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $737d96742fae595e$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $737d96742fae595e$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $fITET.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($737d96742fae595e$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$737d96742fae595e$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $fITET.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $737d96742fae595e$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $737d96742fae595e$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $fITET.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $737d96742fae595e$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $fITET.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $737d96742fae595e$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $737d96742fae595e$export$b273b3273281a049(when);
    $fITET.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $fITET.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $737d96742fae595e$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $fITET.useContext($737d96742fae595e$export$3681f408decb40d1);
    $737d96742fae595e$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $737d96742fae595e$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $737d96742fae595e$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $737d96742fae595e$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $737d96742fae595e$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $737d96742fae595e$export$81336c211d5ff295(path.pathname, nextPath) != null || $737d96742fae595e$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $737d96742fae595e$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $737d96742fae595e$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $737d96742fae595e$var$getStatelessNavigator();
    return /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $737d96742fae595e$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $737d96742fae595e$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $737d96742fae595e$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $737d96742fae595e$var$serializeErrors(context.errors)
        };
        let json = $737d96742fae595e$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $fITET.createElement($fITET.Fragment, null, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $fITET.createElement($737d96742fae595e$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $fITET.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $737d96742fae595e$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($737d96742fae595e$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $737d96742fae595e$var$getStatelessNavigator() {
    return {
        createHref: $737d96742fae595e$var$createHref,
        encodeLocation: $737d96742fae595e$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $737d96742fae595e$export$69163f0b72ec60d9(routes, opts) {
    return $737d96742fae595e$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $737d96742fae595e$export$9269a41d8c4635e
    });
}
function $737d96742fae595e$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $737d96742fae595e$export$87cb1a9238dc3fba(routes, $737d96742fae595e$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $737d96742fae595e$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $737d96742fae595e$var$createHref,
        encodeLocation: $737d96742fae595e$var$encodeLocation,
        getFetcher () {
            return $737d96742fae595e$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $737d96742fae595e$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $737d96742fae595e$var$createHref(to) {
    return typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to);
}
function $737d96742fae595e$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $737d96742fae595e$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $737d96742fae595e$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("64wTB", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("3ehWd")).Trans; });
$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("3Pe9S")).useTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("iBK5u")).initReactI18next; });

var $3ehWd = parcelRequire("3ehWd");

var $d0tVC = parcelRequire("d0tVC");

var $lTfdB = parcelRequire("lTfdB");

var $8SR1Y = parcelRequire("8SR1Y");

var $3Pe9S = parcelRequire("3Pe9S");

var $bDHFt = parcelRequire("bDHFt");

var $7iSKW = parcelRequire("7iSKW");

var $eAteb = parcelRequire("eAteb");

var $9Jw5G = parcelRequire("9Jw5G");

var $fGZM3 = parcelRequire("fGZM3");

var $iBK5u = parcelRequire("iBK5u");

var $38dth = parcelRequire("38dth");

var $f2LNf = parcelRequire("f2LNf");

var $bviPB = parcelRequire("bviPB");
const $46bca235dc09a125$export$324d90190a8b822a = ()=>'';
const $46bca235dc09a125$export$2da9be4cfdb689b1 = ()=>'';
const $46bca235dc09a125$export$98e628dec113755e = ()=>'';
const $46bca235dc09a125$export$2e6c959c16ff56b8 = ()=>'';
const $46bca235dc09a125$export$4e35d5c922a95490 = ()=>'';
const $46bca235dc09a125$export$720a3b9db04b7a0f = ()=>'';

});
parcelRegister("3ehWd", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $25a097fd04d03283$export$8d6a9236f2e3f2ce; });

var $fITET = parcelRequire("fITET");

var $d0tVC = parcelRequire("d0tVC");
parcelRequire("bviPB");
var $f2LNf = parcelRequire("f2LNf");
var $bviPB = parcelRequire("bviPB");
function $25a097fd04d03283$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $fITET.useContext)((0, $bviPB.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $f2LNf.getI18n)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $d0tVC.Trans)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}

});
parcelRegister("d0tVC", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $97827d9e278f1131$export$8d6a9236f2e3f2ce; });

var $fITET = parcelRequire("fITET");

var $aLMH1 = parcelRequire("aLMH1");

var $6Jh8G = parcelRequire("6Jh8G");

var $7ou6r = parcelRequire("7ou6r");

var $38dth = parcelRequire("38dth");

var $f2LNf = parcelRequire("f2LNf");

var $6FVMs = parcelRequire("6FVMs");
const $97827d9e278f1131$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $97827d9e278f1131$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $97827d9e278f1131$var$getAsArray(children) : children;
};
const $97827d9e278f1131$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $fITET.isValidElement));
const $97827d9e278f1131$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $97827d9e278f1131$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $97827d9e278f1131$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $97827d9e278f1131$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $7ou6r.isString)(child)) return;
            if ($97827d9e278f1131$var$hasChildren(child)) getData($97827d9e278f1131$var$getChildren(child));
            else if ((0, $7ou6r.isObject)(child) && !(0, $fITET.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $97827d9e278f1131$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $97827d9e278f1131$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $7ou6r.isString)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $fITET.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount <= 1) {
                const cnt = (0, $7ou6r.isString)(childChildren) ? childChildren : $97827d9e278f1131$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
                stringNode += `<${type}>${cnt}</${type}>`;
                return;
            }
            const content = $97827d9e278f1131$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $7ou6r.warn)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $7ou6r.isObject)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $7ou6r.warn)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $7ou6r.warn)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $97827d9e278f1131$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $97827d9e278f1131$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $7ou6r.isString)(child)) return;
            if ($97827d9e278f1131$var$hasChildren(child)) getData($97827d9e278f1131$var$getChildren(child));
            else if ((0, $7ou6r.isObject)(child) && !(0, $fITET.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const knownNames = Object.keys(data);
    const allowedTags = (name)=>/^\d+$/.test(name) || keepArray.indexOf(name) > -1 || knownNames.indexOf(name) > -1;
    const ast = (0, $6Jh8G.default).parse(`<0>${targetString}</0>`, {
        allowedTags: allowedTags
    });
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $97827d9e278f1131$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $97827d9e278f1131$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $fITET.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $fITET.Children).map([
            child
        ], (c)=>{
            if (c.type === (0, $fITET.Fragment) || c.props?.i18nIsDynamicList !== undefined) {
                const freshProps = {
                    key: i
                };
                if (c && c.props) Object.keys(c.props).forEach((k)=>{
                    if (k === 'children' || k === 'i18nIsDynamicList') return;
                    freshProps[k] = c.props[k];
                });
                return (0, $fITET.createElement)(c.type, freshProps, isVoid ? null : inner);
            }
            const override = {
                key: i
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children') return;
                override[k] = c.props[k];
            });
            return (0, $fITET.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $97827d9e278f1131$var$getAsArray(reactNode);
        const astNodes = $97827d9e278f1131$var$getAsArray(astNode);
        const keepTagOccurrence = {};
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $7ou6r.isString)(val)) props[p] = (0, $6FVMs.unescape)(val);
                });
                const child = Object.keys(props).length !== 0 ? $97827d9e278f1131$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $fITET.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $97827d9e278f1131$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $7ou6r.isObject)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $7ou6r.isObject)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $7ou6r.isString)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($97827d9e278f1131$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $fITET.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const occurrence = keepTagOccurrence[node.name] || 0;
                            keepTagOccurrence[node.name] = occurrence + 1;
                            let matched;
                            let seen = 0;
                            for(let r = 0; r < reactNodes.length; r += 1){
                                const rn = reactNodes[r];
                                if ((0, $fITET.isValidElement)(rn) && rn.type === node.name) {
                                    if (seen === occurrence) {
                                        matched = rn;
                                        break;
                                    }
                                    seen += 1;
                                }
                            }
                            const innerScope = matched ? $97827d9e278f1131$var$getAsArray($97827d9e278f1131$var$getChildren(matched)) : reactNodes;
                            const inner = mapAST(innerScope, node.children, rootReactNode);
                            mem.push((0, $fITET.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $7ou6r.isObject)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $38dth.getDefaults)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $fITET.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $97827d9e278f1131$var$getAsArray(children || []));
    return $97827d9e278f1131$var$getChildren(result[0]);
};
const $97827d9e278f1131$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $fITET.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $fITET.createElement)((0, $fITET.Fragment), null, comp);
    }
    return (0, $fITET.createElement)(Componentized, {
        key: componentKey
    });
};
const $97827d9e278f1131$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$97827d9e278f1131$var$fixComponentProps(c, index, translation));
const $97827d9e278f1131$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $97827d9e278f1131$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $97827d9e278f1131$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $97827d9e278f1131$var$generateArrayComponents(components, translation);
    if ((0, $7ou6r.isObject)(components)) return $97827d9e278f1131$var$generateObjectComponents(components, translation);
    (0, $7ou6r.warnOnce)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $97827d9e278f1131$var$isComponentsMap = (object)=>{
    if (!(0, $7ou6r.isObject)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $97827d9e278f1131$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $f2LNf.getI18n)();
    if (!i18n) {
        (0, $7ou6r.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $38dth.getDefaults)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $7ou6r.isString)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $97827d9e278f1131$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $aLMH1.keyFromSelector)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $97827d9e278f1131$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $97827d9e278f1131$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($97827d9e278f1131$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $97827d9e278f1131$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $fITET.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("aLMH1", function(module, exports) {

$parcel$export(module.exports, "keyFromSelector", function () { return $7d7410914c1c679e$export$ec2cccc18ab4c2ae; });
$parcel$export(module.exports, "default", function () { return $7d7410914c1c679e$export$2e2bcd8739ae039; });
const $7d7410914c1c679e$var$isString = (obj)=>typeof obj === 'string';
const $7d7410914c1c679e$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $7d7410914c1c679e$var$makeString = (object)=>{
    if (object == null) return '';
    return String(object);
};
const $7d7410914c1c679e$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $7d7410914c1c679e$var$lastOfPathSeparatorRegExp = /###/g;
const $7d7410914c1c679e$var$cleanKey = (key)=>key && key.includes('###') ? key.replace($7d7410914c1c679e$var$lastOfPathSeparatorRegExp, '.') : key;
const $7d7410914c1c679e$var$canNotTraverseDeeper = (object)=>!object || $7d7410914c1c679e$var$isString(object);
const $7d7410914c1c679e$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$7d7410914c1c679e$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($7d7410914c1c679e$var$canNotTraverseDeeper(object)) return {};
        const key = $7d7410914c1c679e$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($7d7410914c1c679e$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $7d7410914c1c679e$var$cleanKey(stack[stackIndex])
    };
};
const $7d7410914c1c679e$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $7d7410914c1c679e$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $7d7410914c1c679e$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $7d7410914c1c679e$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $7d7410914c1c679e$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $7d7410914c1c679e$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $7d7410914c1c679e$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $7d7410914c1c679e$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $7d7410914c1c679e$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $7d7410914c1c679e$var$getPath(data, key);
    if (value !== undefined) return value;
    return $7d7410914c1c679e$var$getPath(defaultData, key);
};
const $7d7410914c1c679e$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
            if ($7d7410914c1c679e$var$isString(target[prop]) || target[prop] instanceof String || $7d7410914c1c679e$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $7d7410914c1c679e$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $7d7410914c1c679e$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $7d7410914c1c679e$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $7d7410914c1c679e$var$escape = (data)=>{
    if ($7d7410914c1c679e$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$7d7410914c1c679e$var$_entityMap[s]);
    return data;
};
class $7d7410914c1c679e$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $7d7410914c1c679e$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $7d7410914c1c679e$var$looksLikeObjectPathRegExpCache = new $7d7410914c1c679e$var$RegExpCache(20);
const $7d7410914c1c679e$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $7d7410914c1c679e$var$chars.filter((c)=>!nsSeparator.includes(c) && !keySeparator.includes(c));
    if (possibleChars.length === 0) return true;
    const r = $7d7410914c1c679e$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $7d7410914c1c679e$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $7d7410914c1c679e$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $7d7410914c1c679e$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $7d7410914c1c679e$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $7d7410914c1c679e$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        args = args.map((a)=>$7d7410914c1c679e$var$isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a);
        if ($7d7410914c1c679e$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $7d7410914c1c679e$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $7d7410914c1c679e$var$Logger(this.logger, options);
    }
}
var $7d7410914c1c679e$var$baseLogger = new $7d7410914c1c679e$var$Logger();
class $7d7410914c1c679e$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            listener(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
        return this;
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(event, ...args);
            });
        }
    }
}
class $7d7410914c1c679e$var$ResourceStore extends $7d7410914c1c679e$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.includes('.')) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($7d7410914c1c679e$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $7d7410914c1c679e$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.includes('.')) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$7d7410914c1c679e$var$isString(key)) return result;
        return $7d7410914c1c679e$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.includes('.')) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $7d7410914c1c679e$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($7d7410914c1c679e$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.includes('.')) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $7d7410914c1c679e$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $7d7410914c1c679e$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $7d7410914c1c679e$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $7d7410914c1c679e$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $7d7410914c1c679e$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $7d7410914c1c679e$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $7d7410914c1c679e$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $7d7410914c1c679e$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$7d7410914c1c679e$var$PATH_KEY]: path } = selector($7d7410914c1c679e$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    const strict = opts?.enableSelector === 'strict';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            const candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
        }
    }
    return path.join(keySeparator);
}
const $7d7410914c1c679e$var$shouldHandleAsObject = (res)=>!$7d7410914c1c679e$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $7d7410914c1c679e$var$Translator extends $7d7410914c1c679e$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $7d7410914c1c679e$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $7d7410914c1c679e$var$baseLogger.create('translator');
        this.checkedLoadedFor = {};
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $7d7410914c1c679e$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$7d7410914c1c679e$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $7d7410914c1c679e$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $7d7410914c1c679e$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $7d7410914c1c679e$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $7d7410914c1c679e$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$7d7410914c1c679e$var$isString(opt.count);
        const hasDefaultValue = $7d7410914c1c679e$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $7d7410914c1c679e$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !($7d7410914c1c679e$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $7d7410914c1c679e$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $7d7410914c1c679e$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? `${key}${this.pluralResolver.getSuffix(lng, opt.count, opt)}` : key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && !suffixes.includes(`${this.options.pluralSeparator}zero`)) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $7d7410914c1c679e$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$7d7410914c1c679e$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $7d7410914c1c679e$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $7d7410914c1c679e$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($7d7410914c1c679e$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $7d7410914c1c679e$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$7d7410914c1c679e$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($7d7410914c1c679e$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!this.checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    this.checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$7d7410914c1c679e$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data = {
            ...data,
            count: options.count
        };
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $7d7410914c1c679e$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $7d7410914c1c679e$var$baseLogger.create('languageUtils');
        this.resolveHierarchyCache = {};
    }
    clearCache() {
        this.resolveHierarchyCache = {};
    }
    getScriptPartFromCode(code) {
        code = $7d7410914c1c679e$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $7d7410914c1c679e$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($7d7410914c1c679e$var$isString(code) && code.includes('-')) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return true;
                if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                if (supportedLng.startsWith(lngOnly) && lngOnly.length > 1) return true;
                return false;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($7d7410914c1c679e$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackLng = this.options.fallbackLng;
        const fallbackLngKey = Array.isArray(fallbackLng) ? fallbackLng.join('|') : fallbackLng;
        if (fallbackLngKey !== this._cachedFallbackLng) {
            this.resolveHierarchyCache = {};
            this._cachedFallbackLng = fallbackLngKey;
        }
        const hasCacheableFallback = fallbackCode === undefined || fallbackCode === false || $7d7410914c1c679e$var$isString(fallbackCode);
        const usesUncacheableOptionsFallback = fallbackCode === undefined && typeof this.options.fallbackLng === 'function';
        const cacheable = $7d7410914c1c679e$var$isString(code) && hasCacheableFallback && !usesUncacheableOptionsFallback;
        let cacheKey = null;
        if (cacheable) {
            let fallbackCacheKey;
            if (fallbackCode === undefined) fallbackCacheKey = 'undefined';
            else if (fallbackCode === false) fallbackCacheKey = 'boolean:false';
            else fallbackCacheKey = `string:${fallbackCode}`;
            cacheKey = `${code.length}:${code}|${fallbackCacheKey}`;
        }
        if (cacheKey !== null) {
            const cached = this.resolveHierarchyCache[cacheKey];
            if (cached !== undefined) return cached.slice();
        }
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($7d7410914c1c679e$var$isString(code) && (code.includes('-') || code.includes('_'))) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($7d7410914c1c679e$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (!codes.includes(fc)) addCode(this.formatLanguageCode(fc));
        });
        if (cacheKey !== null) {
            this.resolveHierarchyCache[cacheKey] = codes;
            return codes.slice();
        }
        return codes;
    }
}
const $7d7410914c1c679e$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $7d7410914c1c679e$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $7d7410914c1c679e$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $7d7410914c1c679e$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $7d7410914c1c679e$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $7d7410914c1c679e$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $7d7410914c1c679e$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$7d7410914c1c679e$var$suffixesOrder[pluralCategory1] - $7d7410914c1c679e$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $7d7410914c1c679e$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $7d7410914c1c679e$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $7d7410914c1c679e$var$isString(key)) {
        path = $7d7410914c1c679e$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $7d7410914c1c679e$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $7d7410914c1c679e$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $7d7410914c1c679e$var$Interpolator {
    constructor(options = {}){
        this.logger = $7d7410914c1c679e$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $7d7410914c1c679e$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $7d7410914c1c679e$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $7d7410914c1c679e$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? $7d7410914c1c679e$var$regexEscape(unescapePrefix) : '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? $7d7410914c1c679e$var$regexEscape(unescapeSuffix) : '';
        this.nestingPrefix = nestingPrefix ? $7d7410914c1c679e$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $7d7410914c1c679e$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $7d7410914c1c679e$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $7d7410914c1c679e$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (!key.includes(this.formatSeparator)) {
                const path = $7d7410914c1c679e$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($7d7410914c1c679e$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>val
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? this.escape(val) : val
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $7d7410914c1c679e$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$7d7410914c1c679e$var$isString(value) && !this.useRawValueToEscape) value = $7d7410914c1c679e$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], $7d7410914c1c679e$var$regexSafe(safeValue));
                if (skipOnVariables) {
                    todo.regex.lastIndex += safeValue.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (!key.includes(sep)) return key;
            const c = key.split(new RegExp(`${$7d7410914c1c679e$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(this.prefix)) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$7d7410914c1c679e$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/s.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$7d7410914c1c679e$var$isString(value)) return value;
            if (!$7d7410914c1c679e$var$isString(value)) value = $7d7410914c1c679e$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $7d7410914c1c679e$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.includes('(')) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $7d7410914c1c679e$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($7d7410914c1c679e$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $7d7410914c1c679e$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($7d7410914c1c679e$var$getCleanedCode(l), o)(v);
class $7d7410914c1c679e$var$Formatter {
    constructor(options = {}){
        this.logger = $7d7410914c1c679e$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $7d7410914c1c679e$var$createCachedFormatter : $7d7410914c1c679e$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $7d7410914c1c679e$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        if (!format) return value;
        if (value == null) return value;
        const rawFormats = format.split(this.formatSeparator);
        const formats = [];
        for(let i = 0; i < rawFormats.length; i++){
            let f = rawFormats[i];
            while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = `${f}${this.formatSeparator}${rawFormats[++i]}`;
            formats.push(f);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $7d7410914c1c679e$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $7d7410914c1c679e$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $7d7410914c1c679e$var$Connector extends $7d7410914c1c679e$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $7d7410914c1c679e$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $7d7410914c1c679e$var$pushPath(q.loaded, [
                lng
            ], ns);
            $7d7410914c1c679e$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($7d7410914c1c679e$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($7d7410914c1c679e$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $7d7410914c1c679e$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($7d7410914c1c679e$var$isString(args[1])) ret.defaultValue = args[1];
            if ($7d7410914c1c679e$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $7d7410914c1c679e$var$transformOptions = (options)=>{
    if ($7d7410914c1c679e$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($7d7410914c1c679e$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($7d7410914c1c679e$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $7d7410914c1c679e$var$noop = ()=>{};
const $7d7410914c1c679e$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $7d7410914c1c679e$var$I18n extends $7d7410914c1c679e$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $7d7410914c1c679e$var$transformOptions(options);
        this.services = {};
        this.logger = $7d7410914c1c679e$var$baseLogger;
        this.modules = {
            external: []
        };
        $7d7410914c1c679e$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($7d7410914c1c679e$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
        }
        const defOpts = $7d7410914c1c679e$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$7d7410914c1c679e$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $7d7410914c1c679e$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $7d7410914c1c679e$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $7d7410914c1c679e$var$Formatter;
            const lu = new $7d7410914c1c679e$var$LanguageUtil(this.options);
            this.store = new $7d7410914c1c679e$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $7d7410914c1c679e$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $7d7410914c1c679e$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator
            });
            if (formatter) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $7d7410914c1c679e$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $7d7410914c1c679e$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $7d7410914c1c679e$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $7d7410914c1c679e$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $7d7410914c1c679e$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if ((this.languages || this.isLanguageChangingTo) && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $7d7410914c1c679e$var$noop) {
        let usedCallback = callback;
        const usedLng = $7d7410914c1c679e$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (!toLoad.includes(l)) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $7d7410914c1c679e$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $7d7410914c1c679e$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $7d7410914c1c679e$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].includes(l)) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].includes(lngInLngs)) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $7d7410914c1c679e$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $7d7410914c1c679e$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($7d7410914c1c679e$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix, fixedOpts) {
        const scopeNs = fixedOpts?.scopeNs;
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            const explicitCallNs = o.ns !== undefined && o.ns !== null;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $7d7410914c1c679e$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $7d7410914c1c679e$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $7d7410914c1c679e$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($7d7410914c1c679e$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $7d7410914c1c679e$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($7d7410914c1c679e$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (!this.options.ns.includes(n)) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $7d7410914c1c679e$var$defer();
        if ($7d7410914c1c679e$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>!preloaded.includes(lng) && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $7d7410914c1c679e$var$LanguageUtil($7d7410914c1c679e$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $7d7410914c1c679e$var$I18n(options, callback);
        instance.createInstance = $7d7410914c1c679e$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $7d7410914c1c679e$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $7d7410914c1c679e$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $7d7410914c1c679e$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $7d7410914c1c679e$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $7d7410914c1c679e$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $7d7410914c1c679e$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $7d7410914c1c679e$export$2e2bcd8739ae039 = $7d7410914c1c679e$var$I18n.createInstance();
const $7d7410914c1c679e$export$99152e8d49ca4e7d = $7d7410914c1c679e$export$2e2bcd8739ae039.createInstance;
const $7d7410914c1c679e$export$147ec2801e896265 = $7d7410914c1c679e$export$2e2bcd8739ae039.dir;
const $7d7410914c1c679e$export$2cd8252107eb640b = $7d7410914c1c679e$export$2e2bcd8739ae039.init;
const $7d7410914c1c679e$export$d3d08d944062d7e = $7d7410914c1c679e$export$2e2bcd8739ae039.loadResources;
const $7d7410914c1c679e$export$a5d9bf5d83fcab09 = $7d7410914c1c679e$export$2e2bcd8739ae039.reloadResources;
const $7d7410914c1c679e$export$1f96ae73734a86cc = $7d7410914c1c679e$export$2e2bcd8739ae039.use;
const $7d7410914c1c679e$export$61465194746e7fd2 = $7d7410914c1c679e$export$2e2bcd8739ae039.changeLanguage;
const $7d7410914c1c679e$export$f90d180fc7da3b3b = $7d7410914c1c679e$export$2e2bcd8739ae039.getFixedT;
const $7d7410914c1c679e$export$625550452a3fa3ec = $7d7410914c1c679e$export$2e2bcd8739ae039.t;
const $7d7410914c1c679e$export$f7e9f41ea797a17 = $7d7410914c1c679e$export$2e2bcd8739ae039.exists;
const $7d7410914c1c679e$export$2b4b218e406d2d00 = $7d7410914c1c679e$export$2e2bcd8739ae039.setDefaultNamespace;
const $7d7410914c1c679e$export$93d9ee97c1ad3f31 = $7d7410914c1c679e$export$2e2bcd8739ae039.hasLoadedNamespace;
const $7d7410914c1c679e$export$83be934b53fff43b = $7d7410914c1c679e$export$2e2bcd8739ae039.loadNamespaces;
const $7d7410914c1c679e$export$8cd7e7a54fa865bc = $7d7410914c1c679e$export$2e2bcd8739ae039.loadLanguages;

});

parcelRegister("6Jh8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e643d7d76943888$export$2e2bcd8739ae039; });
// inlined from the former `void-elements` dependency, so the package has
// zero runtime dependencies. `!doctype`/`!DOCTYPE` are treated as void so a
// doctype parses as a childless node instead of swallowing the document.
const $4e643d7d76943888$var$voidElements = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    '!doctype': true,
    '!DOCTYPE': true
};
const $4e643d7d76943888$var$attrRE = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $4e643d7d76943888$var$parseTag(tag) {
    const res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };
    const tagMatch = tag.match(/<\/?([^\s]+?)[/\s>]/);
    if (tagMatch) {
        res.name = tagMatch[1];
        // void-element lookup stays case sensitive on purpose: react-i18next
        // relies on `<Br>` NOT being treated as a void `<br>` (see 1df0f9d)
        if ($4e643d7d76943888$var$voidElements[tagMatch[1]] || tag.charAt(tag.length - 2) === '/') res.voidElement = true;
        // handle comment tag
        if (res.name.startsWith('!--')) {
            const endIndex = tag.indexOf('-->');
            return {
                type: 'comment',
                comment: endIndex !== -1 ? tag.slice(4, endIndex) : ''
            };
        }
    }
    const reg = new RegExp($4e643d7d76943888$var$attrRE);
    let result = null;
    for(;;){
        result = reg.exec(tag);
        if (result === null) break;
        if (!result[0].trim()) continue;
        if (result[1]) {
            const attr = result[1].trim();
            // boolean attributes carry `null` so stringify can render them bare
            // (`<input disabled/>` instead of `<input disabled=""/>`)
            let arr = [
                attr,
                null
            ];
            const eq = attr.indexOf('=');
            if (eq > -1) // split at the first `=` only, so `data-x=a=b` keeps its full value
            arr = [
                attr.slice(0, eq),
                attr.slice(eq + 1)
            ];
            res.attrs[arr[0]] = arr[1];
            reg.lastIndex--;
        } else if (result[2]) res.attrs[result[2]] = result[3].trim().substring(1, result[3].length - 1);
    }
    return res;
}
// comments are matched as a whole (so `>` inside them is fine), everything
// else tag-shaped is matched by the second alternative
const $4e643d7d76943888$var$tagRE = /<!--[\s\S]*?-->|<[a-zA-Z0-9\-!/](?:"[^"]*"|'[^']*'|[^'">])*>/g;
const $4e643d7d76943888$var$tagNameRE = /<\/?([^\s]+?)[/\s>]/;
const $4e643d7d76943888$var$whitespaceRE = /^\s*$/;
// tags whose content is raw text: nothing inside them is markup
const $4e643d7d76943888$var$rawTextRE = /^(script|style)$/i;
// placeholder for `<` of tags rejected by options.allowedTags; restored to a
// literal `<` in text/attr/comment content after parsing (U+0000 cannot appear
// in sane input, and a collision would merely render as an extra `<`)
const $4e643d7d76943888$var$sentinel = '\u0000';
// re-used obj for quick lookups of components
const $4e643d7d76943888$var$empty = Object.create(null);
function $4e643d7d76943888$var$restoreSentinels(nodes) {
    nodes.forEach(function(node) {
        if (node.type === 'text') {
            node.content = node.content.split($4e643d7d76943888$var$sentinel).join('<');
            return;
        }
        if (node.type === 'comment') {
            node.comment = node.comment.split($4e643d7d76943888$var$sentinel).join('<');
            return;
        }
        for(const key in node.attrs){
            const value = node.attrs[key];
            if (typeof value === 'string' && value.indexOf($4e643d7d76943888$var$sentinel) > -1) node.attrs[key] = value.split($4e643d7d76943888$var$sentinel).join('<');
        }
        if (node.children.length) $4e643d7d76943888$var$restoreSentinels(node.children);
    });
}
function $4e643d7d76943888$export$98e6a39c04603d36(html, options) {
    const components = options && options.components || $4e643d7d76943888$var$empty;
    const allowedTags = options && options.allowedTags;
    let restoreNeeded = false;
    if (allowedTags) {
        const isAllowed = typeof allowedTags === 'function' ? allowedTags : function(name) {
            return allowedTags.indexOf(name) > -1;
        };
        // neutralize tags whose name is not allowed, so they parse as text.
        // on a disallowed match only the leading `<` is escaped and scanning
        // resumes right after it, so a valid tag glued into the same match
        // (e.g. `<bold>` inside `<10, <20, and <bold>`) still gets recognized
        let out = '';
        let pos = 0;
        $4e643d7d76943888$var$tagRE.lastIndex = 0;
        let am;
        while(am = $4e643d7d76943888$var$tagRE.exec(html)){
            const tag = am[0];
            out += html.slice(pos, am.index);
            const nameMatch = tag.match($4e643d7d76943888$var$tagNameRE);
            if (tag.startsWith('<!--') || nameMatch && isAllowed(nameMatch[1])) {
                out += tag;
                pos = am.index + tag.length;
            } else {
                restoreNeeded = true;
                out += $4e643d7d76943888$var$sentinel;
                pos = am.index + 1;
                $4e643d7d76943888$var$tagRE.lastIndex = pos;
            }
        }
        html = out + html.slice(pos);
    }
    const result = [];
    const arr = [];
    let current;
    let level = -1;
    let inComponent = false;
    // while parsing raw-text content (script/style), tag-looking matches
    // before this index belong to the content and must be skipped
    let rawUntil = 0;
    // lazily created lowercase copy for case-insensitive raw-text close-tag search
    let htmlLower;
    // handle text at top level
    if (html.indexOf('<') !== 0) {
        const end = html.indexOf('<');
        result.push({
            type: 'text',
            content: end === -1 ? html : html.substring(0, end)
        });
    }
    // collect matches with an exec loop instead of matchAll to keep ES5 API compat
    const matches = [];
    let m;
    while(m = $4e643d7d76943888$var$tagRE.exec(html))matches.push(m);
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        // comments match as a whole; their content must not trigger the
        // mismatched-bracket split below
        if (tag.startsWith('<!--')) return;
        // count brackets outside quoted attribute values, so `<` inside an
        // attribute (e.g. title="1 < 2") can't trigger a bogus split
        let lts = 0;
        let gts = 0;
        let secondLt = -1;
        let quote = null;
        for(let j = 0; j < tag.length; j++){
            const c = tag.charAt(j);
            if (quote) {
                if (c === quote) quote = null;
            } else if (c === '"' || c === "'") quote = c;
            else if (c === '<') {
                lts++;
                if (lts === 2) secondLt = j;
            } else if (c === '>') gts++;
        }
        // only split when the remainder is itself a valid tag start; otherwise
        // a fragment like `< <!-->` desyncs the string-level isComment check
        // from parseTag's name-based comment detection and crashes the walker
        const validSplit = secondLt > -1 && /[a-zA-Z0-9\-!/]/.test(tag.charAt(secondLt + 1));
        if (lts > gts && validSplit) {
            const firstPart = tag.substring(0, secondLt);
            const secondPart = tag.substring(firstPart.length);
            matches[i][0] = secondPart;
            matches[i].index += firstPart.length;
        }
    });
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        const index = match.index;
        if (index < rawUntil) return;
        if (inComponent) {
            if (tag !== '</' + current.name + '>') return;
            else inComponent = false;
        }
        const isOpen = tag.charAt(1) !== '/';
        const isComment = tag.startsWith('<!--');
        const start = index + tag.length;
        const nextChar = html.charAt(start);
        const nextMatch = matches[i + 1];
        let isText;
        if (nextChar === '<' && nextMatch) {
            const nextTag = html.substring(start, nextMatch.index);
            isText = nextTag.split('<').length > nextTag.split('>').length;
        }
        let parent;
        if (isComment) {
            const comment = $4e643d7d76943888$var$parseTag(tag);
            // if we're at root, push new base node
            if (level < 0) {
                result.push(comment);
                return result;
            }
            parent = arr[level];
            parent.children.push(comment);
            const text = html.slice(start, nextMatch ? nextMatch.index : undefined);
            if (text.length > 0) parent.children.push({
                type: 'text',
                content: text
            });
            return result;
        }
        if (isOpen) {
            level++;
            current = $4e643d7d76943888$var$parseTag(tag);
            if (current.type === 'tag' && components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }
            let isRawText = false;
            if (!inComponent && !current.voidElement && $4e643d7d76943888$var$rawTextRE.test(current.name)) {
                // raw-text element: everything up to the matching close tag is one
                // text child, regardless of what it looks like
                isRawText = true;
                htmlLower || (htmlLower = html.toLowerCase());
                const closeIndex = htmlLower.indexOf('</' + current.name.toLowerCase() + '>', start);
                const contentEnd = closeIndex === -1 ? html.length : closeIndex;
                const content = html.slice(start, contentEnd);
                if (content) current.children.push({
                    type: 'text',
                    content: content
                });
                rawUntil = contentEnd;
            }
            if (!current.voidElement && !inComponent && !isRawText && nextChar && nextChar !== '<') // text content runs to the next actual tag match; stray `<`
            // characters in between are part of the text
            current.children.push({
                type: 'text',
                content: html.slice(start, nextMatch ? nextMatch.index : undefined)
            });
            // if we're at root, push new base node
            if (level === 0) result.push(current);
            parent = arr[level - 1];
            if (parent) parent.children.push(current);
            arr[level] = current;
        }
        if (!isOpen || current.voidElement) {
            if (level > -1 && (current.voidElement || current.name === tag.slice(2, -1))) {
                level--;
                // move current up a level to match the end tag
                current = level === -1 ? result : arr[level];
            }
            if (!inComponent && (nextChar !== '<' || isText) && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                // the text node runs to the next actual tag match; -1 means
                // there's no tag after it (trailing text)
                const end = nextMatch ? nextMatch.index : -1;
                let content = html.slice(start, end === -1 ? undefined : end);
                // if a node is nothing but whitespace, collapse it as the spec states:
                // https://www.w3.org/TR/html4/struct/text.html#h-9.1
                if ($4e643d7d76943888$var$whitespaceRE.test(content)) content = ' ';
                // don't add whitespace-only text nodes if they would be trailing text nodes
                // or if they would be leading whitespace-only text nodes:
                //  * end > -1 indicates this is not a trailing text node
                //  * leading node is when level is -1 and parent has length 0
                if (end > -1 && level + parent.length >= 0 || content !== ' ') parent.push({
                    type: 'text',
                    content: content
                });
            }
        }
    });
    if (restoreNeeded) $4e643d7d76943888$var$restoreSentinels(result);
    return result;
}
function $4e643d7d76943888$var$attrString(attrs) {
    const buff = [];
    for(const key in attrs)if (attrs[key] === null) // boolean attribute, render bare
    buff.push(key);
    else // escape double quotes so values parsed from single-quoted or
    // multiline attributes can't break out of the generated markup
    buff.push(key + '="' + String(attrs[key]).replace(/"/g, '&quot;') + '"');
    if (!buff.length) return '';
    return ' ' + buff.join(' ');
}
function $4e643d7d76943888$var$stringifyNode(buff, doc) {
    switch(doc.type){
        case 'text':
            return buff + doc.content;
        case 'tag':
            {
                // a doctype is void but must not self-close: `<!DOCTYPE html>` not `<!DOCTYPE html/>`
                const tagEnd = doc.voidElement && doc.name.toLowerCase() !== '!doctype' ? '/>' : '>';
                buff += '<' + doc.name + (doc.attrs ? $4e643d7d76943888$var$attrString(doc.attrs) : '') + tagEnd;
                if (doc.voidElement) return buff;
                return buff + doc.children.reduce($4e643d7d76943888$var$stringifyNode, '') + '</' + doc.name + '>';
            }
        case 'comment':
            buff += '<!--' + doc.comment + '-->';
            return buff;
    }
}
function $4e643d7d76943888$export$fac44ee5b035f737(doc) {
    return doc.reduce(function(token, rootEl) {
        return token + $4e643d7d76943888$var$stringifyNode('', rootEl);
    }, '');
}
var $4e643d7d76943888$export$2e2bcd8739ae039 = {
    parse: $4e643d7d76943888$export$98e6a39c04603d36,
    stringify: $4e643d7d76943888$export$fac44ee5b035f737
};

});

parcelRegister("7ou6r", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $56222015e5b3028c$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isString", function () { return $56222015e5b3028c$export$844ec244b1367d54; });
$parcel$export(module.exports, "warnOnce", function () { return $56222015e5b3028c$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $56222015e5b3028c$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $56222015e5b3028c$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $56222015e5b3028c$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $56222015e5b3028c$export$be63e0664592e141; });
$parcel$export(module.exports, "isObject", function () { return $56222015e5b3028c$export$a6cdc56e425d0d0a; });
const $56222015e5b3028c$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($56222015e5b3028c$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $56222015e5b3028c$var$alreadyWarned = {};
const $56222015e5b3028c$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($56222015e5b3028c$export$844ec244b1367d54(msg) && $56222015e5b3028c$var$alreadyWarned[msg]) return;
    if ($56222015e5b3028c$export$844ec244b1367d54(msg)) $56222015e5b3028c$var$alreadyWarned[msg] = new Date();
    $56222015e5b3028c$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $56222015e5b3028c$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $56222015e5b3028c$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $56222015e5b3028c$var$loadedClb(i18n, cb));
};
const $56222015e5b3028c$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($56222015e5b3028c$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $56222015e5b3028c$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $56222015e5b3028c$var$loadedClb(i18n, cb));
};
const $56222015e5b3028c$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $56222015e5b3028c$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $56222015e5b3028c$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($56222015e5b3028c$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $56222015e5b3028c$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $56222015e5b3028c$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;

});

parcelRegister("38dth", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $247c918b6f9bc9e2$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $247c918b6f9bc9e2$export$212bb2fc580a90a8; });

var $6FVMs = parcelRequire("6FVMs");
let $247c918b6f9bc9e2$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $6FVMs.unescape,
    transDefaultProps: undefined
};
const $247c918b6f9bc9e2$export$2e2366488d12e20d = (options = {})=>{
    $247c918b6f9bc9e2$var$defaultOptions = {
        ...$247c918b6f9bc9e2$var$defaultOptions,
        ...options
    };
};
const $247c918b6f9bc9e2$export$212bb2fc580a90a8 = ()=>$247c918b6f9bc9e2$var$defaultOptions;

});
parcelRegister("6FVMs", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $4dc364715b74ab29$export$e8bacd2802a88316; });
const $4dc364715b74ab29$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $4dc364715b74ab29$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $4dc364715b74ab29$var$unescapeHtmlEntity = (m)=>$4dc364715b74ab29$var$htmlEntities[m];
const $4dc364715b74ab29$export$e8bacd2802a88316 = (text)=>text.replace($4dc364715b74ab29$var$matchHtmlEntity, $4dc364715b74ab29$var$unescapeHtmlEntity);

});


parcelRegister("f2LNf", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $af3c1da83c0788f5$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $af3c1da83c0788f5$export$64af334f494c2f47; });
let $af3c1da83c0788f5$var$i18nInstance;
const $af3c1da83c0788f5$export$a039134f2fc7e0 = (instance)=>{
    $af3c1da83c0788f5$var$i18nInstance = instance;
};
const $af3c1da83c0788f5$export$64af334f494c2f47 = ()=>$af3c1da83c0788f5$var$i18nInstance;

});


parcelRegister("bviPB", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $8601327097ab1c18$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $8601327097ab1c18$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $8601327097ab1c18$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("38dth")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("f2LNf")).getI18n; });

var $fITET = parcelRequire("fITET");

var $38dth = parcelRequire("38dth");

var $f2LNf = parcelRequire("f2LNf");

var $iBK5u = parcelRequire("iBK5u");
const $8601327097ab1c18$export$5603ab5ced17ce64 = (0, $fITET.createContext)();
class $8601327097ab1c18$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $8601327097ab1c18$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $8601327097ab1c18$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $8601327097ab1c18$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $f2LNf.getI18n)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};

});
parcelRegister("iBK5u", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $d8bf6ebc6540d67e$export$ae7e14d40d89f296; });

var $38dth = parcelRequire("38dth");

var $f2LNf = parcelRequire("f2LNf");
const $d8bf6ebc6540d67e$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $38dth.setDefaults)(instance.options.react);
        (0, $f2LNf.setI18n)(instance);
    }
};

});



parcelRegister("lTfdB", function(module, exports) {

var $fITET = parcelRequire("fITET");

var $8SR1Y = parcelRequire("8SR1Y");
parcelRequire("bviPB");
var $f2LNf = parcelRequire("f2LNf");
var $bviPB = parcelRequire("bviPB");
function $fefa8a12590162c9$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $fITET.useContext)((0, $bviPB.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $f2LNf.getI18n)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $8SR1Y.IcuTransWithoutContext)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$fefa8a12590162c9$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';

});
parcelRegister("8SR1Y", function(module, exports) {

$parcel$export(module.exports, "IcuTransWithoutContext", function () { return $677c80b736394ee8$export$c70a6545d92ee1d4; });

var $fITET = parcelRequire("fITET");

var $7ou6r = parcelRequire("7ou6r");

var $f2LNf = parcelRequire("f2LNf");
parcelRequire("8E6ov");
var $3pp9A = parcelRequire("3pp9A");
function $677c80b736394ee8$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $f2LNf.getI18n)();
    if (!i18n) {
        (0, $7ou6r.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($fITET))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fITET))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $7ou6r.isString)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey || defaultTranslation, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $3pp9A.renderTranslation)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fITET))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fITET))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $7ou6r.warn)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($fITET))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fITET))).Fragment, {}, translation);
    }
}
$677c80b736394ee8$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';

});
parcelRegister("8E6ov", function(module, exports) {
$parcel$export(module.exports, "renderTranslation", function () { return (parcelRequire("3pp9A")).renderTranslation; });
parcelRequire("7tnOq");
parcelRequire("3luQa");
parcelRequire("gjvUi");
parcelRequire("3pp9A");

});
parcelRegister("7tnOq", function(module, exports) {

$parcel$export(module.exports, "TranslationParserError", function () { return $570db674c958129a$export$aa9e222d9ffc5d1b; });
class $570db674c958129a$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $570db674c958129a$export$aa9e222d9ffc5d1b);
    }
}

});

parcelRegister("3luQa", function(module, exports) {

$parcel$export(module.exports, "decodeHtmlEntities", function () { return $26fb418051d5c083$export$5cfeaa4af6841c8f; });
const $26fb418051d5c083$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $26fb418051d5c083$var$entityPattern = new RegExp(Object.keys($26fb418051d5c083$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $26fb418051d5c083$export$5cfeaa4af6841c8f = (text)=>text.replace($26fb418051d5c083$var$entityPattern, (match)=>$26fb418051d5c083$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));

});

parcelRegister("gjvUi", function(module, exports) {

$parcel$export(module.exports, "tokenize", function () { return $be072bbf9e642c01$export$660b2ee2d4fb4eff; });
const $be072bbf9e642c01$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};

});

parcelRegister("3pp9A", function(module, exports) {

$parcel$export(module.exports, "renderTranslation", function () { return $27b737de2bc5eb52$export$1038df9fa5e5f35f; });

var $fITET = parcelRequire("fITET");

var $7tnOq = parcelRequire("7tnOq");

var $gjvUi = parcelRequire("gjvUi");

var $3luQa = parcelRequire("3luQa");
const $27b737de2bc5eb52$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fITET))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($fITET))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($fITET))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fITET))).createElement(type, props, ...children);
};
const $27b737de2bc5eb52$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $gjvUi.tokenize)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $3luQa.decodeHtmlEntities)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $7tnOq.TranslationParserError)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $7tnOq.TranslationParserError)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $27b737de2bc5eb52$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $7tnOq.TranslationParserError)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};

});




parcelRegister("3Pe9S", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $2c911e0bf9d64624$export$9fc83ad70ead8663; });

var $fITET = parcelRequire("fITET");

var $lBQpM = parcelRequire("lBQpM");
parcelRequire("bviPB");
var $38dth = parcelRequire("38dth");
var $f2LNf = parcelRequire("f2LNf");
var $bviPB = parcelRequire("bviPB");

var $7ou6r = parcelRequire("7ou6r");
const $2c911e0bf9d64624$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $7ou6r.isString)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $7ou6r.isObject)(optsOrDefaultValue) && (0, $7ou6r.isString)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $2c911e0bf9d64624$var$notReadySnapshot = {
    t: $2c911e0bf9d64624$var$notReadyT,
    ready: false
};
const $2c911e0bf9d64624$var$dummySubscribe = ()=>()=>{};
const $2c911e0bf9d64624$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $fITET.useContext)((0, $bviPB.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $f2LNf.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $bviPB.ReportNamespaces)();
    if (!i18n) (0, $7ou6r.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
    const i18nOptions = (0, $fITET.useMemo)(()=>({
            ...(0, $38dth.getDefaults)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $7ou6r.isString)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $fITET.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $fITET.useRef)(0);
    const subscribe = (0, $fITET.useCallback)((callback)=>{
        if (!i18n) return $2c911e0bf9d64624$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $fITET.useRef)();
    const getSnapshot = (0, $fITET.useCallback)(()=>{
        if (!i18n) return $2c911e0bf9d64624$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $7ou6r.hasLoadedNamespace)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $fITET.useState)(0);
    const { t: t, ready: ready } = (0, $lBQpM.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $fITET.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $7ou6r.loadLanguages)(i18n, props.lng, namespaces, onLoaded);
            else (0, $7ou6r.loadNamespaces)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $fITET.useRef)(null);
    const wrapperLangRef = (0, $fITET.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $fITET.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $7ou6r.warnOnce)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) {
        let inDevelopment = false;
        try {
            inDevelopment = false;
        } catch (e) {}
        if (inDevelopment) (0, $7ou6r.warnOnce)(i18n, 'SUSPENDED_WHILE_LOADING', 'useTranslation: suspended while translations are loading (useSuspense is true by default). Add a <Suspense> boundary above this component, or set react.useSuspense: false in the i18next init options. https://react.i18next.com/latest/usetranslation-hook');
        throw new Promise((resolve)=>{
            const onLoaded = ()=>resolve();
            if (props.lng) (0, $7ou6r.loadLanguages)(i18n, props.lng, namespaces, onLoaded);
            else (0, $7ou6r.loadNamespaces)(i18n, namespaces, onLoaded);
        });
    }
    return ret;
};

});
parcelRegister("lBQpM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a6dDp"));

});
parcelRegister("a6dDp", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $75a50a758bab5f89$export$306c0aa65ff9ec16; }, function (v) { return $75a50a758bab5f89$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $75a50a758bab5f89$export$306c0aa65ff9ec16;
"use strict";

var $fITET = parcelRequire("fITET");
function $75a50a758bab5f89$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $75a50a758bab5f89$var$objectIs = "function" === typeof Object.is ? Object.is : $75a50a758bab5f89$var$is, $75a50a758bab5f89$var$useState = $fITET.useState, $75a50a758bab5f89$var$useEffect = $fITET.useEffect, $75a50a758bab5f89$var$useLayoutEffect = $fITET.useLayoutEffect, $75a50a758bab5f89$var$useDebugValue = $fITET.useDebugValue;
function $75a50a758bab5f89$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $75a50a758bab5f89$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $75a50a758bab5f89$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $75a50a758bab5f89$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $75a50a758bab5f89$var$useEffect(function() {
        $75a50a758bab5f89$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $75a50a758bab5f89$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $75a50a758bab5f89$var$useDebugValue(value);
    return value;
}
function $75a50a758bab5f89$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$75a50a758bab5f89$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $75a50a758bab5f89$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $75a50a758bab5f89$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $75a50a758bab5f89$var$useSyncExternalStore$1 : $75a50a758bab5f89$var$useSyncExternalStore$2;
$75a50a758bab5f89$export$306c0aa65ff9ec16 = void 0 !== $fITET.useSyncExternalStore ? $fITET.useSyncExternalStore : $75a50a758bab5f89$var$shim;

});



parcelRegister("bDHFt", function(module, exports) {

var $fITET = parcelRequire("fITET");

var $3Pe9S = parcelRequire("3Pe9S");

var $7ou6r = parcelRequire("7ou6r");
const $879535cae38b52ac$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3Pe9S.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $fITET.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $7ou6r.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $fITET.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $fITET.forwardRef)(forwardRef) : I18nextWithTranslation;
    };

});

parcelRegister("7iSKW", function(module, exports) {

var $3Pe9S = parcelRequire("3Pe9S");
const $5514b0467e23d5e1$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3Pe9S.useTranslation)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};

});

parcelRegister("eAteb", function(module, exports) {

var $fITET = parcelRequire("fITET");

var $bviPB = parcelRequire("bviPB");
function $a9eb19826f5af0de$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $fITET.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $fITET.createElement)((0, $bviPB.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRegister("9Jw5G", function(module, exports) {

var $fITET = parcelRequire("fITET");

var $fGZM3 = parcelRequire("fGZM3");

var $bviPB = parcelRequire("bviPB");

var $7ou6r = parcelRequire("7ou6r");
const $716135918861ddd7$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $fGZM3.useSSR)(initialI18nStore, initialLanguage);
            return (0, $fITET.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $bviPB.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $7ou6r.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };

});
parcelRegister("fGZM3", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $b6cab24e61fda674$export$3526fb65ade8d8b7; });

var $fITET = parcelRequire("fITET");
parcelRequire("bviPB");
var $f2LNf = parcelRequire("f2LNf");
var $bviPB = parcelRequire("bviPB");

var $7ou6r = parcelRequire("7ou6r");
const $b6cab24e61fda674$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $fITET.useContext)((0, $bviPB.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $f2LNf.getI18n)();
    if (!i18n) {
        (0, $7ou6r.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $7ou6r.warnOnce)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};

});



parcelRegister("cl8Lt", function(module, exports) {

$parcel$export(module.exports, "IOS_APP_STORE_URL", function () { return $0d9fafedd44f058e$export$ef60ccf9afe15d64; });
$parcel$export(module.exports, "ANDROID_PLAY_STORE_URL", function () { return $0d9fafedd44f058e$export$d6e385e987baddf5; });
$parcel$export(module.exports, "default", function () { return $0d9fafedd44f058e$export$2e2bcd8739ae039; });

var $lUgbo = parcelRequire("lUgbo");
parcelRequire("64wTB");
var $3Pe9S = parcelRequire("3Pe9S");

var $d7p8X = parcelRequire("d7p8X");

var $iU2M9 = parcelRequire("iU2M9");
const $0d9fafedd44f058e$export$ef60ccf9afe15d64 = "https://apps.apple.com/us/app/salt-church-companion/id1614084359";
const $0d9fafedd44f058e$export$d6e385e987baddf5 = "https://play.google.com/store/apps/details?id=com.saltplatform.salt_android";
function $0d9fafedd44f058e$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $3Pe9S.useTranslation)("appHandoff");
    return /*#__PURE__*/ (0, $lUgbo.jsxs)("main", {
        className: "min-h-screen flex flex-col items-center justify-center gap-6 p-8",
        children: [
            /*#__PURE__*/ (0, $lUgbo.jsxs)("div", {
                className: "flex flex-col items-center gap-3 text-center",
                children: [
                    /*#__PURE__*/ (0, $lUgbo.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0, $lUgbo.jsx)("source", {
                                srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($iU2M9))),
                                media: "(prefers-color-scheme: dark)"
                            }),
                            /*#__PURE__*/ (0, $lUgbo.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d7p8X))),
                                alt: "Salt",
                                className: "w-32 md:w-40 mb-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lUgbo.jsx)("h1", {
                        className: "text-3xl md:text-5xl font-semibold",
                        children: props.heading
                    }),
                    /*#__PURE__*/ (0, $lUgbo.jsx)("p", {
                        className: "text-lg text-gray-600 max-w-prose",
                        children: props.instructions
                    })
                ]
            }),
            props.children,
            /*#__PURE__*/ (0, $lUgbo.jsxs)("div", {
                className: "flex flex-col sm:flex-row items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $lUgbo.jsx)($0d9fafedd44f058e$var$StoreLink, {
                        label: t("downloadIos"),
                        href: $0d9fafedd44f058e$export$ef60ccf9afe15d64
                    }),
                    /*#__PURE__*/ (0, $lUgbo.jsx)($0d9fafedd44f058e$var$StoreLink, {
                        label: t("downloadAndroid"),
                        href: $0d9fafedd44f058e$export$d6e385e987baddf5
                    })
                ]
            })
        ]
    });
}
function $0d9fafedd44f058e$var$StoreLink(props) {
    const base = "py-3 px-6 rounded-full text-lg font-medium text-center w-full max-w-80 sm:w-auto whitespace-nowrap";
    return /*#__PURE__*/ (0, $lUgbo.jsx)("a", {
        href: props.href,
        className: `${base} select-none bg-accent text-white hover:opacity-75 transition-opacity duration-300`,
        children: props.label
    });
}

});
parcelRegister("d7p8X", function(module, exports) {
module.exports = $parcel$resolve("2i5fR");

});

parcelRegister("iU2M9", function(module, exports) {
module.exports = $parcel$resolve("hnBOC");

});


parcelRegister("2SzOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $358da8f3966849a6$export$2e2bcd8739ae039; });

var $fITET = parcelRequire("fITET");
function $358da8f3966849a6$export$2e2bcd8739ae039(title) {
    (0, $fITET.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
}

});

parcelRegister("aOB4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29772196d621e633$export$2e2bcd8739ae039; });

var $lUgbo = parcelRequire("lUgbo");

var $PAdBB = parcelRequire("PAdBB");
parcelRequire("64wTB");
var $3Pe9S = parcelRequire("3Pe9S");

var $2SzOE = parcelRequire("2SzOE");
function $29772196d621e633$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3Pe9S.useTranslation)("notFound");
    (0, $2SzOE.default)(t("documentTitle"));
    return /*#__PURE__*/ (0, $lUgbo.jsxs)("main", {
        className: "min-h-screen flex flex-col items-center justify-center gap-4 p-8",
        children: [
            /*#__PURE__*/ (0, $lUgbo.jsx)("h1", {
                className: "text-4xl font-semibold text-gray-900",
                children: t("heading")
            }),
            /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Link), {
                to: "/",
                className: "text-accent hover:opacity-75 transition-opacity duration-300",
                children: t("backHome")
            })
        ]
    });
}

});

parcelRegister("8Mq9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $410130567588058f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useSongPlatforms", function () { return $410130567588058f$export$12f9aae84cbba3da; });

var $lUgbo = parcelRequire("lUgbo");

var $fITET = parcelRequire("fITET");

// Loaded the first time it's presented, like DiscussionQuestionsProvider's
// sheet, so pages that never show a song don't carry it.
const $410130567588058f$var$SongPlatformsSheet = /*#__PURE__*/ (0, $fITET.lazy)(()=>(parcelRequire("cEkRM")));
// Stands in for the app's Navigator: in iOS, SongTileButton calls
// navigator.present(sheet: .songPlatforms(song)) and the sheet is presented
// by whatever is hosting the navigator.
//
// Here the provider owns the sheet, and useSongPlatforms() lets any component
// present it, so tapping a song opens the same sheet from anywhere on the site
// without each page wiring up its own state.
const $410130567588058f$var$SongPlatformsContext = /*#__PURE__*/ (0, $fITET.createContext)(null);
function $410130567588058f$export$2e2bcd8739ae039(props) {
    const [song, setSong] = (0, $fITET.useState)(null);
    const [presented, setPresented] = (0, $fITET.useState)(false);
    const present = (0, $fITET.useCallback)((next)=>{
        setPresented(true);
        setSong(next);
    }, []);
    const dismiss = (0, $fITET.useCallback)(()=>setSong(null), []);
    // Stable so consumers don't re-render every time the sheet opens or closes.
    const value = (0, $fITET.useMemo)(()=>present, [
        present
    ]);
    return /*#__PURE__*/ (0, $lUgbo.jsxs)($410130567588058f$var$SongPlatformsContext.Provider, {
        value: value,
        children: [
            props.children,
            presented && /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                children: /*#__PURE__*/ (0, $lUgbo.jsx)($410130567588058f$var$SongPlatformsSheet, {
                    song: song,
                    onClose: dismiss
                })
            })
        ]
    });
}
function $410130567588058f$export$12f9aae84cbba3da() {
    return (0, $fITET.useContext)($410130567588058f$var$SongPlatformsContext);
}

});
parcelRegister("cEkRM", function(module, exports) {
module.exports = $parcel$import("9Sp8b").then(()=>parcelRequire('23BzP'));

});


parcelRegister("jd2YQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb7576e23edec4f2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useDiscussionQuestions", function () { return $cb7576e23edec4f2$export$2fb551f169d192e6; });

var $lUgbo = parcelRequire("lUgbo");

var $fITET = parcelRequire("fITET");

// The sheet renders Markdown, the heaviest dependency on the site, and the
// provider wraps every page — the login and invite pages included. So the
// sheet loads the first time it's presented and stays mounted after that,
// which keeps its close animation. Its opening animation is CSS
// @starting-style, so mounting it already open still animates.
const $cb7576e23edec4f2$var$DiscussionQuestionsSheet = /*#__PURE__*/ (0, $fITET.lazy)(()=>(parcelRequire("1HCLu")));
// Companion to SongPlatformsProvider: stands in for the app's Navigator, where
// FeaturedServiceView calls navigator.present(sheet: .discussionQuestions(...)).
//
// Mounted once at the root so any card can present the sheet without each page
// wiring up its own state.
const $cb7576e23edec4f2$var$DiscussionQuestionsContext = /*#__PURE__*/ (0, $fITET.createContext)(null);
function $cb7576e23edec4f2$export$2e2bcd8739ae039(props) {
    const [questions, setQuestions] = (0, $fITET.useState)(null);
    const [presented, setPresented] = (0, $fITET.useState)(false);
    const present = (0, $fITET.useCallback)((next)=>{
        setPresented(true);
        setQuestions(next);
    }, []);
    const dismiss = (0, $fITET.useCallback)(()=>setQuestions(null), []);
    const value = (0, $fITET.useMemo)(()=>present, [
        present
    ]);
    return /*#__PURE__*/ (0, $lUgbo.jsxs)($cb7576e23edec4f2$var$DiscussionQuestionsContext.Provider, {
        value: value,
        children: [
            props.children,
            presented && /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                children: /*#__PURE__*/ (0, $lUgbo.jsx)($cb7576e23edec4f2$var$DiscussionQuestionsSheet, {
                    questions: questions,
                    onClose: dismiss
                })
            })
        ]
    });
}
function $cb7576e23edec4f2$export$2fb551f169d192e6() {
    return (0, $fITET.useContext)($cb7576e23edec4f2$var$DiscussionQuestionsContext);
}

});
parcelRegister("1HCLu", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("cthsP"),
    $parcel$import("au7Zs")
]).then(()=>parcelRequire('kQswB'));

});


parcelRegister("iKxNa", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DETAIL_ROUTE", function () { return $a6174473aeee25a7$export$53dc924289ea5ea5; });
$parcel$export(module.exports, "serviceDetailPath", function () { return $a6174473aeee25a7$export$b5262f89cde09dfc; });
$parcel$export(module.exports, "EVENT_DETAIL_ROUTE", function () { return $a6174473aeee25a7$export$3d1d745721eeb9c4; });
$parcel$export(module.exports, "eventDetailPath", function () { return $a6174473aeee25a7$export$533f36a59e834920; });
$parcel$export(module.exports, "PLAYLIST_DETAIL_ROUTE", function () { return $a6174473aeee25a7$export$ccb653aeb4226c3d; });
$parcel$export(module.exports, "playlistDetailPath", function () { return $a6174473aeee25a7$export$62e28f25ff5abc11; });
$parcel$export(module.exports, "CHURCH_ROUTE", function () { return $a6174473aeee25a7$export$80a92a6fdf96ada8; });
$parcel$export(module.exports, "churchPath", function () { return $a6174473aeee25a7$export$d53e56a774fc9543; });
$parcel$export(module.exports, "LAUNCHPAD_ROUTE", function () { return $a6174473aeee25a7$export$32074c49ba3a8ad5; });
$parcel$export(module.exports, "launchpadPath", function () { return $a6174473aeee25a7$export$664bd8697ba7ef8; });
$parcel$export(module.exports, "LAUNCHPAD_TAG_ROUTE", function () { return $a6174473aeee25a7$export$ecbd585076c07cb6; });
$parcel$export(module.exports, "canonicalLaunchpadPath", function () { return $a6174473aeee25a7$export$eefc87a5efca135d; });
$parcel$export(module.exports, "TEST_ROUTE", function () { return $a6174473aeee25a7$export$74b69ee542814f75; });
$parcel$export(module.exports, "TEST_SAMPLE_ROUTE", function () { return $a6174473aeee25a7$export$fdedfc64dbcc2d35; });
// Route patterns and the helpers that build them, kept together so a link can
// never drift from the route it targets.
const $a6174473aeee25a7$export$53dc924289ea5ea5 = "/church/:churchID/service/:serviceID";
function $a6174473aeee25a7$export$b5262f89cde09dfc(service) {
    return `/church/${encodeURIComponent(service.churchID)}/service/${encodeURIComponent(service.id)}`;
}
const $a6174473aeee25a7$export$3d1d745721eeb9c4 = "/church/:churchID/event/:eventID";
function $a6174473aeee25a7$export$533f36a59e834920(event) {
    return `/church/${encodeURIComponent(event.churchID)}/event/${encodeURIComponent(event.id)}`;
}
const $a6174473aeee25a7$export$ccb653aeb4226c3d = "/church/:churchID/playlist/:playlistID";
function $a6174473aeee25a7$export$62e28f25ff5abc11(playlist) {
    return `/church/${encodeURIComponent(playlist.churchID)}/playlist/${encodeURIComponent(playlist.id)}`;
}
const $a6174473aeee25a7$export$80a92a6fdf96ada8 = "/church/:churchID";
function $a6174473aeee25a7$export$d53e56a774fc9543(churchID) {
    return `/church/${encodeURIComponent(churchID)}`;
}
const $a6174473aeee25a7$export$32074c49ba3a8ad5 = "/church/:churchID/launchpad/:launchpadID";
function $a6174473aeee25a7$export$664bd8697ba7ef8(churchID, launchpadID) {
    return `/church/${encodeURIComponent(churchID)}/launchpad/${encodeURIComponent(launchpadID)}`;
}
const $a6174473aeee25a7$export$ecbd585076c07cb6 = "/t/:tag";
function $a6174473aeee25a7$export$8206ba8757ef9747(tag) {
    return `/t/${encodeURIComponent(tag)}`;
}
function $a6174473aeee25a7$export$eefc87a5efca135d(launchpad) {
    return launchpad.tag ? $a6174473aeee25a7$export$8206ba8757ef9747(launchpad.tag) : $a6174473aeee25a7$export$664bd8697ba7ef8(launchpad.churchID, launchpad.launchpadID);
}
const $a6174473aeee25a7$export$74b69ee542814f75 = "/test";
const $a6174473aeee25a7$export$fdedfc64dbcc2d35 = "/test/sample";

});

parcelRegister("eXhvp", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("cthsP"),
    $parcel$import("2aWnQ")
]).then(()=>parcelRequire('hYgN8'));

});

var $1fcad8a293935c12$exports = {};
$parcel$extendImportMap({
    "2i5fR": "logo_light.14e96363.svg",
    "hnBOC": "logo_dark.a071cff0.svg",
    "9Sp8b": "SongPlatformsSheet.a17c9c67.js",
    "aNlbC": "song-placeholder.4c43a489.svg",
    "jyVzi": "apple-music.99a209d9.png",
    "lQr5J": "spotify.29406c19.png",
    "6wTvA": "youtube-music.07eee2c3.jpg",
    "7M15Y": "tidal.6285109a.jpg",
    "au7Zs": "DiscussionQuestionsSheet.e0b54eb1.js",
    "cthsP": "DiscussionQuestionsSheet.55e6506c.js",
    "2aWnQ": "launchpadPages.f506ce7f.js"
});


var $lUgbo = parcelRequire("lUgbo");

var $fITET = parcelRequire("fITET");
var $9e8d7ffdc767baf8$exports = {};
'use strict';
function $9e8d7ffdc767baf8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9e8d7ffdc767baf8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9e8d7ffdc767baf8$var$checkDCE();

$9e8d7ffdc767baf8$exports = (parcelRequire("c0pna"));



var $PAdBB = parcelRequire("PAdBB");

var $aLMH1 = parcelRequire("aLMH1");
parcelRequire("64wTB");
var $iBK5u = parcelRequire("iBK5u");
const { slice: $4cf08018b195ecaf$var$slice, forEach: $4cf08018b195ecaf$var$forEach } = [];
function $4cf08018b195ecaf$var$defaults(obj) {
    $4cf08018b195ecaf$var$forEach.call($4cf08018b195ecaf$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $4cf08018b195ecaf$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $4cf08018b195ecaf$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $4cf08018b195ecaf$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$4cf08018b195ecaf$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$4cf08018b195ecaf$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $4cf08018b195ecaf$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $4cf08018b195ecaf$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $4cf08018b195ecaf$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $4cf08018b195ecaf$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $4cf08018b195ecaf$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $4cf08018b195ecaf$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $4cf08018b195ecaf$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $4cf08018b195ecaf$var$hasLocalStorageSupport = null;
const $4cf08018b195ecaf$var$localStorageAvailable = ()=>{
    if ($4cf08018b195ecaf$var$hasLocalStorageSupport !== null) return $4cf08018b195ecaf$var$hasLocalStorageSupport;
    try {
        $4cf08018b195ecaf$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$4cf08018b195ecaf$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $4cf08018b195ecaf$var$hasLocalStorageSupport = false;
    }
    return $4cf08018b195ecaf$var$hasLocalStorageSupport;
};
var $4cf08018b195ecaf$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $4cf08018b195ecaf$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $4cf08018b195ecaf$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $4cf08018b195ecaf$var$hasSessionStorageSupport = null;
const $4cf08018b195ecaf$var$sessionStorageAvailable = ()=>{
    if ($4cf08018b195ecaf$var$hasSessionStorageSupport !== null) return $4cf08018b195ecaf$var$hasSessionStorageSupport;
    try {
        $4cf08018b195ecaf$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$4cf08018b195ecaf$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $4cf08018b195ecaf$var$hasSessionStorageSupport = false;
    }
    return $4cf08018b195ecaf$var$hasSessionStorageSupport;
};
var $4cf08018b195ecaf$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $4cf08018b195ecaf$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $4cf08018b195ecaf$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $4cf08018b195ecaf$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $4cf08018b195ecaf$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $4cf08018b195ecaf$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $4cf08018b195ecaf$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $4cf08018b195ecaf$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $4cf08018b195ecaf$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $4cf08018b195ecaf$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$4cf08018b195ecaf$var$canCookies) $4cf08018b195ecaf$var$order.splice(1, 1);
const $4cf08018b195ecaf$var$getDefaults = ()=>({
        order: $4cf08018b195ecaf$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $4cf08018b195ecaf$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $4cf08018b195ecaf$var$defaults(options, this.options || {}, $4cf08018b195ecaf$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($4cf08018b195ecaf$var$cookie$1);
        this.addDetector($4cf08018b195ecaf$var$querystring);
        this.addDetector($4cf08018b195ecaf$var$localStorage);
        this.addDetector($4cf08018b195ecaf$var$sessionStorage);
        this.addDetector($4cf08018b195ecaf$var$navigator$1);
        this.addDetector($4cf08018b195ecaf$var$htmlTag);
        this.addDetector($4cf08018b195ecaf$var$path);
        this.addDetector($4cf08018b195ecaf$var$subdomain);
        this.addDetector($4cf08018b195ecaf$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$4cf08018b195ecaf$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$4cf08018b195ecaf$export$2e2bcd8739ae039.type = 'languageDetector';


var $eaa605fd334ccf64$exports = {};
$eaa605fd334ccf64$exports = JSON.parse("{\"title\":\"Launchpad by Salt\",\"subtitle\":\"Your church's sermons, worship songs, and events. Open the link your church shared, or get the Salt app to keep up with them.\"}");


var $6f70e5b3763d122e$exports = {};
$6f70e5b3763d122e$exports = JSON.parse("{\"documentTitle\":\"Sign in to Salt\",\"heading\":\"Welcome to Salt\",\"instructions\":\"Download the Salt app, then tap the Magic Link in the email again to sign in.\",\"codeLabel\":\"Your login code\"}");


var $e274f98bfa9a1a80$exports = {};
$e274f98bfa9a1a80$exports = JSON.parse("{\"documentTitle\":\"Page not found\",\"heading\":\"Page not found\",\"backHome\":\"Back to Launchpad\"}");


var $cd69699d880f4104$exports = {};
$cd69699d880f4104$exports = JSON.parse("{\"featuredSermon\":\"Featured Sermon\",\"discussionQuestions\":\"Discussion Questions\",\"details\":\"Details\"}");


var $397775932be71973$exports = {};
$397775932be71973$exports = JSON.parse("{\"worshipSongs\":\"Worship Songs\",\"playlists\":\"Playlists\",\"songCount_one\":\"{{count}} song\",\"songCount_other\":\"{{count}} songs\"}");


var $7feb79c623dbcb79$exports = {};
$7feb79c623dbcb79$exports = JSON.parse("{\"label\":\"Streaming options\",\"close\":\"Close\",\"noLinksTitle\":\"No Streaming Options\",\"noLinksDescription\":\"We couldn't find links to this song on music streaming services.\"}");


var $dbb448d915cc0728$exports = {};
$dbb448d915cc0728$exports = JSON.parse("{\"back\":\"Back\",\"noSongsTitle\":\"No Songs in Playlist\",\"noSongsDescription\":\"There aren't any songs in this playlist.\",\"notFoundTitle\":\"Playlist Not Found\",\"notFoundDescription\":\"We couldn't find that playlist.\"}");


var $1af4f070fb997ff1$exports = {};
$1af4f070fb997ff1$exports = JSON.parse("{\"label\":\"Discussion Questions\",\"close\":\"Close\",\"empty\":\"There aren't any discussion questions for this message.\"}");


var $43041cacc31e2001$exports = {};
$43041cacc31e2001$exports = JSON.parse('{"footer-powered-by":"Powered by ","footer-extra":", a Boise ID company","copyright":"Copyright \xa9 {{year}} Salt Technologies LLC.","loading":"Loading\u2026","errorTitle":"Couldn\'t Load This Page","networkError":"Check your connection and try again.","retry":"Try Again","footer-get-app":"Download the <ios>iOS</ios> or <android>Android</android> app to see more from your church."}');


var $5079cef9defd07c6$exports = {};
$5079cef9defd07c6$exports = JSON.parse("{\"featuredEvent\":\"Featured Event\",\"upcomingEvents\":\"Upcoming Events\",\"rsvp\":\"RSVP\",\"dateAtTime\":\"{{date}} at {{time}}\",\"dateRange\":\"{{start}} - {{end}}\",\"descriptionFrameTitle\":\"Event description\",\"notFoundTitle\":\"Event Not Found\",\"notFoundDescription\":\"We couldn't find that event.\"}");


var $ee775834d6a113b3$exports = {};
$ee775834d6a113b3$exports = JSON.parse("{\"watchVideo\":\"Watch Video\",\"notFoundTitle\":\"Sermon Not Found\",\"notFoundDescription\":\"We couldn't find that sermon.\"}");


var $26c7292694cbb7e8$exports = {};
$26c7292694cbb7e8$exports = JSON.parse("{\"downloadIos\":\"Download for iPhone\",\"downloadAndroid\":\"Download for Android\"}");


var $93cf6d105e50634a$exports = {};
$93cf6d105e50634a$exports = JSON.parse("{\"documentTitle\":\"Join your team on Salt\",\"heading\":\"Join your team\",\"instructions\":\"You've been invited to serve on a volunteer team. Get the Salt app to accept your invitation.\",\"steps\":{\"download\":\"Download the Salt app\",\"reopen\":\"Tap the invite link in your email again\",\"signIn\":\"Sign in with your email to join the team\"}}");


var $14504ed36dae9a14$exports = {};
$14504ed36dae9a14$exports = JSON.parse("{\"back\":\"Back\",\"share\":\"Share\"}");


var $10f1b1b2f98d6a33$exports = {};
$10f1b1b2f98d6a33$exports = JSON.parse("{\"title\":\"Choose Your View\",\"description\":\"Salt features sermons, services, and more for the view that you select below.\",\"noLaunchpadsTitle\":\"Nothing to Choose From\",\"noLaunchpadsDescription\":\"This church hasn't set up any views, so there's no content to show.\"}");


var $4cfb8dbd8879ff2c$exports = {};
$4cfb8dbd8879ff2c$exports = JSON.parse('{"title":"Launchpad de Salt","subtitle":"Les pr\xe9dications, les chants d\'adoration et les \xe9v\xe9nements de votre \xe9glise. Ouvrez le lien que votre \xe9glise a partag\xe9, ou t\xe9l\xe9chargez l\'application Salt pour les suivre."}');


var $4b3d94886eeafbc1$exports = {};
$4b3d94886eeafbc1$exports = JSON.parse('{"documentTitle":"Se connecter \xe0 Salt","heading":"Bienvenue dans Salt","instructions":"T\xe9l\xe9chargez l\'application Salt, puis appuyez \xe0 nouveau sur le \xab Magic Link \xbb figurant dans l\'e-mail pour vous connecter.","codeLabel":"Votre code de connexion"}');


var $2e039783f11b99f9$exports = {};
$2e039783f11b99f9$exports = JSON.parse('{"documentTitle":"Page introuvable","heading":"Page introuvable","backHome":"Retour \xe0 Launchpad"}');


var $1d0f7ce203e5760d$exports = {};
$1d0f7ce203e5760d$exports = JSON.parse('{"featuredSermon":"Pr\xe9dication \xe0 l\'affiche","discussionQuestions":"Questions de discussion","details":"D\xe9tails"}');


var $fd86ef25d0278a8e$exports = {};
$fd86ef25d0278a8e$exports = JSON.parse("{\"worshipSongs\":\"Chants de louange\",\"playlists\":\"Listes de lecture\",\"songCount_one\":\"{{count}} chanson\",\"songCount_many\":\"{{count}} chansons\",\"songCount_other\":\"{{count}} chansons\"}");


var $3b4b55dd32f690ad$exports = {};
$3b4b55dd32f690ad$exports = JSON.parse('{"label":"Options d\'\xe9coute en continu","close":"Fermer","noLinksTitle":"Aucune option de diffusion en continu","noLinksDescription":"Nous n\'avons trouv\xe9 aucun lien vers cette chanson sur les services de diffusion de musique en continu."}');


var $901e2ded24e8bf89$exports = {};
$901e2ded24e8bf89$exports = JSON.parse('{"back":"Retour","noSongsTitle":"Aucune chanson dans la liste de lecture","noSongsDescription":"Cette liste de lecture ne contient aucune chanson.","notFoundTitle":"Liste de lecture introuvable","notFoundDescription":"Nous n\'avons pas trouv\xe9 cette liste de lecture."}');


var $1e493643141cfa6b$exports = {};
$1e493643141cfa6b$exports = JSON.parse("{\"label\":\"Questions de discussion\",\"close\":\"Fermer\",\"empty\":\"Il n'y a aucune question de discussion pour ce message.\"}");


var $1e0f43c2e2483bb2$exports = {};
$1e0f43c2e2483bb2$exports = JSON.parse('{"footer-powered-by":"R\xe9alis\xe9 par ","footer-extra":", une entreprise de Boise ID","loading":"Chargement\u2026","errorTitle":"Impossible de charger cette page","networkError":"V\xe9rifiez votre connexion et r\xe9essayez.","retry":"R\xe9essayer","footer-get-app":"T\xe9l\xe9chargez l\'application <ios>iOS</ios> ou <android>Android</android> pour voir plus de contenu de votre \xe9glise."}');


var $e22a2f266df28064$exports = {};
$e22a2f266df28064$exports = JSON.parse('{"featuredEvent":"\xc9v\xe9nement \xe0 l\'affiche","upcomingEvents":"\xc9v\xe9nements \xe0 venir","rsvp":"RSVP","dateAtTime":"{{date}} \xe0 {{time}}","dateRange":"{{start}} - {{end}}","descriptionFrameTitle":"Description de l\'\xe9v\xe9nement","notFoundTitle":"\xc9v\xe9nement introuvable","notFoundDescription":"Nous n\'avons pas trouv\xe9 cet \xe9v\xe9nement."}');


var $c65419dce8c156a1$exports = {};
$c65419dce8c156a1$exports = JSON.parse('{"watchVideo":"Regarder la vid\xe9o","notFoundTitle":"Pr\xe9dication introuvable","notFoundDescription":"Nous n\'avons pas trouv\xe9 cette pr\xe9dication."}');


var $6b20b8eb0bfb562f$exports = {};
$6b20b8eb0bfb562f$exports = JSON.parse('{"downloadIos":"T\xe9l\xe9charger pour iPhone","downloadAndroid":"T\xe9l\xe9charger pour Android"}');


var $e51c5bfc40f9b835$exports = {};
$e51c5bfc40f9b835$exports = JSON.parse('{"documentTitle":"Rejoignez votre \xe9quipe dans Salt","heading":"Rejoignez votre \xe9quipe","instructions":"Vous avez \xe9t\xe9 invit\xe9 \xe0 servir dans une \xe9quipe de b\xe9n\xe9voles. T\xe9l\xe9chargez l\'application Salt pour accepter votre invitation.","steps":{"download":"T\xe9l\xe9chargez l\'application Salt","reopen":"Appuyez \xe0 nouveau sur le lien d\'invitation dans l\'e-mail","signIn":"Connectez-vous avec votre adresse e-mail pour rejoindre l\'\xe9quipe"}}');


var $8209339436185c62$exports = {};
$8209339436185c62$exports = JSON.parse("{\"back\":\"Retour\",\"share\":\"Partager\"}");


var $6771fbc5574c5c70$exports = {};
$6771fbc5574c5c70$exports = JSON.parse('{"title":"Choisissez votre affichage","description":"Salt met en avant les pr\xe9dications, les services et plus encore pour l\'affichage que vous s\xe9lectionnez ci-dessous.","noLaunchpadsTitle":"Rien \xe0 choisir","noLaunchpadsDescription":"Cette \xe9glise n\'a configur\xe9 aucun affichage, il n\'y a donc aucun contenu \xe0 afficher."}');


var $7e4947b67aa4d3c1$exports = {};
$7e4947b67aa4d3c1$exports = JSON.parse("{\"documentTitle\":\"Ouvrir une session dans Salt\",\"codeLabel\":\"Votre code d'ouverture de session\"}");


var $aaec97b652c35786$exports = {};
$aaec97b652c35786$exports = JSON.parse('{"steps":{"reopen":"Appuyez \xe0 nouveau sur le lien d\'invitation dans le courriel","signIn":"Ouvrez une session avec votre courriel pour rejoindre l\'\xe9quipe"}}');


const $4e9f130d1b2d86a3$export$bc99aaabaf7b70a7 = {
    en: {
        home: (0, (/*@__PURE__*/$parcel$interopDefault($eaa605fd334ccf64$exports))),
        login: (0, (/*@__PURE__*/$parcel$interopDefault($6f70e5b3763d122e$exports))),
        notFound: (0, (/*@__PURE__*/$parcel$interopDefault($e274f98bfa9a1a80$exports))),
        serviceCard: (0, (/*@__PURE__*/$parcel$interopDefault($cd69699d880f4104$exports))),
        library: (0, (/*@__PURE__*/$parcel$interopDefault($397775932be71973$exports))),
        songPlatforms: (0, (/*@__PURE__*/$parcel$interopDefault($7feb79c623dbcb79$exports))),
        playlistDetail: (0, (/*@__PURE__*/$parcel$interopDefault($dbb448d915cc0728$exports))),
        discussionQuestions: (0, (/*@__PURE__*/$parcel$interopDefault($1af4f070fb997ff1$exports))),
        launchpad: (0, (/*@__PURE__*/$parcel$interopDefault($43041cacc31e2001$exports))),
        events: (0, (/*@__PURE__*/$parcel$interopDefault($5079cef9defd07c6$exports))),
        serviceDetail: (0, (/*@__PURE__*/$parcel$interopDefault($ee775834d6a113b3$exports))),
        appHandoff: (0, (/*@__PURE__*/$parcel$interopDefault($26c7292694cbb7e8$exports))),
        teamInvite: (0, (/*@__PURE__*/$parcel$interopDefault($93cf6d105e50634a$exports))),
        detailPage: (0, (/*@__PURE__*/$parcel$interopDefault($14504ed36dae9a14$exports))),
        churchLaunchpads: (0, (/*@__PURE__*/$parcel$interopDefault($10f1b1b2f98d6a33$exports)))
    },
    fr: {
        home: (0, (/*@__PURE__*/$parcel$interopDefault($4cfb8dbd8879ff2c$exports))),
        login: (0, (/*@__PURE__*/$parcel$interopDefault($4b3d94886eeafbc1$exports))),
        notFound: (0, (/*@__PURE__*/$parcel$interopDefault($2e039783f11b99f9$exports))),
        serviceCard: (0, (/*@__PURE__*/$parcel$interopDefault($1d0f7ce203e5760d$exports))),
        library: (0, (/*@__PURE__*/$parcel$interopDefault($fd86ef25d0278a8e$exports))),
        songPlatforms: (0, (/*@__PURE__*/$parcel$interopDefault($3b4b55dd32f690ad$exports))),
        playlistDetail: (0, (/*@__PURE__*/$parcel$interopDefault($901e2ded24e8bf89$exports))),
        discussionQuestions: (0, (/*@__PURE__*/$parcel$interopDefault($1e493643141cfa6b$exports))),
        launchpad: (0, (/*@__PURE__*/$parcel$interopDefault($1e0f43c2e2483bb2$exports))),
        events: (0, (/*@__PURE__*/$parcel$interopDefault($e22a2f266df28064$exports))),
        serviceDetail: (0, (/*@__PURE__*/$parcel$interopDefault($c65419dce8c156a1$exports))),
        appHandoff: (0, (/*@__PURE__*/$parcel$interopDefault($6b20b8eb0bfb562f$exports))),
        teamInvite: (0, (/*@__PURE__*/$parcel$interopDefault($e51c5bfc40f9b835$exports))),
        detailPage: (0, (/*@__PURE__*/$parcel$interopDefault($8209339436185c62$exports))),
        churchLaunchpads: (0, (/*@__PURE__*/$parcel$interopDefault($6771fbc5574c5c70$exports)))
    },
    "fr-CA": {
        login: (0, (/*@__PURE__*/$parcel$interopDefault($7e4947b67aa4d3c1$exports))),
        teamInvite: (0, (/*@__PURE__*/$parcel$interopDefault($aaec97b652c35786$exports)))
    }
};
const $4e9f130d1b2d86a3$export$7c77c3a9bb93870d = [
    "en",
    "fr",
    "fr-CA"
];
const $4e9f130d1b2d86a3$export$4d2fb7344096e022 = [
    "home",
    "login",
    "notFound",
    "serviceCard",
    "library",
    "songPlatforms",
    "playlistDetail",
    "discussionQuestions",
    "launchpad",
    "events",
    "serviceDetail",
    "appHandoff",
    "teamInvite",
    "detailPage",
    "churchLaunchpads"
];
(0, $aLMH1.default).use((0, $4cf08018b195ecaf$export$2e2bcd8739ae039)).use((0, $iBK5u.initReactI18next)).init({
    resources: $4e9f130d1b2d86a3$export$bc99aaabaf7b70a7,
    ns: $4e9f130d1b2d86a3$export$4d2fb7344096e022,
    defaultNS: "home",
    supportedLngs: $4e9f130d1b2d86a3$export$7c77c3a9bb93870d,
    nonExplicitSupportedLngs: true,
    fallbackLng: {
        "fr-CA": [
            "fr",
            "en"
        ],
        default: [
            "en"
        ]
    },
    // fr-CA ships only the namespaces it overrides, so a missing key must fall
    // through to fr rather than resolving to an empty string.
    fallbackNS: false,
    returnEmptyString: false,
    interpolation: {
        // React already escapes rendered values.
        escapeValue: false
    },
    detection: {
        // ?lang=fr-CA is handy for QA and for links we send to a known audience.
        order: [
            "querystring",
            "localStorage",
            "navigator"
        ],
        lookupQuerystring: "lang",
        lookupLocalStorage: "lang",
        caches: [
            "localStorage"
        ]
    }
});
// Keep <html lang> in step with the active language for screen readers,
// browser translation prompts, and correct hyphenation.
function $4e9f130d1b2d86a3$var$syncDocumentLang(lng) {
    document.documentElement.lang = lng;
}
$4e9f130d1b2d86a3$var$syncDocumentLang((0, $aLMH1.default).resolvedLanguage ?? "en");
(0, $aLMH1.default).on("languageChanged", $4e9f130d1b2d86a3$var$syncDocumentLang);
var $4e9f130d1b2d86a3$export$2e2bcd8739ae039 = (0, $aLMH1.default);



var $lUgbo = parcelRequire("lUgbo");
parcelRequire("64wTB");
var $3Pe9S = parcelRequire("3Pe9S");

var $cl8Lt = parcelRequire("cl8Lt");

var $2SzOE = parcelRequire("2SzOE");
function $7a14dd2dff127569$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3Pe9S.useTranslation)("home");
    (0, $2SzOE.default)(t("title"));
    return /*#__PURE__*/ (0, $lUgbo.jsx)((0, $cl8Lt.default), {
        heading: t("title"),
        instructions: t("subtitle")
    });
}



var $lUgbo = parcelRequire("lUgbo");

var $PAdBB = parcelRequire("PAdBB");
parcelRequire("64wTB");
var $3Pe9S = parcelRequire("3Pe9S");

var $cl8Lt = parcelRequire("cl8Lt");

var $2SzOE = parcelRequire("2SzOE");
function $accd284849e5d647$export$2e2bcd8739ae039() {
    const { code: code } = (0, $PAdBB.useParams)();
    const { t: t } = (0, $3Pe9S.useTranslation)("login");
    (0, $2SzOE.default)(t("documentTitle"));
    return /*#__PURE__*/ (0, $lUgbo.jsx)((0, $cl8Lt.default), {
        heading: t("heading"),
        instructions: t("instructions"),
        children: code && /*#__PURE__*/ (0, $lUgbo.jsxs)("div", {
            className: "flex flex-col items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $lUgbo.jsx)("span", {
                    className: "text-sm text-gray-500 uppercase tracking-wide",
                    children: t("codeLabel")
                }),
                /*#__PURE__*/ (0, $lUgbo.jsx)("code", {
                    className: "px-4 py-2 bg-gray-100 rounded-lg text-lg font-mono tracking-widest break-all max-w-full",
                    children: code
                })
            ]
        })
    });
}



var $lUgbo = parcelRequire("lUgbo");
parcelRequire("64wTB");
var $3Pe9S = parcelRequire("3Pe9S");

var $cl8Lt = parcelRequire("cl8Lt");

var $2SzOE = parcelRequire("2SzOE");
// Reached via the universal link
// https://launchpad.saltplatform.com/app/church/{churchID}/team/{teamID}.
//
// The app does the joining: it opens on the inviting church and asks the
// person to sign in (VolunteerTeamInviteCoordinator in Salt-iOS). So this page
// only has to get the app installed and send them back to the link.
const $31179ae862a65f4e$var$STEPS = [
    "download",
    "reopen",
    "signIn"
];
function $31179ae862a65f4e$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3Pe9S.useTranslation)("teamInvite");
    (0, $2SzOE.default)(t("documentTitle"));
    return /*#__PURE__*/ (0, $lUgbo.jsx)((0, $cl8Lt.default), {
        heading: t("heading"),
        instructions: t("instructions"),
        children: /*#__PURE__*/ (0, $lUgbo.jsx)("ol", {
            className: "flex flex-col gap-3 w-full max-w-sm",
            children: $31179ae862a65f4e$var$STEPS.map((step, index)=>/*#__PURE__*/ (0, $lUgbo.jsxs)("li", {
                    className: "flex items-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $lUgbo.jsx)("span", {
                            className: "shrink-0 size-8 rounded-full bg-gray-100 text-gray-600 font-semibold flex items-center justify-center",
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)("span", {
                            className: "text-gray-700",
                            children: t(`steps.${step}`)
                        })
                    ]
                }, step))
        })
    });
}



var $aOB4t = parcelRequire("aOB4t");

var $8Mq9R = parcelRequire("8Mq9R");

var $jd2YQ = parcelRequire("jd2YQ");

var $lUgbo = parcelRequire("lUgbo");

var $fITET = parcelRequire("fITET");

var $PAdBB = parcelRequire("PAdBB");
// Slides each new screen in, and resets scroll so a new page starts at the top.
//
// React Router's `viewTransition` option needs a data router
// (createBrowserRouter); this app uses BrowserRouter, so the animation is
// driven off the navigation type instead. That has the advantage of covering
// the browser's own back button, not just in-app navigation.
//
// Forward navigations slide in from the right; going back reverses it. Only
// the incoming screen animates — the outgoing one unmounts immediately, which
// the short duration and the fade make read as a single movement.
function $9c71f11bc6408de7$var$readHistoryIndex() {
    const index = window.history.state?.idx;
    return typeof index === "number" ? index : null;
}
function $9c71f11bc6408de7$export$2e2bcd8739ae039(props) {
    const location = (0, $PAdBB.useLocation)();
    const navigationType = (0, $PAdBB.useNavigationType)();
    // Null until the first navigation, so the very first page load does not
    // animate in.
    const previousKey = (0, $fITET.useRef)(null);
    // Back and forward are both POP, so the navigation type alone cannot tell
    // them apart. React Router stamps an incrementing `idx` onto history state;
    // comparing it against the last one gives the direction.
    const historyIndex = $9c71f11bc6408de7$var$readHistoryIndex();
    const previousIndex = (0, $fITET.useRef)(historyIndex);
    (0, $fITET.useEffect)(()=>{
        previousKey.current = location.key;
        previousIndex.current = historyIndex;
    }, [
        location.key,
        historyIndex
    ]);
    // A new screen starts at the top. Back and forward are left alone so the
    // browser can restore the position that history entry was at, which is what
    // people expect when returning to a list they had scrolled.
    //
    // Runs before paint, so the new page never flashes at the old scroll offset.
    (0, $fITET.useLayoutEffect)(()=>{
        if (navigationType === "POP") return;
        window.scrollTo(0, 0);
    }, [
        location.key,
        navigationType
    ]);
    const hasNavigated = previousKey.current !== null;
    let direction = "forward";
    if (navigationType === "POP") {
        const from = previousIndex.current;
        // Unknown index (older entry, or a shape change in the router) reads as
        // back, which is what POP is the overwhelming majority of the time.
        direction = from !== null && historyIndex !== null && historyIndex > from ? "forward" : "back";
    }
    return /*#__PURE__*/ (0, $lUgbo.jsx)("div", {
        className: "page-viewport",
        children: /*#__PURE__*/ (0, $lUgbo.jsx)("div", {
            className: hasNavigated ? `page-enter-${direction}` : undefined,
            children: props.children
        }, location.key)
    });
}



var $iKxNa = parcelRequire("iKxNa");
/** Set once the chunk has loaded, so later pages from it render straight away. */ let $08c3affee5962ca0$var$launchpadPages = null;

const $08c3affee5962ca0$var$loadLaunchpadPages = ()=>(parcelRequire("eXhvp")).then((pages)=>$08c3affee5962ca0$var$launchpadPages = pages);
// Each page gets its own lazy() only for the first page opened from the
// chunk. React.lazy suspends on its first render even when the module is
// already loaded — it only learns that asynchronously — and a navigation that
// suspends keeps the old page up, then swaps the new one in on its own a
// moment later. Opening an event from a Launchpad would do exactly that the
// first time, and not slide in like every later time. Rendering the loaded
// page directly keeps the navigation in one render, like any other.
function $08c3affee5962ca0$var$launchpadPage(name) {
    const Lazy = /*#__PURE__*/ (0, $fITET.lazy)(()=>$08c3affee5962ca0$var$loadLaunchpadPages().then((pages)=>({
                default: pages[name]
            })));
    return function LaunchpadPage() {
        const Page = $08c3affee5962ca0$var$launchpadPages?.[name];
        return Page ? /*#__PURE__*/ (0, $lUgbo.jsx)(Page, {}) : /*#__PURE__*/ (0, $lUgbo.jsx)(Lazy, {});
    };
}
const $08c3affee5962ca0$var$LaunchpadByID = $08c3affee5962ca0$var$launchpadPage("LaunchpadByID");
const $08c3affee5962ca0$var$LaunchpadByTag = $08c3affee5962ca0$var$launchpadPage("LaunchpadByTag");
const $08c3affee5962ca0$var$ServiceDetail = $08c3affee5962ca0$var$launchpadPage("ServiceDetail");
const $08c3affee5962ca0$var$EventDetail = $08c3affee5962ca0$var$launchpadPage("EventDetail");
const $08c3affee5962ca0$var$PlaylistDetail = $08c3affee5962ca0$var$launchpadPage("PlaylistDetail");
const $08c3affee5962ca0$var$ChurchLaunchpads = $08c3affee5962ca0$var$launchpadPage("ChurchLaunchpads");
// Dev tools — the Launchpad picker, the bundled sample and the component
// gallery — exist only in `npm start`. Staging and production builds leave
// them out, along with the sample data.
//
// Parcel inlines NODE_ENV at build time, then:
// - drops the import() below before resolving imports, so the pages and sample
//   data aren't bundled or deployed at all. It only does that when the check is
//   written inline around the import(), not through a variable, and a static
//   import would be kept because the sample data runs code when it loads.
// - lets the minifier fold SHOW_DEV_PAGES to `false`, removing the routes.
// Hence the same condition twice; keep them in step.
const $08c3affee5962ca0$var$SHOW_DEV_PAGES = false;
const $08c3affee5962ca0$var$loadDevPages = null;
function $08c3affee5962ca0$var$devPage(name) {
    return /*#__PURE__*/ (0, $fITET.lazy)(()=>$08c3affee5962ca0$var$loadDevPages().then((pages)=>({
                default: pages[name]
            })));
}
const $08c3affee5962ca0$var$Test = $08c3affee5962ca0$var$devPage("Test");
const $08c3affee5962ca0$var$SampleLaunchpad = $08c3affee5962ca0$var$devPage("SampleLaunchpad");
const $08c3affee5962ca0$var$Library = $08c3affee5962ca0$var$devPage("Library");
const $08c3affee5962ca0$var$container = document.getElementById("app");
if (!$08c3affee5962ca0$var$container) throw new Error("Missing #app container");
(0, $9e8d7ffdc767baf8$exports.createRoot)($08c3affee5962ca0$var$container).render(/*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.BrowserRouter), {
    children: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $8Mq9R.default), {
        children: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $jd2YQ.default), {
            children: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $9c71f11bc6408de7$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $lUgbo.jsxs)((0, $PAdBB.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $7a14dd2dff127569$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: "/app/login/:code",
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $accd284849e5d647$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: "/app/church/:churchId/team/:teamId",
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $31179ae862a65f4e$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: (0, $iKxNa.LAUNCHPAD_TAG_ROUTE),
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$LaunchpadByTag, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: (0, $iKxNa.CHURCH_ROUTE),
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$ChurchLaunchpads, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: (0, $iKxNa.LAUNCHPAD_ROUTE),
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$LaunchpadByID, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: (0, $iKxNa.SERVICE_DETAIL_ROUTE),
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$ServiceDetail, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: (0, $iKxNa.EVENT_DETAIL_ROUTE),
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$EventDetail, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: (0, $iKxNa.PLAYLIST_DETAIL_ROUTE),
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$PlaylistDetail, {})
                            })
                        }),
                        $08c3affee5962ca0$var$SHOW_DEV_PAGES && /*#__PURE__*/ (0, $lUgbo.jsxs)((0, $lUgbo.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                                    path: (0, $iKxNa.TEST_ROUTE),
                                    element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                        children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$Test, {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                                    path: (0, $iKxNa.TEST_SAMPLE_ROUTE),
                                    element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                        children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$SampleLaunchpad, {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                                    path: "/library",
                                    element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $fITET.Suspense), {
                                        children: /*#__PURE__*/ (0, $lUgbo.jsx)($08c3affee5962ca0$var$Library, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lUgbo.jsx)((0, $PAdBB.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $lUgbo.jsx)((0, $aOB4t.default), {})
                        })
                    ]
                })
            })
        })
    })
}));


//# sourceMappingURL=src859620624.602e7098.js.map
